import { Observable, Subject, BehaviorSubject, Subscription } from 'rxjs';
import { publish, take } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { Component, Input, ViewChild, Pipe, Inject, Optional, Output, HostBinding, NgModule, ViewChildren, Directive, TemplateRef, ContentChild, PLATFORM_ID, Injectable as Injectable$1 } from '@angular/core';
import { __decorate } from 'tslib';
import * as i1$2 from '@banta/common';
import { Injectable, FilterMode, CommentsOrder, SocketRPC, RpcEvent, DurableSocket, buildQuery } from '@banta/common';
import * as i2 from '@angular/common';
import { CommonModule, isPlatformServer } from '@angular/common';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as marked from 'marked';
import createDOMPurify from 'dompurify';
import twemoji$1 from 'twemoji';
import * as i1 from '@angular/platform-browser';
import * as i3 from '@angular/cdk/bidi';
import * as i8 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i4 from '@angular/cdk/portal';
import { PortalModule } from '@angular/cdk/portal';
import * as i2$4 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i7$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i11 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i2$3 from '@angular/router';
import * as i3$2 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2$2 from '@angular/cdk/text-field';
import { TextFieldModule } from '@angular/cdk/text-field';
import * as i2$5 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i3$3 from '@angular/material/core';
import { v4 } from 'uuid';
function TimestampComponent_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵpipe(1, "date");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 2, ctx_r0.value, "short"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, ctx_r0.value, "shortDate"), " ");
  }
}
function TimestampComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵpipe(1, "date");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 2, ctx_r0.value, "short"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.relative, " ");
  }
}
const _c0 = ["container"];
function BantaAttachmentComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function BantaAttachmentComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
function BantaAttachmentComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 3);
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "em", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.theErrorMessage);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-spinner");
    i0.ɵɵelementStart(2, "em");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.loadingMessage);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_iframe_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "iframe", 8);
    i0.ɵɵpipe(1, "trustResourceUrl");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", i0.ɵɵpipeBind1(1, 1, ctx_r1.frameUrl), i0.ɵɵsanitizeResourceUrl);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_a_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r1.attachment.card.image, i0.ɵɵsanitizeUrl);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtemplate(1, BantaAttachmentComponent_ng_container_2_ng_container_2_a_2_img_1_Template, 1, 1, "img", 10);
    i0.ɵɵelementStart(2, "div", 11)(3, "h1");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "cite");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("has-image", ctx_r1.attachment.card.image);
    i0.ɵɵproperty("href", ctx_r1.attachment.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.attachment.card.image);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.attachment.card.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.attachment.card.description, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.attachment.card.url);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function BantaAttachmentComponent_ng_container_2_ng_container_2_a_3_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.activate());
    });
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.attachment.url, i0.ɵɵsanitizeUrl);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_blockquote_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "blockquote", 16);
    i0.ɵɵelement(1, "p", 17)(2, "a", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.attachment.url, i0.ɵɵsanitizeUrl);
  }
}
function BantaAttachmentComponent_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaAttachmentComponent_ng_container_2_ng_container_2_iframe_1_Template, 2, 3, "iframe", 4)(2, BantaAttachmentComponent_ng_container_2_ng_container_2_a_2_Template, 9, 7, "a", 5)(3, BantaAttachmentComponent_ng_container_2_ng_container_2_a_3_Template, 2, 1, "a", 6)(4, BantaAttachmentComponent_ng_container_2_ng_container_2_blockquote_4_Template, 3, 1, "blockquote", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasFrame);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.attachment.type === "card");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isImageAttachment && ctx_r1.attachment.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.attachment.type === "tweet");
  }
}
function BantaAttachmentComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaAttachmentComponent_ng_container_2_ng_container_1_Template, 4, 1, "ng-container", 1)(2, BantaAttachmentComponent_ng_container_2_ng_container_2_Template, 5, 4, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLoading && ctx_r1.attachment);
  }
}
const _c1 = ["lightbox"];
function BantaAttachmentsComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "banta-attachment", 5);
    i0.ɵɵlistener("loaded", function BantaAttachmentsComponent_ng_container_0_ng_container_4_Template_banta_attachment_loaded_1_listener() {
      const attachment_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.markAttachmentLoaded(attachment_r2));
    })("removed", function BantaAttachmentsComponent_ng_container_0_ng_container_4_Template_banta_attachment_removed_1_listener() {
      const attachment_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.removeAttachment(attachment_r2));
    })("activated", function BantaAttachmentsComponent_ng_container_0_ng_container_4_Template_banta_attachment_activated_1_listener() {
      const attachment_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.showLightbox(attachment_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const attachment_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("attachment", attachment_r2)("editing", ctx_r2.editing);
  }
}
function BantaAttachmentsComponent_ng_container_0_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "banta-attachment", 5);
    i0.ɵɵlistener("loaded", function BantaAttachmentsComponent_ng_container_0_div_5_ng_container_1_Template_banta_attachment_loaded_1_listener() {
      const attachment_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.markAttachmentLoaded(attachment_r5));
    })("removed", function BantaAttachmentsComponent_ng_container_0_div_5_ng_container_1_Template_banta_attachment_removed_1_listener() {
      const attachment_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.removeAttachment(attachment_r5));
    })("activated", function BantaAttachmentsComponent_ng_container_0_div_5_ng_container_1_Template_banta_attachment_activated_1_listener() {
      const attachment_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.showLightbox(attachment_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const attachment_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("attachment", attachment_r5)("editing", ctx_r2.editing);
  }
}
function BantaAttachmentsComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, BantaAttachmentsComponent_ng_container_0_div_5_ng_container_1_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("single", (ctx_r2.attachments == null ? null : ctx_r2.attachments.length) === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.inlineAttachments)("ngForTrackBy", ctx_r2.attachmentId);
  }
}
function BantaAttachmentsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "banta-lightbox", null, 0);
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵtemplate(4, BantaAttachmentsComponent_ng_container_0_ng_container_4_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, BantaAttachmentsComponent_ng_container_0_div_5_Template, 2, 4, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.blockAttachments)("ngForTrackBy", ctx_r2.attachmentId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.attachments && (ctx_r2.attachments == null ? null : ctx_r2.attachments.length) > 0);
  }
}
function EmojiSelectorPanelComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function EmojiSelectorPanelComponent_div_0_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hideSearch());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "arrow_back");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-form-field", 5)(5, "mat-label");
    i0.ɵɵtext(6, "Search for emoji");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 6);
    i0.ɵɵtwoWayListener("ngModelChange", function EmojiSelectorPanelComponent_div_0_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchQuery, $event) || (ctx_r1.searchQuery = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchQuery);
  }
}
function EmojiSelectorPanelComponent_ng_container_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_2_a_2_Template_a_click_0_listener() {
      const emoji_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(emoji_r4.char));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const emoji_r4 = ctx.$implicit;
    i0.ɵɵproperty("innerHtml", emoji_r4.html || "", i0.ɵɵsanitizeHtml);
  }
}
function EmojiSelectorPanelComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_2_a_2_Template, 1, 1, "a", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.searchResults);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template_a_click_0_listener() {
      const category_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.activeCategory = category_r7.name);
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const category_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("active", ctx_r1.activeCategory === category_r7.name);
    i0.ɵɵproperty("title", ctx_r1.humanize(category_r7.name));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r7.icon);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_2_a_1_Template, 3, 4, "a", 12);
    i0.ɵɵelementStart(2, "a", 13);
    i0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.showSearch());
    });
    i0.ɵɵelementStart(3, "mat-icon");
    i0.ɵɵtext(4, "search");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.categories);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template_a_click_0_listener() {
      const emoji_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.select(emoji_r9.char));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const emoji_r9 = ctx.$implicit;
    i0.ɵɵproperty("innerHtml", emoji_r9.html || "", i0.ɵɵsanitizeHtml);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_a_1_Template, 1, 1, "a", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r10.emojis);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_div_1_Template, 2, 1, "div", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const category_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.activeCategory && ctx_r1.activeCategory == category_r10.name);
  }
}
function EmojiSelectorPanelComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_3_ng_container_2_Template, 5, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EmojiSelectorPanelComponent_ng_container_3_ng_container_3_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.searchVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.categories);
  }
}
const _c2 = ["selectorPanelTemplate"];
function EmojiSelectorButtonComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emoji-selector-panel", 5, 2);
    i0.ɵɵlistener("selected", function EmojiSelectorButtonComponent_ng_template_4_Template_emoji_selector_panel_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.insert($event));
    });
    i0.ɵɵelementEnd();
  }
}
function CommentComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function CommentComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.report());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "warning");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Report ");
    i0.ɵɵelementEnd();
  }
}
function CommentComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CommentComponent_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startEdit());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Edit ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !(ctx_r2.permissions == null ? null : ctx_r2.permissions.canEdit) || ctx_r2.readonly);
  }
}
function CommentComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CommentComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.delete());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Delete ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !(ctx_r2.permissions == null ? null : ctx_r2.permissions.canDelete) || ctx_r2.readonly);
  }
}
function CommentComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function CommentComponent_button_9_Template_button_click_0_listener() {
      const menuItem_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(menuItem_r7.action(ctx_r2.message));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menuItem_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(menuItem_r7.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", menuItem_r7.label, " ");
  }
}
function CommentComponent_span_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.message.user.tag);
  }
}
function CommentComponent_div_23_li_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1, "(Edited)");
    i0.ɵɵelementEnd();
  }
}
function CommentComponent_div_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵpipe(2, "mentionLinker");
    i0.ɵɵpipe(3, "bantaMarkdownToHtml");
    i0.ɵɵelementStart(4, "banta-attachments", 28);
    i0.ɵɵlistener("loaded", function CommentComponent_div_23_Template_banta_attachments_loaded_4_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.markAttachmentsLoaded());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 29);
    i0.ɵɵtemplate(6, CommentComponent_div_23_li_6_Template, 2, 0, "li", 30);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 6, i0.ɵɵpipeBind2(2, 3, ctx_r2.message.message, ctx_r2.message.mentionLinks)), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("attachments", ctx_r2.message.attachments);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.message.edits == null ? null : ctx_r2.message.edits.length) > 0);
  }
}
function CommentComponent_div_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "div")(2, "mat-form-field", 32)(3, "mat-label");
    i0.ɵɵtext(4, "Edit Message");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "textarea", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function CommentComponent_div_24_Template_textarea_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.editedMessage, $event) || (ctx_r2.editedMessage = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function CommentComponent_div_24_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveEdit());
    });
    i0.ɵɵtext(7, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " \xA0 ");
    i0.ɵɵelementStart(9, "button", 35);
    i0.ɵɵlistener("click", function CommentComponent_div_24_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.endEditing());
    });
    i0.ɵɵtext(10, "Cancel");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.editedMessage);
    i0.ɵɵproperty("maxlength", ctx_r2.maxLength);
  }
}
function CommentComponent_div_27_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 36);
    i0.ɵɵlistener("click", function CommentComponent_div_27_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.select());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "comment");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 37);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("matTooltip", ctx_r2.replyCount > 0 ? "Replies" : "Reply");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.replyCount > 0 ? "Replies" : "Reply", " ", ctx_r2.replyCount > 0 ? "(" + ctx_r2.replyCount + ")" : "", " ");
  }
}
function CommentComponent_button_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵelement(1, "mat-spinner", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", true)("matTooltip", ctx_r2.upvoting ? "Please wait..." : (ctx_r2.message.userState == null ? null : ctx_r2.message.userState.liked) ? "Unlike" : "Like");
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 15);
  }
}
function CommentComponent_button_30_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.message.likes, " ");
  }
}
function CommentComponent_button_30_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵlistener("click", function CommentComponent_button_30_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView((ctx_r2.message.userState == null ? null : ctx_r2.message.userState.liked) ? ctx_r2.unlike() : ctx_r2.like());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "thumb_up");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CommentComponent_button_30_span_3_Template, 2, 1, "span", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.readonly)("matTooltip", (ctx_r2.permissions == null ? null : ctx_r2.permissions.canLike) ? ctx_r2.upvoting ? "Please wait..." : "Like" : ctx_r2.permissions == null ? null : ctx_r2.permissions.canLikeErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.message.likes > 0);
  }
}
const _c3 = ["messageContainer"];
const _c4 = [[["", "data-before", ""]], [["", 3, "data-before", "", 9, "inline-replies"]], [["", 8, "inline-replies"]]];
const _c5 = ["[data-before]", ":not([data-before]):not(.inline-replies)", ".inline-replies"];
function CommentViewComponent_a_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" New (", ctx_r2.newMessages.length, ") ");
  }
}
function CommentViewComponent_a_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Newest ");
    i0.ɵɵelementContainerEnd();
  }
}
function CommentViewComponent_a_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵlistener("click", function CommentViewComponent_a_4_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showNew($event));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "file_upload");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CommentViewComponent_a_4_ng_container_3_Template, 2, 1, "ng-container", 5)(4, CommentViewComponent_a_4_ng_container_4_Template, 2, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("visible", ctx_r2.shouldShowNewMessageIndicator);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.newMessages.length >= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.newMessages.length == 0);
  }
}
function CommentViewComponent_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, " Be the first to comment! ");
    i0.ɵɵelementEnd();
  }
}
function CommentViewComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CommentViewComponent_ng_container_7_div_1_Template, 2, 0, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showEmptyState);
  }
}
function CommentViewComponent_ng_container_8_banta_comment_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-comment", 14);
    i0.ɵɵlistener("click", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.enableHoldOnClick ? ctx_r2.holdNewMessages = true : undefined);
    })("editStarted", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_editStarted_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startEditing(message_r5));
    })("deleted", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_deleted_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteMessage(message_r5));
    })("editEnded", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_editEnded_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(message_r5.transientState.editing = false);
    })("edited", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_edited_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.saveEdit(message_r5, $event));
    })("userSelected", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_userSelected_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectMessageUser(message_r5));
    })("avatarSelected", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_avatarSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectAvatar($event));
    })("usernameSelected", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_usernameSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectUsername($event));
    })("liked", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_liked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.likeMessage(message_r5));
    })("unliked", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_unliked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.unlikeMessage(message_r5));
    })("reported", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_reported_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.reportMessage(message_r5));
    })("selected", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_selected_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const message_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectMessage(message_r5));
    })("shared", function CommentViewComponent_ng_container_8_banta_comment_1_Template_banta_comment_shared_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.sharedMessage($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customMenuItems", ctx_r2.customMenuItems)("message", message_r5)("mine", (ctx_r2.currentUser == null ? null : ctx_r2.currentUser.id) === (message_r5.user == null ? null : message_r5.user.id))("permissions", ctx_r2.source == null ? null : ctx_r2.source.permissions)("showReplyAction", ctx_r2.allowReplies)("editing", message_r5.transientState.editing)("genericAvatarUrl", ctx_r2.genericAvatarUrl)("readonly", ctx_r2.source == null ? null : ctx_r2.source.readonly);
  }
}
function CommentViewComponent_ng_container_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function CommentViewComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CommentViewComponent_ng_container_8_banta_comment_1_Template, 1, 8, "banta-comment", 12)(2, CommentViewComponent_ng_container_8_div_2_Template, 2, 0, "div", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const message_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !message_r5.hidden);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectedMessage === message_r5);
  }
}
function CommentViewComponent_a_10_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" New (", ctx_r2.newMessages.length, ") ");
  }
}
function CommentViewComponent_a_10_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Newest ");
    i0.ɵɵelementContainerEnd();
  }
}
function CommentViewComponent_a_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵlistener("click", function CommentViewComponent_a_10_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showNew($event));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CommentViewComponent_a_10_ng_container_3_Template, 2, 1, "ng-container", 5)(4, CommentViewComponent_a_10_ng_container_4_Template, 2, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("visible", ctx_r2.shouldShowNewMessageIndicator);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.newMessages.length >= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.newMessages.length == 0);
  }
}
function CommentViewComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "mat-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c6 = ["fileUpload"];
const _c7 = ["autocomplete"];
const _c8 = ["autocompleteContainer"];
const _c9 = ["textarea"];
const _c10 = ["*"];
function CommentFieldComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵlistener("click", function CommentFieldComponent_ng_container_12_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.alertError());
    });
    i0.ɵɵelement(2, "mat-spinner", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("expanded", true);
    i0.ɵɵproperty("matTooltip", ctx_r2.transientMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("inline", true)("diameter", 15);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.transientMessage, " ");
  }
}
function CommentFieldComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵlistener("click", function CommentFieldComponent_ng_container_13_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.alertError());
    });
    i0.ɵɵelement(2, "mat-spinner", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("expanded", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("inline", true)("diameter", 15);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.sendingLabel, "... ");
  }
}
function CommentFieldComponent_ng_container_14_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "error");
    i0.ɵɵelementEnd();
  }
}
function CommentFieldComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵlistener("click", function CommentFieldComponent_ng_container_14_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.alertError());
    });
    i0.ɵɵtemplate(2, CommentFieldComponent_ng_container_14_mat_icon_2_Template, 2, 0, "mat-icon", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("expanded", ctx_r2.expandError);
    i0.ɵɵproperty("matTooltip", ctx_r2.sendError.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.sendError);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.sendError.message, " ");
  }
}
function CommentFieldComponent_banta_attachment_button_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-attachment-button", 26);
    i0.ɵɵlistener("addedAttachment", function CommentFieldComponent_banta_attachment_button_18_Template_banta_attachment_button_addedAttachment_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addedAttachment($event));
    })("attachmentError", function CommentFieldComponent_banta_attachment_button_18_Template_banta_attachment_button_attachmentError_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.attachmentError($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.readonly);
  }
}
function CommentFieldComponent_a_28_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 27);
    i0.ɵɵlistener("click", function CommentFieldComponent_a_28_Template_a_click_0_listener() {
      const option_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.activateAutoComplete(option_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const index_r9 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r2.autoCompleteSelected === index_r9);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r8.label, " ");
  }
}
function CommentFieldComponent_ng_container_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function CommentFieldComponent_ng_container_31_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showSignIn());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.signInLabel);
  }
}
function CommentFieldComponent_ng_container_32_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 30)(1, "mat-icon");
    i0.ɵɵtext(2, "chevron_right");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 31);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r2.sendButtonEnabled);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.sendLabel);
  }
}
function CommentFieldComponent_ng_container_32_button_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.sendingLabel, " ");
  }
}
function CommentFieldComponent_ng_container_32_button_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.signingInLabel, " ");
  }
}
function CommentFieldComponent_ng_container_32_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵelement(1, "mat-spinner", 32);
    i0.ɵɵelementStart(2, "span", 31);
    i0.ɵɵtemplate(3, CommentFieldComponent_ng_container_32_button_2_ng_container_3_Template, 2, 1, "ng-container", 12)(4, CommentFieldComponent_ng_container_32_button_2_ng_container_4_Template, 2, 1, "ng-container", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r2.sendButtonEnabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.buttonState === "sending");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.buttonState === "signing-in");
  }
}
function CommentFieldComponent_ng_container_32_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r2.sendButtonEnabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.permissionDeniedLabel, " ");
  }
}
function CommentFieldComponent_ng_container_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CommentFieldComponent_ng_container_32_button_1_Template, 5, 2, "button", 29)(2, CommentFieldComponent_ng_container_32_button_2_Template, 5, 3, "button", 29)(3, CommentFieldComponent_ng_container_32_button_3_Template, 2, 2, "button", 29);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.buttonState === "send");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.buttonState === "sending" || ctx_r2.buttonState === "signing-in");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.buttonState === "permission-denied");
  }
}
const _c11 = ["commentView"];
function BantaCommentsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "h1");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "mat-spinner", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("visible", ctx_r0.showLoadingScreen);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.loadingTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("diameter", 300)("strokeWidth", 2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("visible", ctx_r0.loadingMessageVisible);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.loadingMessage);
  }
}
function BantaCommentsComponent_ng_container_1_div_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelement(2, "mat-spinner");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "banta-comment-view", 23, 3);
    i0.ɵɵlistener("liked", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_liked_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.likeMessage(ctx_r0.selectedMessageThread, $event));
    })("unliked", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_unliked_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.unlikeMessage(ctx_r0.selectedMessageThread, $event));
    })("messageEdited", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_messageEdited_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.editMessage(ctx_r0.selectedMessageThread, $event.message, $event.newMessage));
    })("reported", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_reported_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.reportMessage($event));
    })("usernameSelected", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_usernameSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.selectUsername($event));
    })("avatarSelected", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_avatarSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.selectAvatar($event));
    })("shared", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_shared_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.shareMessage($event));
    })("deleted", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_view_deleted_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.deleteMessage($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "banta-comment-field", 24);
    i0.ɵɵlistener("signInSelected", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_field_signInSelected_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.showSignIn());
    })("editAvatarSelected", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_field_editAvatarSelected_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.showEditAvatar());
    })("permissionDeniedError", function BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template_banta_comment_field_permissionDeniedError_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handlePermissionDenied($event));
    });
    i0.ɵɵtemplate(4, BantaCommentsComponent_ng_container_1_div_1_ng_container_9_ng_container_4_Template, 1, 0, "ng-container", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("source", ctx_r0.selectedMessageThread)("allowReplies", false)("fixedHeight", false)("showEmptyState", false)("newestLast", true)("genericAvatarUrl", ctx_r0.genericAvatarUrl)("customMenuItems", ctx_r0.customMenuItems);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("url", ctx_r0.url)("sendLabel", ctx_r0.replyLabel)("sendingLabel", ctx_r0.sendingLabel)("signingInLabel", ctx_r0.signingInLabel)("hashtags", ctx_r0.hashtags)("participants", ctx_r0.participants)("readonly", ctx_r0.source == null ? null : ctx_r0.source.readonly)("source", ctx_r0.selectedMessageThread)("maxLength", ctx_r0.maxCommentLength)("canComment", ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPost)("signInState", ctx_r0.source == null ? null : ctx_r0.source.signInState)("signInLabel", ctx_r0.signInLabel)("permissionDeniedLabel", (ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPostErrorMessage) || ctx_r0.permissionDeniedLabel)("shouldInterceptMessageSend", ctx_r0.shouldInterceptMessageSend)("user", ctx_r0.user)("label", ctx_r0.postReplyLabel)("submit", ctx_r0.sendReply)("allowAttachments", ctx_r0.allowAttachments)("genericAvatarUrl", ctx_r0.genericAvatarUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sendReplyOptionsTemplate);
  }
}
function BantaCommentsComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div")(2, "a", 19);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_div_1_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.unselectMessage());
    });
    i0.ɵɵelementStart(3, "mat-icon");
    i0.ɵɵtext(4, "arrow_back");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " Latest Comments ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "banta-comment", 20);
    i0.ɵɵlistener("editStarted", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_editStarted_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.startEditing(ctx_r0.selectedMessage));
    })("editEnded", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_editEnded_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectedMessage.transientState.editing = false);
    })("edited", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_edited_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.saveEdit(ctx_r0.selectedMessage, $event));
    })("userSelected", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_userSelected_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectMessageUser(ctx_r0.selectedMessage));
    })("avatarSelected", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_avatarSelected_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectAvatar($event));
    })("usernameSelected", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_usernameSelected_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectUsername($event));
    })("liked", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_liked_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.likeMessage(ctx_r0.source, ctx_r0.selectedMessage));
    })("unliked", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_unliked_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.unlikeMessage(ctx_r0.source, ctx_r0.selectedMessage));
    })("reported", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_reported_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.reportMessage(ctx_r0.selectedMessage));
    })("selected", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_selected_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggleSelectedMessage(ctx_r0.selectedMessage));
    })("shared", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_shared_6_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareMessage($event));
    })("deleted", function BantaCommentsComponent_ng_container_1_div_1_Template_banta_comment_deleted_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.deleteMessage(ctx_r0.selectedMessage));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵtemplate(8, BantaCommentsComponent_ng_container_1_div_1_ng_container_8_Template, 3, 0, "ng-container", 4)(9, BantaCommentsComponent_ng_container_1_div_1_ng_container_9_Template, 5, 27, "ng-container", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("visible", ctx_r0.selectedMessageVisible);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("message", ctx_r0.selectedMessage)("liking", ctx_r0.selectedMessage.transientState.liking)("mine", (ctx_r0.user == null ? null : ctx_r0.user.id) === (ctx_r0.selectedMessage.user == null ? null : ctx_r0.selectedMessage.user.id))("permissions", ctx_r0.source == null ? null : ctx_r0.source.permissions)("showReplyAction", false)("editing", ctx_r0.selectedMessage.transientState.editing)("maxLength", ctx_r0.maxCommentLength)("genericAvatarUrl", ctx_r0.genericAvatarUrl)("readonly", ctx_r0.source == null ? null : ctx_r0.source.readonly);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.selectedMessageThread);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedMessageThread);
  }
}
function BantaCommentsComponent_ng_container_1_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_button_6_Template_button_click_0_listener() {
      const filter_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.filterMode = filter_r6);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filter_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.filterModeLabels[filter_r6], " ");
  }
}
function BantaCommentsComponent_ng_container_1_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_button_9_Template_button_click_0_listener() {
      const sort_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.sortOrder = sort_r8);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sort_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.sortOrderLabels[sort_r8], " ");
  }
}
function BantaCommentsComponent_ng_container_1_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "h1");
    i0.ɵɵtext(2, "Loading the comment you linked to...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "mat-spinner", 6);
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, " If there are a lot of comments, this might take awhile! ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("diameter", 300)("strokeWidth", 2);
  }
}
function BantaCommentsComponent_ng_container_1_div_20_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 28);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_div_20_ng_container_1_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.lastSharedCommentID = null);
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "h1")(5, "mat-icon");
    i0.ɵɵtext(6, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " Uh oh! ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9, "The comment you linked to can't be found! It may have been removed.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function BantaCommentsComponent_ng_container_1_div_20_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 28);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_div_20_ng_container_2_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.lastSharedCommentID = null);
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 29);
    i0.ɵɵlistener("click", function BantaCommentsComponent_ng_container_1_div_20_ng_container_2_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.navigateToSharedComment(ctx_r0.lastSharedCommentID));
    });
    i0.ɵɵelementStart(5, "mat-icon");
    i0.ɵɵtext(6, "move_down");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " Jump to shared comment ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function BantaCommentsComponent_ng_container_1_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, BantaCommentsComponent_ng_container_1_div_20_ng_container_1_Template, 10, 0, "ng-container", 4)(2, BantaCommentsComponent_ng_container_1_div_20_ng_container_2_Template, 8, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.sharedCommentMissing);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.sharedCommentMissing);
  }
}
function BantaCommentsComponent_ng_container_1_div_24_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelement(2, "mat-spinner");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "banta-comment-view", 30);
    i0.ɵɵlistener("liked", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_liked_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.likeMessage(ctx_r0.selectedMessageThread, $event));
    })("unliked", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_unliked_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.unlikeMessage(ctx_r0.selectedMessageThread, $event));
    })("messageEdited", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_messageEdited_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.editMessage(ctx_r0.selectedMessageThread, $event.message, $event.newMessage));
    })("reported", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_reported_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.reportMessage($event));
    })("usernameSelected", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_usernameSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.selectUsername($event));
    })("avatarSelected", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_avatarSelected_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.selectAvatar($event));
    })("shared", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_shared_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.shareMessage($event));
    })("deleted", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_view_deleted_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.deleteMessage($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "banta-comment-field", 31);
    i0.ɵɵlistener("signInSelected", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_field_signInSelected_2_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.showSignIn());
    })("permissionDeniedError", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_field_permissionDeniedError_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handlePermissionDenied($event));
    })("editAvatarSelected", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_field_editAvatarSelected_2_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.showEditAvatar());
    })("focusChange", function BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template_banta_comment_field_focusChange_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.replyFieldFocused = $event);
    });
    i0.ɵɵtemplate(3, BantaCommentsComponent_ng_container_1_div_24_ng_container_3_ng_container_3_Template, 1, 0, "ng-container", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("source", ctx_r0.selectedMessageThread)("allowReplies", false)("fixedHeight", false)("showEmptyState", false)("newestLast", true)("enableHoldOnClick", false)("holdNewMessages", ctx_r0.replyFieldFocused)("genericAvatarUrl", ctx_r0.genericAvatarUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("url", ctx_r0.url)("sendLabel", ctx_r0.replyLabel)("sendingLabel", ctx_r0.sendingLabel)("signingInLabel", ctx_r0.signingInLabel)("hashtags", ctx_r0.hashtags)("participants", ctx_r0.participants)("maxLength", ctx_r0.maxCommentLength)("source", ctx_r0.selectedMessageThread)("signInState", ctx_r0.source == null ? null : ctx_r0.source.signInState)("canComment", ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPost)("signInLabel", ctx_r0.signInLabel)("permissionDeniedLabel", (ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPostErrorMessage) || ctx_r0.permissionDeniedLabel)("readonly", ctx_r0.source == null ? null : ctx_r0.source.readonly)("shouldInterceptMessageSend", ctx_r0.shouldInterceptMessageSend)("user", ctx_r0.user)("label", ctx_r0.postReplyLabel)("submit", ctx_r0.sendReply)("allowAttachments", ctx_r0.allowAttachments)("genericAvatarUrl", ctx_r0.genericAvatarUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sendReplyOptionsTemplate);
  }
}
function BantaCommentsComponent_ng_container_1_div_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 21);
    i0.ɵɵtemplate(2, BantaCommentsComponent_ng_container_1_div_24_ng_container_2_Template, 3, 0, "ng-container", 4)(3, BantaCommentsComponent_ng_container_1_div_24_ng_container_3_Template, 4, 28, "ng-container", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("visible", ctx_r0.selectedMessageVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.selectedMessageThread);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedMessageThread);
  }
}
function BantaCommentsComponent_ng_container_1_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "strong");
    i0.ɵɵtext(2, "Connection to Live Comments lost.");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Reconnecting... ");
    i0.ɵɵelementEnd();
  }
}
function BantaCommentsComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaCommentsComponent_ng_container_1_div_1_Template, 10, 13, "div", 8);
    i0.ɵɵelementStart(2, "div", 9)(3, "banta-comment-field", 10);
    i0.ɵɵlistener("editAvatarSelected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_field_editAvatarSelected_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.showEditAvatar());
    })("signInSelected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_field_signInSelected_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.showSignIn());
    })("permissionDeniedError", function BantaCommentsComponent_ng_container_1_Template_banta_comment_field_permissionDeniedError_3_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handlePermissionDenied($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-menu", null, 0);
    i0.ɵɵtemplate(6, BantaCommentsComponent_ng_container_1_button_6_Template, 2, 1, "button", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-menu", null, 1);
    i0.ɵɵtemplate(9, BantaCommentsComponent_ng_container_1_button_9_Template, 2, 1, "button", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 12)(11, "button", 13)(12, "mat-icon");
    i0.ɵɵtext(13, "filter_list");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 13)(16, "mat-icon");
    i0.ɵɵtext(17, "sort");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, BantaCommentsComponent_ng_container_1_div_19_Template, 6, 2, "div", 14)(20, BantaCommentsComponent_ng_container_1_div_20_Template, 3, 2, "div", 14);
    i0.ɵɵelementStart(21, "banta-comment-view", 15, 2);
    i0.ɵɵlistener("userSelected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_userSelected_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectMessageUser($event));
    })("sortOrderChanged", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_sortOrderChanged_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.sortOrder = $event);
    })("filterModeChanged", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_filterModeChanged_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.filterMode = $event);
    })("selected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_selected_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleSelectedMessage($event));
    })("liked", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_liked_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.likeMessage(ctx_r0.source, $event));
    })("unliked", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_unliked_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.unlikeMessage(ctx_r0.source, $event));
    })("messageEdited", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_messageEdited_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.editMessage(ctx_r0.source, $event.message, $event.newMessage));
    })("reported", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_reported_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.reportMessage($event));
    })("usernameSelected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_usernameSelected_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectUsername($event));
    })("avatarSelected", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_avatarSelected_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectAvatar($event));
    })("shared", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_shared_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.shareMessage($event));
    })("deleted", function BantaCommentsComponent_ng_container_1_Template_banta_comment_view_deleted_21_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.deleteMessage($event));
    });
    i0.ɵɵelementStart(23, "div", 16);
    i0.ɵɵtemplate(24, BantaCommentsComponent_ng_container_1_div_24_Template, 4, 4, "div", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(25, BantaCommentsComponent_ng_container_1_div_25_Template, 4, 0, "div", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const filterMenu_r12 = i0.ɵɵreference(5);
    const sortMenu_r13 = i0.ɵɵreference(8);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedMessage && !ctx_r0.useInlineReplies);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("hidden", ctx_r0.selectedMessage && !ctx_r0.useInlineReplies);
    i0.ɵɵadvance();
    i0.ɵɵproperty("url", ctx_r0.url)("source", ctx_r0.source)("user", ctx_r0.user)("sendLabel", ctx_r0.sendLabel)("sendingLabel", ctx_r0.sendingLabel)("signingInLabel", ctx_r0.signingInLabel)("signInLabel", ctx_r0.signInLabel)("signInState", ctx_r0.source == null ? null : ctx_r0.source.signInState)("canComment", ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPost)("hashtags", ctx_r0.hashtags)("participants", ctx_r0.participants)("label", ctx_r0.postCommentLabel)("maxLength", ctx_r0.maxCommentLength)("permissionDeniedLabel", (ctx_r0.source == null ? null : ctx_r0.source.permissions == null ? null : ctx_r0.source.permissions.canPostErrorMessage) || ctx_r0.permissionDeniedLabel)("shouldInterceptMessageSend", ctx_r0.shouldInterceptMessageSend)("submit", ctx_r0.sendMessage)("allowAttachments", ctx_r0.allowAttachments)("genericAvatarUrl", ctx_r0.genericAvatarUrl)("readonly", ctx_r0.source == null ? null : ctx_r0.source.readonly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.filterModes);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.sortOrders);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matMenuTriggerFor", filterMenu_r12);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.filterModeLabels[ctx_r0.filterMode], " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", sortMenu_r13);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.sortOrderLabels[ctx_r0.sortOrder], " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingSharedComment);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingSharedComment && ctx_r0.lastSharedCommentID);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("faded", ctx_r0.selectedMessage && !ctx_r0.useInlineReplies);
    i0.ɵɵproperty("source", ctx_r0.source)("fixedHeight", ctx_r0.fixedHeight)("maxMessages", ctx_r0.maxMessages)("maxVisibleMessages", ctx_r0.maxVisibleMessages)("genericAvatarUrl", ctx_r0.genericAvatarUrl)("customMenuItems", ctx_r0.customMenuItems)("holdNewMessages", ctx_r0.selectedMessageVisible)("selectedMessage", ctx_r0.selectedMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.connectionState === "lost");
  }
}
function ChatMessageComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "mat-icon");
    i0.ɵɵtext(2, "star");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.message.likes, " ");
  }
}
const _c12 = [[["", "data-before", ""]], [["", 3, "data-before", ""]]];
const _c13 = ["[data-before]", ":not([data-before])"];
function ChatViewComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.emptyLabel, " ");
  }
}
function ChatViewComponent_ng_container_4_banta_chat_message_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-chat-message", 6);
    i0.ɵɵlistener("selected", function ChatViewComponent_ng_container_4_banta_chat_message_1_Template_banta_chat_message_selected_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const message_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectMessage(message_r3));
    })("upvoted", function ChatViewComponent_ng_container_4_banta_chat_message_1_Template_banta_chat_message_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const message_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.upvoteMessage(message_r3));
    })("reported", function ChatViewComponent_ng_container_4_banta_chat_message_1_Template_banta_chat_message_reported_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const message_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.reportMessage(message_r3));
    })("userSelected", function ChatViewComponent_ng_container_4_banta_chat_message_1_Template_banta_chat_message_userSelected_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const message_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectMessageUser(message_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("highlight", ctx_r0.mentionsMe(message_r3))("flash", message_r3.id === ctx_r0.flashedMessageId);
    i0.ɵɵproperty("message", message_r3);
    i0.ɵɵattribute("data-id", message_r3.id);
  }
}
function ChatViewComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ChatViewComponent_ng_container_4_banta_chat_message_1_Template, 1, 6, "banta-chat-message", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const message_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !message_r3.hidden);
  }
}
const _c14 = ["chatView"];
const _c15 = ["input"];
function BantaChatComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 9);
    i0.ɵɵlistener("click", function BantaChatComponent_ng_container_8_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showSignIn());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.signInLabel);
  }
}
function BantaChatComponent_ng_container_9_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r2.newMessage.message);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.sendLabel);
  }
}
function BantaChatComponent_ng_container_9_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function BantaChatComponent_ng_container_9_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.sendPermissionError());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.permissionDeniedLabel);
  }
}
function BantaChatComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaChatComponent_ng_container_9_button_1_Template, 2, 2, "button", 10)(2, BantaChatComponent_ng_container_9_button_2_Template, 2, 1, "button", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.canChat);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.canChat);
  }
}
function LiveCommentComponent_banta_comment_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-comment", 1);
    i0.ɵɵlistener("upvoted", function LiveCommentComponent_banta_comment_0_Template_banta_comment_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.upvote());
    })("reported", function LiveCommentComponent_banta_comment_0_Template_banta_comment_reported_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.report());
    })("selected", function LiveCommentComponent_banta_comment_0_Template_banta_comment_selected_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.select());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("message", ctx_r1.message);
  }
}
function LiveChatMessageComponent_banta_chat_message_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-chat-message", 1);
    i0.ɵɵlistener("upvoted", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.upvote());
    })("reported", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_reported_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.report());
    })("selected", function LiveChatMessageComponent_banta_chat_message_0_Template_banta_chat_message_selected_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.select());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("message", ctx_r1.message);
  }
}
function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-live-chat-message", 2);
    i0.ɵɵlistener("upvoted", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.upvote(ctx_r1.message));
    })("reported", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_reported_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.report(ctx_r1.message));
    })("selected", function LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template_banta_live_chat_message_selected_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(ctx_r1.message));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("message", ctx_r1.message);
  }
}
function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-live-comment", 2);
    i0.ɵɵlistener("upvoted", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.upvote(ctx_r1.message));
    })("reported", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_reported_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.report(ctx_r1.message));
    })("selected", function LiveMessageComponent_ng_container_0_banta_live_comment_2_Template_banta_live_comment_selected_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(ctx_r1.message));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("message", ctx_r1.message);
  }
}
function LiveMessageComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LiveMessageComponent_ng_container_0_banta_live_chat_message_1_Template, 1, 1, "banta-live-chat-message", 1)(2, LiveMessageComponent_ng_container_0_banta_live_comment_2_Template, 1, 1, "banta-live-comment", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.viewType === "chat");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.viewType === "comment");
  }
}
const _c16 = ["firehose"];
function BantaComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵlistener("click", function BantaComponent_ng_container_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.signOut());
    });
    i0.ɵɵtext(4, "Sign Out");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r2.currentUser.displayName, " (@", ctx_r2.currentUser.username, ")");
  }
}
function BantaComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 3);
    i0.ɵɵtext(2, "Sign In");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function BantaComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 12);
    i0.ɵɵlistener("click", function BantaComponent_ng_container_14_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showNotifications());
    });
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "notification_important");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const userMenu_r5 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", userMenu_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" @", ctx_r2.currentUser.username, " ");
  }
}
function BantaComponent_button_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function BantaComponent_button_15_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showSignIn());
    });
    i0.ɵɵtext(1, " Sign In ");
    i0.ɵɵelementEnd();
  }
}
function BantaComponent_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 12);
    i0.ɵɵlistener("click", function BantaComponent_ng_container_22_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showNotifications());
    });
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "notification_important");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const userMenu_r5 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", userMenu_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" @", ctx_r2.currentUser.username, " ");
  }
}
function BantaComponent_button_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function BantaComponent_button_23_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showSignIn());
    });
    i0.ɵɵtext(1, " Sign In ");
    i0.ɵɵelementEnd();
  }
}
function BantaComponent_ng_container_36_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "strong", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "strong");
    i0.ɵɵtext(7, "Top Messages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div")(9, "em");
    i0.ɵɵtext(10, "Not yet available");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "br");
    i0.ɵɵelementStart(12, "strong");
    i0.ɵɵtext(13, "Recent Messages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div")(15, "em");
    i0.ɵɵtext(16, "Not yet available");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.profileUser.displayName, " ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" @", ctx_r2.profileUser.username, " ");
  }
}
function BantaComponent_ng_container_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaComponent_ng_container_36_ng_container_1_Template, 17, 2, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.profileUser);
  }
}
function BantaComponent_ng_container_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Are you sure you want to report this message?");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "banta-live-message", 24);
    i0.ɵɵelementStart(4, "div", 25)(5, "button", 26);
    i0.ɵɵlistener("click", function BantaComponent_ng_container_37_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.sendReport(ctx_r2.reportedMessage));
    });
    i0.ɵɵtext(6, "Yes, Report");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " \xA0 ");
    i0.ɵɵelementStart(8, "button", 27);
    i0.ɵɵlistener("click", function BantaComponent_ng_container_37_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.auxOpen = false);
    });
    i0.ɵɵtext(9, "No, Cancel");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("message", ctx_r2.reportedMessage);
  }
}
function BantaComponent_ng_container_38_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "em");
    i0.ɵɵtext(2, "You do not have any notifications yet");
    i0.ɵɵelementEnd()();
  }
}
function BantaComponent_ng_container_38_div_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "banta-live-message", 32);
    i0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_upvoted_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.upvoteMessage(notif_r11.message));
    })("reported", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_reported_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.reportMessage(notif_r11.message));
    })("selected", function BantaComponent_ng_container_38_div_3_ng_container_2_Template_banta_live_message_selected_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goToMessage(notif_r11.message));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notif_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" @", notif_r11.message == null ? null : notif_r11.message.user == null ? null : notif_r11.message.user.username, " upvoted your post ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("message", notif_r11.message);
  }
}
function BantaComponent_ng_container_38_div_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 33);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notif_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", notif_r11.message, " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", notif_r11.actionUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", notif_r11.actionLabel, " ");
  }
}
function BantaComponent_ng_container_38_div_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "banta-live-message", 32);
    i0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_upvoted_2_listener() {
      i0.ɵɵrestoreView(_r12);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.upvoteMessage(notif_r11.message));
    })("reported", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_reported_2_listener() {
      i0.ɵɵrestoreView(_r12);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.reportMessage(notif_r11.message));
    })("selected", function BantaComponent_ng_container_38_div_3_ng_container_4_Template_banta_live_message_selected_2_listener() {
      i0.ɵɵrestoreView(_r12);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goToMessage(notif_r11.message));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notif_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" You were mentioned by @", notif_r11.message == null ? null : notif_r11.message.user == null ? null : notif_r11.message.user.username, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("message", notif_r11.message);
  }
}
function BantaComponent_ng_container_38_div_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "banta-live-message", 32);
    i0.ɵɵlistener("upvoted", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_upvoted_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.upvoteMessage(notif_r11.replyMessage));
    })("reported", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_reported_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.reportMessage(notif_r11.replyMessage));
    })("selected", function BantaComponent_ng_container_38_div_3_ng_container_5_Template_banta_live_message_selected_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const notif_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goToMessage(notif_r11.replyMessage));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notif_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" @", notif_r11.replyMessage == null ? null : notif_r11.replyMessage.user == null ? null : notif_r11.replyMessage.user.username, " replied to your post ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("message", notif_r11.replyMessage);
  }
}
function BantaComponent_ng_container_38_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div");
    i0.ɵɵtemplate(2, BantaComponent_ng_container_38_div_3_ng_container_2_Template, 3, 2, "ng-container", 2)(3, BantaComponent_ng_container_38_div_3_ng_container_3_Template, 5, 3, "ng-container", 2)(4, BantaComponent_ng_container_38_div_3_ng_container_4_Template, 3, 2, "ng-container", 2)(5, BantaComponent_ng_container_38_div_3_ng_container_5_Template, 3, 2, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "banta-timestamp", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notif_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notif_r11.type === "upvote");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notif_r11.type === "notice");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notif_r11.type === "mention");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notif_r11.type === "reply");
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", notif_r11.sentAt);
  }
}
function BantaComponent_ng_container_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BantaComponent_ng_container_38_div_1_Template, 3, 0, "div", 2);
    i0.ɵɵelementStart(2, "div", 28);
    i0.ɵɵtemplate(3, BantaComponent_ng_container_38_div_3_Template, 7, 5, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.notifications || ctx_r2.notifications.length === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.notifications);
  }
}
function BantaComponent_ng_container_51_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 34)(2, "div", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 36)(5, "mat-icon");
    i0.ɵɵtext(6, "thumb_up");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.pointOpen.likes, " ");
  }
}
function BantaComponent_div_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Error: No subchat ");
    i0.ɵɵelementEnd();
  }
}
function BantaComponent_banta_comment_view_53_banta_comment_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-comment", 43);
    i0.ɵɵlistener("upvoted", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_upvoted_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.upvoteMessage(ctx_r2.pointOpen));
    })("userSelected", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_userSelected_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.showProfile(ctx_r2.pointOpen.user));
    })("reported", function BantaComponent_banta_comment_view_53_banta_comment_1_Template_banta_comment_reported_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.reportMessage(ctx_r2.pointOpen));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("showReplyAction", false)("message", ctx_r2.pointOpen)("readonly", ctx_r2.pointSubChat == null ? null : ctx_r2.pointSubChat.readonly);
  }
}
function BantaComponent_banta_comment_view_53_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "banta-comment-view", 37);
    i0.ɵɵlistener("upvoted", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_upvoted_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.upvoteMessage($event));
    })("reported", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_reported_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.reportMessage($event));
    })("userSelected", function BantaComponent_banta_comment_view_53_Template_banta_comment_view_userSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showProfile($event.user));
    });
    i0.ɵɵtemplate(1, BantaComponent_banta_comment_view_53_banta_comment_1_Template, 1, 3, "banta-comment", 38);
    i0.ɵɵelementStart(2, "div", 39);
    i0.ɵɵtext(3, " Reply: ");
    i0.ɵɵelementStart(4, "form", 40);
    i0.ɵɵlistener("submit", function BantaComponent_banta_comment_view_53_Template_form_submit_4_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.sendPointSubMessage());
    });
    i0.ɵɵelementStart(5, "textarea", 41);
    i0.ɵɵlistener("keydown", function BantaComponent_banta_comment_view_53_Template_textarea_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.newPointSubMessageKeyDown($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function BantaComponent_banta_comment_view_53_Template_textarea_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.newPointSubMessage.message, $event) || (ctx_r2.newPointSubMessage.message = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16)(7, "button", 42);
    i0.ɵɵtext(8, "Send");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("newestLast", true)("allowReplies", false)("source", ctx_r2.pointSubChat);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.pointOpen);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.newPointSubMessage.message);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r2.newPointSubMessage.message);
  }
}
function lazyConnection(options) {
  let obs = new Observable(observer => {
    let subject = new Subject();
    let subscription = subject.subscribe(observer);
    options.start(subject);
    return () => {
      subscription.unsubscribe();
      options.stop();
    };
  });
  return obs.pipe(publish()).refCount();
}

/**
 * Provides a way to hook in to a shared set of timers, instead of creating a timer per instance.
 * This is very useful for cases where the update is not extremely time-sensitive, but happens at scale.
 * The principal use case is the TimestampComponent. When several hundred (or several thousand) comments are
 * being displayed, we do not want to trigger thousands of independent relative timestamp updates, because over
 * time the updates will saturate the CPU since they don't perfectly align.
 */
let TimerPool = /*#__PURE__*/(() => {
  let TimerPool = class TimerPool {
    constructor() {
      this.subscriptions = new Map();
      this.newSubscriptions = new Map();
      this.removedSubscriptions = new Map();
    }
    addTimer(interval, callback) {
      if (interval <= 0) {
        console.warn(`Refusing to set timer with interval of ${interval}!`);
        return () => {};
      }
      let state;
      let sizeWas = this.subscriptions.size;
      if (!this.subscriptions.has(interval)) {
        state = {
          subscribers: []
        };
        state.handle = setInterval(() => {
          console.debug(`[Banta/TimerPool] Notifying ${state.subscribers.length} subs [${interval}ms]`);
          state.subscribers.forEach(sub => sub());
        }, interval);
        this.subscriptions.set(interval, state);
      } else {
        state = this.subscriptions.get(interval);
      }
      state.subscribers.push(callback);
      // Debug information //////////////////////////
      //
      if (!this.newSubscriptions.has(interval)) this.newSubscriptions.set(interval, 0);
      this.newSubscriptions.set(interval, (this.newSubscriptions.get(interval) ?? 0) + 1);
      clearTimeout(this.newSubscriptionsNotice);
      this.newSubscriptionsNotice = setTimeout(() => {
        for (let [interval, count] of this.newSubscriptions) {
          console.debug(`[Banta/TimerPool] ${count} new subscriptions to ${interval}ms [${state.subscribers.length} total]`);
        }
        this.newSubscriptions.clear();
      });
      //
      ///////////////////////////////////////////////
      if (sizeWas === 0) {
        console.debug(`[Banta/TimerPool] No longer idle.`);
      }
      // Unsubscribe function 
      return () => {
        let state = this.subscriptions.get(interval);
        if (!state) return;
        let index = state.subscribers.indexOf(callback);
        if (index >= 0) state.subscribers.splice(index, 1);
        if (state.subscribers.length === 0) {
          clearInterval(state.handle);
          this.subscriptions.delete(interval);
        }
        if (!this.removedSubscriptions.has(interval)) this.removedSubscriptions.set(interval, 0);
        this.removedSubscriptions.set(interval, (this.removedSubscriptions.get(interval) ?? 0) + 1);
        // Debug information ////////////////////////////////////////////////////////////////////
        clearTimeout(this.removedSubscriptionsNotice);
        this.removedSubscriptionsNotice = setTimeout(() => {
          for (let [interval, count] of this.removedSubscriptions) {
            let state = this.subscriptions.get(interval);
            console.debug(`[Banta/TimerPool] ${count} unsubscribed from ${interval}ms [${state?.subscribers?.length ?? 0} remain]`);
          }
          if (this.subscriptions.size === 0) console.debug(`[Banta/TimerPool] All subscriptions have been removed. Now idle.`);
          this.removedSubscriptions.clear();
        });
      };
    }
  };
  TimerPool = __decorate([Injectable()], TimerPool);
  return TimerPool;
})();
let TimestampComponent = /*#__PURE__*/(() => {
  class TimestampComponent {
    constructor(timerPool) {
      this.timerPool = timerPool;
      this.relative = '';
      this.tooltip = '';
      this.timerInterval = 0;
      this._destroyed = false;
      this.showAbsolute = false;
    }
    ngOnDestroy() {
      this._destroyed = true;
      this.timerUnsubscribe?.();
      this.timerUnsubscribe = undefined;
    }
    get value() {
      return this._value;
    }
    update() {
      if (this._destroyed) return;
      let now = Date.now();
      let diff = now - this.value;
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let week = day * 7;
      let month = day * 30;
      let year = day * 365;
      this.showAbsolute = false;
      let updateTime = 0;
      if (diff > year) {
        this.showAbsolute = true;
        this.relative = 'abs';
        return;
      }
      if (diff > month) {
        let months = Math.floor(diff / month);
        if (months === 1) this.relative = `${months} month ago`;else this.relative = `${months} months ago`;
      } else if (diff > week) {
        let weeks = Math.floor(diff / week);
        if (weeks === 1) this.relative = `${weeks} week ago`;else this.relative = `${weeks} weeks ago`;
      } else if (diff > day) {
        let days = Math.floor(diff / day);
        if (days === 1) this.relative = `${days} day ago`;else this.relative = `${days} days ago`;
      } else if (diff > hour) {
        let hours = Math.floor(diff / hour);
        if (hours === 1) this.relative = `${hours} hour ago`;else this.relative = `${hours} hours ago`;
        updateTime = 1000 * 60 * 30;
      } else if (diff > minute) {
        let minutes = Math.floor(diff / minute);
        if (minutes === 1) this.relative = `${minutes} minute ago`;else this.relative = `${minutes} minutes ago`;
        updateTime = 1000 * 45;
      } else if (diff > 30_000) {
        this.relative = `about a minute ago`;
        updateTime = 1000 * 60;
      } else {
        this.relative = `just now`;
        updateTime = 1000 * 30;
      }
      if (typeof window !== 'undefined') {
        if (this.timerInterval !== updateTime) {
          this.timerInterval = updateTime;
          this.timerUnsubscribe?.();
          if (updateTime > 0) {
            this.timerUnsubscribe = this.timerPool.addTimer(updateTime, () => this.update());
          }
        }
      }
    }
    set value(v) {
      if (this._value !== v) {
        this._value = v;
        this.update();
      }
    }
    static {
      this.ɵfac = function TimestampComponent_Factory(t) {
        return new (t || TimestampComponent)(i0.ɵɵdirectiveInject(TimerPool));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TimestampComponent,
        selectors: [["banta-timestamp"]],
        inputs: {
          value: "value"
        },
        decls: 2,
        vars: 2,
        consts: [[3, "title", 4, "ngIf"], [3, "title"]],
        template: function TimestampComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TimestampComponent_span_0_Template, 4, 8, "span", 0)(1, TimestampComponent_span_1_Template, 3, 5, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showAbsolute);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.showAbsolute);
          }
        },
        dependencies: [i2.NgIf, i2.DatePipe]
      });
    }
  }
  return TimestampComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LightboxComponent = /*#__PURE__*/(() => {
  class LightboxComponent {
    ngAfterViewInit() {
      if (typeof window !== 'undefined') {
        document.body.appendChild(this.containerElement.nativeElement);
      }
    }
    ngOnDestroy() {
      this.containerElement.nativeElement.remove();
    }
    close() {
      this.isOpen = false;
    }
    open(currentImage, images) {
      this.currentImage = currentImage;
      this.images = images;
      this.isOpen = true;
    }
    static {
      this.ɵfac = function LightboxComponent_Factory(t) {
        return new (t || LightboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LightboxComponent,
        selectors: [["banta-lightbox"]],
        viewQuery: function LightboxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerElement = _t.first);
          }
        },
        decls: 7,
        vars: 3,
        consts: [["container", ""], [1, "banta-lightbox-container"], ["href", "javascript:;", 1, "underlay", 3, "click"], ["href", "javascript:;", 1, "close-button", 3, "click"], [3, "src"]],
        template: function LightboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1, 0)(2, "a", 2);
            i0.ɵɵlistener("click", function LightboxComponent_Template_a_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.close());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "a", 3);
            i0.ɵɵlistener("click", function LightboxComponent_Template_a_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.close());
            });
            i0.ɵɵelementStart(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "img", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("open", ctx.isOpen);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("src", ctx.currentImage, i0.ɵɵsanitizeUrl);
          }
        },
        dependencies: [i2$1.MatIcon],
        styles: [".banta-lightbox-container{position:fixed;inset:0;opacity:0;pointer-events:none;background-color:#000000bf;color:#fff;z-index:10000;transition:.25s opacity ease-in-out;display:flex;align-items:center;justify-content:center}  .banta-lightbox-container a.underlay{z-index:0;position:absolute;inset:0;opacity:0}  .banta-lightbox-container img{z-index:10;max-width:95%}  .banta-lightbox-container.open{opacity:1;pointer-events:initial}  .banta-lightbox-container a.close-button{position:absolute;top:0;right:0;padding:.75em;z-index:20}"]
      });
    }
  }
  return LightboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BANTA_SDK_OPTIONS = 'BANTA_SDK_OPTIONS';
const underline = {
  name: 'underline',
  level: 'inline',
  // Is this a block-level or inline-level tokenizer?
  start(src) {
    return src.match(/\+\+/)?.index;
  },
  // Hint to Marked.js to stop and check for a match
  tokenizer(src, tokens) {
    const rule = /^\+\+(.*?)\+\+/; // Regex for the complete token
    const match = rule.exec(src);
    if (match) {
      return {
        type: 'underline',
        // Should match "name" above
        raw: match[0],
        // Text to consume from the source
        text: this.lexer.inlineTokens(match[1].trim()) // Additional custom properties
      };
    }
  },
  renderer(token) {
    return `<u>${this.parser.parseInline(token.text)}</u>`;
  }
};
marked.marked.use({
  extensions: [underline]
});
let BantaMarkdownToHtmlPipe = /*#__PURE__*/(() => {
  class BantaMarkdownToHtmlPipe {
    constructor(sanitizer, sdkOptions) {
      this.sanitizer = sanitizer;
      this.sdkOptions = sdkOptions;
      this.renderer = new marked.Renderer();
      const linkRenderer = this.renderer.link;
      this.renderer.link = token => {
        const html = linkRenderer.call(this.renderer, token);
        return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer nofollow" ');
      };
    }
    get emojiUrl() {
      return this.sdkOptions?.emojiUrl ?? 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/';
    }
    transform(value) {
      if (!value) return '';
      let purifier = createDOMPurify(window);
      // https://github.com/cure53/DOMPurify/blob/e1c19cf6407d782b666cb1d02a6af191f9cbc09e/demos/hooks-target-blank-demo.html
      // Add a hook to make all links open a new window
      purifier.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
          node.setAttribute('target', '_blank');
          // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
          node.setAttribute('rel', 'noopener noreferrer nofollow');
        }
        // set non-HTML/MathML links to xlink:show=new
        if (!node.hasAttribute('target') && (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
          node.setAttribute('xlink:show', 'new');
        }
      });
      value = marked.marked.parse(value, {
        renderer: this.renderer
      });
      value = twemoji$1.parse(value, {
        base: this.emojiUrl
      });
      return this.sanitizer.bypassSecurityTrustHtml(purifier.sanitize(value, {
        FORBID_TAGS: ['h1', 'h2', 'h3', 'h4', 'style', 'link', 'script'],
        FORBID_ATTR: ['style'],
        KEEP_CONTENT: true
      }));
    }
    static {
      this.ɵfac = function BantaMarkdownToHtmlPipe_Factory(t) {
        return new (t || BantaMarkdownToHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16), i0.ɵɵdirectiveInject(BANTA_SDK_OPTIONS, 24));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "bantaMarkdownToHtml",
        type: BantaMarkdownToHtmlPipe,
        pure: true
      });
    }
  }
  return BantaMarkdownToHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BantaTrustResourceUrlPipe = /*#__PURE__*/(() => {
  class BantaTrustResourceUrlPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value) {
      if (!value) return undefined;
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
    static {
      this.ɵfac = function BantaTrustResourceUrlPipe_Factory(t) {
        return new (t || BantaTrustResourceUrlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "trustResourceUrl",
        type: BantaTrustResourceUrlPipe,
        pure: true
      });
    }
  }
  return BantaTrustResourceUrlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BantaMentionLinkerPipe = /*#__PURE__*/(() => {
  class BantaMentionLinkerPipe {
    transform(value, links) {
      if (!value) return '';
      if (!links) return value;
      let text = value;
      for (let i = 0, max = links.length; i < max; ++i) {
        let mention = links[i];
        text = text.replace(new RegExp(`${this.escapeRegExp(mention.text)}`, `gi`), `@{${i + 1}}`);
      }
      text = text.replace(/@\{(\d+)\}/g, (text, i) => links[i - 1] ? this.formatLink(links[i - 1]) : text);
      return text;
    }
    formatLink(link) {
      return `<a${link.external ? ` target="_blank" rel="noopener"` : ``} class="mention" href="${link.link}">${link.text}</a>`;
    }
    /**
     * https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
     */
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    static {
      this.ɵfac = function BantaMentionLinkerPipe_Factory(t) {
        return new (t || BantaMentionLinkerPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "mentionLinker",
        type: BantaMentionLinkerPipe,
        pure: true
      });
    }
  }
  return BantaMentionLinkerPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TWITTER_LOADED = false;
let BantaAttachmentComponent = /*#__PURE__*/(() => {
  class BantaAttachmentComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.loading = false;
      this.editing = false;
      this.loadingMessage = 'Please wait...';
      this.error = false;
      this.errorMessage = 'An error has occurred';
      this.removed = new Subject();
      this.activated = new Subject();
      this.loaded = new Subject();
      this._viewLoaded = false;
    }
    get attachment() {
      return this._attachment;
    }
    set attachment(value) {
      this._attachment = value;
      this.checkLoad();
      this.loadPlatformSpecific();
    }
    ngAfterViewInit() {
      this._viewLoaded = true;
      this.checkLoad();
    }
    loadTwitterWidgets() {
      if (typeof window !== 'undefined') window['twttr']?.widgets.load();
    }
    loadPlatformSpecific() {
      if (typeof window === 'undefined') return;
      if (this._attachment?.type === 'tweet') {
        if (!TWITTER_LOADED && document.querySelector('script[src="https://platform.twitter.com/widgets.js"]')) TWITTER_LOADED = true;
        if (typeof window !== 'undefined' && !TWITTER_LOADED) {
          TWITTER_LOADED = true;
          let script = document.createElement('script');
          script.src = 'https://platform.twitter.com/widgets.js';
          script.async = true;
          script.addEventListener('load', () => setTimeout(() => this.loadTwitterWidgets()));
          document.body.appendChild(script);
        } else {
          setTimeout(() => this.loadTwitterWidgets());
        }
      }
    }
    checkLoad() {
      if (!this._attachment || !this._viewLoaded || !this.elementRef?.nativeElement) return;
      if (typeof window === 'undefined') this.loaded.next();else setTimeout(() => this.loaded.next(), 250);
    }
    activate() {
      this.activated.next();
    }
    remove() {
      this.removed.next();
    }
    get isError() {
      return this.error || this.attachment?.transientState?.error;
    }
    get theErrorMessage() {
      return this.errorMessage || this.attachment?.transientState?.errorMessage;
    }
    get isLoading() {
      return this.editing && (this.loading || !this.attachment || this.attachment.transientState?.loading || !this.attachment.url);
    }
    get isImageAttachment() {
      return this.attachment?.type?.startsWith('image/');
    }
    get hasFrame() {
      if (!this.attachment) return false;
      return this.attachment.type === 'iframe' || this.attachment.type === 'card' && this.attachment.card?.player;
    }
    get frameUrl() {
      if (!this.attachment) return undefined;
      if (this.attachment.type === 'iframe') {
        return this.attachment.url;
      } else if (this.attachment.type === 'card') {
        return this.attachment.card.player;
      }
    }
    static {
      this.ɵfac = function BantaAttachmentComponent_Factory(t) {
        return new (t || BantaAttachmentComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaAttachmentComponent,
        selectors: [["banta-attachment"]],
        hostVars: 2,
        hostBindings: function BantaAttachmentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("loading", ctx.isLoading);
          }
        },
        inputs: {
          attachment: "attachment",
          loading: "loading",
          editing: "editing",
          loadingMessage: "loadingMessage",
          error: "error",
          errorMessage: "errorMessage"
        },
        outputs: {
          removed: "removed",
          activated: "activated",
          loaded: "loaded"
        },
        decls: 3,
        vars: 3,
        consts: [["type", "button", "mat-mini-fab", "", "color", "primary", "class", "remove-button", 3, "click", 4, "ngIf"], [4, "ngIf"], ["type", "button", "mat-mini-fab", "", "color", "primary", 1, "remove-button", 3, "click"], [1, "error"], ["sandbox", "allow-scripts allow-popups allow-same-origin allow-presentation", 3, "src", 4, "ngIf"], ["class", "card-attachment", "target", "_blank", 3, "href", "has-image", 4, "ngIf"], ["class", "image-attachment", "href", "javascript:;", 3, "click", 4, "ngIf"], ["class", "twitter-tweet", 4, "ngIf"], ["sandbox", "allow-scripts allow-popups allow-same-origin allow-presentation", 3, "src"], ["target", "_blank", 1, "card-attachment", 3, "href"], ["class", "thumbnail", 3, "src", 4, "ngIf"], [1, "description"], [1, "summary"], [1, "thumbnail", 3, "src"], ["href", "javascript:;", 1, "image-attachment", 3, "click"], ["alt", "Image Attachment", 3, "src"], [1, "twitter-tweet"], ["lang", "en", "dir", "ltr"], [3, "href"]],
        template: function BantaAttachmentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BantaAttachmentComponent_button_0_Template, 3, 0, "button", 0)(1, BantaAttachmentComponent_ng_container_1_Template, 5, 1, "ng-container", 1)(2, BantaAttachmentComponent_ng_container_2_Template, 3, 2, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.editing);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isError);
          }
        },
        dependencies: [i2.NgIf, i2$1.MatIcon, i3.Dir, i8.MatProgressSpinner, i6.MatMiniFabButton, BantaTrustResourceUrlPipe],
        styles: ["[_nghost-%COMP%]{position:relative;display:block}.loading[_nghost-%COMP%]{outline:1px solid #333;padding:1em 0;width:300px;text-align:center}.loading[_nghost-%COMP%]   mat-spinner[_ngcontent-%COMP%]{display:block;margin:0 auto .5em;width:fit-content}a.card-attachment[_ngcontent-%COMP%]{display:flex;align-items:flex-start;gap:1em;width:100%;border:1px solid #666;border-radius:4px;padding:1em;box-sizing:border-box;background-color:#191919;margin:1em 0}a.card-attachment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:250px;aspect-ratio:16/9;object-fit:cover;border-radius:10px}a.card-attachment.has-image[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:22px}a.card-attachment[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{min-width:0;margin:0 0 .5em;font-size:26px}a.card-attachment[_ngcontent-%COMP%]   cite[_ngcontent-%COMP%]{min-width:0;opacity:.75;margin-top:1em;display:block;font-size:80%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}a.card-attachment[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{min-width:0;width:100%}a.card-attachment[_ngcontent-%COMP%]   .summary[_ngcontent-%COMP%]{overflow-x:hidden;text-overflow:ellipsis}.remove-button[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;margin:0;z-index:1}a.image-attachment[_ngcontent-%COMP%]{width:300px;position:relative;text-align:center}a.image-attachment.with-border[_ngcontent-%COMP%]{outline:1px solid #333;padding:1em 0}a.image-attachment[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{display:block;margin:0 auto .5em;width:fit-content}a.image-attachment[_ngcontent-%COMP%]   mat-icon.error[_ngcontent-%COMP%]{display:block;font-size:48px;width:48px;height:48px;margin:0 auto .5em}a.image-attachment[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:#b76363}a.image-attachment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px;border-radius:10px;max-width:100%;max-height:20em;object-fit:cover}iframe[_ngcontent-%COMP%]{border:none;width:100%;aspect-ratio:16/9}@media (max-width: 700px){a.card-attachment[_ngcontent-%COMP%]{flex-direction:column}a.card-attachment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}}"]
      });
    }
  }
  return BantaAttachmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BantaAttachmentsComponent = /*#__PURE__*/(() => {
  class BantaAttachmentsComponent {
    constructor() {
      this.editing = false;
      this.remove = new Subject();
      this.loaded = new Subject();
      this.loadedAttachments = new WeakMap();
    }
    ngAfterViewInit() {}
    markAttachmentLoaded(attachment) {
      this.loadedAttachments.set(attachment, true);
      if (this.allAttachmentsLoaded) this.loaded.next();
    }
    isAttachmentLoaded(attachment) {
      return this.loadedAttachments.has(attachment);
    }
    get allAttachmentsLoaded() {
      return this.attachments.every(x => this.isAttachmentLoaded(x));
    }
    removeAttachment(attachment) {
      this.remove.next(attachment);
    }
    isImageAttachment(attachment) {
      if (attachment.type.startsWith('image/')) return true;
      return false;
    }
    isCardAttachment(attachment) {
      if (['card'].includes(attachment.type)) return true;
      return false;
    }
    showLightbox(image) {
      this.lightbox.open(image.url, this.attachments.filter(x => x.type === 'image/png').map(x => x.url));
    }
    get validAttachments() {
      return this.attachments.filter(x => x.type);
    }
    get inlineAttachments() {
      return this.validAttachments.filter(x => x.type !== 'card' && (x.style === 'inline' || !x.style));
    }
    get blockAttachments() {
      return this.validAttachments.filter(x => x.style === 'block' || x.type === 'card');
    }
    attachmentId(index, attachment) {
      return attachment.url;
    }
    static {
      this.ɵfac = function BantaAttachmentsComponent_Factory(t) {
        return new (t || BantaAttachmentsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaAttachmentsComponent,
        selectors: [["banta-attachments"]],
        viewQuery: function BantaAttachmentsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lightbox = _t.first);
          }
        },
        inputs: {
          attachments: "attachments",
          editing: "editing"
        },
        outputs: {
          remove: "remove",
          loaded: "loaded"
        },
        decls: 1,
        vars: 1,
        consts: [["lightbox", ""], [4, "ngIf"], [1, "block-attachments"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "inline-attachments", 3, "single", 4, "ngIf"], [3, "loaded", "removed", "activated", "attachment", "editing"], [1, "inline-attachments"]],
        template: function BantaAttachmentsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BantaAttachmentsComponent_ng_container_0_Template, 6, 3, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.attachments == null ? null : ctx.attachments.length) > 0);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, LightboxComponent, BantaAttachmentComponent],
        styles: [".block-attachments[_ngcontent-%COMP%]{display:flex;flex-direction:column}.block-attachments[_ngcontent-%COMP%]   banta-attachment[_ngcontent-%COMP%]{width:100%}.inline-attachments[_ngcontent-%COMP%]{flex-direction:row;margin-top:15px;display:flex;gap:20px;flex-wrap:wrap}"]
      });
    }
  }
  return BantaAttachmentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS$3 = [TimestampComponent, LightboxComponent, BantaMarkdownToHtmlPipe, BantaMentionLinkerPipe, BantaTrustResourceUrlPipe, BantaAttachmentComponent, BantaAttachmentsComponent];
let BantaCommonModule = /*#__PURE__*/(() => {
  class BantaCommonModule {
    static forRoot() {
      return {
        ngModule: BantaCommonModule,
        providers: [TimerPool]
      };
    }
    static {
      this.ɵfac = function BantaCommonModule_Factory(t) {
        return new (t || BantaCommonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BantaCommonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatProgressSpinnerModule, MatButtonModule]
      });
    }
  }
  return BantaCommonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const EMOJIS = {
  "grinning": {
    "keywords": ["face", "smile", "happy", "joy", ":D", "grin"],
    "char": "😀",
    "category": "people"
  },
  "grimacing": {
    "keywords": ["face", "grimace", "teeth"],
    "char": "😬",
    "category": "people"
  },
  "grin": {
    "keywords": ["face", "happy", "smile", "joy", "kawaii"],
    "char": "😁",
    "category": "people"
  },
  "joy": {
    "keywords": ["face", "cry", "tears", "weep", "happy", "happytears", "haha"],
    "char": "😂",
    "category": "people"
  },
  "smiley": {
    "keywords": ["face", "happy", "joy", "haha", ":D", ":)", "smile", "funny"],
    "char": "😃",
    "category": "people"
  },
  "smile": {
    "keywords": ["face", "happy", "joy", "funny", "haha", "laugh", "like", ":D", ":)"],
    "char": "😄",
    "category": "people"
  },
  "sweat_smile": {
    "keywords": ["face", "hot", "happy", "laugh", "sweat", "smile", "relief"],
    "char": "😅",
    "category": "people"
  },
  "laughing": {
    "keywords": ["happy", "joy", "lol", "satisfied", "haha", "face", "glad", "XD", "laugh"],
    "char": "😆",
    "category": "people"
  },
  "innocent": {
    "keywords": ["face", "angel", "heaven", "halo"],
    "char": "😇",
    "category": "people"
  },
  "wink": {
    "keywords": ["face", "happy", "mischievous", "secret", ";)", "smile"],
    "char": "😉",
    "category": "people"
  },
  "blush": {
    "keywords": ["face", "smile", "happy", "flushed", "crush", "embarrassed", "shy", "joy"],
    "char": "😊",
    "category": "people"
  },
  "slightly_smiling": {
    "keywords": ["face", "smile"],
    "char": "🙂",
    "category": "people"
  },
  "upside_down": {
    "keywords": ["face", "flipped", "silly", "smile"],
    "char": "🙃",
    "category": "people"
  },
  "relaxed": {
    "keywords": ["face", "blush", "massage", "happiness"],
    "char": "☺️",
    "category": "people"
  },
  "yum": {
    "keywords": ["happy", "joy", "tongue", "smile", "face", "silly", "yummy", "nom"],
    "char": "😋",
    "category": "people"
  },
  "relieved": {
    "keywords": ["face", "relaxed", "phew", "massage", "happiness"],
    "char": "😌",
    "category": "people"
  },
  "heart_eyes": {
    "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "crush", "heart"],
    "char": "😍",
    "category": "people"
  },
  "kissing_heart": {
    "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
    "char": "😘",
    "category": "people"
  },
  "kissing": {
    "keywords": ["love", "like", "face", "3", "valentines", "infatuation", "kiss"],
    "char": "😗",
    "category": "people"
  },
  "kissing_smiling_eyes": {
    "keywords": ["face", "affection", "valentines", "infatuation", "kiss"],
    "char": "😙",
    "category": "people"
  },
  "kissing_closed_eyes": {
    "keywords": ["face", "love", "like", "affection", "valentines", "infatuation", "kiss"],
    "char": "😚",
    "category": "people"
  },
  "stuck_out_tongue_winking_eye": {
    "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "wink", "tongue"],
    "char": "😜",
    "category": "people"
  },
  "stuck_out_tongue_closed_eyes": {
    "keywords": ["face", "prank", "playful", "mischievous", "smile", "tongue"],
    "char": "😝",
    "category": "people"
  },
  "stuck_out_tongue": {
    "keywords": ["face", "prank", "childish", "playful", "mischievous", "smile", "tongue"],
    "char": "😛",
    "category": "people"
  },
  "money_mouth": {
    "keywords": ["face", "rich", "dollar", "money"],
    "char": "🤑",
    "category": "people"
  },
  "nerd": {
    "keywords": ["face", "nerdy", "geek", "dork"],
    "char": "🤓",
    "category": "people"
  },
  "sunglasses": {
    "keywords": ["face", "cool", "smile", "summer", "beach", "sunglass"],
    "char": "😎",
    "category": "people"
  },
  "hugging": {
    "keywords": ["face", "smile", "hug"],
    "char": "🤗",
    "category": "people"
  },
  "smirk": {
    "keywords": ["face", "smile", "mean", "prank", "smug", "sarcasm"],
    "char": "😏",
    "category": "people"
  },
  "no_mouth": {
    "keywords": ["face", "hellokitty"],
    "char": "😶",
    "category": "people"
  },
  "neutral_face": {
    "keywords": ["indifference", "meh", ":|", "neutral"],
    "char": "😐",
    "category": "people"
  },
  "expressionless": {
    "keywords": ["face", "indifferent", "-_-", "meh", "deadpan"],
    "char": "😑",
    "category": "people"
  },
  "unamused": {
    "keywords": ["indifference", "bored", "straight face", "serious", "sarcasm"],
    "char": "😒",
    "category": "people"
  },
  "rolling_eyes": {
    "keywords": ["face", "eyeroll", "frustrated"],
    "char": "🙄",
    "category": "people"
  },
  "thinking": {
    "keywords": ["face", "hmmm", "think", "consider"],
    "char": "🤔",
    "category": "people"
  },
  "flushed": {
    "keywords": ["face", "blush", "shy", "flattered"],
    "char": "😳",
    "category": "people"
  },
  "disappointed": {
    "keywords": ["face", "sad", "upset", "depressed", ":("],
    "char": "😞",
    "category": "people"
  },
  "worried": {
    "keywords": ["face", "concern", "nervous", ":("],
    "char": "😟",
    "category": "people"
  },
  "angry": {
    "keywords": ["mad", "face", "annoyed", "frustrated"],
    "char": "😠",
    "category": "people"
  },
  "rage": {
    "keywords": ["angry", "mad", "hate", "despise"],
    "char": "😡",
    "category": "people"
  },
  "pensive": {
    "keywords": ["face", "sad", "depressed", "okay", "upset"],
    "char": "😔",
    "category": "people"
  },
  "confused": {
    "keywords": ["face", "indifference", "huh", "weird", "hmmm", ":/"],
    "char": "😕",
    "category": "people"
  },
  "slightly_sad": {
    "keywords": ["face", "frowning", "disappointed", "sad", "upset"],
    "char": "🙁",
    "category": "people"
  },
  "white_frowning": {
    "keywords": ["face", "sad", "upset", "frown"],
    "char": "☹",
    "category": "people"
  },
  "persevere": {
    "keywords": ["face", "sick", "no", "upset", "oops"],
    "char": "😣",
    "category": "people"
  },
  "confounded": {
    "keywords": ["face", "confused", "sick", "unwell", "oops", ":S"],
    "char": "😖",
    "category": "people"
  },
  "tired_face": {
    "keywords": ["sick", "whine", "upset", "frustrated"],
    "char": "😫",
    "category": "people"
  },
  "weary": {
    "keywords": ["face", "tired", "sleepy", "sad", "frustrated", "upset"],
    "char": "😩",
    "category": "people"
  },
  "triumph": {
    "keywords": ["face", "gas", "phew", "proud", "pride"],
    "char": "😤",
    "category": "people"
  },
  "open_mouth": {
    "keywords": ["face", "surprise", "impressed", "wow", "whoa", ":O"],
    "char": "😮",
    "category": "people"
  },
  "scream": {
    "keywords": ["face", "munch", "scared", "omg"],
    "char": "😱",
    "category": "people"
  },
  "fearful": {
    "keywords": ["face", "scared", "terrified", "nervous", "oops", "huh"],
    "char": "😨",
    "category": "people"
  },
  "cold_sweat": {
    "keywords": ["face", "nervous", "sweat"],
    "char": "😰",
    "category": "people"
  },
  "hushed": {
    "keywords": ["face", "woo", "shh"],
    "char": "😯",
    "category": "people"
  },
  "frowning": {
    "keywords": ["face", "aw", "what"],
    "char": "😦",
    "category": "people"
  },
  "anguished": {
    "keywords": ["face", "stunned", "nervous"],
    "char": "😧",
    "category": "people"
  },
  "cry": {
    "keywords": ["face", "tears", "sad", "depressed", "upset", ":'("],
    "char": "😢",
    "category": "people"
  },
  "disappointed_relieved": {
    "keywords": ["face", "phew", "sweat", "nervous"],
    "char": "😥",
    "category": "people"
  },
  "sleepy": {
    "keywords": ["face", "tired", "rest", "nap"],
    "char": "😪",
    "category": "people"
  },
  "sweat": {
    "keywords": ["face", "hot", "sad", "tired", "exercise"],
    "char": "😓",
    "category": "people"
  },
  "sob": {
    "keywords": ["face", "cry", "tears", "sad", "upset", "depressed"],
    "char": "😭",
    "category": "people"
  },
  "dizzy_face": {
    "keywords": ["spent", "unconscious", "xox", "dizzy"],
    "char": "😵",
    "category": "people"
  },
  "astonished": {
    "keywords": ["face", "xox", "surprised", "poisoned"],
    "char": "😲",
    "category": "people"
  },
  "zipper_mouth": {
    "keywords": ["face", "sealed", "zipper", "secret"],
    "char": "🤐",
    "category": "people"
  },
  "mask": {
    "keywords": ["face", "sick", "ill", "disease"],
    "char": "😷",
    "category": "people"
  },
  "thermometer_face": {
    "keywords": ["sick", "temperature", "thermometer", "cold"],
    "char": "🤒",
    "category": "people"
  },
  "bandage_face": {
    "keywords": ["injured", "clumsy", "bandage", "hurt"],
    "char": "🤕",
    "category": "people"
  },
  "sleeping": {
    "keywords": ["face", "tired", "sleepy", "night", "zzz"],
    "char": "😴",
    "category": "people"
  },
  "zzz": {
    "keywords": ["sleepy", "tired"],
    "char": "💤",
    "category": "people"
  },
  "hankey": {
    "keywords": ["poop", "shitface", "fail", "turd", "shit"],
    "char": "💩",
    "category": "people"
  },
  "smiling_imp": {
    "keywords": ["devil", "horns"],
    "char": "😈",
    "category": "people"
  },
  "imp": {
    "keywords": ["devil", "angry", "horns"],
    "char": "👿",
    "category": "people"
  },
  "japanese_ogre": {
    "keywords": ["monster", "red", "mask", "halloween", "scary", "creepy", "devil", "demon", "japanese", "ogre"],
    "char": "👹",
    "category": "people"
  },
  "japanese_goblin": {
    "keywords": ["red", "evil", "mask", "monster", "scary", "creepy", "japanese", "goblin"],
    "char": "👺",
    "category": "people"
  },
  "skull": {
    "keywords": ["dead", "skeleton", "creepy"],
    "char": "💀",
    "category": "people"
  },
  "ghost": {
    "keywords": ["halloween", "spooky", "scary"],
    "char": "👻",
    "category": "people"
  },
  "alien": {
    "keywords": ["UFO", "paul", "weird", "outer_space"],
    "char": "👽",
    "category": "people"
  },
  "robot": {
    "keywords": ["computer", "machine"],
    "char": "🤖",
    "category": "people"
  },
  "smiley_cat": {
    "keywords": ["animal", "cats", "happy", "smile"],
    "char": "😺",
    "category": "people"
  },
  "smile_cat": {
    "keywords": ["animal", "cats", "smile"],
    "char": "😸",
    "category": "people"
  },
  "joy_cat": {
    "keywords": ["animal", "cats", "haha", "happy", "tears"],
    "char": "😹",
    "category": "people"
  },
  "heart_eyes_cat": {
    "keywords": ["animal", "love", "like", "affection", "cats", "valentines", "heart"],
    "char": "😻",
    "category": "people"
  },
  "smirk_cat": {
    "keywords": ["animal", "cats", "smirk"],
    "char": "😼",
    "category": "people"
  },
  "kissing_cat": {
    "keywords": ["animal", "cats", "kiss"],
    "char": "😽",
    "category": "people"
  },
  "scream_cat": {
    "keywords": ["animal", "cats", "munch", "scared", "scream"],
    "char": "🙀",
    "category": "people"
  },
  "crying_cat_face": {
    "keywords": ["animal", "tears", "weep", "sad", "cats", "upset", "cry"],
    "char": "😿",
    "category": "people"
  },
  "pouting_cat": {
    "keywords": ["animal", "cats"],
    "char": "😾",
    "category": "people"
  },
  "raised_hands": {
    "keywords": ["gesture", "hooray", "yea", "celebration", "hands"],
    "char": "🙌",
    "category": "people"
  },
  "clap": {
    "keywords": ["hands", "praise", "applause", "congrats", "yay"],
    "char": "👏",
    "category": "people"
  },
  "wave": {
    "keywords": ["hands", "gesture", "goodbye", "solong", "farewell", "hello", "palm"],
    "char": "👋",
    "category": "people"
  },
  "+1": {
    "keywords": ["thumbsup", "yes", "awesome", "good", "agree", "accept", "cool", "hand", "like"],
    "char": "👍",
    "category": "people"
  },
  "minus1": {
    "keywords": ["thumbsdown", "no", "dislike", "hand"],
    "char": "👎",
    "category": "people"
  },
  "facepunch": {
    "keywords": ["angry", "violence", "fist", "hit", "attack", "hand"],
    "char": "👊",
    "category": "people"
  },
  "fist": {
    "keywords": ["fingers", "hand", "grasp"],
    "char": "✊",
    "category": "people"
  },
  "v": {
    "keywords": ["fingers", "ohyeah", "hand", "peace", "victory", "two"],
    "char": "✌️",
    "category": "people"
  },
  "ok_hand": {
    "keywords": ["fingers", "limbs", "perfect", "ok"],
    "char": "👌",
    "category": "people"
  },
  "hand": {
    "keywords": ["fingers", "stop", "highfive", "palm", "ban", "raised_hand"],
    "char": "✋",
    "category": "people"
  },
  "open_hands": {
    "keywords": ["fingers", "butterfly", "hands", "open"],
    "char": "👐",
    "category": "people"
  },
  "muscle": {
    "keywords": ["arm", "flex", "hand", "summer", "strong", "biceps"],
    "char": "💪",
    "category": "people"
  },
  "pray": {
    "keywords": ["please", "hope", "wish", "namaste", "highfive"],
    "char": "🙏",
    "category": "people"
  },
  "point_up": {
    "keywords": ["hand", "fingers", "direction", "up"],
    "char": "☝️",
    "category": "people"
  },
  "point_up_2": {
    "keywords": ["fingers", "hand", "direction", "up"],
    "char": "👆",
    "category": "people"
  },
  "point_down": {
    "keywords": ["fingers", "hand", "direction", "down"],
    "char": "👇",
    "category": "people"
  },
  "point_left": {
    "keywords": ["direction", "fingers", "hand", "left"],
    "char": "👈",
    "category": "people"
  },
  "point_right": {
    "keywords": ["fingers", "hand", "direction", "right"],
    "char": "👉",
    "category": "people"
  },
  "middle_finger": {
    "keywords": ["hand", "fingers", "rude"],
    "char": "🖕",
    "category": "people"
  },
  "splayed_fingers": {
    "keywords": ["hand", "fingers", "palm"],
    "char": "🖐",
    "category": "people"
  },
  "sign_of_horns": {
    "keywords": ["hand", "fingers", "evil_eye", "metal", "rock_on"],
    "char": "🤘",
    "category": "people"
  },
  "vulcan_salute": {
    "keywords": ["hand", "fingers", "spock", "star trek"],
    "char": "🖖",
    "category": "people"
  },
  "writing_hand": {
    "keywords": ["pen", "stationery", "write"],
    "char": "✍",
    "category": "people"
  },
  "nail_care": {
    "keywords": ["beauty", "manicure", "finger", "fashion", "nail"],
    "char": "💅",
    "category": "people"
  },
  "lips": {
    "keywords": ["mouth", "kiss"],
    "char": "👄",
    "category": "people"
  },
  "tongue": {
    "keywords": ["mouth", "playful"],
    "char": "👅",
    "category": "people"
  },
  "ear": {
    "keywords": ["face", "hear", "sound", "listen"],
    "char": "👂",
    "category": "people"
  },
  "nose": {
    "keywords": ["smell", "sniff"],
    "char": "👃",
    "category": "people"
  },
  "eye": {
    "keywords": ["face", "look", "see", "watch", "stare"],
    "char": "👁",
    "category": "people"
  },
  "eyes": {
    "keywords": ["look", "watch", "stalk", "peek", "see"],
    "char": "👀",
    "category": "people"
  },
  "bust_in_silhouette": {
    "keywords": ["user", "person", "human"],
    "char": "👤",
    "category": "people"
  },
  "busts_in_silhouette": {
    "keywords": ["user", "person", "human", "group", "team"],
    "char": "👥",
    "category": "people"
  },
  "speaking_head": {
    "keywords": ["user", "person", "human"],
    "char": "🗣",
    "category": "people"
  },
  "baby": {
    "keywords": ["child", "boy", "girl", "toddler"],
    "char": "👶",
    "category": "people"
  },
  "boy": {
    "keywords": ["man", "male", "guy", "teenager"],
    "char": "👦",
    "category": "people"
  },
  "girl": {
    "keywords": ["female", "woman", "teenager"],
    "char": "👧",
    "category": "people"
  },
  "man": {
    "keywords": ["mustache", "father", "dad", "guy", "classy", "sir", "moustache"],
    "char": "👨",
    "category": "people"
  },
  "woman": {
    "keywords": ["female", "girls", "lady"],
    "char": "👩",
    "category": "people"
  },
  "person_with_blond_hair": {
    "keywords": ["man", "male", "boy", "blonde", "guy", "person"],
    "char": "👱",
    "category": "people"
  },
  "older_man": {
    "keywords": ["human", "male", "men", "old", "elder", "senior"],
    "char": "👴",
    "category": "people"
  },
  "older_woman": {
    "keywords": ["human", "female", "women", "lady", "old", "elder", "senior"],
    "char": "👵",
    "category": "people"
  },
  "man_with_gua_pi_mao": {
    "keywords": ["male", "boy", "chinese"],
    "char": "👲",
    "category": "people"
  },
  "man_with_turban": {
    "keywords": ["male", "indian", "hinduism", "arabs"],
    "char": "👳",
    "category": "people"
  },
  "cop": {
    "keywords": ["man", "police", "law", "legal", "enforcement", "arrest", "911"],
    "char": "👮",
    "category": "people"
  },
  "construction_worker": {
    "keywords": ["male", "human", "wip", "guy", "build", "construction", "worker", "labor"],
    "char": "👷",
    "category": "people"
  },
  "guardsman": {
    "keywords": ["uk", "gb", "british", "male", "guy", "royal"],
    "char": "💂",
    "category": "people"
  },
  "sleuth": {
    "keywords": ["human", "spy", "detective"],
    "char": "🕵",
    "category": "people"
  },
  "santa": {
    "keywords": ["festival", "man", "male", "xmas", "father christmas"],
    "char": "🎅",
    "category": "people"
  },
  "angel": {
    "keywords": ["heaven", "wings", "halo"],
    "char": "👼",
    "category": "people"
  },
  "princess": {
    "keywords": ["girl", "woman", "female", "blond", "crown", "royal", "queen"],
    "char": "👸",
    "category": "people"
  },
  "bride_with_veil": {
    "keywords": ["couple", "marriage", "wedding", "woman", "bride"],
    "char": "👰",
    "category": "people"
  },
  "runner": {
    "keywords": ["man", "walking", "exercise", "race", "running"],
    "char": "🏃",
    "category": "people"
  },
  "walking": {
    "keywords": ["human", "feet", "steps"],
    "char": "🚶",
    "category": "people"
  },
  "dancer": {
    "keywords": ["female", "girl", "woman", "fun"],
    "char": "💃",
    "category": "people"
  },
  "dancers": {
    "keywords": ["female", "bunny", "women", "girls"],
    "char": "👯",
    "category": "people"
  },
  "couple": {
    "keywords": ["pair", "people", "human", "love", "date", "dating", "like", "affection", "valentines", "marriage"],
    "char": "👫",
    "category": "people"
  },
  "two_men_holding_hands": {
    "keywords": ["pair", "couple", "love", "like", "bromance", "friendship", "people", "human"],
    "char": "👬",
    "category": "people"
  },
  "two_women_holding_hands": {
    "keywords": ["pair", "friendship", "couple", "love", "like", "female", "people", "human"],
    "char": "👭",
    "category": "people"
  },
  "bow": {
    "keywords": ["man", "male", "boy"],
    "char": "🙇",
    "category": "people"
  },
  "information_desk_person": {
    "keywords": ["female", "girl", "woman", "human", "information"],
    "char": "💁",
    "category": "people"
  },
  "no_good": {
    "keywords": ["female", "girl", "woman", "nope"],
    "char": "🙅",
    "category": "people"
  },
  "ok_woman": {
    "keywords": ["women", "girl", "female", "pink", "human", "woman"],
    "char": "🙆",
    "category": "people"
  },
  "raising_hand": {
    "keywords": ["female", "girl", "woman"],
    "char": "🙋",
    "category": "people"
  },
  "person_with_pouting_face": {
    "keywords": ["female", "girl", "woman"],
    "char": "🙎",
    "category": "people"
  },
  "person_frowning": {
    "keywords": ["female", "girl", "woman", "sad", "depressed", "discouraged", "unhappy"],
    "char": "🙍",
    "category": "people"
  },
  "haircut": {
    "keywords": ["female", "girl", "woman"],
    "char": "💇",
    "category": "people"
  },
  "massage": {
    "keywords": ["female", "girl", "woman", "head"],
    "char": "💆",
    "category": "people"
  },
  "couple_with_heart": {
    "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
    "char": "💑",
    "category": "people"
  },
  "female_couple_with_heart": {
    "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
    "char": "👩‍❤️‍👩",
    "category": "people"
  },
  "male_couple_with_heart": {
    "keywords": ["pair", "love", "like", "affection", "human", "dating", "valentines", "marriage"],
    "char": "👨‍❤️‍👨",
    "category": "people"
  },
  "couplekiss": {
    "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
    "char": "💏",
    "category": "people"
  },
  "female_couplekiss": {
    "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
    "char": "👩‍❤️‍💋‍👩",
    "category": "people"
  },
  "male_couplekiss": {
    "keywords": ["pair", "valentines", "love", "like", "dating", "marriage"],
    "char": "👨‍❤️‍💋‍👨",
    "category": "people"
  },
  "family": {
    "keywords": ["home", "parents", "child", "mom", "dad", "father", "mother", "people", "human"],
    "char": "👪",
    "category": "people"
  },
  "family_man_woman_girl": {
    "keywords": ["home", "parents", "people", "human", "child"],
    "char": "👨‍👩‍👧",
    "category": "people"
  },
  "family_man_woman_girl_boy": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👩‍👧‍👦",
    "category": "people"
  },
  "family_man_woman_boys": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👩‍👦‍👦",
    "category": "people"
  },
  "family_man_woman_girls": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👩‍👧‍👧",
    "category": "people"
  },
  "family_women_boy": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👩‍👩‍👦",
    "category": "people"
  },
  "family_women_girl": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👩‍👩‍👧",
    "category": "people"
  },
  "family_women_girl_boy": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👩‍👩‍👧‍👦",
    "category": "people"
  },
  "family_women_boys": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👩‍👩‍👦‍👦",
    "category": "people"
  },
  "family_women_girls": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👩‍👩‍👧‍👧",
    "category": "people"
  },
  "family_men_boy": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👨‍👦",
    "category": "people"
  },
  "family_men_girl": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👨‍👧",
    "category": "people"
  },
  "family_men_girl_boy": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👨‍👧‍👦",
    "category": "people"
  },
  "family_men_boys": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👨‍👦‍👦",
    "category": "people"
  },
  "family_men_girls": {
    "keywords": ["home", "parents", "people", "human", "children"],
    "char": "👨‍👨‍👧‍👧",
    "category": "people"
  },
  "womans_clothes": {
    "keywords": ["fashion", "shopping", "female"],
    "char": "👚",
    "category": "people"
  },
  "shirt": {
    "keywords": ["fashion", "cloth", "casual", "tshirt", "tee"],
    "char": "👕",
    "category": "people"
  },
  "jeans": {
    "keywords": ["fashion", "shopping"],
    "char": "👖",
    "category": "people"
  },
  "necktie": {
    "keywords": ["shirt", "suitup", "formal", "fashion", "cloth", "business"],
    "char": "👔",
    "category": "people"
  },
  "dress": {
    "keywords": ["clothes", "fashion", "shopping"],
    "char": "👗",
    "category": "people"
  },
  "bikini": {
    "keywords": ["swimming", "female", "woman", "girl", "fashion", "beach", "summer"],
    "char": "👙",
    "category": "people"
  },
  "kimono": {
    "keywords": ["dress", "fashion", "women", "female", "japanese"],
    "char": "👘",
    "category": "people"
  },
  "lipstick": {
    "keywords": ["female", "girl", "fashion", "woman"],
    "char": "💄",
    "category": "people"
  },
  "kiss": {
    "keywords": ["face", "lips", "love", "like", "affection", "valentines"],
    "char": "💋",
    "category": "people"
  },
  "footprints": {
    "keywords": ["feet", "tracking", "walking", "beach"],
    "char": "👣",
    "category": "people"
  },
  "high_heel": {
    "keywords": ["fashion", "shoes", "female", "pumps", "stiletto"],
    "char": "👠",
    "category": "people"
  },
  "sandal": {
    "keywords": ["shoes", "fashion", "flip flops"],
    "char": "👡",
    "category": "people"
  },
  "boot": {
    "keywords": ["shoes", "fashion"],
    "char": "👢",
    "category": "people"
  },
  "mans_shoe": {
    "keywords": ["fashion", "male"],
    "char": "👞",
    "category": "people"
  },
  "athletic_shoe": {
    "keywords": ["shoes", "sports", "sneakers"],
    "char": "👟",
    "category": "people"
  },
  "womans_hat": {
    "keywords": ["fashion", "accessories", "female", "lady", "spring"],
    "char": "👒",
    "category": "people"
  },
  "tophat": {
    "keywords": ["magic", "gentleman", "classy", "circus"],
    "char": "🎩",
    "category": "people"
  },
  "helmet": {
    "keywords": ["construction", "build"],
    "char": "⛑",
    "category": "people"
  },
  "mortar_board": {
    "keywords": ["school", "college", "degree", "university", "graduation", "cap", "hat", "legal", "learn", "education"],
    "char": "🎓",
    "category": "people"
  },
  "crown": {
    "keywords": ["king", "kod", "leader", "royalty", "lord"],
    "char": "👑",
    "category": "people"
  },
  "school_satchel": {
    "keywords": ["student", "education", "bag", "backpack"],
    "char": "🎒",
    "category": "people"
  },
  "pouch": {
    "keywords": ["bag", "accessories", "shopping"],
    "char": "👝",
    "category": "people"
  },
  "purse": {
    "keywords": ["fashion", "accessories", "money", "sales", "shopping"],
    "char": "👛",
    "category": "people"
  },
  "handbag": {
    "keywords": ["fashion", "accessory", "accessories", "shopping"],
    "char": "👜",
    "category": "people"
  },
  "briefcase": {
    "keywords": ["business", "documents", "work", "law", "legal"],
    "char": "💼",
    "category": "people"
  },
  "eyeglasses": {
    "keywords": ["fashion", "accessories", "eyesight", "nerdy", "dork", "geek"],
    "char": "👓",
    "category": "people"
  },
  "dark_sunglasses": {
    "keywords": ["face", "cool", "accessories"],
    "char": "🕶",
    "category": "people"
  },
  "ring": {
    "keywords": ["wedding", "propose", "marriage", "valentines", "diamond", "fashion", "jewelry", "gem", "engagement"],
    "char": "💍",
    "category": "people"
  },
  "closed_umbrella": {
    "keywords": ["weather", "rain", "drizzle"],
    "char": "🌂",
    "category": "people"
  },
  "dog": {
    "keywords": ["animal", "friend", "nature", "woof", "puppy", "pet", "faithful"],
    "char": "🐶",
    "category": "animals_and_nature"
  },
  "cat": {
    "keywords": ["animal", "meow", "nature", "pet", "kitten"],
    "char": "🐱",
    "category": "animals_and_nature"
  },
  "mouse": {
    "keywords": ["animal", "nature", "cheese", "rodent"],
    "char": "🐭",
    "category": "animals_and_nature"
  },
  "hamster": {
    "keywords": ["animal", "nature"],
    "char": "🐹",
    "category": "animals_and_nature"
  },
  "rabbit": {
    "keywords": ["animal", "nature", "pet", "spring", "magic", "bunny"],
    "char": "🐰",
    "category": "animals_and_nature"
  },
  "bear": {
    "keywords": ["animal", "nature", "wild"],
    "char": "🐻",
    "category": "animals_and_nature"
  },
  "panda_face": {
    "keywords": ["animal", "nature", "panda"],
    "char": "🐼",
    "category": "animals_and_nature"
  },
  "koala": {
    "keywords": ["animal", "nature"],
    "char": "🐨",
    "category": "animals_and_nature"
  },
  "tiger": {
    "keywords": ["animal", "cat", "danger", "wild", "nature", "roar"],
    "char": "🐯",
    "category": "animals_and_nature"
  },
  "lion_face": {
    "keywords": ["animal", "nature"],
    "char": "🦁",
    "category": "animals_and_nature"
  },
  "cow": {
    "keywords": ["beef", "ox", "animal", "nature", "moo", "milk"],
    "char": "🐮",
    "category": "animals_and_nature"
  },
  "pig": {
    "keywords": ["animal", "oink", "nature"],
    "char": "🐷",
    "category": "animals_and_nature"
  },
  "pig_nose": {
    "keywords": ["animal", "oink"],
    "char": "🐽",
    "category": "animals_and_nature"
  },
  "frog": {
    "keywords": ["animal", "nature", "croak", "toad"],
    "char": "🐸",
    "category": "animals_and_nature"
  },
  "octopus": {
    "keywords": ["animal", "creature", "ocean", "sea", "nature", "beach"],
    "char": "🐙",
    "category": "animals_and_nature"
  },
  "monkey_face": {
    "keywords": ["animal", "nature", "circus"],
    "char": "🐵",
    "category": "animals_and_nature"
  },
  "see_no_evil": {
    "keywords": ["monkey", "animal", "nature", "haha"],
    "char": "🙈",
    "category": "animals_and_nature"
  },
  "hear_no_evil": {
    "keywords": ["animal", "monkey", "nature"],
    "char": "🙉",
    "category": "animals_and_nature"
  },
  "speak_no_evil": {
    "keywords": ["monkey", "animal", "nature", "omg"],
    "char": "🙊",
    "category": "animals_and_nature"
  },
  "monkey": {
    "keywords": ["animal", "nature", "banana", "circus"],
    "char": "🐒",
    "category": "animals_and_nature"
  },
  "chicken": {
    "keywords": ["animal", "cluck", "nature", "bird"],
    "char": "🐔",
    "category": "animals_and_nature"
  },
  "penguin": {
    "keywords": ["animal", "nature"],
    "char": "🐧",
    "category": "animals_and_nature"
  },
  "bird": {
    "keywords": ["animal", "nature", "fly", "tweet", "spring"],
    "char": "🐦",
    "category": "animals_and_nature"
  },
  "baby_chick": {
    "keywords": ["animal", "chicken", "bird"],
    "char": "🐤",
    "category": "animals_and_nature"
  },
  "hatching_chick": {
    "keywords": ["animal", "chicken", "egg", "born", "baby", "bird"],
    "char": "🐣",
    "category": "animals_and_nature"
  },
  "hatched_chick": {
    "keywords": ["animal", "chicken", "baby", "bird"],
    "char": "🐥",
    "category": "animals_and_nature"
  },
  "wolf": {
    "keywords": ["animal", "nature", "wild"],
    "char": "🐺",
    "category": "animals_and_nature"
  },
  "boar": {
    "keywords": ["animal", "nature"],
    "char": "🐗",
    "category": "animals_and_nature"
  },
  "horse": {
    "keywords": ["animal", "brown", "nature"],
    "char": "🐴",
    "category": "animals_and_nature"
  },
  "unicorn_face": {
    "keywords": ["animal", "nature", "mystical"],
    "char": "🦄",
    "category": "animals_and_nature"
  },
  "bee": {
    "keywords": ["animal", "insect", "nature", "bug", "spring", "honey"],
    "char": "🐝",
    "category": "animals_and_nature"
  },
  "bug": {
    "keywords": ["animal", "insect", "nature", "worm"],
    "char": "🐛",
    "category": "animals_and_nature"
  },
  "snail": {
    "keywords": ["slow", "animal", "shell"],
    "char": "🐌",
    "category": "animals_and_nature"
  },
  "beetle": {
    "keywords": ["animal", "insect", "nature", "ladybug"],
    "char": "🐞",
    "category": "animals_and_nature"
  },
  "ant": {
    "keywords": ["animal", "insect", "nature", "bug"],
    "char": "🐜",
    "category": "animals_and_nature"
  },
  "spider": {
    "keywords": ["animal", "arachnid"],
    "char": "🕷",
    "category": "animals_and_nature"
  },
  "scorpion": {
    "keywords": ["animal", "arachnid"],
    "char": "🦂",
    "category": "animals_and_nature"
  },
  "crab": {
    "keywords": ["animal", "crustacean"],
    "char": "🦀",
    "category": "animals_and_nature"
  },
  "snake": {
    "keywords": ["animal", "evil", "nature", "hiss", "python"],
    "char": "🐍",
    "category": "animals_and_nature"
  },
  "turtle": {
    "keywords": ["animal", "slow", "nature", "tortoise"],
    "char": "🐢",
    "category": "animals_and_nature"
  },
  "tropical_fish": {
    "keywords": ["animal", "swim", "ocean", "beach", "nemo"],
    "char": "🐠",
    "category": "animals_and_nature"
  },
  "fish": {
    "keywords": ["animal", "food", "nature"],
    "char": "🐟",
    "category": "animals_and_nature"
  },
  "blowfish": {
    "keywords": ["animal", "nature", "food", "sea", "ocean"],
    "char": "🐡",
    "category": "animals_and_nature"
  },
  "dolphin": {
    "keywords": ["animal", "nature", "fish", "sea", "ocean", "flipper", "fins", "beach"],
    "char": "🐬",
    "category": "animals_and_nature"
  },
  "whale": {
    "keywords": ["animal", "nature", "sea", "ocean"],
    "char": "🐳",
    "category": "animals_and_nature"
  },
  "whale2": {
    "keywords": ["animal", "nature", "sea", "ocean"],
    "char": "🐋",
    "category": "animals_and_nature"
  },
  "crocodile": {
    "keywords": ["animal", "nature", "reptile", "lizard", "alligator"],
    "char": "🐊",
    "category": "animals_and_nature"
  },
  "leopard": {
    "keywords": ["animal", "nature"],
    "char": "🐆",
    "category": "animals_and_nature"
  },
  "tiger2": {
    "keywords": ["animal", "nature", "roar"],
    "char": "🐅",
    "category": "animals_and_nature"
  },
  "water_buffalo": {
    "keywords": ["animal", "nature", "ox", "cow"],
    "char": "🐃",
    "category": "animals_and_nature"
  },
  "ox": {
    "keywords": ["animal", "cow", "beef"],
    "char": "🐂",
    "category": "animals_and_nature"
  },
  "cow2": {
    "keywords": ["beef", "ox", "animal", "nature", "moo", "milk"],
    "char": "🐄",
    "category": "animals_and_nature"
  },
  "dromedary_camel": {
    "keywords": ["animal", "hot", "desert", "hump"],
    "char": "🐪",
    "category": "animals_and_nature"
  },
  "camel": {
    "keywords": ["animal", "nature", "hot", "desert", "hump"],
    "char": "🐫",
    "category": "animals_and_nature"
  },
  "elephant": {
    "keywords": ["animal", "nature", "nose", "thailand", "circus"],
    "char": "🐘",
    "category": "animals_and_nature"
  },
  "goat": {
    "keywords": ["animal", "nature"],
    "char": "🐐",
    "category": "animals_and_nature"
  },
  "ram": {
    "keywords": ["animal", "sheep", "nature"],
    "char": "🐏",
    "category": "animals_and_nature"
  },
  "sheep": {
    "keywords": ["animal", "nature", "wool", "shipit"],
    "char": "🐑",
    "category": "animals_and_nature"
  },
  "racehorse": {
    "keywords": ["animal", "gamble", "luck"],
    "char": "🐎",
    "category": "animals_and_nature"
  },
  "pig2": {
    "keywords": ["animal", "nature"],
    "char": "🐖",
    "category": "animals_and_nature"
  },
  "rat": {
    "keywords": ["animal", "mouse", "rodent"],
    "char": "🐀",
    "category": "animals_and_nature"
  },
  "mouse2": {
    "keywords": ["animal", "nature", "rodent"],
    "char": "🐁",
    "category": "animals_and_nature"
  },
  "rooster": {
    "keywords": ["animal", "nature", "chicken"],
    "char": "🐓",
    "category": "animals_and_nature"
  },
  "turkey": {
    "keywords": ["animal", "bird"],
    "char": "🦃",
    "category": "animals_and_nature"
  },
  "dove_of_peace": {
    "keywords": ["animal", "bird"],
    "char": "🕊",
    "category": "animals_and_nature"
  },
  "dog2": {
    "keywords": ["animal", "nature", "friend", "doge", "pet", "faithful"],
    "char": "🐕",
    "category": "animals_and_nature"
  },
  "poodle": {
    "keywords": ["dog", "animal", "101", "nature", "pet"],
    "char": "🐩",
    "category": "animals_and_nature"
  },
  "cat2": {
    "keywords": ["animal", "meow", "pet", "cats"],
    "char": "🐈",
    "category": "animals_and_nature"
  },
  "rabbit2": {
    "keywords": ["animal", "nature", "pet", "magic", "spring"],
    "char": "🐇",
    "category": "animals_and_nature"
  },
  "chipmunk": {
    "keywords": ["animal", "nature", "rodent", "squirrel"],
    "char": "🐿",
    "category": "animals_and_nature"
  },
  "feet": {
    "keywords": ["animal", "tracking", "footprints", "dog", "cat", "pet", "paw_prints"],
    "char": "🐾",
    "category": "animals_and_nature"
  },
  "dragon": {
    "keywords": ["animal", "myth", "nature", "chinese", "green"],
    "char": "🐉",
    "category": "animals_and_nature"
  },
  "dragon_face": {
    "keywords": ["animal", "myth", "nature", "chinese", "green"],
    "char": "🐲",
    "category": "animals_and_nature"
  },
  "cactus": {
    "keywords": ["vegetable", "plant", "nature"],
    "char": "🌵",
    "category": "animals_and_nature"
  },
  "christmas_tree": {
    "keywords": ["festival", "vacation", "december", "xmas", "celebration"],
    "char": "🎄",
    "category": "animals_and_nature"
  },
  "evergreen_tree": {
    "keywords": ["plant", "nature"],
    "char": "🌲",
    "category": "animals_and_nature"
  },
  "deciduous_tree": {
    "keywords": ["plant", "nature"],
    "char": "🌳",
    "category": "animals_and_nature"
  },
  "palm_tree": {
    "keywords": ["plant", "vegetable", "nature", "summer", "beach", "mojito", "tropical"],
    "char": "🌴",
    "category": "animals_and_nature"
  },
  "seedling": {
    "keywords": ["plant", "nature", "grass", "lawn", "spring"],
    "char": "🌱",
    "category": "animals_and_nature"
  },
  "herb": {
    "keywords": ["vegetable", "plant", "medicine", "weed", "grass", "lawn"],
    "char": "🌿",
    "category": "animals_and_nature"
  },
  "shamrock": {
    "keywords": ["vegetable", "plant", "nature", "irish", "clover"],
    "char": "☘",
    "category": "animals_and_nature"
  },
  "four_leaf_clover": {
    "keywords": ["vegetable", "plant", "nature", "lucky", "irish"],
    "char": "🍀",
    "category": "animals_and_nature"
  },
  "bamboo": {
    "keywords": ["plant", "nature", "vegetable", "panda", "pine_decoration"],
    "char": "🎍",
    "category": "animals_and_nature"
  },
  "tanabata_tree": {
    "keywords": ["plant", "nature", "branch", "summer"],
    "char": "🎋",
    "category": "animals_and_nature"
  },
  "leaves": {
    "keywords": ["nature", "plant", "tree", "vegetable", "grass", "lawn", "spring"],
    "char": "🍃",
    "category": "animals_and_nature"
  },
  "fallen_leaf": {
    "keywords": ["nature", "plant", "vegetable", "leaves"],
    "char": "🍂",
    "category": "animals_and_nature"
  },
  "maple_leaf": {
    "keywords": ["nature", "plant", "vegetable", "canada", "fall"],
    "char": "🍁",
    "category": "animals_and_nature"
  },
  "ear_of_rice": {
    "keywords": ["nature", "plant"],
    "char": "🌾",
    "category": "animals_and_nature"
  },
  "hibiscus": {
    "keywords": ["plant", "vegetable", "flowers", "beach"],
    "char": "🌺",
    "category": "animals_and_nature"
  },
  "sunflower": {
    "keywords": ["nature", "plant", "fall"],
    "char": "🌻",
    "category": "animals_and_nature"
  },
  "rose": {
    "keywords": ["flowers", "valentines", "love", "spring"],
    "char": "🌹",
    "category": "animals_and_nature"
  },
  "tulip": {
    "keywords": ["flowers", "plant", "nature", "summer", "spring"],
    "char": "🌷",
    "category": "animals_and_nature"
  },
  "blossom": {
    "keywords": ["nature", "flowers", "yellow"],
    "char": "🌼",
    "category": "animals_and_nature"
  },
  "cherry_blossom": {
    "keywords": ["nature", "plant", "spring", "flower"],
    "char": "🌸",
    "category": "animals_and_nature"
  },
  "bouquet": {
    "keywords": ["flowers", "nature", "spring"],
    "char": "💐",
    "category": "animals_and_nature"
  },
  "mushroom": {
    "keywords": ["plant", "vegetable"],
    "char": "🍄",
    "category": "animals_and_nature"
  },
  "chestnut": {
    "keywords": ["food", "squirrel"],
    "char": "🌰",
    "category": "animals_and_nature"
  },
  "jack_o_lantern": {
    "keywords": ["halloween", "light", "pumpkin", "creepy", "fall"],
    "char": "🎃",
    "category": "animals_and_nature"
  },
  "shell": {
    "keywords": ["nature", "sea", "beach"],
    "char": "🐚",
    "category": "animals_and_nature"
  },
  "spider_web": {
    "keywords": ["animal", "insect", "arachnid", "silk"],
    "char": "🕸",
    "category": "animals_and_nature"
  },
  "earth_americas": {
    "keywords": ["globe", "world", "USA", "international"],
    "char": "🌎",
    "category": "animals_and_nature"
  },
  "earth_africa": {
    "keywords": ["globe", "world", "international"],
    "char": "🌍",
    "category": "animals_and_nature"
  },
  "earth_asia": {
    "keywords": ["globe", "world", "east", "international"],
    "char": "🌏",
    "category": "animals_and_nature"
  },
  "full_moon": {
    "keywords": ["nature", "yellow", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌕",
    "category": "animals_and_nature"
  },
  "waning_gibbous_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep", "waxing_gibbous_moon"],
    "char": "🌖",
    "category": "animals_and_nature"
  },
  "last_quarter_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌗",
    "category": "animals_and_nature"
  },
  "waning_crescent_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌘",
    "category": "animals_and_nature"
  },
  "new_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌑",
    "category": "animals_and_nature"
  },
  "waxing_crescent_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌒",
    "category": "animals_and_nature"
  },
  "first_quarter_moon": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌓",
    "category": "animals_and_nature"
  },
  "moon": {
    "keywords": ["nature", "night", "sky", "gray", "twilight", "planet", "space", "evening", "sleep"],
    "char": "🌔",
    "category": "animals_and_nature"
  },
  "new_moon_with_face": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌚",
    "category": "animals_and_nature"
  },
  "full_moon_with_face": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌝",
    "category": "animals_and_nature"
  },
  "first_quarter_moon_with_face": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌛",
    "category": "animals_and_nature"
  },
  "last_quarter_moon_with_face": {
    "keywords": ["nature", "twilight", "planet", "space", "night", "evening", "sleep"],
    "char": "🌜",
    "category": "animals_and_nature"
  },
  "sun_with_face": {
    "keywords": ["nature", "morning", "sky"],
    "char": "🌞",
    "category": "animals_and_nature"
  },
  "crescent_moon": {
    "keywords": ["night", "sleep", "sky", "evening", "magic"],
    "char": "🌙",
    "category": "animals_and_nature"
  },
  "star": {
    "keywords": ["night", "yellow"],
    "char": "⭐",
    "category": "animals_and_nature"
  },
  "star2": {
    "keywords": ["night", "sparkle", "awesome", "good", "magic"],
    "char": "🌟",
    "category": "animals_and_nature"
  },
  "dizzy": {
    "keywords": ["star", "sparkle", "shoot", "magic"],
    "char": "💫",
    "category": "animals_and_nature"
  },
  "sparkles": {
    "keywords": ["stars", "shine", "shiny", "cool", "awesome", "good", "magic"],
    "char": "✨",
    "category": "animals_and_nature"
  },
  "comet": {
    "keywords": ["space"],
    "char": "☄",
    "category": "animals_and_nature"
  },
  "sunny": {
    "keywords": ["weather", "nature", "brightness", "summer", "beach", "spring"],
    "char": "☀️",
    "category": "animals_and_nature"
  },
  "white_sun_with_small_cloud": {
    "keywords": ["weather"],
    "char": "🌤",
    "category": "animals_and_nature"
  },
  "partly_sunny": {
    "keywords": ["weather", "nature", "cloudy", "morning", "fall", "spring"],
    "char": "⛅",
    "category": "animals_and_nature"
  },
  "white_sun_behind_cloud": {
    "keywords": ["weather"],
    "char": "🌥",
    "category": "animals_and_nature"
  },
  "white_sun_behind_cloud_with_rain": {
    "keywords": ["weather"],
    "char": "🌦",
    "category": "animals_and_nature"
  },
  "cloud": {
    "keywords": ["weather", "sky"],
    "char": "☁️",
    "category": "animals_and_nature"
  },
  "cloud_with_rain": {
    "keywords": ["weather"],
    "char": "🌧",
    "category": "animals_and_nature"
  },
  "thunder_cloud_and_rain": {
    "keywords": ["weather", "lightning"],
    "char": "⛈",
    "category": "animals_and_nature"
  },
  "cloud_with_lightning": {
    "keywords": ["weather", "thunder"],
    "char": "🌩",
    "category": "animals_and_nature"
  },
  "zap": {
    "keywords": ["thunder", "weather", "lightning bolt", "fast"],
    "char": "⚡",
    "category": "animals_and_nature"
  },
  "fire": {
    "keywords": ["hot", "cook", "flame"],
    "char": "🔥",
    "category": "animals_and_nature"
  },
  "boom": {
    "keywords": ["bomb", "explode", "explosion", "collision", "blown"],
    "char": "💥",
    "category": "animals_and_nature"
  },
  "snowflake": {
    "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas"],
    "char": "❄️",
    "category": "animals_and_nature"
  },
  "cloud_with_snow": {
    "keywords": ["weather"],
    "char": "🌨",
    "category": "animals_and_nature"
  },
  "snowman": {
    "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen", "without_snow"],
    "char": "⛄",
    "category": "animals_and_nature"
  },
  "snowman_with_snow": {
    "keywords": ["winter", "season", "cold", "weather", "christmas", "xmas", "frozen"],
    "char": "☃",
    "category": "animals_and_nature"
  },
  "wind_blowing_face": {
    "keywords": ["gust", "air"],
    "char": "🌬",
    "category": "animals_and_nature"
  },
  "dash": {
    "keywords": ["wind", "air", "fast", "shoo", "fart", "smoke", "puff"],
    "char": "💨",
    "category": "animals_and_nature"
  },
  "cloud_with_tornado": {
    "keywords": ["weather", "cyclone", "twister"],
    "char": "🌪",
    "category": "animals_and_nature"
  },
  "fog": {
    "keywords": ["weather"],
    "char": "🌫",
    "category": "animals_and_nature"
  },
  "umbrella_without_rain": {
    "keywords": ["weather", "spring"],
    "char": "☂",
    "category": "animals_and_nature"
  },
  "umbrella": {
    "keywords": ["rainy", "weather", "spring"],
    "char": "☔",
    "category": "animals_and_nature"
  },
  "droplet": {
    "keywords": ["water", "drip", "faucet", "spring"],
    "char": "💧",
    "category": "animals_and_nature"
  },
  "sweat_drops": {
    "keywords": ["water", "drip", "oops"],
    "char": "💦",
    "category": "animals_and_nature"
  },
  "ocean": {
    "keywords": ["sea", "water", "wave", "nature", "tsunami", "disaster"],
    "char": "🌊",
    "category": "animals_and_nature"
  },
  "green_apple": {
    "keywords": ["fruit", "nature"],
    "char": "🍏",
    "category": "food_and_drink"
  },
  "apple": {
    "keywords": ["fruit", "mac", "school"],
    "char": "🍎",
    "category": "food_and_drink"
  },
  "pear": {
    "keywords": ["fruit", "nature", "food"],
    "char": "🍐",
    "category": "food_and_drink"
  },
  "tangerine": {
    "keywords": ["food", "fruit", "nature", "orange"],
    "char": "🍊",
    "category": "food_and_drink"
  },
  "lemon": {
    "keywords": ["fruit", "nature"],
    "char": "🍋",
    "category": "food_and_drink"
  },
  "banana": {
    "keywords": ["fruit", "food", "monkey"],
    "char": "🍌",
    "category": "food_and_drink"
  },
  "watermelon": {
    "keywords": ["fruit", "food", "picnic", "summer"],
    "char": "🍉",
    "category": "food_and_drink"
  },
  "grapes": {
    "keywords": ["fruit", "food", "wine"],
    "char": "🍇",
    "category": "food_and_drink"
  },
  "strawberry": {
    "keywords": ["fruit", "food", "nature"],
    "char": "🍓",
    "category": "food_and_drink"
  },
  "melon": {
    "keywords": ["fruit", "nature", "food"],
    "char": "🍈",
    "category": "food_and_drink"
  },
  "cherries": {
    "keywords": ["food", "fruit"],
    "char": "🍒",
    "category": "food_and_drink"
  },
  "peach": {
    "keywords": ["fruit", "nature", "food"],
    "char": "🍑",
    "category": "food_and_drink"
  },
  "pineapple": {
    "keywords": ["fruit", "nature", "food"],
    "char": "🍍",
    "category": "food_and_drink"
  },
  "tomato": {
    "keywords": ["fruit", "vegetable", "nature", "food"],
    "char": "🍅",
    "category": "food_and_drink"
  },
  "eggplant": {
    "keywords": ["vegetable", "nature", "food", "aubergine"],
    "char": "🍆",
    "category": "food_and_drink"
  },
  "hot_pepper": {
    "keywords": ["food", "spicy", "chilli", "chili"],
    "char": "🌶",
    "category": "food_and_drink"
  },
  "corn": {
    "keywords": ["food", "vegetable", "plant"],
    "char": "🌽",
    "category": "food_and_drink"
  },
  "sweet_potato": {
    "keywords": ["food", "nature"],
    "char": "🍠",
    "category": "food_and_drink"
  },
  "honey_pot": {
    "keywords": ["bees", "sweet", "kitchen"],
    "char": "🍯",
    "category": "food_and_drink"
  },
  "bread": {
    "keywords": ["food", "wheat", "breakfast", "toast"],
    "char": "🍞",
    "category": "food_and_drink"
  },
  "cheese_wedge": {
    "keywords": ["food", "chadder"],
    "char": "🧀",
    "category": "food_and_drink"
  },
  "poultry_leg": {
    "keywords": ["food", "meat", "drumstick", "bird", "chicken", "turkey"],
    "char": "🍗",
    "category": "food_and_drink"
  },
  "meat_on_bone": {
    "keywords": ["good", "food", "drumstick"],
    "char": "🍖",
    "category": "food_and_drink"
  },
  "fried_shrimp": {
    "keywords": ["food", "animal", "appetizer", "summer"],
    "char": "🍤",
    "category": "food_and_drink"
  },
  "egg": {
    "keywords": ["food", "breakfast", "kitchen"],
    "char": "🍳",
    "category": "food_and_drink"
  },
  "hamburger": {
    "keywords": ["meat", "fast food", "beef", "cheeseburger", "mcdonalds", "burger king"],
    "char": "🍔",
    "category": "food_and_drink"
  },
  "fries": {
    "keywords": ["chips", "snack", "fast food"],
    "char": "🍟",
    "category": "food_and_drink"
  },
  "hot_dog": {
    "keywords": ["food", "frankfurter", "hotdog"],
    "char": "🌭",
    "category": "food_and_drink"
  },
  "pizza": {
    "keywords": ["food", "party"],
    "char": "🍕",
    "category": "food_and_drink"
  },
  "spaghetti": {
    "keywords": ["food", "italian", "noodle"],
    "char": "🍝",
    "category": "food_and_drink"
  },
  "taco": {
    "keywords": ["food", "mexican"],
    "char": "🌮",
    "category": "food_and_drink"
  },
  "burrito": {
    "keywords": ["food", "mexican"],
    "char": "🌯",
    "category": "food_and_drink"
  },
  "ramen": {
    "keywords": ["food", "japanese", "noodle", "chopsticks"],
    "char": "🍜",
    "category": "food_and_drink"
  },
  "stew": {
    "keywords": ["food", "meat", "soup"],
    "char": "🍲",
    "category": "food_and_drink"
  },
  "fish_cake": {
    "keywords": ["food", "japan", "sea", "beach"],
    "char": "🍥",
    "category": "food_and_drink"
  },
  "sushi": {
    "keywords": ["food", "fish", "japanese", "rice"],
    "char": "🍣",
    "category": "food_and_drink"
  },
  "bento": {
    "keywords": ["food", "japanese", "box"],
    "char": "🍱",
    "category": "food_and_drink"
  },
  "curry": {
    "keywords": ["food", "spicy", "hot", "indian"],
    "char": "🍛",
    "category": "food_and_drink"
  },
  "rice_ball": {
    "keywords": ["food", "japanese"],
    "char": "🍙",
    "category": "food_and_drink"
  },
  "rice": {
    "keywords": ["food", "china", "asian"],
    "char": "🍚",
    "category": "food_and_drink"
  },
  "rice_cracker": {
    "keywords": ["food", "japanese"],
    "char": "🍘",
    "category": "food_and_drink"
  },
  "oden": {
    "keywords": ["food", "japanese"],
    "char": "🍢",
    "category": "food_and_drink"
  },
  "dango": {
    "keywords": ["food", "dessert", "sweet", "japanese", "barbecue", "meat"],
    "char": "🍡",
    "category": "food_and_drink"
  },
  "shaved_ice": {
    "keywords": ["hot", "dessert", "summer"],
    "char": "🍧",
    "category": "food_and_drink"
  },
  "ice_cream": {
    "keywords": ["food", "hot", "dessert"],
    "char": "🍨",
    "category": "food_and_drink"
  },
  "icecream": {
    "keywords": ["food", "hot", "dessert", "summer"],
    "char": "🍦",
    "category": "food_and_drink"
  },
  "cake": {
    "keywords": ["food", "dessert"],
    "char": "🍰",
    "category": "food_and_drink"
  },
  "birthday": {
    "keywords": ["food", "dessert", "cake"],
    "char": "🎂",
    "category": "food_and_drink"
  },
  "custard": {
    "keywords": ["dessert", "food"],
    "char": "🍮",
    "category": "food_and_drink"
  },
  "candy": {
    "keywords": ["snack", "dessert", "sweet", "lolly"],
    "char": "🍬",
    "category": "food_and_drink"
  },
  "lollipop": {
    "keywords": ["food", "snack", "candy", "sweet"],
    "char": "🍭",
    "category": "food_and_drink"
  },
  "chocolate_bar": {
    "keywords": ["food", "snack", "dessert", "sweet"],
    "char": "🍫",
    "category": "food_and_drink"
  },
  "popcorn": {
    "keywords": ["food", "movie theater", "films", "snack"],
    "char": "🍿",
    "category": "food_and_drink"
  },
  "doughnut": {
    "keywords": ["food", "dessert", "snack", "sweet", "donut"],
    "char": "🍩",
    "category": "food_and_drink"
  },
  "cookie": {
    "keywords": ["food", "snack", "oreo", "chocolate", "sweet", "dessert"],
    "char": "🍪",
    "category": "food_and_drink"
  },
  "beer": {
    "keywords": ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
    "char": "🍺",
    "category": "food_and_drink"
  },
  "beers": {
    "keywords": ["relax", "beverage", "drink", "drunk", "party", "pub", "summer", "alcohol", "booze"],
    "char": "🍻",
    "category": "food_and_drink"
  },
  "wine_glass": {
    "keywords": ["drink", "beverage", "drunk", "alcohol", "booze"],
    "char": "🍷",
    "category": "food_and_drink"
  },
  "cocktail": {
    "keywords": ["drink", "drunk", "alcohol", "beverage", "booze", "mojito"],
    "char": "🍸",
    "category": "food_and_drink"
  },
  "tropical_drink": {
    "keywords": ["beverage", "cocktail", "summer", "beach", "alcohol", "booze", "mojito"],
    "char": "🍹",
    "category": "food_and_drink"
  },
  "bottle": {
    "keywords": ["drink", "wine", "champagne"],
    "char": "🍾",
    "category": "food_and_drink"
  },
  "sake": {
    "keywords": ["wine", "drink", "drunk", "beverage", "japanese", "alcohol", "booze"],
    "char": "🍶",
    "category": "food_and_drink"
  },
  "tea": {
    "keywords": ["drink", "bowl", "breakfast", "green", "british"],
    "char": "🍵",
    "category": "food_and_drink"
  },
  "coffee": {
    "keywords": ["beverage", "caffeine", "latte", "espresso"],
    "char": "☕",
    "category": "food_and_drink"
  },
  "baby_bottle": {
    "keywords": ["food", "container", "milk"],
    "char": "🍼",
    "category": "food_and_drink"
  },
  "fork_and_knife": {
    "keywords": ["cutlery", "kitchen"],
    "char": "🍴",
    "category": "food_and_drink"
  },
  "fork_and_knife_with_plate": {
    "keywords": ["food", "eat", "meal", "lunch", "dinner", "restaurant"],
    "char": "🍽",
    "category": "food_and_drink"
  },
  "soccer": {
    "keywords": ["sports", "football"],
    "char": "⚽",
    "category": "activity"
  },
  "basketball": {
    "keywords": ["sports", "balls", "NBA"],
    "char": "🏀",
    "category": "activity"
  },
  "football": {
    "keywords": ["sports", "balls", "NFL"],
    "char": "🏈",
    "category": "activity"
  },
  "baseball": {
    "keywords": ["sports", "balls"],
    "char": "⚾",
    "category": "activity"
  },
  "tennis": {
    "keywords": ["sports", "balls", "green"],
    "char": "🎾",
    "category": "activity"
  },
  "volleyball": {
    "keywords": ["sports", "balls"],
    "char": "🏐",
    "category": "activity"
  },
  "rugby_football": {
    "keywords": ["sports", "team"],
    "char": "🏉",
    "category": "activity"
  },
  "8ball": {
    "keywords": ["pool", "hobby", "game", "luck", "magic"],
    "char": "🎱",
    "category": "activity"
  },
  "golf": {
    "keywords": ["sports", "business", "flag", "hole", "summer"],
    "char": "⛳",
    "category": "activity"
  },
  "golfer": {
    "keywords": ["sports", "business"],
    "char": "🏌",
    "category": "activity"
  },
  "table_tennis": {
    "keywords": ["sports", "pingpong"],
    "char": "🏓",
    "category": "activity"
  },
  "badminton": {
    "keywords": ["sports"],
    "char": "🏸",
    "category": "activity"
  },
  "ice_hockey": {
    "keywords": ["sports"],
    "char": "🏒",
    "category": "activity"
  },
  "field_hockey": {
    "keywords": ["sports"],
    "char": "🏑",
    "category": "activity"
  },
  "cricket": {
    "keywords": ["sports"],
    "char": "🏏",
    "category": "activity"
  },
  "ski": {
    "keywords": ["sports", "winter", "cold", "snow"],
    "char": "🎿",
    "category": "activity"
  },
  "skier": {
    "keywords": ["sports", "winter", "snow"],
    "char": "⛷",
    "category": "activity"
  },
  "snowboarder": {
    "keywords": ["sports", "winter"],
    "char": "🏂",
    "category": "activity"
  },
  "ice_skate": {
    "keywords": ["sports"],
    "char": "⛸",
    "category": "activity"
  },
  "bow_and_arrow": {
    "keywords": ["sports"],
    "char": "🏹",
    "category": "activity"
  },
  "fishing_pole_and_fish": {
    "keywords": ["food", "hobby", "summer"],
    "char": "🎣",
    "category": "activity"
  },
  "rowboat": {
    "keywords": ["sports", "hobby", "water", "ship"],
    "char": "🚣",
    "category": "activity"
  },
  "swimmer": {
    "keywords": ["sports", "exercise", "human", "athlete", "water", "summer"],
    "char": "🏊",
    "category": "activity"
  },
  "surfer": {
    "keywords": ["sports", "ocean", "sea", "summer", "beach"],
    "char": "🏄",
    "category": "activity"
  },
  "bath": {
    "keywords": ["clean", "shower", "bathroom"],
    "char": "🛀",
    "category": "activity"
  },
  "person_with_ball": {
    "keywords": ["sports", "human"],
    "char": "⛹",
    "category": "activity"
  },
  "weight_lifter": {
    "keywords": ["sports", "training", "exercise"],
    "char": "🏋",
    "category": "activity"
  },
  "bicyclist": {
    "keywords": ["sports", "bike", "exercise", "hipster"],
    "char": "🚴",
    "category": "activity"
  },
  "mountain_bicyclist": {
    "keywords": ["transportation", "sports", "human", "race", "bike"],
    "char": "🚵",
    "category": "activity"
  },
  "horse_racing": {
    "keywords": ["animal", "betting", "competition", "gambling", "luck"],
    "char": "🏇",
    "category": "activity"
  },
  "man_levitating": {
    "keywords": ["suit", "business", "levitate", "hover", "jump"],
    "char": "🕴",
    "category": "activity"
  },
  "trophy": {
    "keywords": ["win", "award", "contest", "place", "ftw", "ceremony"],
    "char": "🏆",
    "category": "activity"
  },
  "running_shirt_with_sash": {
    "keywords": ["play", "pageant"],
    "char": "🎽",
    "category": "activity"
  },
  "sports_medal": {
    "keywords": ["award", "winning"],
    "char": "🏅",
    "category": "activity"
  },
  "military_medal": {
    "keywords": ["award", "winning", "army"],
    "char": "🎖",
    "category": "activity"
  },
  "reminder_ribbon": {
    "keywords": ["sports", "cause", "support", "awareness"],
    "char": "🎗",
    "category": "activity"
  },
  "rosette": {
    "keywords": ["flower", "decoration", "military"],
    "char": "🏵",
    "category": "activity"
  },
  "ticket": {
    "keywords": ["event", "concert", "pass"],
    "char": "🎫",
    "category": "activity"
  },
  "admission_ticket": {
    "keywords": ["sports", "concert", "entrance"],
    "char": "🎟",
    "category": "activity"
  },
  "performing_arts": {
    "keywords": ["acting", "theater", "drama"],
    "char": "🎭",
    "category": "activity"
  },
  "art": {
    "keywords": ["design", "paint", "draw", "colors"],
    "char": "🎨",
    "category": "activity"
  },
  "circus_tent": {
    "keywords": ["festival", "carnival", "party"],
    "char": "🎪",
    "category": "activity"
  },
  "microphone": {
    "keywords": ["sound", "music", "PA"],
    "char": "🎤",
    "category": "activity"
  },
  "headphones": {
    "keywords": ["music", "score", "gadgets"],
    "char": "🎧",
    "category": "activity"
  },
  "musical_score": {
    "keywords": ["treble", "clef"],
    "char": "🎼",
    "category": "activity"
  },
  "musical_keyboard": {
    "keywords": ["piano", "instrument"],
    "char": "🎹",
    "category": "activity"
  },
  "saxophone": {
    "keywords": ["music", "instrument", "jazz", "blues"],
    "char": "🎷",
    "category": "activity"
  },
  "trumpet": {
    "keywords": ["music", "brass"],
    "char": "🎺",
    "category": "activity"
  },
  "guitar": {
    "keywords": ["music", "instrument"],
    "char": "🎸",
    "category": "activity"
  },
  "violin": {
    "keywords": ["music", "instrument", "orchestra", "symphony"],
    "char": "🎻",
    "category": "activity"
  },
  "clapper": {
    "keywords": ["movie", "film", "record"],
    "char": "🎬",
    "category": "activity"
  },
  "video_game": {
    "keywords": ["play", "console", "PS4", "controller"],
    "char": "🎮",
    "category": "activity"
  },
  "space_invader": {
    "keywords": ["game", "arcade", "play"],
    "char": "👾",
    "category": "activity"
  },
  "dart": {
    "keywords": ["game", "play", "bar"],
    "char": "🎯",
    "category": "activity"
  },
  "game_die": {
    "keywords": ["dice", "random", "tabletop", "play", "luck"],
    "char": "🎲",
    "category": "activity"
  },
  "slot_machine": {
    "keywords": ["bet", "gamble", "vegas", "fruit machine", "luck", "casino"],
    "char": "🎰",
    "category": "activity"
  },
  "bowling": {
    "keywords": ["sports", "fun", "play"],
    "char": "🎳",
    "category": "activity"
  },
  "car": {
    "keywords": ["red", "transportation", "vehicle"],
    "char": "🚗",
    "category": "travel_and_places"
  },
  "taxi": {
    "keywords": ["uber", "vehicle", "cars", "transportation"],
    "char": "🚕",
    "category": "travel_and_places"
  },
  "blue_car": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚙",
    "category": "travel_and_places"
  },
  "bus": {
    "keywords": ["car", "vehicle", "transportation"],
    "char": "🚌",
    "category": "travel_and_places"
  },
  "trolleybus": {
    "keywords": ["bart", "transportation", "vehicle"],
    "char": "🚎",
    "category": "travel_and_places"
  },
  "racing_car": {
    "keywords": ["sports", "race", "fast", "formula", "f1"],
    "char": "🏎",
    "category": "travel_and_places"
  },
  "police_car": {
    "keywords": ["vehicle", "cars", "transportation", "law", "legal", "enforcement"],
    "char": "🚓",
    "category": "travel_and_places"
  },
  "ambulance": {
    "keywords": ["health", "911", "hospital"],
    "char": "🚑",
    "category": "travel_and_places"
  },
  "fire_engine": {
    "keywords": ["transportation", "cars", "vehicle"],
    "char": "🚒",
    "category": "travel_and_places"
  },
  "minibus": {
    "keywords": ["vehicle", "car", "transportation"],
    "char": "🚐",
    "category": "travel_and_places"
  },
  "truck": {
    "keywords": ["cars", "transportation"],
    "char": "🚚",
    "category": "travel_and_places"
  },
  "articulated_lorry": {
    "keywords": ["vehicle", "cars", "transportation", "express"],
    "char": "🚛",
    "category": "travel_and_places"
  },
  "tractor": {
    "keywords": ["vehicle", "car", "farming", "agriculture"],
    "char": "🚜",
    "category": "travel_and_places"
  },
  "racing_motorcycle": {
    "keywords": ["race", "sports", "fast"],
    "char": "🏍",
    "category": "travel_and_places"
  },
  "bike": {
    "keywords": ["sports", "bicycle", "exercise", "hipster"],
    "char": "🚲",
    "category": "travel_and_places"
  },
  "rotating_light": {
    "keywords": ["police", "ambulance", "911", "emergency", "alert", "error", "pinged", "law", "legal"],
    "char": "🚨",
    "category": "travel_and_places"
  },
  "oncoming_police_car": {
    "keywords": ["vehicle", "law", "legal", "enforcement", "911"],
    "char": "🚔",
    "category": "travel_and_places"
  },
  "oncoming_bus": {
    "keywords": ["vehicle", "transportation"],
    "char": "🚍",
    "category": "travel_and_places"
  },
  "oncoming_automobile": {
    "keywords": ["car", "vehicle", "transportation"],
    "char": "🚘",
    "category": "travel_and_places"
  },
  "oncoming_taxi": {
    "keywords": ["vehicle", "cars", "uber"],
    "char": "🚖",
    "category": "travel_and_places"
  },
  "aerial_tramway": {
    "keywords": ["transportation", "vehicle", "ski"],
    "char": "🚡",
    "category": "travel_and_places"
  },
  "mountain_cableway": {
    "keywords": ["transportation", "vehicle", "ski"],
    "char": "🚠",
    "category": "travel_and_places"
  },
  "suspension_railway": {
    "keywords": ["vehicle", "transportation"],
    "char": "🚟",
    "category": "travel_and_places"
  },
  "railway_car": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚃",
    "category": "travel_and_places"
  },
  "train": {
    "keywords": ["transportation", "vehicle", "carriage", "public", "travel"],
    "char": "🚋",
    "category": "travel_and_places"
  },
  "monorail": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚝",
    "category": "travel_and_places"
  },
  "bullettrain_side": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚄",
    "category": "travel_and_places"
  },
  "bullettrain_front": {
    "keywords": ["transportation", "vehicle", "speed", "fast", "public", "travel"],
    "char": "🚅",
    "category": "travel_and_places"
  },
  "light_rail": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚈",
    "category": "travel_and_places"
  },
  "mountain_railway": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚞",
    "category": "travel_and_places"
  },
  "steam_locomotive": {
    "keywords": ["transportation", "vehicle", "train"],
    "char": "🚂",
    "category": "travel_and_places"
  },
  "train2": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚆",
    "category": "travel_and_places"
  },
  "metro": {
    "keywords": ["transportation", "blue-square", "mrt", "underground", "tube"],
    "char": "🚇",
    "category": "travel_and_places"
  },
  "tram": {
    "keywords": ["transportation", "vehicle"],
    "char": "🚊",
    "category": "travel_and_places"
  },
  "station": {
    "keywords": ["transportation", "vehicle", "public"],
    "char": "🚉",
    "category": "travel_and_places"
  },
  "helicopter": {
    "keywords": ["transportation", "vehicle", "fly"],
    "char": "🚁",
    "category": "travel_and_places"
  },
  "small_airplane": {
    "keywords": ["flight", "transportation", "fly", "vehicle"],
    "char": "🛩",
    "category": "travel_and_places"
  },
  "airplane": {
    "keywords": ["vehicle", "transportation", "flight", "fly"],
    "char": "✈️",
    "category": "travel_and_places"
  },
  "airplane_departure": {
    "keywords": ["airport", "flight", "landing"],
    "char": "🛫",
    "category": "travel_and_places"
  },
  "airplane_arrival": {
    "keywords": ["airport", "flight", "boarding"],
    "char": "🛬",
    "category": "travel_and_places"
  },
  "boat": {
    "keywords": ["ship", "summer", "transportation", "water", "sailing", "sailboat"],
    "char": "⛵",
    "category": "travel_and_places"
  },
  "motor_boat": {
    "keywords": ["ship"],
    "char": "🛥",
    "category": "travel_and_places"
  },
  "speedboat": {
    "keywords": ["ship", "transportation", "vehicle", "summer"],
    "char": "🚤",
    "category": "travel_and_places"
  },
  "ferry": {
    "keywords": ["boat", "ship", "yacht"],
    "char": "⛴",
    "category": "travel_and_places"
  },
  "passenger_ship": {
    "keywords": ["yacht", "cruise", "ferry"],
    "char": "🛳",
    "category": "travel_and_places"
  },
  "rocket": {
    "keywords": ["launch", "ship", "staffmode", "NASA", "outer space", "outer_space", "fly"],
    "char": "🚀",
    "category": "travel_and_places"
  },
  "artificial_satellite": {
    "keywords": ["communication", "gps", "orbit", "spaceflight", "NASA", "ISS"],
    "char": "🛰",
    "category": "travel_and_places"
  },
  "seat": {
    "keywords": ["sit", "airplane", "transport", "bus", "flight", "fly"],
    "char": "💺",
    "category": "travel_and_places"
  },
  "anchor": {
    "keywords": ["ship", "ferry", "sea", "boat"],
    "char": "⚓",
    "category": "travel_and_places"
  },
  "construction": {
    "keywords": ["wip", "progress", "caution", "warning"],
    "char": "🚧",
    "category": "travel_and_places"
  },
  "fuelpump": {
    "keywords": ["gas station", "petroleum"],
    "char": "⛽",
    "category": "travel_and_places"
  },
  "busstop": {
    "keywords": ["transportation", "wait"],
    "char": "🚏",
    "category": "travel_and_places"
  },
  "vertical_traffic_light": {
    "keywords": ["transportation", "driving"],
    "char": "🚦",
    "category": "travel_and_places"
  },
  "traffic_light": {
    "keywords": ["transportation", "signal"],
    "char": "🚥",
    "category": "travel_and_places"
  },
  "checkered_flag": {
    "keywords": ["contest", "finishline", "race", "gokart"],
    "char": "🏁",
    "category": "travel_and_places"
  },
  "ship": {
    "keywords": ["transportation", "titanic", "deploy"],
    "char": "🚢",
    "category": "travel_and_places"
  },
  "ferris_wheel": {
    "keywords": ["photo", "carnival", "londoneye"],
    "char": "🎡",
    "category": "travel_and_places"
  },
  "roller_coaster": {
    "keywords": ["carnival", "playground", "photo", "fun"],
    "char": "🎢",
    "category": "travel_and_places"
  },
  "carousel_horse": {
    "keywords": ["photo", "carnival"],
    "char": "🎠",
    "category": "travel_and_places"
  },
  "building_construction": {
    "keywords": ["wip", "working", "progress"],
    "char": "🏗",
    "category": "travel_and_places"
  },
  "foggy": {
    "keywords": ["photo", "mountain"],
    "char": "🌁",
    "category": "travel_and_places"
  },
  "tokyo_tower": {
    "keywords": ["photo", "japanese"],
    "char": "🗼",
    "category": "travel_and_places"
  },
  "factory": {
    "keywords": ["building", "industry", "pollution", "smoke"],
    "char": "🏭",
    "category": "travel_and_places"
  },
  "fountain": {
    "keywords": ["photo", "summer", "water", "fresh"],
    "char": "⛲",
    "category": "travel_and_places"
  },
  "rice_scene": {
    "keywords": ["photo", "japan", "asia", "tsukimi"],
    "char": "🎑",
    "category": "travel_and_places"
  },
  "mountain": {
    "keywords": ["photo", "nature", "environment"],
    "char": "⛰",
    "category": "travel_and_places"
  },
  "snow_capped_mountain": {
    "keywords": ["photo", "nature", "environment", "winter", "cold"],
    "char": "🏔",
    "category": "travel_and_places"
  },
  "mount_fuji": {
    "keywords": ["photo", "mountain", "nature", "japanese"],
    "char": "🗻",
    "category": "travel_and_places"
  },
  "volcano": {
    "keywords": ["photo", "nature", "disaster"],
    "char": "🌋",
    "category": "travel_and_places"
  },
  "japan": {
    "keywords": ["nation", "country", "japanese", "asia"],
    "char": "🗾",
    "category": "travel_and_places"
  },
  "camping": {
    "keywords": ["photo", "outdoors", "tent"],
    "char": "🏕",
    "category": "travel_and_places"
  },
  "tent": {
    "keywords": ["photo", "camping", "outdoors"],
    "char": "⛺",
    "category": "travel_and_places"
  },
  "national_park": {
    "keywords": ["photo", "environment", "nature"],
    "char": "🏞",
    "category": "travel_and_places"
  },
  "motorway": {
    "keywords": ["road", "cupertino", "interstate", "highway"],
    "char": "🛣",
    "category": "travel_and_places"
  },
  "railway_track": {
    "keywords": ["train", "transportation"],
    "char": "🛤",
    "category": "travel_and_places"
  },
  "sunrise": {
    "keywords": ["morning", "view", "vacation", "photo"],
    "char": "🌅",
    "category": "travel_and_places"
  },
  "sunrise_over_mountains": {
    "keywords": ["view", "vacation", "photo"],
    "char": "🌄",
    "category": "travel_and_places"
  },
  "desert": {
    "keywords": ["photo", "warm", "saharah"],
    "char": "🏜",
    "category": "travel_and_places"
  },
  "beach_with_umbrella": {
    "keywords": ["weather", "summer", "sunny", "sand", "mojito"],
    "char": "🏖",
    "category": "travel_and_places"
  },
  "desert_island": {
    "keywords": ["photo", "tropical", "mojito"],
    "char": "🏝",
    "category": "travel_and_places"
  },
  "city_sunrise": {
    "keywords": ["photo", "good morning", "dawn"],
    "char": "🌇",
    "category": "travel_and_places"
  },
  "city_sunset": {
    "keywords": ["photo", "evening", "sky", "buildings"],
    "char": "🌆",
    "category": "travel_and_places"
  },
  "cityscape": {
    "keywords": ["photo", "night life", "urban"],
    "char": "🏙",
    "category": "travel_and_places"
  },
  "night_with_stars": {
    "keywords": ["evening", "city", "downtown"],
    "char": "🌃",
    "category": "travel_and_places"
  },
  "bridge_at_night": {
    "keywords": ["photo", "sanfrancisco"],
    "char": "🌉",
    "category": "travel_and_places"
  },
  "milky_way": {
    "keywords": ["photo", "space", "stars"],
    "char": "🌌",
    "category": "travel_and_places"
  },
  "stars": {
    "keywords": ["night", "photo"],
    "char": "🌠",
    "category": "travel_and_places"
  },
  "sparkler": {
    "keywords": ["stars", "night", "shine"],
    "char": "🎇",
    "category": "travel_and_places"
  },
  "fireworks": {
    "keywords": ["photo", "festival", "carnival", "congratulations"],
    "char": "🎆",
    "category": "travel_and_places"
  },
  "rainbow": {
    "keywords": ["nature", "happy", "unicorn", "photo", "sky", "spring"],
    "char": "🌈",
    "category": "travel_and_places"
  },
  "buildings": {
    "keywords": ["houses", "photo"],
    "char": "🏘",
    "category": "travel_and_places"
  },
  "european_castle": {
    "keywords": ["building", "royalty", "history"],
    "char": "🏰",
    "category": "travel_and_places"
  },
  "japanese_castle": {
    "keywords": ["photo", "building"],
    "char": "🏯",
    "category": "travel_and_places"
  },
  "stadium": {
    "keywords": ["photo", "place", "sports", "concert", "venue"],
    "char": "🏟",
    "category": "travel_and_places"
  },
  "statue_of_liberty": {
    "keywords": ["american", "newyork"],
    "char": "🗽",
    "category": "travel_and_places"
  },
  "house": {
    "keywords": ["building", "home"],
    "char": "🏠",
    "category": "travel_and_places"
  },
  "house_with_garden": {
    "keywords": ["home", "plant", "nature"],
    "char": "🏡",
    "category": "travel_and_places"
  },
  "derelict_house": {
    "keywords": ["abandon", "evict", "broken", "building"],
    "char": "🏚",
    "category": "travel_and_places"
  },
  "office": {
    "keywords": ["building", "bureau", "work"],
    "char": "🏢",
    "category": "travel_and_places"
  },
  "department_store": {
    "keywords": ["building", "shopping", "mall"],
    "char": "🏬",
    "category": "travel_and_places"
  },
  "post_office": {
    "keywords": ["building", "email", "communication"],
    "char": "🏣",
    "category": "travel_and_places"
  },
  "european_post_office": {
    "keywords": ["building", "email"],
    "char": "🏤",
    "category": "travel_and_places"
  },
  "hospital": {
    "keywords": ["building", "health", "surgery", "doctor"],
    "char": "🏥",
    "category": "travel_and_places"
  },
  "bank": {
    "keywords": ["building", "money", "sales", "cash", "business", "enterprise"],
    "char": "🏦",
    "category": "travel_and_places"
  },
  "hotel": {
    "keywords": ["building", "accomodation", "checkin"],
    "char": "🏨",
    "category": "travel_and_places"
  },
  "convenience_store": {
    "keywords": ["building", "shopping", "groceries"],
    "char": "🏪",
    "category": "travel_and_places"
  },
  "school": {
    "keywords": ["building", "student", "education", "learn", "teach"],
    "char": "🏫",
    "category": "travel_and_places"
  },
  "love_hotel": {
    "keywords": ["like", "affection", "dating"],
    "char": "🏩",
    "category": "travel_and_places"
  },
  "wedding": {
    "keywords": ["love", "like", "affection", "couple", "marriage", "bride", "groom"],
    "char": "💒",
    "category": "travel_and_places"
  },
  "museum": {
    "keywords": ["art", "culture", "history"],
    "char": "🏛",
    "category": "travel_and_places"
  },
  "church": {
    "keywords": ["building", "religion", "christ"],
    "char": "⛪",
    "category": "travel_and_places"
  },
  "mosque": {
    "keywords": ["islam", "worship", "minaret"],
    "char": "🕌",
    "category": "travel_and_places"
  },
  "synagogue": {
    "keywords": ["judaism", "worship", "temple", "jewish"],
    "char": "🕍",
    "category": "travel_and_places"
  },
  "kaaba": {
    "keywords": ["mecca", "mosque", "islam"],
    "char": "🕋",
    "category": "travel_and_places"
  },
  "shinto_shrine": {
    "keywords": ["temple", "japan", "kyoto"],
    "char": "⛩",
    "category": "travel_and_places"
  },
  "watch": {
    "keywords": ["time", "accessories"],
    "char": "⌚",
    "category": "objects"
  },
  "iphone": {
    "keywords": ["technology", "apple", "gadgets", "dial"],
    "char": "📱",
    "category": "objects"
  },
  "calling": {
    "keywords": ["iphone", "incoming"],
    "char": "📲",
    "category": "objects"
  },
  "computer": {
    "keywords": ["technology", "laptop", "screen", "display", "monitor"],
    "char": "💻",
    "category": "objects"
  },
  "keyboard": {
    "keywords": ["technology", "computer", "type", "input", "text"],
    "char": "⌨",
    "category": "objects"
  },
  "desktop_computer": {
    "keywords": ["technology", "computing", "screen"],
    "char": "🖥",
    "category": "objects"
  },
  "printer": {
    "keywords": ["paper", "ink"],
    "char": "🖨",
    "category": "objects"
  },
  "three_button_mouse": {
    "keywords": ["click"],
    "char": "🖱",
    "category": "objects"
  },
  "trackball": {
    "keywords": ["technology", "trackpad"],
    "char": "🖲",
    "category": "objects"
  },
  "joystick": {
    "keywords": ["game", "play"],
    "char": "🕹",
    "category": "objects"
  },
  "compression": {
    "keywords": ["tool"],
    "char": "🗜",
    "category": "objects"
  },
  "minidisc": {
    "keywords": ["technology", "record", "data", "disk", "90s"],
    "char": "💽",
    "category": "objects"
  },
  "floppy_disk": {
    "keywords": ["oldschool", "technology", "save", "90s", "80s"],
    "char": "💾",
    "category": "objects"
  },
  "cd": {
    "keywords": ["technology", "dvd", "disk", "disc", "90s"],
    "char": "💿",
    "category": "objects"
  },
  "dvd": {
    "keywords": ["cd", "disk", "disc"],
    "char": "📀",
    "category": "objects"
  },
  "vhs": {
    "keywords": ["record", "video", "oldschool", "90s", "80s"],
    "char": "📼",
    "category": "objects"
  },
  "camera": {
    "keywords": ["gadgets", "photography"],
    "char": "📷",
    "category": "objects"
  },
  "camera_with_flash": {
    "keywords": ["photography", "gadgets"],
    "char": "📸",
    "category": "objects"
  },
  "video_camera": {
    "keywords": ["film", "record"],
    "char": "📹",
    "category": "objects"
  },
  "movie_camera": {
    "keywords": ["film", "record"],
    "char": "🎥",
    "category": "objects"
  },
  "film_projector": {
    "keywords": ["video", "tape", "record", "movie"],
    "char": "📽",
    "category": "objects"
  },
  "film_frames": {
    "keywords": ["movie"],
    "char": "🎞",
    "category": "objects"
  },
  "telephone_receiver": {
    "keywords": ["technology", "communication", "dial"],
    "char": "📞",
    "category": "objects"
  },
  "phone": {
    "keywords": ["technology", "communication", "dial", "telephone"],
    "char": "☎️",
    "category": "objects"
  },
  "pager": {
    "keywords": ["bbcall", "oldschool", "90s"],
    "char": "📟",
    "category": "objects"
  },
  "fax": {
    "keywords": ["communication", "technology"],
    "char": "📠",
    "category": "objects"
  },
  "tv": {
    "keywords": ["technology", "program", "oldschool", "show", "television"],
    "char": "📺",
    "category": "objects"
  },
  "radio": {
    "keywords": ["communication", "music", "podcast", "program"],
    "char": "📻",
    "category": "objects"
  },
  "studio_microphone": {
    "keywords": ["singer", "recording", "artist"],
    "char": "🎙",
    "category": "objects"
  },
  "level_slider": {
    "keywords": ["scale"],
    "char": "🎚",
    "category": "objects"
  },
  "control_knobs": {
    "keywords": ["dial"],
    "char": "🎛",
    "category": "objects"
  },
  "stopwatch": {
    "keywords": ["time", "deadline"],
    "char": "⏱",
    "category": "objects"
  },
  "timer_clock": {
    "keywords": ["alarm"],
    "char": "⏲",
    "category": "objects"
  },
  "alarm_clock": {
    "keywords": ["time", "wake"],
    "char": "⏰",
    "category": "objects"
  },
  "mantelpiece_clock": {
    "keywords": ["time"],
    "char": "🕰",
    "category": "objects"
  },
  "hourglass_flowing_sand": {
    "keywords": ["oldschool", "time", "countdown"],
    "char": "⏳",
    "category": "objects"
  },
  "hourglass": {
    "keywords": ["time", "clock", "oldschool", "limit", "exam", "quiz", "test"],
    "char": "⌛",
    "category": "objects"
  },
  "satellite": {
    "keywords": ["communication", "future", "radio", "space"],
    "char": "📡",
    "category": "objects"
  },
  "battery": {
    "keywords": ["power", "energy", "sustain"],
    "char": "🔋",
    "category": "objects"
  },
  "electric_plug": {
    "keywords": ["charger", "power"],
    "char": "🔌",
    "category": "objects"
  },
  "bulb": {
    "keywords": ["light", "electricity", "idea"],
    "char": "💡",
    "category": "objects"
  },
  "flashlight": {
    "keywords": ["dark", "camping", "sight", "night"],
    "char": "🔦",
    "category": "objects"
  },
  "candle": {
    "keywords": ["fire", "wax"],
    "char": "🕯",
    "category": "objects"
  },
  "wastebasket": {
    "keywords": ["bin", "trash", "rubbish", "garbage", "toss"],
    "char": "🗑",
    "category": "objects"
  },
  "oil_drum": {
    "keywords": ["barrell"],
    "char": "🛢",
    "category": "objects"
  },
  "money_with_wings": {
    "keywords": ["dollar", "bills", "payment", "sale"],
    "char": "💸",
    "category": "objects"
  },
  "dollar": {
    "keywords": ["money", "sales", "bill", "currency"],
    "char": "💵",
    "category": "objects"
  },
  "yen": {
    "keywords": ["money", "sales", "japanese", "dollar", "currency"],
    "char": "💴",
    "category": "objects"
  },
  "euro": {
    "keywords": ["money", "sales", "dollar", "currency"],
    "char": "💶",
    "category": "objects"
  },
  "pound": {
    "keywords": ["british", "sterling", "money", "sales", "bills", "uk", "england", "currency"],
    "char": "💷",
    "category": "objects"
  },
  "moneybag": {
    "keywords": ["dollar", "payment", "coins", "sale"],
    "char": "💰",
    "category": "objects"
  },
  "credit_card": {
    "keywords": ["money", "sales", "dollar", "bill", "payment", "shopping"],
    "char": "💳",
    "category": "objects"
  },
  "gem": {
    "keywords": ["blue", "ruby", "diamond", "jewelry"],
    "char": "💎",
    "category": "objects"
  },
  "scales": {
    "keywords": ["law", "fairness", "weight"],
    "char": "⚖",
    "category": "objects"
  },
  "wrench": {
    "keywords": ["tools", "diy", "ikea", "fix", "maintainer"],
    "char": "🔧",
    "category": "objects"
  },
  "hammer": {
    "keywords": ["tools", "build", "create"],
    "char": "🔨",
    "category": "objects"
  },
  "hammer_and_pick": {
    "keywords": ["tools", "build", "create"],
    "char": "⚒",
    "category": "objects"
  },
  "hammer_and_wrench": {
    "keywords": ["tools", "build", "create"],
    "char": "🛠",
    "category": "objects"
  },
  "pick": {
    "keywords": ["tools", "dig"],
    "char": "⛏",
    "category": "objects"
  },
  "nut_and_bolt": {
    "keywords": ["handy", "tools", "fix"],
    "char": "🔩",
    "category": "objects"
  },
  "gear": {
    "keywords": ["cog"],
    "char": "⚙",
    "category": "objects"
  },
  "chains": {
    "keywords": ["lock", "arrest"],
    "char": "⛓",
    "category": "objects"
  },
  "gun": {
    "keywords": ["violence", "weapon", "pistol", "revolver"],
    "char": "🔫",
    "category": "objects"
  },
  "bomb": {
    "keywords": ["boom", "explode", "explosion", "terrorism"],
    "char": "💣",
    "category": "objects"
  },
  "hocho": {
    "keywords": ["knife", "blade", "cutlery", "kitchen", "weapon"],
    "char": "🔪",
    "category": "objects"
  },
  "dagger_knife": {
    "keywords": ["weapon"],
    "char": "🗡",
    "category": "objects"
  },
  "crossed_swords": {
    "keywords": ["weapon"],
    "char": "⚔",
    "category": "objects"
  },
  "shield": {
    "keywords": ["protection", "security"],
    "char": "🛡",
    "category": "objects"
  },
  "smoking": {
    "keywords": ["kills", "tobacco", "cigarette", "joint", "smoke"],
    "char": "🚬",
    "category": "objects"
  },
  "skull_and_crossbones": {
    "keywords": ["poison", "danger", "deadly", "scary"],
    "char": "☠",
    "category": "objects"
  },
  "coffin": {
    "keywords": ["vampire", "dead", "die", "death", "rip", "graveyard", "cemetery"],
    "char": "⚰",
    "category": "objects"
  },
  "funeral_urn": {
    "keywords": ["dead", "die", "death", "rip", "ashes"],
    "char": "⚱",
    "category": "objects"
  },
  "amphora": {
    "keywords": ["vase", "jar"],
    "char": "🏺",
    "category": "objects"
  },
  "crystal_ball": {
    "keywords": ["disco", "party", "magic", "circus", "fortune_teller"],
    "char": "🔮",
    "category": "objects"
  },
  "prayer_beads": {
    "keywords": ["dhikr", "religious"],
    "char": "📿",
    "category": "objects"
  },
  "barber": {
    "keywords": ["hair", "salon", "style"],
    "char": "💈",
    "category": "objects"
  },
  "alembic": {
    "keywords": ["distilling", "science", "experiment"],
    "char": "⚗",
    "category": "objects"
  },
  "telescope": {
    "keywords": ["stars", "space", "zoom"],
    "char": "🔭",
    "category": "objects"
  },
  "microscope": {
    "keywords": ["laboratory", "experiment", "zoomin", "science", "study"],
    "char": "🔬",
    "category": "objects"
  },
  "hole": {
    "keywords": ["embarrassing"],
    "char": "🕳",
    "category": "objects"
  },
  "pill": {
    "keywords": ["health", "medicine", "doctor", "pharmacy", "drug"],
    "char": "💊",
    "category": "objects"
  },
  "syringe": {
    "keywords": ["health", "hospital", "drugs", "blood", "medicine", "needle", "doctor", "nurse"],
    "char": "💉",
    "category": "objects"
  },
  "thermometer": {
    "keywords": ["weather", "temperature", "hot", "cold"],
    "char": "🌡",
    "category": "objects"
  },
  "label": {
    "keywords": ["sale", "tag"],
    "char": "🏷",
    "category": "objects"
  },
  "bookmark": {
    "keywords": ["favorite", "label", "save"],
    "char": "🔖",
    "category": "objects"
  },
  "toilet": {
    "keywords": ["restroom", "wc", "washroom", "bathroom", "potty"],
    "char": "🚽",
    "category": "objects"
  },
  "shower": {
    "keywords": ["clean", "water", "bathroom"],
    "char": "🚿",
    "category": "objects"
  },
  "bathtub": {
    "keywords": ["clean", "shower", "bathroom"],
    "char": "🛁",
    "category": "objects"
  },
  "key": {
    "keywords": ["lock", "door", "password"],
    "char": "🔑",
    "category": "objects"
  },
  "old_key": {
    "keywords": ["lock", "door", "password"],
    "char": "🗝",
    "category": "objects"
  },
  "couch_and_lamp": {
    "keywords": ["read", "chill"],
    "char": "🛋",
    "category": "objects"
  },
  "sleeping_accommodation": {
    "keywords": ["bed", "rest"],
    "char": "🛌",
    "category": "objects"
  },
  "bed": {
    "keywords": ["sleep", "rest"],
    "char": "🛏",
    "category": "objects"
  },
  "door": {
    "keywords": ["house", "entry", "exit"],
    "char": "🚪",
    "category": "objects"
  },
  "bellhop_bell": {
    "keywords": ["service"],
    "char": "🛎",
    "category": "objects"
  },
  "frame_with_picture": {
    "keywords": ["photography"],
    "char": "🖼",
    "category": "objects"
  },
  "world_map": {
    "keywords": ["location", "direction"],
    "char": "🗺",
    "category": "objects"
  },
  "umbrella_on_ground": {
    "keywords": ["weather", "summer"],
    "char": "⛱",
    "category": "objects"
  },
  "moyai": {
    "keywords": ["rock", "easter island", "moai"],
    "char": "🗿",
    "category": "objects"
  },
  "shopping_bags": {
    "keywords": ["mall", "buy", "purchase"],
    "char": "🛍",
    "category": "objects"
  },
  "balloon": {
    "keywords": ["party", "celebration", "birthday", "circus"],
    "char": "🎈",
    "category": "objects"
  },
  "flags": {
    "keywords": ["fish", "japanese", "koinobori", "carp", "banner"],
    "char": "🎏",
    "category": "objects"
  },
  "ribbon": {
    "keywords": ["decoration", "pink", "girl", "bowtie"],
    "char": "🎀",
    "category": "objects"
  },
  "gift": {
    "keywords": ["present", "birthday", "christmas", "xmas"],
    "char": "🎁",
    "category": "objects"
  },
  "confetti_ball": {
    "keywords": ["festival", "party", "birthday", "circus"],
    "char": "🎊",
    "category": "objects"
  },
  "tada": {
    "keywords": ["party", "contulations", "birthday", "magic", "circus"],
    "char": "🎉",
    "category": "objects"
  },
  "dolls": {
    "keywords": ["japanese", "toy", "kimono"],
    "char": "🎎",
    "category": "objects"
  },
  "wind_chime": {
    "keywords": ["nature", "ding", "spring", "bell"],
    "char": "🎐",
    "category": "objects"
  },
  "crossed_flags": {
    "keywords": ["japanese", "nation", "country", "border"],
    "char": "🎌",
    "category": "objects"
  },
  "izakaya_lantern": {
    "keywords": ["light", "paper", "halloween", "spooky"],
    "char": "🏮",
    "category": "objects"
  },
  "envelope": {
    "keywords": ["letter", "postal", "inbox", "communication"],
    "char": "✉️",
    "category": "objects"
  },
  "envelope_with_arrow": {
    "keywords": ["email", "communication"],
    "char": "📩",
    "category": "objects"
  },
  "incoming_envelope": {
    "keywords": ["email", "inbox"],
    "char": "📨",
    "category": "objects"
  },
  "email": {
    "keywords": ["communication", "inbox"],
    "char": "📧",
    "category": "objects"
  },
  "love_letter": {
    "keywords": ["email", "like", "affection", "envelope", "valentines"],
    "char": "💌",
    "category": "objects"
  },
  "postbox": {
    "keywords": ["email", "letter", "envelope"],
    "char": "📮",
    "category": "objects"
  },
  "mailbox_closed": {
    "keywords": ["email", "communication", "inbox"],
    "char": "📪",
    "category": "objects"
  },
  "mailbox": {
    "keywords": ["email", "inbox", "communication"],
    "char": "📫",
    "category": "objects"
  },
  "mailbox_with_mail": {
    "keywords": ["email", "inbox", "communication"],
    "char": "📬",
    "category": "objects"
  },
  "mailbox_with_no_mail": {
    "keywords": ["email", "inbox"],
    "char": "📭",
    "category": "objects"
  },
  "package": {
    "keywords": ["mail", "gift", "cardboard", "box", "moving"],
    "char": "📦",
    "category": "objects"
  },
  "postal_horn": {
    "keywords": ["instrument", "music"],
    "char": "📯",
    "category": "objects"
  },
  "inbox_tray": {
    "keywords": ["email", "documents"],
    "char": "📥",
    "category": "objects"
  },
  "outbox_tray": {
    "keywords": ["inbox", "email"],
    "char": "📤",
    "category": "objects"
  },
  "scroll": {
    "keywords": ["documents", "ancient", "history", "paper"],
    "char": "📜",
    "category": "objects"
  },
  "page_with_curl": {
    "keywords": ["documents", "office", "paper"],
    "char": "📃",
    "category": "objects"
  },
  "bookmark_tabs": {
    "keywords": ["favorite", "save", "order", "tidy"],
    "char": "📑",
    "category": "objects"
  },
  "bar_chart": {
    "keywords": ["graph", "presentation", "stats"],
    "char": "📊",
    "category": "objects"
  },
  "chart_with_upwards_trend": {
    "keywords": ["graph", "presentation", "stats", "recovery", "business", "economics", "money", "sales", "good", "success"],
    "char": "📈",
    "category": "objects"
  },
  "chart_with_downwards_trend": {
    "keywords": ["graph", "presentation", "stats", "recession", "business", "economics", "money", "sales", "bad", "failure"],
    "char": "📉",
    "category": "objects"
  },
  "page_facing_up": {
    "keywords": ["documents", "office", "paper", "information"],
    "char": "📄",
    "category": "objects"
  },
  "date": {
    "keywords": ["calendar", "schedule"],
    "char": "📅",
    "category": "objects"
  },
  "calendar": {
    "keywords": ["schedule", "date", "planning"],
    "char": "📆",
    "category": "objects"
  },
  "spiral_calendar_pad": {
    "keywords": ["date", "schedule", "planning"],
    "char": "🗓",
    "category": "objects"
  },
  "card_index": {
    "keywords": ["business", "stationery"],
    "char": "📇",
    "category": "objects"
  },
  "card_file_box": {
    "keywords": ["business", "stationery"],
    "char": "🗃",
    "category": "objects"
  },
  "ballot_box_with_ballot": {
    "keywords": ["election", "vote"],
    "char": "🗳",
    "category": "objects"
  },
  "file_cabinet": {
    "keywords": ["filing", "organizing"],
    "char": "🗄",
    "category": "objects"
  },
  "clipboard": {
    "keywords": ["stationery", "documents"],
    "char": "📋",
    "category": "objects"
  },
  "spiral_note_pad": {
    "keywords": ["memo", "stationery"],
    "char": "🗒",
    "category": "objects"
  },
  "file_folder": {
    "keywords": ["documents", "business", "office"],
    "char": "📁",
    "category": "objects"
  },
  "open_file_folder": {
    "keywords": ["documents", "load"],
    "char": "📂",
    "category": "objects"
  },
  "card_index_dividers": {
    "keywords": ["organizing", "business", "stationery"],
    "char": "🗂",
    "category": "objects"
  },
  "rolled_up_newspaper": {
    "keywords": ["press", "headline"],
    "char": "🗞",
    "category": "objects"
  },
  "newspaper": {
    "keywords": ["press", "headline"],
    "char": "📰",
    "category": "objects"
  },
  "notebook": {
    "keywords": ["stationery", "record", "notes", "paper", "study"],
    "char": "📓",
    "category": "objects"
  },
  "closed_book": {
    "keywords": ["read", "library", "knowledge", "textbook", "learn"],
    "char": "📕",
    "category": "objects"
  },
  "green_book": {
    "keywords": ["read", "library", "knowledge", "study"],
    "char": "📗",
    "category": "objects"
  },
  "blue_book": {
    "keywords": ["read", "library", "knowledge", "learn", "study"],
    "char": "📘",
    "category": "objects"
  },
  "orange_book": {
    "keywords": ["read", "library", "knowledge", "textbook", "study"],
    "char": "📙",
    "category": "objects"
  },
  "notebook_with_decorative_cover": {
    "keywords": ["classroom", "notes", "record", "paper", "study"],
    "char": "📔",
    "category": "objects"
  },
  "ledger": {
    "keywords": ["notes", "paper"],
    "char": "📒",
    "category": "objects"
  },
  "books": {
    "keywords": ["literature", "library", "study"],
    "char": "📚",
    "category": "objects"
  },
  "book": {
    "keywords": ["open_book", "read", "library", "knowledge", "literature", "learn", "study"],
    "char": "📖",
    "category": "objects"
  },
  "link": {
    "keywords": ["rings", "url"],
    "char": "🔗",
    "category": "objects"
  },
  "paperclip": {
    "keywords": ["documents", "stationery"],
    "char": "📎",
    "category": "objects"
  },
  "linked_paperclips": {
    "keywords": ["documents", "stationery"],
    "char": "🖇",
    "category": "objects"
  },
  "scissors": {
    "keywords": ["stationery", "cut"],
    "char": "✂️",
    "category": "objects"
  },
  "triangular_ruler": {
    "keywords": ["stationery", "math", "architect", "sketch"],
    "char": "📐",
    "category": "objects"
  },
  "straight_ruler": {
    "keywords": ["stationery", "calculate", "length", "math", "school", "drawing", "architect", "sketch"],
    "char": "📏",
    "category": "objects"
  },
  "pushpin": {
    "keywords": ["stationery", "mark", "here"],
    "char": "📌",
    "category": "objects"
  },
  "round_pushpin": {
    "keywords": ["stationery", "location", "map", "here"],
    "char": "📍",
    "category": "objects"
  },
  "triangular_flag_on_post": {
    "keywords": ["mark", "milestone", "place"],
    "char": "🚩",
    "category": "objects"
  },
  "waving_white_flag": {
    "keywords": ["losing", "loser", "lost", "surrender", "give up", "fail"],
    "char": "🏳",
    "category": "objects"
  },
  "waving_black_flag": {
    "keywords": ["pirate"],
    "char": "🏴",
    "category": "objects"
  },
  "closed_lock_with_key": {
    "keywords": ["security", "privacy"],
    "char": "🔐",
    "category": "objects"
  },
  "lock": {
    "keywords": ["security", "password", "padlock"],
    "char": "🔒",
    "category": "objects"
  },
  "unlock": {
    "keywords": ["privacy", "security"],
    "char": "🔓",
    "category": "objects"
  },
  "lock_with_ink_pen": {
    "keywords": ["security", "secret"],
    "char": "🔏",
    "category": "objects"
  },
  "lower_left_ballpoint_pen": {
    "keywords": ["stationery", "writing", "write"],
    "char": "🖊",
    "category": "objects"
  },
  "lower_left_fountain_pen": {
    "keywords": ["stationery", "writing", "write"],
    "char": "🖋",
    "category": "objects"
  },
  "black_nib": {
    "keywords": ["pen", "stationery", "writing", "write"],
    "char": "✒️",
    "category": "objects"
  },
  "memo": {
    "keywords": ["write", "documents", "stationery", "pencil", "paper", "writing", "legal", "exam", "quiz", "test", "study"],
    "char": "📝",
    "category": "objects"
  },
  "pencil2": {
    "keywords": ["stationery", "write", "paper", "writing", "school", "study"],
    "char": "✏️",
    "category": "objects"
  },
  "lower_left_crayon": {
    "keywords": ["drawing", "creativity"],
    "char": "🖍",
    "category": "objects"
  },
  "lower_left_paintbrush": {
    "keywords": ["drawing", "creativity", "art"],
    "char": "🖌",
    "category": "objects"
  },
  "mag": {
    "keywords": ["search", "zoom", "find", "detective"],
    "char": "🔍",
    "category": "objects"
  },
  "mag_right": {
    "keywords": ["search", "zoom", "find", "detective"],
    "char": "🔎",
    "category": "objects"
  },
  "heart": {
    "keywords": ["love", "like", "valentines"],
    "char": "❤️",
    "category": "symbols"
  },
  "yellow_heart": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💛",
    "category": "symbols"
  },
  "green_heart": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💚",
    "category": "symbols"
  },
  "blue_heart": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💙",
    "category": "symbols"
  },
  "purple_heart": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💜",
    "category": "symbols"
  },
  "broken_heart": {
    "keywords": ["sad", "sorry", "break", "heart", "heartbreak"],
    "char": "💔",
    "category": "symbols"
  },
  "heavy_heart_exclamation_mark_ornament": {
    "keywords": ["decoration", "love"],
    "char": "❣",
    "category": "symbols"
  },
  "two_hearts": {
    "keywords": ["love", "like", "affection", "valentines", "heart"],
    "char": "💕",
    "category": "symbols"
  },
  "revolving_hearts": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💞",
    "category": "symbols"
  },
  "heartbeat": {
    "keywords": ["love", "like", "affection", "valentines", "pink", "heart"],
    "char": "💓",
    "category": "symbols"
  },
  "heartpulse": {
    "keywords": ["like", "love", "affection", "valentines", "pink"],
    "char": "💗",
    "category": "symbols"
  },
  "sparkling_heart": {
    "keywords": ["love", "like", "affection", "valentines"],
    "char": "💖",
    "category": "symbols"
  },
  "cupid": {
    "keywords": ["love", "like", "heart", "affection", "valentines"],
    "char": "💘",
    "category": "symbols"
  },
  "gift_heart": {
    "keywords": ["love", "valentines"],
    "char": "💝",
    "category": "symbols"
  },
  "heart_decoration": {
    "keywords": ["purple-square", "love", "like"],
    "char": "💟",
    "category": "symbols"
  },
  "peace_symbol": {
    "keywords": ["hippie"],
    "char": "☮",
    "category": "symbols"
  },
  "latin_cross": {
    "keywords": ["christianity"],
    "char": "✝",
    "category": "symbols"
  },
  "star_and_crescent": {
    "keywords": ["islam"],
    "char": "☪",
    "category": "symbols"
  },
  "om_symbol": {
    "keywords": ["hinduism", "buddhism", "sikhism", "jainism"],
    "char": "🕉",
    "category": "symbols"
  },
  "wheel_of_dharma": {
    "keywords": ["hinduism", "buddhism", "sikhism", "jainism"],
    "char": "☸",
    "category": "symbols"
  },
  "star_of_david": {
    "keywords": ["judaism"],
    "char": "✡",
    "category": "symbols"
  },
  "six_pointed_star": {
    "keywords": ["purple-square", "religion", "jewish", "hexagram"],
    "char": "🔯",
    "category": "symbols"
  },
  "menorah_with_nine_branches": {
    "keywords": ["hanukkah", "candles", "jewish"],
    "char": "🕎",
    "category": "symbols"
  },
  "yin_yang": {
    "keywords": ["balance"],
    "char": "☯",
    "category": "symbols"
  },
  "orthodox_cross": {
    "keywords": ["suppedaneum", "religion"],
    "char": "☦",
    "category": "symbols"
  },
  "place_of_worship": {
    "keywords": ["religion", "church", "temple", "prayer"],
    "char": "🛐",
    "category": "symbols"
  },
  "ophiuchus": {
    "keywords": ["sign", "purple-square", "constellation", "astrology"],
    "char": "⛎",
    "category": "symbols"
  },
  "aries": {
    "keywords": ["sign", "purple-square", "zodiac", "astrology"],
    "char": "♈",
    "category": "symbols"
  },
  "taurus": {
    "keywords": ["purple-square", "sign", "zodiac", "astrology"],
    "char": "♉",
    "category": "symbols"
  },
  "gemini": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology"],
    "char": "♊",
    "category": "symbols"
  },
  "cancer": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology"],
    "char": "♋",
    "category": "symbols"
  },
  "leo": {
    "keywords": ["sign", "purple-square", "zodiac", "astrology"],
    "char": "♌",
    "category": "symbols"
  },
  "virgo": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology"],
    "char": "♍",
    "category": "symbols"
  },
  "libra": {
    "keywords": ["sign", "purple-square", "zodiac", "astrology"],
    "char": "♎",
    "category": "symbols"
  },
  "scorpius": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology", "scorpio"],
    "char": "♏",
    "category": "symbols"
  },
  "sagittarius": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology"],
    "char": "♐",
    "category": "symbols"
  },
  "capricorn": {
    "keywords": ["sign", "zodiac", "purple-square", "astrology"],
    "char": "♑",
    "category": "symbols"
  },
  "aquarius": {
    "keywords": ["sign", "purple-square", "zodiac", "astrology"],
    "char": "♒",
    "category": "symbols"
  },
  "pisces": {
    "keywords": ["purple-square", "sign", "zodiac", "astrology"],
    "char": "♓",
    "category": "symbols"
  },
  "id": {
    "keywords": ["purple-square", "words"],
    "char": "🆔",
    "category": "symbols"
  },
  "atom_symbol": {
    "keywords": ["science"],
    "char": "⚛",
    "category": "symbols"
  },
  "u7a7a": {
    "keywords": ["kanji", "japanese", "chinese", "empty", "sky", "blue-square"],
    "char": "🈳",
    "category": "symbols"
  },
  "u5272": {
    "keywords": ["cut", "divide", "chinese", "kanji", "pink-square"],
    "char": "🈹",
    "category": "symbols"
  },
  "radioactive_sign": {
    "keywords": ["nuclear", "danger"],
    "char": "☢",
    "category": "symbols"
  },
  "biohazard_sign": {
    "keywords": ["danger"],
    "char": "☣",
    "category": "symbols"
  },
  "mobile_phone_off": {
    "keywords": ["mute", "orange-square", "silence", "quiet"],
    "char": "📴",
    "category": "symbols"
  },
  "vibration_mode": {
    "keywords": ["orange-square", "phone"],
    "char": "📳",
    "category": "symbols"
  },
  "u6709": {
    "keywords": ["orange-square", "chinese", "have", "kanji"],
    "char": "🈶",
    "category": "symbols"
  },
  "u7121": {
    "keywords": ["nothing", "chinese", "kanji", "japanese", "orange-square"],
    "char": "🈚",
    "category": "symbols"
  },
  "u7533": {
    "keywords": ["chinese", "japanese", "kanji", "orange-square"],
    "char": "🈸",
    "category": "symbols"
  },
  "u55b6": {
    "keywords": ["japanese", "opening hours", "orange-square"],
    "char": "🈺",
    "category": "symbols"
  },
  "u6708": {
    "keywords": ["chinese", "month", "moon", "japanese", "orange-square", "kanji"],
    "char": "🈷️",
    "category": "symbols"
  },
  "eight_pointed_black_star": {
    "keywords": ["orange-square", "shape", "polygon"],
    "char": "✴️",
    "category": "symbols"
  },
  "vs": {
    "keywords": ["words", "orange-square"],
    "char": "🆚",
    "category": "symbols"
  },
  "accept": {
    "keywords": ["ok", "good", "chinese", "kanji", "agree", "yes", "orange-circle"],
    "char": "🉑",
    "category": "symbols"
  },
  "white_flower": {
    "keywords": ["japanese", "spring"],
    "char": "💮",
    "category": "symbols"
  },
  "ideograph_advantage": {
    "keywords": ["chinese", "kanji", "obtain", "get", "circle"],
    "char": "🉐",
    "category": "symbols"
  },
  "secret": {
    "keywords": ["privacy", "chinese", "sshh", "kanji", "red-circle"],
    "char": "㊙️",
    "category": "symbols"
  },
  "congratulations": {
    "keywords": ["chinese", "kanji", "japanese", "red-circle"],
    "char": "㊗️",
    "category": "symbols"
  },
  "u5408": {
    "keywords": ["japanese", "chinese", "join", "kanji", "red-square"],
    "char": "🈴",
    "category": "symbols"
  },
  "u6e80": {
    "keywords": ["full", "chinese", "japanese", "red-square", "kanji"],
    "char": "🈵",
    "category": "symbols"
  },
  "u7981": {
    "keywords": ["kanji", "japanese", "chinese", "forbidden", "limit", "restricted", "red-square"],
    "char": "🈲",
    "category": "symbols"
  },
  "a": {
    "keywords": ["red-square", "alphabet", "letter"],
    "char": "🅰️",
    "category": "symbols"
  },
  "b": {
    "keywords": ["red-square", "alphabet", "letter"],
    "char": "🅱️",
    "category": "symbols"
  },
  "ab": {
    "keywords": ["red-square", "alphabet"],
    "char": "🆎",
    "category": "symbols"
  },
  "cl": {
    "keywords": ["alphabet", "words", "red-square"],
    "char": "🆑",
    "category": "symbols"
  },
  "o2": {
    "keywords": ["alphabet", "red-square", "letter"],
    "char": "🅾️",
    "category": "symbols"
  },
  "sos": {
    "keywords": ["help", "red-square", "words", "emergency", "911"],
    "char": "🆘",
    "category": "symbols"
  },
  "no_entry": {
    "keywords": ["limit", "security", "privacy", "bad", "denied", "stop", "circle"],
    "char": "⛔",
    "category": "symbols"
  },
  "name_badge": {
    "keywords": ["fire", "forbid"],
    "char": "📛",
    "category": "symbols"
  },
  "no_entry_sign": {
    "keywords": ["forbid", "stop", "limit", "denied", "disallow", "circle"],
    "char": "🚫",
    "category": "symbols"
  },
  "x": {
    "keywords": ["no", "delete", "remove", "cancel"],
    "char": "❌",
    "category": "symbols"
  },
  "o": {
    "keywords": ["circle", "round"],
    "char": "⭕",
    "category": "symbols"
  },
  "anger": {
    "keywords": ["angry", "mad"],
    "char": "💢",
    "category": "symbols"
  },
  "hotsprings": {
    "keywords": ["bath", "warm", "relax"],
    "char": "♨️",
    "category": "symbols"
  },
  "no_pedestrians": {
    "keywords": ["rules", "crossing", "walking", "circle"],
    "char": "🚷",
    "category": "symbols"
  },
  "do_not_litter": {
    "keywords": ["trash", "bin", "garbage", "circle"],
    "char": "🚯",
    "category": "symbols"
  },
  "no_bicycles": {
    "keywords": ["cyclist", "prohibited", "circle"],
    "char": "🚳",
    "category": "symbols"
  },
  "non-potable_water": {
    "keywords": ["drink", "faucet", "tap", "circle"],
    "char": "🚱",
    "category": "symbols"
  },
  "underage": {
    "keywords": ["18", "drink", "pub", "night", "minor", "circle"],
    "char": "🔞",
    "category": "symbols"
  },
  "no_mobile_phones": {
    "keywords": ["iphone", "mute", "circle"],
    "char": "📵",
    "category": "symbols"
  },
  "exclamation": {
    "keywords": ["heavy_exclamation_mark", "danger", "surprise", "punctuation", "wow", "warning"],
    "char": "❗",
    "category": "symbols"
  },
  "grey_exclamation": {
    "keywords": ["surprise", "punctuation", "gray", "wow", "warning"],
    "char": "❕",
    "category": "symbols"
  },
  "question": {
    "keywords": ["doubt", "confused"],
    "char": "❓",
    "category": "symbols"
  },
  "grey_question": {
    "keywords": ["doubts", "gray", "huh", "confused"],
    "char": "❔",
    "category": "symbols"
  },
  "bangbang": {
    "keywords": ["exclamation", "surprise"],
    "char": "‼️",
    "category": "symbols"
  },
  "interrobang": {
    "keywords": ["wat", "punctuation", "surprise"],
    "char": "⁉️",
    "category": "symbols"
  },
  "100": {
    "keywords": ["score", "perfect", "numbers", "century", "exam", "quiz", "test", "pass", "hundred"],
    "char": "💯",
    "category": "symbols"
  },
  "low_brightness": {
    "keywords": ["sun", "afternoon", "warm", "summer"],
    "char": "🔅",
    "category": "symbols"
  },
  "high_brightness": {
    "keywords": ["sun", "light"],
    "char": "🔆",
    "category": "symbols"
  },
  "trident": {
    "keywords": ["weapon", "spear"],
    "char": "🔱",
    "category": "symbols"
  },
  "fleur_de_lis": {
    "keywords": ["decorative", "scout"],
    "char": "⚜",
    "category": "symbols"
  },
  "part_alternation_mark": {
    "keywords": ["graph", "presentation", "stats", "business", "economics", "bad"],
    "char": "〽️",
    "category": "symbols"
  },
  "warning": {
    "keywords": ["exclamation", "wip", "alert", "error", "problem", "issue"],
    "char": "⚠️",
    "category": "symbols"
  },
  "children_crossing": {
    "keywords": ["school", "warning", "danger", "sign", "driving", "yellow-diamond"],
    "char": "🚸",
    "category": "symbols"
  },
  "beginner": {
    "keywords": ["badge", "shield"],
    "char": "🔰",
    "category": "symbols"
  },
  "recycle": {
    "keywords": ["arrow", "environment", "garbage", "trash"],
    "char": "♻️",
    "category": "symbols"
  },
  "u6307": {
    "keywords": ["chinese", "point", "green-square", "kanji"],
    "char": "🈯",
    "category": "symbols"
  },
  "chart": {
    "keywords": ["green-square", "graph", "presentation", "stats"],
    "char": "💹",
    "category": "symbols"
  },
  "sparkle": {
    "keywords": ["stars", "green-square", "awesome", "good", "fireworks"],
    "char": "❇️",
    "category": "symbols"
  },
  "eight_spoked_asterisk": {
    "keywords": ["star", "sparkle", "green-square"],
    "char": "✳️",
    "category": "symbols"
  },
  "negative_squared_cross_mark": {
    "keywords": ["x", "green-square", "no", "deny"],
    "char": "❎",
    "category": "symbols"
  },
  "white_check_mark": {
    "keywords": ["green-square", "ok", "agree", "vote", "election", "answer"],
    "char": "✅",
    "category": "symbols"
  },
  "diamond_shape_with_a_dot_inside": {
    "keywords": ["jewel", "blue", "gem", "crystal", "fancy"],
    "char": "💠",
    "category": "symbols"
  },
  "cyclone": {
    "keywords": ["weather", "swirl", "blue", "cloud", "vortex", "spiral", "whirlpool", "spin"],
    "char": "🌀",
    "category": "symbols"
  },
  "loop": {
    "keywords": ["tape", "cassette"],
    "char": "➿",
    "category": "symbols"
  },
  "globe_with_meridians": {
    "keywords": ["earth", "international", "world", "internet", "interweb", "i18n"],
    "char": "🌐",
    "category": "symbols"
  },
  "m": {
    "keywords": ["alphabet", "blue-circle", "letter"],
    "char": "Ⓜ️",
    "category": "symbols"
  },
  "atm": {
    "keywords": ["money", "sales", "cash", "blue-square", "payment", "bank"],
    "char": "🏧",
    "category": "symbols"
  },
  "sa": {
    "keywords": ["japanese", "blue-square", "katakana"],
    "char": "🈂️",
    "category": "symbols"
  },
  "passport_control": {
    "keywords": ["custom", "blue-square"],
    "char": "🛂",
    "category": "symbols"
  },
  "customs": {
    "keywords": ["passport", "border", "blue-square"],
    "char": "🛃",
    "category": "symbols"
  },
  "baggage_claim": {
    "keywords": ["blue-square", "airport", "transport"],
    "char": "🛄",
    "category": "symbols"
  },
  "left_luggage": {
    "keywords": ["blue-square", "travel"],
    "char": "🛅",
    "category": "symbols"
  },
  "wheelchair": {
    "keywords": ["blue-square", "disabled", "a11y", "accessibility"],
    "char": "♿",
    "category": "symbols"
  },
  "no_smoking": {
    "keywords": ["cigarette", "blue-square", "smell", "smoke"],
    "char": "🚭",
    "category": "symbols"
  },
  "wc": {
    "keywords": ["toilet", "restroom", "blue-square"],
    "char": "🚾",
    "category": "symbols"
  },
  "parking": {
    "keywords": ["cars", "blue-square", "alphabet", "letter"],
    "char": "🅿️",
    "category": "symbols"
  },
  "potable_water": {
    "keywords": ["blue-square", "liquid", "restroom", "cleaning", "faucet"],
    "char": "🚰",
    "category": "symbols"
  },
  "mens": {
    "keywords": ["toilet", "restroom", "wc", "blue-square", "gender", "male"],
    "char": "🚹",
    "category": "symbols"
  },
  "womens": {
    "keywords": ["purple-square", "woman", "female", "toilet", "loo", "restroom", "gender"],
    "char": "🚺",
    "category": "symbols"
  },
  "baby_symbol": {
    "keywords": ["orange-square", "child"],
    "char": "🚼",
    "category": "symbols"
  },
  "restroom": {
    "keywords": ["blue-square", "toilet", "refresh", "wc", "gender"],
    "char": "🚻",
    "category": "symbols"
  },
  "put_litter_in_its_place": {
    "keywords": ["blue-square", "sign", "human", "info"],
    "char": "🚮",
    "category": "symbols"
  },
  "cinema": {
    "keywords": ["blue-square", "record", "film", "movie", "curtain", "stage", "theater"],
    "char": "🎦",
    "category": "symbols"
  },
  "signal_strength": {
    "keywords": ["blue-square", "reception", "phone", "internet", "connection", "wifi", "bluetooth", "bars"],
    "char": "📶",
    "category": "symbols"
  },
  "koko": {
    "keywords": ["blue-square", "here", "katakana", "japanese", "destination"],
    "char": "🈁",
    "category": "symbols"
  },
  "ng": {
    "keywords": ["blue-square", "words", "shape", "icon"],
    "char": "🆖",
    "category": "symbols"
  },
  "ok": {
    "keywords": ["good", "agree", "yes", "blue-square"],
    "char": "🆗",
    "category": "symbols"
  },
  "up": {
    "keywords": ["blue-square", "above", "high"],
    "char": "🆙",
    "category": "symbols"
  },
  "cool": {
    "keywords": ["words", "blue-square"],
    "char": "🆒",
    "category": "symbols"
  },
  "new": {
    "keywords": ["blue-square", "words", "start"],
    "char": "🆕",
    "category": "symbols"
  },
  "free": {
    "keywords": ["blue-square", "words"],
    "char": "🆓",
    "category": "symbols"
  },
  "zero": {
    "keywords": ["0", "numbers", "blue-square", "null"],
    "char": "0️⃣",
    "category": "symbols"
  },
  "one": {
    "keywords": ["blue-square", "numbers", "1"],
    "char": "1️⃣",
    "category": "symbols"
  },
  "two": {
    "keywords": ["numbers", "2", "prime", "blue-square"],
    "char": "2️⃣",
    "category": "symbols"
  },
  "three": {
    "keywords": ["3", "numbers", "prime", "blue-square"],
    "char": "3️⃣",
    "category": "symbols"
  },
  "four": {
    "keywords": ["4", "numbers", "blue-square"],
    "char": "4️⃣",
    "category": "symbols"
  },
  "five": {
    "keywords": ["5", "numbers", "blue-square", "prime"],
    "char": "5️⃣",
    "category": "symbols"
  },
  "six": {
    "keywords": ["6", "numbers", "blue-square"],
    "char": "6️⃣",
    "category": "symbols"
  },
  "seven": {
    "keywords": ["7", "numbers", "blue-square", "prime"],
    "char": "7️⃣",
    "category": "symbols"
  },
  "eight": {
    "keywords": ["8", "blue-square", "numbers"],
    "char": "8️⃣",
    "category": "symbols"
  },
  "nine": {
    "keywords": ["blue-square", "numbers", "9"],
    "char": "9️⃣",
    "category": "symbols"
  },
  "keycap_ten": {
    "keywords": ["numbers", "10", "blue-square"],
    "char": "🔟",
    "category": "symbols"
  },
  "keycap_star": {
    "keywords": ["asterisk"],
    "char": "*⃣",
    "category": "symbols"
  },
  "1234": {
    "keywords": ["numbers", "blue-square"],
    "char": "🔢",
    "category": "symbols"
  },
  "arrow_forward": {
    "keywords": ["blue-square", "right", "direction", "play"],
    "char": "▶️",
    "category": "symbols"
  },
  "double_vertical_bar": {
    "keywords": ["pause", "blue-square"],
    "char": "⏸",
    "category": "symbols"
  },
  "black_right_pointing_triangle_with_double_vertical_bar": {
    "keywords": ["forward", "next", "blue-square"],
    "char": "⏭",
    "category": "symbols"
  },
  "black_square_for_stop": {
    "keywords": ["blue-square"],
    "char": "⏹",
    "category": "symbols"
  },
  "black_circle_for_record": {
    "keywords": ["blue-square"],
    "char": "⏺",
    "category": "symbols"
  },
  "black_right_pointing_double_triangle_with_vertical_bar": {
    "keywords": ["blue-square", "play", "pause"],
    "char": "⏯",
    "category": "symbols"
  },
  "black_left_pointing_double_triangle_with_vertical_bar": {
    "keywords": ["backward"],
    "char": "⏮",
    "category": "symbols"
  },
  "fast_forward": {
    "keywords": ["blue-square", "play", "speed", "continue"],
    "char": "⏩",
    "category": "symbols"
  },
  "rewind": {
    "keywords": ["play", "blue-square"],
    "char": "⏪",
    "category": "symbols"
  },
  "twisted_rightwards_arrows": {
    "keywords": ["blue-square", "shuffle", "music", "random"],
    "char": "🔀",
    "category": "symbols"
  },
  "repeat": {
    "keywords": ["loop", "record"],
    "char": "🔁",
    "category": "symbols"
  },
  "repeat_one": {
    "keywords": ["blue-square", "loop"],
    "char": "🔂",
    "category": "symbols"
  },
  "arrow_backward": {
    "keywords": ["blue-square", "left", "direction"],
    "char": "◀️",
    "category": "symbols"
  },
  "arrow_up_small": {
    "keywords": ["blue-square", "triangle", "direction", "point", "forward", "top"],
    "char": "🔼",
    "category": "symbols"
  },
  "arrow_down_small": {
    "keywords": ["blue-square", "direction", "bottom"],
    "char": "🔽",
    "category": "symbols"
  },
  "arrow_double_up": {
    "keywords": ["blue-square", "direction", "top"],
    "char": "⏫",
    "category": "symbols"
  },
  "arrow_double_down": {
    "keywords": ["blue-square", "direction", "bottom"],
    "char": "⏬",
    "category": "symbols"
  },
  "arrow_right": {
    "keywords": ["blue-square", "next"],
    "char": "➡️",
    "category": "symbols"
  },
  "arrow_left": {
    "keywords": ["blue-square", "previous", "back"],
    "char": "⬅️",
    "category": "symbols"
  },
  "arrow_up": {
    "keywords": ["blue-square", "continue", "top", "direction"],
    "char": "⬆️",
    "category": "symbols"
  },
  "arrow_down": {
    "keywords": ["blue-square", "direction", "bottom"],
    "char": "⬇️",
    "category": "symbols"
  },
  "arrow_upper_right": {
    "keywords": ["blue-square", "point", "direction", "diagonal", "northeast"],
    "char": "↗️",
    "category": "symbols"
  },
  "arrow_lower_right": {
    "keywords": ["blue-square", "direction", "diagonal", "southeast"],
    "char": "↘️",
    "category": "symbols"
  },
  "arrow_lower_left": {
    "keywords": ["blue-square", "direction", "diagonal", "southwest"],
    "char": "↙️",
    "category": "symbols"
  },
  "arrow_upper_left": {
    "keywords": ["blue-square", "point", "direction", "diagonal", "northwest"],
    "char": "↖️",
    "category": "symbols"
  },
  "arrow_up_down": {
    "keywords": ["blue-square", "direction", "way", "vertical"],
    "char": "↕️",
    "category": "symbols"
  },
  "left_right_arrow": {
    "keywords": ["shape", "direction", "horizontal", "sideways"],
    "char": "↔️",
    "category": "symbols"
  },
  "arrows_counterclockwise": {
    "keywords": ["blue-square", "sync", "cycle"],
    "char": "🔄",
    "category": "symbols"
  },
  "arrow_right_hook": {
    "keywords": ["blue-square", "return", "rotate", "direction"],
    "char": "↪️",
    "category": "symbols"
  },
  "leftwards_arrow_with_hook": {
    "keywords": ["back", "return", "blue-square", "undo", "enter"],
    "char": "↩️",
    "category": "symbols"
  },
  "arrow_heading_up": {
    "keywords": ["blue-square", "direction", "top"],
    "char": "⤴️",
    "category": "symbols"
  },
  "arrow_heading_down": {
    "keywords": ["blue-square", "direction", "bottom"],
    "char": "⤵️",
    "category": "symbols"
  },
  "hash": {
    "keywords": ["symbol", "blue-square", "twitter"],
    "char": "#️⃣",
    "category": "symbols"
  },
  "information_source": {
    "keywords": ["blue-square", "alphabet", "letter"],
    "char": "ℹ️",
    "category": "symbols"
  },
  "abc": {
    "keywords": ["blue-square", "alphabet"],
    "char": "🔤",
    "category": "symbols"
  },
  "abcd": {
    "keywords": ["blue-square", "alphabet"],
    "char": "🔡",
    "category": "symbols"
  },
  "capital_abcd": {
    "keywords": ["alphabet", "words", "blue-square"],
    "char": "🔠",
    "category": "symbols"
  },
  "symbols": {
    "keywords": ["blue-square", "music", "note", "ampersand", "percent", "glyphs", "characters"],
    "char": "🔣",
    "category": "symbols"
  },
  "musical_note": {
    "keywords": ["score", "tone", "sound"],
    "char": "🎵",
    "category": "symbols"
  },
  "notes": {
    "keywords": ["music", "score"],
    "char": "🎶",
    "category": "symbols"
  },
  "wavy_dash": {
    "keywords": ["draw", "line", "moustache", "mustache", "squiggle", "scribble"],
    "char": "〰️",
    "category": "symbols"
  },
  "curly_loop": {
    "keywords": ["scribble", "draw", "shape", "squiggle"],
    "char": "➰",
    "category": "symbols"
  },
  "heavy_check_mark": {
    "keywords": ["ok", "nike", "answer", "yes", "tick"],
    "char": "✔️",
    "category": "symbols"
  },
  "arrows_clockwise": {
    "keywords": ["sync", "cycle", "round", "repeat"],
    "char": "🔃",
    "category": "symbols"
  },
  "heavy_plus_sign": {
    "keywords": ["math", "calculation", "addition", "more", "increase"],
    "char": "➕",
    "category": "symbols"
  },
  "heavy_minus_sign": {
    "keywords": ["math", "calculation", "subtract", "less"],
    "char": "➖",
    "category": "symbols"
  },
  "heavy_division_sign": {
    "keywords": ["divide", "math", "calculation"],
    "char": "➗",
    "category": "symbols"
  },
  "heavy_multiplication_x": {
    "keywords": ["math", "calculation"],
    "char": "✖️",
    "category": "symbols"
  },
  "heavy_dollar_sign": {
    "keywords": ["money", "sales", "payment", "currency", "buck"],
    "char": "💲",
    "category": "symbols"
  },
  "currency_exchange": {
    "keywords": ["money", "sales", "dollar", "travel"],
    "char": "💱",
    "category": "symbols"
  },
  "copyright": {
    "keywords": ["ip", "license", "circle", "law", "legal"],
    "char": "©️",
    "category": "symbols"
  },
  "registered": {
    "keywords": ["alphabet", "circle"],
    "char": "®️",
    "category": "symbols"
  },
  "tm": {
    "keywords": ["trademark", "brand", "law", "legal"],
    "char": "™️",
    "category": "symbols"
  },
  "end": {
    "keywords": ["words", "arrow"],
    "char": "🔚",
    "category": "symbols"
  },
  "back": {
    "keywords": ["arrow", "words", "return"],
    "char": "🔙",
    "category": "symbols"
  },
  "on": {
    "keywords": ["arrow", "words"],
    "char": "🔛",
    "category": "symbols"
  },
  "top": {
    "keywords": ["words", "blue-square"],
    "char": "🔝",
    "category": "symbols"
  },
  "soon": {
    "keywords": ["arrow", "words"],
    "char": "🔜",
    "category": "symbols"
  },
  "ballot_box_with_check": {
    "keywords": ["ok", "agree", "confirm", "black-square", "vote", "election", "yes"],
    "char": "☑️",
    "category": "symbols"
  },
  "radio_button": {
    "keywords": ["input", "old", "music", "circle"],
    "char": "🔘",
    "category": "symbols"
  },
  "white_circle": {
    "keywords": ["shape", "round"],
    "char": "⚪",
    "category": "symbols"
  },
  "black_circle": {
    "keywords": ["shape", "button", "round"],
    "char": "⚫",
    "category": "symbols"
  },
  "red_circle": {
    "keywords": ["shape", "error", "danger"],
    "char": "🔴",
    "category": "symbols"
  },
  "large_blue_circle": {
    "keywords": ["shape", "icon", "button"],
    "char": "🔵",
    "category": "symbols"
  },
  "small_orange_diamond": {
    "keywords": ["shape", "jewel", "gem"],
    "char": "🔸",
    "category": "symbols"
  },
  "small_blue_diamond": {
    "keywords": ["shape", "jewel", "gem"],
    "char": "🔹",
    "category": "symbols"
  },
  "large_orange_diamond": {
    "keywords": ["shape", "jewel", "gem"],
    "char": "🔶",
    "category": "symbols"
  },
  "large_blue_diamond": {
    "keywords": ["shape", "jewel", "gem"],
    "char": "🔷",
    "category": "symbols"
  },
  "small_red_triangle": {
    "keywords": ["shape", "direction", "up", "top"],
    "char": "🔺",
    "category": "symbols"
  },
  "black_small_square": {
    "keywords": ["shape", "icon"],
    "char": "▪️",
    "category": "symbols"
  },
  "white_small_square": {
    "keywords": ["shape", "icon"],
    "char": "▫️",
    "category": "symbols"
  },
  "black_large_square": {
    "keywords": ["shape", "icon", "button"],
    "char": "⬛",
    "category": "symbols"
  },
  "white_large_square": {
    "keywords": ["shape", "icon", "stone", "button"],
    "char": "⬜",
    "category": "symbols"
  },
  "small_red_triangle_down": {
    "keywords": ["shape", "direction", "bottom"],
    "char": "🔻",
    "category": "symbols"
  },
  "black_medium_square": {
    "keywords": ["shape", "button", "icon"],
    "char": "◼️",
    "category": "symbols"
  },
  "white_medium_square": {
    "keywords": ["shape", "stone", "icon"],
    "char": "◻️",
    "category": "symbols"
  },
  "black_medium_small_square": {
    "keywords": ["icon", "shape", "button"],
    "char": "◾",
    "category": "symbols"
  },
  "white_medium_small_square": {
    "keywords": ["shape", "stone", "icon", "button"],
    "char": "◽",
    "category": "symbols"
  },
  "black_square_button": {
    "keywords": ["shape", "input", "frame"],
    "char": "🔲",
    "category": "symbols"
  },
  "white_square_button": {
    "keywords": ["shape", "input"],
    "char": "🔳",
    "category": "symbols"
  },
  "speaker": {
    "keywords": ["sound", "volume", "silence", "broadcast"],
    "char": "🔈",
    "category": "symbols"
  },
  "sound": {
    "keywords": ["volume", "speaker", "broadcast"],
    "char": "🔉",
    "category": "symbols"
  },
  "loud_sound": {
    "keywords": ["volume", "noise", "noisy", "speaker", "broadcast"],
    "char": "🔊",
    "category": "symbols"
  },
  "mute": {
    "keywords": ["sound", "volume", "silence", "quiet"],
    "char": "🔇",
    "category": "symbols"
  },
  "mega": {
    "keywords": ["sound", "speaker", "volume"],
    "char": "📣",
    "category": "symbols"
  },
  "loudspeaker": {
    "keywords": ["volume", "sound"],
    "char": "📢",
    "category": "symbols"
  },
  "bell": {
    "keywords": ["sound", "notification", "christmas", "xmas", "chime"],
    "char": "🔔",
    "category": "symbols"
  },
  "no_bell": {
    "keywords": ["sound", "volume", "mute", "quiet", "silent"],
    "char": "🔕",
    "category": "symbols"
  },
  "black_joker": {
    "keywords": ["poker", "cards", "game", "play", "magic"],
    "char": "🃏",
    "category": "symbols"
  },
  "mahjong": {
    "keywords": ["game", "play", "chinese", "kanji"],
    "char": "🀄",
    "category": "symbols"
  },
  "spades": {
    "keywords": ["poker", "cards", "suits", "magic"],
    "char": "♠️",
    "category": "symbols"
  },
  "clubs": {
    "keywords": ["poker", "cards", "magic", "suits"],
    "char": "♣️",
    "category": "symbols"
  },
  "hearts": {
    "keywords": ["poker", "cards", "magic", "suits"],
    "char": "♥️",
    "category": "symbols"
  },
  "diamonds": {
    "keywords": ["poker", "cards", "magic", "suits"],
    "char": "♦️",
    "category": "symbols"
  },
  "flower_playing_cards": {
    "keywords": ["game", "sunset", "red"],
    "char": "🎴",
    "category": "symbols"
  },
  "thought_balloon": {
    "keywords": ["bubble", "cloud", "speech", "thinking"],
    "char": "💭",
    "category": "symbols"
  },
  "right_anger_bubble": {
    "keywords": ["caption", "speech", "thinking", "mad"],
    "char": "🗯",
    "category": "symbols"
  },
  "speech_balloon": {
    "keywords": ["bubble", "words", "message", "talk", "chatting"],
    "char": "💬",
    "category": "symbols"
  },
  "left_speech_bubble": {
    "keywords": ["words", "message", "talk", "chatting"],
    "char": "🗨",
    "category": "symbols"
  },
  "clock1": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕐",
    "category": "symbols"
  },
  "clock2": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕑",
    "category": "symbols"
  },
  "clock3": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕒",
    "category": "symbols"
  },
  "clock4": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕓",
    "category": "symbols"
  },
  "clock5": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕔",
    "category": "symbols"
  },
  "clock6": {
    "keywords": ["time", "late", "early", "schedule", "dawn", "dusk"],
    "char": "🕕",
    "category": "symbols"
  },
  "clock7": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕖",
    "category": "symbols"
  },
  "clock8": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕗",
    "category": "symbols"
  },
  "clock9": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕘",
    "category": "symbols"
  },
  "clock10": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕙",
    "category": "symbols"
  },
  "clock11": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕚",
    "category": "symbols"
  },
  "clock12": {
    "keywords": ["time", "noon", "midnight", "midday", "late", "early", "schedule"],
    "char": "🕛",
    "category": "symbols"
  },
  "clock130": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕜",
    "category": "symbols"
  },
  "clock230": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕝",
    "category": "symbols"
  },
  "clock330": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕞",
    "category": "symbols"
  },
  "clock430": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕟",
    "category": "symbols"
  },
  "clock530": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕠",
    "category": "symbols"
  },
  "clock630": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕡",
    "category": "symbols"
  },
  "clock730": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕢",
    "category": "symbols"
  },
  "clock830": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕣",
    "category": "symbols"
  },
  "clock930": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕤",
    "category": "symbols"
  },
  "clock1030": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕥",
    "category": "symbols"
  },
  "clock1130": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕦",
    "category": "symbols"
  },
  "clock1230": {
    "keywords": ["time", "late", "early", "schedule"],
    "char": "🕧",
    "category": "symbols"
  },
  "af": {
    "keywords": ["afghanistan", "flag", "nation", "country", "banner"],
    "char": "🇦🇫",
    "category": "flags"
  },
  "ax": {
    "keywords": ["Åland", "islands", "flag", "nation", "country", "banner"],
    "char": "🇦🇽",
    "category": "flags"
  },
  "al": {
    "keywords": ["albania", "flag", "nation", "country", "banner"],
    "char": "🇦🇱",
    "category": "flags"
  },
  "dz": {
    "keywords": ["algeria", "flag", "nation", "country", "banner"],
    "char": "🇩🇿",
    "category": "flags"
  },
  "as": {
    "keywords": ["american", "samoa", "flag", "nation", "country", "banner"],
    "char": "🇦🇸",
    "category": "flags"
  },
  "ad": {
    "keywords": ["andorra", "flag", "nation", "country", "banner"],
    "char": "🇦🇩",
    "category": "flags"
  },
  "ao": {
    "keywords": ["angola", "flag", "nation", "country", "banner"],
    "char": "🇦🇴",
    "category": "flags"
  },
  "ai": {
    "keywords": ["anguilla", "flag", "nation", "country", "banner"],
    "char": "🇦🇮",
    "category": "flags"
  },
  "aq": {
    "keywords": ["antarctica", "flag", "nation", "country", "banner"],
    "char": "🇦🇶",
    "category": "flags"
  },
  "ag": {
    "keywords": ["antigua", "barbuda", "flag", "nation", "country", "banner"],
    "char": "🇦🇬",
    "category": "flags"
  },
  "ar": {
    "keywords": ["argentina", "flag", "nation", "country", "banner"],
    "char": "🇦🇷",
    "category": "flags"
  },
  "am": {
    "keywords": ["armenia", "flag", "nation", "country", "banner"],
    "char": "🇦🇲",
    "category": "flags"
  },
  "aw": {
    "keywords": ["aruba", "flag", "nation", "country", "banner"],
    "char": "🇦🇼",
    "category": "flags"
  },
  "au": {
    "keywords": ["australia", "flag", "nation", "country", "banner"],
    "char": "🇦🇺",
    "category": "flags"
  },
  "at": {
    "keywords": ["austria", "flag", "nation", "country", "banner"],
    "char": "🇦🇹",
    "category": "flags"
  },
  "az": {
    "keywords": ["azerbaijan", "flag", "nation", "country", "banner"],
    "char": "🇦🇿",
    "category": "flags"
  },
  "bs": {
    "keywords": ["bahamas", "flag", "nation", "country", "banner"],
    "char": "🇧🇸",
    "category": "flags"
  },
  "bh": {
    "keywords": ["bahrain", "flag", "nation", "country", "banner"],
    "char": "🇧🇭",
    "category": "flags"
  },
  "bd": {
    "keywords": ["bangladesh", "flag", "nation", "country", "banner"],
    "char": "🇧🇩",
    "category": "flags"
  },
  "bb": {
    "keywords": ["barbados", "flag", "nation", "country", "banner"],
    "char": "🇧🇧",
    "category": "flags"
  },
  "by": {
    "keywords": ["belarus", "flag", "nation", "country", "banner"],
    "char": "🇧🇾",
    "category": "flags"
  },
  "be": {
    "keywords": ["belgium", "flag", "nation", "country", "banner"],
    "char": "🇧🇪",
    "category": "flags"
  },
  "bz": {
    "keywords": ["belize", "flag", "nation", "country", "banner"],
    "char": "🇧🇿",
    "category": "flags"
  },
  "bj": {
    "keywords": ["benin", "flag", "nation", "country", "banner"],
    "char": "🇧🇯",
    "category": "flags"
  },
  "bm": {
    "keywords": ["bermuda", "flag", "nation", "country", "banner"],
    "char": "🇧🇲",
    "category": "flags"
  },
  "bt": {
    "keywords": ["bhutan", "flag", "nation", "country", "banner"],
    "char": "🇧🇹",
    "category": "flags"
  },
  "bo": {
    "keywords": ["bolivia", "flag", "nation", "country", "banner"],
    "char": "🇧🇴",
    "category": "flags"
  },
  "bq": {
    "keywords": ["bonaire", "flag", "nation", "country", "banner"],
    "char": "🇧🇶",
    "category": "flags"
  },
  "ba": {
    "keywords": ["bosnia", "herzegovina", "flag", "nation", "country", "banner"],
    "char": "🇧🇦",
    "category": "flags"
  },
  "bw": {
    "keywords": ["botswana", "flag", "nation", "country", "banner"],
    "char": "🇧🇼",
    "category": "flags"
  },
  "br": {
    "keywords": ["brazil", "flag", "nation", "country", "banner"],
    "char": "🇧🇷",
    "category": "flags"
  },
  "io": {
    "keywords": ["british", "indian", "ocean", "territory", "flag", "nation", "country", "banner"],
    "char": "🇮🇴",
    "category": "flags"
  },
  "vg": {
    "keywords": ["british", "virgin", "islands", "bvi", "flag", "nation", "country", "banner"],
    "char": "🇻🇬",
    "category": "flags"
  },
  "bn": {
    "keywords": ["brunei", "darussalam", "flag", "nation", "country", "banner"],
    "char": "🇧🇳",
    "category": "flags"
  },
  "bg": {
    "keywords": ["bulgaria", "flag", "nation", "country", "banner"],
    "char": "🇧🇬",
    "category": "flags"
  },
  "bf": {
    "keywords": ["burkina", "faso", "flag", "nation", "country", "banner"],
    "char": "🇧🇫",
    "category": "flags"
  },
  "bi": {
    "keywords": ["burundi", "flag", "nation", "country", "banner"],
    "char": "🇧🇮",
    "category": "flags"
  },
  "cv": {
    "keywords": ["cabo", "verde", "flag", "nation", "country", "banner"],
    "char": "🇨🇻",
    "category": "flags"
  },
  "kh": {
    "keywords": ["cambodia", "flag", "nation", "country", "banner"],
    "char": "🇰🇭",
    "category": "flags"
  },
  "cm": {
    "keywords": ["cameroon", "flag", "nation", "country", "banner"],
    "char": "🇨🇲",
    "category": "flags"
  },
  "ca": {
    "keywords": ["canada", "flag", "nation", "country", "banner"],
    "char": "🇨🇦",
    "category": "flags"
  },
  "ic": {
    "keywords": ["canary", "islands", "flag", "nation", "country", "banner"],
    "char": "🇮🇨",
    "category": "flags"
  },
  "ky": {
    "keywords": ["cayman", "islands", "flag", "nation", "country", "banner"],
    "char": "🇰🇾",
    "category": "flags"
  },
  "cf": {
    "keywords": ["central", "african", "republic", "flag", "nation", "country", "banner"],
    "char": "🇨🇫",
    "category": "flags"
  },
  "td": {
    "keywords": ["chad", "flag", "nation", "country", "banner"],
    "char": "🇹🇩",
    "category": "flags"
  },
  "chile": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇨🇱",
    "category": "flags"
  },
  "cn": {
    "keywords": ["china", "chinese", "prc", "flag", "country", "nation", "banner"],
    "char": "🇨🇳",
    "category": "flags"
  },
  "cx": {
    "keywords": ["christmas", "island", "flag", "nation", "country", "banner"],
    "char": "🇨🇽",
    "category": "flags"
  },
  "cc": {
    "keywords": ["cocos", "keeling", "islands", "flag", "nation", "country", "banner"],
    "char": "🇨🇨",
    "category": "flags"
  },
  "co": {
    "keywords": ["colombia", "flag", "nation", "country", "banner"],
    "char": "🇨🇴",
    "category": "flags"
  },
  "km": {
    "keywords": ["comoros", "flag", "nation", "country", "banner"],
    "char": "🇰🇲",
    "category": "flags"
  },
  "cg": {
    "keywords": ["congo", "flag", "nation", "country", "banner"],
    "char": "🇨🇬",
    "category": "flags"
  },
  "drc": {
    "keywords": ["congo", "democratic", "republic", "flag", "nation", "country", "banner"],
    "char": "🇨🇩",
    "category": "flags"
  },
  "ck": {
    "keywords": ["cook", "islands", "flag", "nation", "country", "banner"],
    "char": "🇨🇰",
    "category": "flags"
  },
  "cr": {
    "keywords": ["costa", "rica", "flag", "nation", "country", "banner"],
    "char": "🇨🇷",
    "category": "flags"
  },
  "hr": {
    "keywords": ["croatia", "flag", "nation", "country", "banner"],
    "char": "🇭🇷",
    "category": "flags"
  },
  "cu": {
    "keywords": ["cuba", "flag", "nation", "country", "banner"],
    "char": "🇨🇺",
    "category": "flags"
  },
  "cw": {
    "keywords": ["curaçao", "flag", "nation", "country", "banner"],
    "char": "🇨🇼",
    "category": "flags"
  },
  "cy": {
    "keywords": ["cyprus", "flag", "nation", "country", "banner"],
    "char": "🇨🇾",
    "category": "flags"
  },
  "cz": {
    "keywords": ["czech_republic", "flag", "nation", "country", "banner"],
    "char": "🇨🇿",
    "category": "flags"
  },
  "dk": {
    "keywords": ["denmark", "flag", "nation", "country", "banner"],
    "char": "🇩🇰",
    "category": "flags"
  },
  "dj": {
    "keywords": ["djibouti", "flag", "nation", "country", "banner"],
    "char": "🇩🇯",
    "category": "flags"
  },
  "dm": {
    "keywords": ["dominica", "flag", "nation", "country", "banner"],
    "char": "🇩🇲",
    "category": "flags"
  },
  "do": {
    "keywords": ["dominican", "republic", "flag", "nation", "country", "banner"],
    "char": "🇩🇴",
    "category": "flags"
  },
  "ec": {
    "keywords": ["ecuador", "flag", "nation", "country", "banner"],
    "char": "🇪🇨",
    "category": "flags"
  },
  "eg": {
    "keywords": ["egypt", "flag", "nation", "country", "banner"],
    "char": "🇪🇬",
    "category": "flags"
  },
  "sv": {
    "keywords": ["el", "salvador", "flag", "nation", "country", "banner"],
    "char": "🇸🇻",
    "category": "flags"
  },
  "gq": {
    "keywords": ["equatorial", "guinea", "flag", "nation", "country", "banner"],
    "char": "🇬🇶",
    "category": "flags"
  },
  "er": {
    "keywords": ["eritrea", "flag", "nation", "country", "banner"],
    "char": "🇪🇷",
    "category": "flags"
  },
  "ee": {
    "keywords": ["estonia", "flag", "nation", "country", "banner"],
    "char": "🇪🇪",
    "category": "flags"
  },
  "et": {
    "keywords": ["ethiopia", "flag", "nation", "country", "banner"],
    "char": "🇪🇹",
    "category": "flags"
  },
  "eu": {
    "keywords": ["european", "union", "flag", "banner"],
    "char": "🇪🇺",
    "category": "flags"
  },
  "fk": {
    "keywords": ["falkland", "islands", "malvinas", "flag", "nation", "country", "banner"],
    "char": "🇫🇰",
    "category": "flags"
  },
  "fo": {
    "keywords": ["faroe", "islands", "flag", "nation", "country", "banner"],
    "char": "🇫🇴",
    "category": "flags"
  },
  "fj": {
    "keywords": ["fiji", "flag", "nation", "country", "banner"],
    "char": "🇫🇯",
    "category": "flags"
  },
  "fi": {
    "keywords": ["finland", "flag", "nation", "country", "banner"],
    "char": "🇫🇮",
    "category": "flags"
  },
  "fr": {
    "keywords": ["banner", "flag", "nation", "france", "french", "country"],
    "char": "🇫🇷",
    "category": "flags"
  },
  "gf": {
    "keywords": ["french", "guiana", "flag", "nation", "country", "banner"],
    "char": "🇬🇫",
    "category": "flags"
  },
  "pf": {
    "keywords": ["french", "polynesia", "flag", "nation", "country", "banner"],
    "char": "🇵🇫",
    "category": "flags"
  },
  "tf": {
    "keywords": ["french", "southern", "territories", "flag", "nation", "country", "banner"],
    "char": "🇹🇫",
    "category": "flags"
  },
  "ga": {
    "keywords": ["gabon", "flag", "nation", "country", "banner"],
    "char": "🇬🇦",
    "category": "flags"
  },
  "gm": {
    "keywords": ["gambia", "flag", "nation", "country", "banner"],
    "char": "🇬🇲",
    "category": "flags"
  },
  "ge": {
    "keywords": ["georgia", "flag", "nation", "country", "banner"],
    "char": "🇬🇪",
    "category": "flags"
  },
  "de": {
    "keywords": ["german", "nation", "flag", "country", "banner"],
    "char": "🇩🇪",
    "category": "flags"
  },
  "gh": {
    "keywords": ["ghana", "flag", "nation", "country", "banner"],
    "char": "🇬🇭",
    "category": "flags"
  },
  "gi": {
    "keywords": ["gibraltar", "flag", "nation", "country", "banner"],
    "char": "🇬🇮",
    "category": "flags"
  },
  "gr": {
    "keywords": ["greece", "flag", "nation", "country", "banner"],
    "char": "🇬🇷",
    "category": "flags"
  },
  "gl": {
    "keywords": ["greenland", "flag", "nation", "country", "banner"],
    "char": "🇬🇱",
    "category": "flags"
  },
  "gd": {
    "keywords": ["grenada", "flag", "nation", "country", "banner"],
    "char": "🇬🇩",
    "category": "flags"
  },
  "gp": {
    "keywords": ["guadeloupe", "flag", "nation", "country", "banner"],
    "char": "🇬🇵",
    "category": "flags"
  },
  "gu": {
    "keywords": ["guam", "flag", "nation", "country", "banner"],
    "char": "🇬🇺",
    "category": "flags"
  },
  "gt": {
    "keywords": ["guatemala", "flag", "nation", "country", "banner"],
    "char": "🇬🇹",
    "category": "flags"
  },
  "gg": {
    "keywords": ["guernsey", "flag", "nation", "country", "banner"],
    "char": "🇬🇬",
    "category": "flags"
  },
  "gn": {
    "keywords": ["guinea", "flag", "nation", "country", "banner"],
    "char": "🇬🇳",
    "category": "flags"
  },
  "gw": {
    "keywords": ["guinea", "bissau", "flag", "nation", "country", "banner"],
    "char": "🇬🇼",
    "category": "flags"
  },
  "gy": {
    "keywords": ["guyana", "flag", "nation", "country", "banner"],
    "char": "🇬🇾",
    "category": "flags"
  },
  "ht": {
    "keywords": ["haiti", "flag", "nation", "country", "banner"],
    "char": "🇭🇹",
    "category": "flags"
  },
  "hn": {
    "keywords": ["honduras", "flag", "nation", "country", "banner"],
    "char": "🇭🇳",
    "category": "flags"
  },
  "hk": {
    "keywords": ["hong", "kong", "flag", "nation", "country", "banner"],
    "char": "🇭🇰",
    "category": "flags"
  },
  "hu": {
    "keywords": ["hungary", "flag", "nation", "country", "banner"],
    "char": "🇭🇺",
    "category": "flags"
  },
  "is": {
    "keywords": ["iceland", "flag", "nation", "country", "banner"],
    "char": "🇮🇸",
    "category": "flags"
  },
  "in": {
    "keywords": ["india", "flag", "nation", "country", "banner"],
    "char": "🇮🇳",
    "category": "flags"
  },
  "indonesia": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇮🇩",
    "category": "flags"
  },
  "ir": {
    "keywords": ["iran,", "islamic", "republic", "flag", "nation", "country", "banner"],
    "char": "🇮🇷",
    "category": "flags"
  },
  "iq": {
    "keywords": ["iraq", "flag", "nation", "country", "banner"],
    "char": "🇮🇶",
    "category": "flags"
  },
  "ie": {
    "keywords": ["ireland", "flag", "nation", "country", "banner"],
    "char": "🇮🇪",
    "category": "flags"
  },
  "im": {
    "keywords": ["isle", "man", "flag", "nation", "country", "banner"],
    "char": "🇮🇲",
    "category": "flags"
  },
  "il": {
    "keywords": ["israel", "flag", "nation", "country", "banner"],
    "char": "🇮🇱",
    "category": "flags"
  },
  "it": {
    "keywords": ["italy", "flag", "nation", "country", "banner"],
    "char": "🇮🇹",
    "category": "flags"
  },
  "ci": {
    "keywords": ["ivory", "coast", "flag", "nation", "country", "banner"],
    "char": "🇨🇮",
    "category": "flags"
  },
  "jm": {
    "keywords": ["jamaica", "flag", "nation", "country", "banner"],
    "char": "🇯🇲",
    "category": "flags"
  },
  "jp": {
    "keywords": ["japanese", "nation", "flag", "country", "banner"],
    "char": "🇯🇵",
    "category": "flags"
  },
  "je": {
    "keywords": ["jersey", "flag", "nation", "country", "banner"],
    "char": "🇯🇪",
    "category": "flags"
  },
  "jo": {
    "keywords": ["jordan", "flag", "nation", "country", "banner"],
    "char": "🇯🇴",
    "category": "flags"
  },
  "kz": {
    "keywords": ["kazakhstan", "flag", "nation", "country", "banner"],
    "char": "🇰🇿",
    "category": "flags"
  },
  "ke": {
    "keywords": ["kenya", "flag", "nation", "country", "banner"],
    "char": "🇰🇪",
    "category": "flags"
  },
  "ki": {
    "keywords": ["kiribati", "flag", "nation", "country", "banner"],
    "char": "🇰🇮",
    "category": "flags"
  },
  "xk": {
    "keywords": ["kosovo", "flag", "nation", "country", "banner"],
    "char": "🇽🇰",
    "category": "flags"
  },
  "kw": {
    "keywords": ["kuwait", "flag", "nation", "country", "banner"],
    "char": "🇰🇼",
    "category": "flags"
  },
  "kg": {
    "keywords": ["kyrgyzstan", "flag", "nation", "country", "banner"],
    "char": "🇰🇬",
    "category": "flags"
  },
  "la": {
    "keywords": ["lao", "democratic", "republic", "flag", "nation", "country", "banner"],
    "char": "🇱🇦",
    "category": "flags"
  },
  "lv": {
    "keywords": ["latvia", "flag", "nation", "country", "banner"],
    "char": "🇱🇻",
    "category": "flags"
  },
  "lb": {
    "keywords": ["lebanon", "flag", "nation", "country", "banner"],
    "char": "🇱🇧",
    "category": "flags"
  },
  "ls": {
    "keywords": ["lesotho", "flag", "nation", "country", "banner"],
    "char": "🇱🇸",
    "category": "flags"
  },
  "lr": {
    "keywords": ["liberia", "flag", "nation", "country", "banner"],
    "char": "🇱🇷",
    "category": "flags"
  },
  "ly": {
    "keywords": ["libya", "flag", "nation", "country", "banner"],
    "char": "🇱🇾",
    "category": "flags"
  },
  "li": {
    "keywords": ["liechtenstein", "flag", "nation", "country", "banner"],
    "char": "🇱🇮",
    "category": "flags"
  },
  "lt": {
    "keywords": ["lithuania", "flag", "nation", "country", "banner"],
    "char": "🇱🇹",
    "category": "flags"
  },
  "lu": {
    "keywords": ["luxembourg", "flag", "nation", "country", "banner"],
    "char": "🇱🇺",
    "category": "flags"
  },
  "mo": {
    "keywords": ["macao", "flag", "nation", "country", "banner"],
    "char": "🇲🇴",
    "category": "flags"
  },
  "mk": {
    "keywords": ["macedonia,", "flag", "nation", "country", "banner"],
    "char": "🇲🇰",
    "category": "flags"
  },
  "mg": {
    "keywords": ["madagascar", "flag", "nation", "country", "banner"],
    "char": "🇲🇬",
    "category": "flags"
  },
  "mw": {
    "keywords": ["malawi", "flag", "nation", "country", "banner"],
    "char": "🇲🇼",
    "category": "flags"
  },
  "my": {
    "keywords": ["malaysia", "flag", "nation", "country", "banner"],
    "char": "🇲🇾",
    "category": "flags"
  },
  "mv": {
    "keywords": ["maldives", "flag", "nation", "country", "banner"],
    "char": "🇲🇻",
    "category": "flags"
  },
  "ml": {
    "keywords": ["mali", "flag", "nation", "country", "banner"],
    "char": "🇲🇱",
    "category": "flags"
  },
  "mt": {
    "keywords": ["malta", "flag", "nation", "country", "banner"],
    "char": "🇲🇹",
    "category": "flags"
  },
  "mh": {
    "keywords": ["marshall", "islands", "flag", "nation", "country", "banner"],
    "char": "🇲🇭",
    "category": "flags"
  },
  "mq": {
    "keywords": ["martinique", "flag", "nation", "country", "banner"],
    "char": "🇲🇶",
    "category": "flags"
  },
  "mr": {
    "keywords": ["mauritania", "flag", "nation", "country", "banner"],
    "char": "🇲🇷",
    "category": "flags"
  },
  "mu": {
    "keywords": ["mauritius", "flag", "nation", "country", "banner"],
    "char": "🇲🇺",
    "category": "flags"
  },
  "yt": {
    "keywords": ["mayotte", "flag", "nation", "country", "banner"],
    "char": "🇾🇹",
    "category": "flags"
  },
  "mx": {
    "keywords": ["mexico", "flag", "nation", "country", "banner"],
    "char": "🇲🇽",
    "category": "flags"
  },
  "fm": {
    "keywords": ["micronesia,", "federated", "states", "flag", "nation", "country", "banner"],
    "char": "🇫🇲",
    "category": "flags"
  },
  "md": {
    "keywords": ["moldova,", "republic", "flag", "nation", "country", "banner"],
    "char": "🇲🇩",
    "category": "flags"
  },
  "mc": {
    "keywords": ["monaco", "flag", "nation", "country", "banner"],
    "char": "🇲🇨",
    "category": "flags"
  },
  "mn": {
    "keywords": ["mongolia", "flag", "nation", "country", "banner"],
    "char": "🇲🇳",
    "category": "flags"
  },
  "me": {
    "keywords": ["montenegro", "flag", "nation", "country", "banner"],
    "char": "🇲🇪",
    "category": "flags"
  },
  "ms": {
    "keywords": ["montserrat", "flag", "nation", "country", "banner"],
    "char": "🇲🇸",
    "category": "flags"
  },
  "ma": {
    "keywords": ["morocco", "flag", "nation", "country", "banner"],
    "char": "🇲🇦",
    "category": "flags"
  },
  "mz": {
    "keywords": ["mozambique", "flag", "nation", "country", "banner"],
    "char": "🇲🇿",
    "category": "flags"
  },
  "mm": {
    "keywords": ["myanmar", "flag", "nation", "country", "banner"],
    "char": "🇲🇲",
    "category": "flags"
  },
  "na": {
    "keywords": ["namibia", "flag", "nation", "country", "banner"],
    "char": "🇳🇦",
    "category": "flags"
  },
  "nr": {
    "keywords": ["nauru", "flag", "nation", "country", "banner"],
    "char": "🇳🇷",
    "category": "flags"
  },
  "np": {
    "keywords": ["nepal", "flag", "nation", "country", "banner"],
    "char": "🇳🇵",
    "category": "flags"
  },
  "nl": {
    "keywords": ["netherlands", "flag", "nation", "country", "banner"],
    "char": "🇳🇱",
    "category": "flags"
  },
  "nc": {
    "keywords": ["new", "caledonia", "flag", "nation", "country", "banner"],
    "char": "🇳🇨",
    "category": "flags"
  },
  "nz": {
    "keywords": ["new", "zealand", "flag", "nation", "country", "banner"],
    "char": "🇳🇿",
    "category": "flags"
  },
  "ni": {
    "keywords": ["nicaragua", "flag", "nation", "country", "banner"],
    "char": "🇳🇮",
    "category": "flags"
  },
  "ne": {
    "keywords": ["niger", "flag", "nation", "country", "banner"],
    "char": "🇳🇪",
    "category": "flags"
  },
  "nigeria": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇳🇬",
    "category": "flags"
  },
  "nu": {
    "keywords": ["niue", "flag", "nation", "country", "banner"],
    "char": "🇳🇺",
    "category": "flags"
  },
  "nf": {
    "keywords": ["norfolk", "island", "flag", "nation", "country", "banner"],
    "char": "🇳🇫",
    "category": "flags"
  },
  "mp": {
    "keywords": ["northern", "mariana", "islands", "flag", "nation", "country", "banner"],
    "char": "🇲🇵",
    "category": "flags"
  },
  "kp": {
    "keywords": ["north", "korea", "nation", "flag", "country", "banner"],
    "char": "🇰🇵",
    "category": "flags"
  },
  "no": {
    "keywords": ["norway", "flag", "nation", "country", "banner"],
    "char": "🇳🇴",
    "category": "flags"
  },
  "om": {
    "keywords": ["oman", "flag", "nation", "country", "banner"],
    "char": "🇴🇲",
    "category": "flags"
  },
  "pk": {
    "keywords": ["pakistan", "flag", "nation", "country", "banner"],
    "char": "🇵🇰",
    "category": "flags"
  },
  "pw": {
    "keywords": ["palau", "flag", "nation", "country", "banner"],
    "char": "🇵🇼",
    "category": "flags"
  },
  "ps": {
    "keywords": ["palestine", "palestinian", "territories", "flag", "nation", "country", "banner"],
    "char": "🇵🇸",
    "category": "flags"
  },
  "pa": {
    "keywords": ["panama", "flag", "nation", "country", "banner"],
    "char": "🇵🇦",
    "category": "flags"
  },
  "pg": {
    "keywords": ["papua", "new", "guinea", "flag", "nation", "country", "banner"],
    "char": "🇵🇬",
    "category": "flags"
  },
  "py": {
    "keywords": ["paraguay", "flag", "nation", "country", "banner"],
    "char": "🇵🇾",
    "category": "flags"
  },
  "pe": {
    "keywords": ["peru", "flag", "nation", "country", "banner"],
    "char": "🇵🇪",
    "category": "flags"
  },
  "ph": {
    "keywords": ["philippines", "flag", "nation", "country", "banner"],
    "char": "🇵🇭",
    "category": "flags"
  },
  "pn": {
    "keywords": ["pitcairn", "flag", "nation", "country", "banner"],
    "char": "🇵🇳",
    "category": "flags"
  },
  "pl": {
    "keywords": ["poland", "flag", "nation", "country", "banner"],
    "char": "🇵🇱",
    "category": "flags"
  },
  "pt": {
    "keywords": ["portugal", "flag", "nation", "country", "banner"],
    "char": "🇵🇹",
    "category": "flags"
  },
  "pr": {
    "keywords": ["puerto", "rico", "flag", "nation", "country", "banner"],
    "char": "🇵🇷",
    "category": "flags"
  },
  "qa": {
    "keywords": ["qatar", "flag", "nation", "country", "banner"],
    "char": "🇶🇦",
    "category": "flags"
  },
  "re": {
    "keywords": ["réunion", "flag", "nation", "country", "banner"],
    "char": "🇷🇪",
    "category": "flags"
  },
  "ro": {
    "keywords": ["romania", "flag", "nation", "country", "banner"],
    "char": "🇷🇴",
    "category": "flags"
  },
  "ru": {
    "keywords": ["russian", "federation", "flag", "nation", "country", "banner"],
    "char": "🇷🇺",
    "category": "flags"
  },
  "rw": {
    "keywords": ["rwanda", "flag", "nation", "country", "banner"],
    "char": "🇷🇼",
    "category": "flags"
  },
  "bl": {
    "keywords": ["saint", "barthélemy", "flag", "nation", "country", "banner"],
    "char": "🇧🇱",
    "category": "flags"
  },
  "sh": {
    "keywords": ["saint", "helena", "ascension", "tristan", "cunha", "flag", "nation", "country", "banner"],
    "char": "🇸🇭",
    "category": "flags"
  },
  "kn": {
    "keywords": ["saint", "kitts", "nevis", "flag", "nation", "country", "banner"],
    "char": "🇰🇳",
    "category": "flags"
  },
  "lc": {
    "keywords": ["saint", "lucia", "flag", "nation", "country", "banner"],
    "char": "🇱🇨",
    "category": "flags"
  },
  "pm": {
    "keywords": ["saint", "pierre", "miquelon", "flag", "nation", "country", "banner"],
    "char": "🇵🇲",
    "category": "flags"
  },
  "vc": {
    "keywords": ["saint", "vincent", "grenadines", "flag", "nation", "country", "banner"],
    "char": "🇻🇨",
    "category": "flags"
  },
  "ws": {
    "keywords": ["samoa", "flag", "nation", "country", "banner"],
    "char": "🇼🇸",
    "category": "flags"
  },
  "sm": {
    "keywords": ["san", "marino", "flag", "nation", "country", "banner"],
    "char": "🇸🇲",
    "category": "flags"
  },
  "st": {
    "keywords": ["sao", "tome", "principe", "flag", "nation", "country", "banner"],
    "char": "🇸🇹",
    "category": "flags"
  },
  "saudi_arabia": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇸🇦",
    "category": "flags"
  },
  "sn": {
    "keywords": ["senegal", "flag", "nation", "country", "banner"],
    "char": "🇸🇳",
    "category": "flags"
  },
  "rs": {
    "keywords": ["serbia", "flag", "nation", "country", "banner"],
    "char": "🇷🇸",
    "category": "flags"
  },
  "sc": {
    "keywords": ["seychelles", "flag", "nation", "country", "banner"],
    "char": "🇸🇨",
    "category": "flags"
  },
  "sl": {
    "keywords": ["sierra", "leone", "flag", "nation", "country", "banner"],
    "char": "🇸🇱",
    "category": "flags"
  },
  "sg": {
    "keywords": ["singapore", "flag", "nation", "country", "banner"],
    "char": "🇸🇬",
    "category": "flags"
  },
  "sx": {
    "keywords": ["sint", "maarten", "dutch", "flag", "nation", "country", "banner"],
    "char": "🇸🇽",
    "category": "flags"
  },
  "sk": {
    "keywords": ["slovakia", "flag", "nation", "country", "banner"],
    "char": "🇸🇰",
    "category": "flags"
  },
  "si": {
    "keywords": ["slovenia", "flag", "nation", "country", "banner"],
    "char": "🇸🇮",
    "category": "flags"
  },
  "sb": {
    "keywords": ["solomon", "islands", "flag", "nation", "country", "banner"],
    "char": "🇸🇧",
    "category": "flags"
  },
  "so": {
    "keywords": ["somalia", "flag", "nation", "country", "banner"],
    "char": "🇸🇴",
    "category": "flags"
  },
  "za": {
    "keywords": ["south", "africa", "flag", "nation", "country", "banner"],
    "char": "🇿🇦",
    "category": "flags"
  },
  "gs": {
    "keywords": ["south", "georgia", "sandwich", "islands", "flag", "nation", "country", "banner"],
    "char": "🇬🇸",
    "category": "flags"
  },
  "kr": {
    "keywords": ["south", "korea", "nation", "flag", "country", "banner"],
    "char": "🇰🇷",
    "category": "flags"
  },
  "ss": {
    "keywords": ["south", "sudan", "flag", "nation", "country", "banner"],
    "char": "🇸🇸",
    "category": "flags"
  },
  "es": {
    "keywords": ["spain", "flag", "nation", "country", "banner"],
    "char": "🇪🇸",
    "category": "flags"
  },
  "lk": {
    "keywords": ["sri", "lanka", "flag", "nation", "country", "banner"],
    "char": "🇱🇰",
    "category": "flags"
  },
  "sd": {
    "keywords": ["sudan", "flag", "nation", "country", "banner"],
    "char": "🇸🇩",
    "category": "flags"
  },
  "sr": {
    "keywords": ["suriname", "flag", "nation", "country", "banner"],
    "char": "🇸🇷",
    "category": "flags"
  },
  "sz": {
    "keywords": ["swaziland", "flag", "nation", "country", "banner"],
    "char": "🇸🇿",
    "category": "flags"
  },
  "se": {
    "keywords": ["sweden", "flag", "nation", "country", "banner"],
    "char": "🇸🇪",
    "category": "flags"
  },
  "ch": {
    "keywords": ["switzerland", "flag", "nation", "country", "banner"],
    "char": "🇨🇭",
    "category": "flags"
  },
  "sy": {
    "keywords": ["syrian", "arab", "republic", "flag", "nation", "country", "banner"],
    "char": "🇸🇾",
    "category": "flags"
  },
  "tw": {
    "keywords": ["taiwan", "flag", "nation", "country", "banner"],
    "char": "🇹🇼",
    "category": "flags"
  },
  "tj": {
    "keywords": ["tajikistan", "flag", "nation", "country", "banner"],
    "char": "🇹🇯",
    "category": "flags"
  },
  "tz": {
    "keywords": ["tanzania,", "united", "republic", "flag", "nation", "country", "banner"],
    "char": "🇹🇿",
    "category": "flags"
  },
  "th": {
    "keywords": ["thailand", "flag", "nation", "country", "banner"],
    "char": "🇹🇭",
    "category": "flags"
  },
  "tl": {
    "keywords": ["timor", "leste", "flag", "nation", "country", "banner"],
    "char": "🇹🇱",
    "category": "flags"
  },
  "tg": {
    "keywords": ["togo", "flag", "nation", "country", "banner"],
    "char": "🇹🇬",
    "category": "flags"
  },
  "tk": {
    "keywords": ["tokelau", "flag", "nation", "country", "banner"],
    "char": "🇹🇰",
    "category": "flags"
  },
  "to": {
    "keywords": ["tonga", "flag", "nation", "country", "banner"],
    "char": "🇹🇴",
    "category": "flags"
  },
  "tt": {
    "keywords": ["trinidad", "tobago", "flag", "nation", "country", "banner"],
    "char": "🇹🇹",
    "category": "flags"
  },
  "tn": {
    "keywords": ["tunisia", "flag", "nation", "country", "banner"],
    "char": "🇹🇳",
    "category": "flags"
  },
  "tr": {
    "keywords": ["turkey", "flag", "nation", "country", "banner"],
    "char": "🇹🇷",
    "category": "flags"
  },
  "turkmenistan": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇹🇲",
    "category": "flags"
  },
  "tc": {
    "keywords": ["turks", "caicos", "islands", "flag", "nation", "country", "banner"],
    "char": "🇹🇨",
    "category": "flags"
  },
  "tuvalu": {
    "keywords": ["flag", "nation", "country", "banner"],
    "char": "🇹🇻",
    "category": "flags"
  },
  "ug": {
    "keywords": ["uganda", "flag", "nation", "country", "banner"],
    "char": "🇺🇬",
    "category": "flags"
  },
  "ua": {
    "keywords": ["ukraine", "flag", "nation", "country", "banner"],
    "char": "🇺🇦",
    "category": "flags"
  },
  "ae": {
    "keywords": ["united", "arab", "emirates", "flag", "nation", "country", "banner"],
    "char": "🇦🇪",
    "category": "flags"
  },
  "gb": {
    "keywords": ["united", "kingdom", "great", "britain", "northern", "ireland", "flag", "nation", "country", "banner", "british", "UK", "english", "england", "union jack"],
    "char": "🇬🇧",
    "category": "flags"
  },
  "us": {
    "keywords": ["united", "states", "america", "flag", "nation", "country", "banner"],
    "char": "🇺🇸",
    "category": "flags"
  },
  "vi": {
    "keywords": ["virgin", "islands", "us", "flag", "nation", "country", "banner"],
    "char": "🇻🇮",
    "category": "flags"
  },
  "uy": {
    "keywords": ["uruguay", "flag", "nation", "country", "banner"],
    "char": "🇺🇾",
    "category": "flags"
  },
  "uz": {
    "keywords": ["uzbekistan", "flag", "nation", "country", "banner"],
    "char": "🇺🇿",
    "category": "flags"
  },
  "vu": {
    "keywords": ["vanuatu", "flag", "nation", "country", "banner"],
    "char": "🇻🇺",
    "category": "flags"
  },
  "va": {
    "keywords": ["vatican", "city", "flag", "nation", "country", "banner"],
    "char": "🇻🇦",
    "category": "flags"
  },
  "ve": {
    "keywords": ["venezuela", "bolivarian", "republic", "flag", "nation", "country", "banner"],
    "char": "🇻🇪",
    "category": "flags"
  },
  "vn": {
    "keywords": ["viet", "nam", "flag", "nation", "country", "banner"],
    "char": "🇻🇳",
    "category": "flags"
  },
  "wf": {
    "keywords": ["wallis", "futuna", "flag", "nation", "country", "banner"],
    "char": "🇼🇫",
    "category": "flags"
  },
  "eh": {
    "keywords": ["western", "sahara", "flag", "nation", "country", "banner"],
    "char": "🇪🇭",
    "category": "flags"
  },
  "ye": {
    "keywords": ["yemen", "flag", "nation", "country", "banner"],
    "char": "🇾🇪",
    "category": "flags"
  },
  "zm": {
    "keywords": ["zambia", "flag", "nation", "country", "banner"],
    "char": "🇿🇲",
    "category": "flags"
  },
  "zw": {
    "keywords": ["zimbabwe", "flag", "nation", "country", "banner"],
    "char": "🇿🇼",
    "category": "flags"
  },
  "octocat": {
    "keywords": ["animal", "octopus", "github", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "shipit": {
    "keywords": ["squirrel", "detective", "animal", "sherlock", "inspector", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "bowtie": {
    "keywords": ["face", "formal", "fashion", "suit", "classy", "magic", "circus"],
    "char": null,
    "category": "_custom"
  },
  "neckbeard": {
    "keywords": ["nerdy", "face", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "metal": {
    "keywords": ["fingers", "rocknroll", "concert", "band", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "fu": {
    "keywords": ["fuck", "finger", "dislike", "thumbsdown", "disapprove", "no", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "trollface": {
    "keywords": ["internet", "meme", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "godmode": {
    "keywords": ["doom", "oldschool"],
    "char": null,
    "category": "_custom"
  },
  "goberserk": {
    "keywords": ["doom", "rage", "bloody", "hurt"],
    "char": null,
    "category": "_custom"
  },
  "finnadie": {
    "keywords": ["doom", "oldschool"],
    "char": null,
    "category": "_custom"
  },
  "feelsgood": {
    "keywords": ["doom", "oldschool"],
    "char": null,
    "category": "_custom"
  },
  "rage1": {
    "keywords": ["angry", "mad", "hate", "despise"],
    "char": null,
    "category": "_custom"
  },
  "rage2": {
    "keywords": ["angry", "mad", "hate", "despise"],
    "char": null,
    "category": "_custom"
  },
  "rage3": {
    "keywords": ["angry", "mad", "hate", "despise"],
    "char": null,
    "category": "_custom"
  },
  "rage4": {
    "keywords": ["angry", "mad", "hate", "despise"],
    "char": null,
    "category": "_custom"
  },
  "suspect": {
    "keywords": ["mad", "custom_"],
    "char": null,
    "category": "_custom"
  },
  "hurtrealbad": {
    "keywords": ["mad", "injured", "doom", "oldschool", "custom_"],
    "char": null,
    "category": "_custom"
  }
};
let EmojiSelectorPanelComponent = /*#__PURE__*/(() => {
  class EmojiSelectorPanelComponent {
    constructor(sanitizer, sdkOptions) {
      this.sanitizer = sanitizer;
      this.sdkOptions = sdkOptions;
      this.activeCategory = 'people';
      this.searchResults = [];
      this.searchVisible = false;
      this.selected = new Subject();
    }
    get searchQuery() {
      return this._searchQuery;
    }
    set searchQuery(value) {
      this._searchQuery = value;
      setTimeout(() => {
        this.searchResults = Object.keys(EMOJIS).filter(k => k.includes(value)).map(k => EMOJIS[k]);
        this.searchResults.splice(50, this.searchResults.length);
        console.log(`looking for '${value}' => ${this.searchResults.length} results`);
      });
    }
    humanize(str) {
      return str.replace(/(^| )[a-z]/g, k => k.toUpperCase()).replace(/_/g, ' ');
    }
    select(char) {
      this.selected.next(char);
    }
    pairs(object) {
      return Object.keys(object).map(key => [key, object[key]]);
    }
    hideSearch() {
      // because of the "outside click detection"
      setTimeout(() => {
        this.searchVisible = false;
      });
    }
    showSearch() {
      // because of the "outside click detection"
      setTimeout(() => {
        this.searchVisible = true;
      });
    }
    get emojiUrl() {
      return this.sdkOptions?.emojiUrl ?? 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/';
    }
    ngOnInit() {
      let cats = {};
      let categoryIcons = {
        symbols: 'warning',
        people: 'people',
        animals_and_nature: 'nature',
        travel_and_places: 'location_on',
        activity: 'local_activity',
        food_and_drink: 'restaurant',
        objects: 'computer',
        flags: 'flag'
      };
      for (let pair of this.pairs(EMOJIS)) {
        let name = pair[0];
        let emoji = pair[1];
        if (!cats[emoji.category]) {
          cats[emoji.category] = {
            name: emoji.category,
            icon: categoryIcons[emoji.category] || 'code',
            emojis: []
          };
        }
        emoji.html = this.sanitizer.bypassSecurityTrustHtml(twemoji.parse(emoji.char || '', {
          base: this.emojiUrl
        }));
        cats[emoji.category].emojis.push(emoji);
      }
      this.categories = this.pairs(cats).map(pair => pair[1]);
    }
    static {
      this.ɵfac = function EmojiSelectorPanelComponent_Factory(t) {
        return new (t || EmojiSelectorPanelComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(BANTA_SDK_OPTIONS, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmojiSelectorPanelComponent,
        selectors: [["emoji-selector-panel"]],
        outputs: {
          selected: "selected"
        },
        decls: 4,
        vars: 3,
        consts: [["class", "search-box", 4, "ngIf"], [1, "selector"], [4, "ngIf"], [1, "search-box"], ["mat-icon-button", "", "href", "javascript:;", 3, "click"], ["appearance", "outline", "floatLabel", "always"], ["name", "search", "type", "text", "matInput", "", "placeholder", "Start typing", 3, "ngModelChange", "ngModel"], [1, "emoji-list"], ["href", "javascript:;", 3, "innerHtml", "click", 4, "ngFor", "ngForOf"], ["href", "javascript:;", 3, "click", "innerHtml"], [1, "categories"], [4, "ngFor", "ngForOf"], ["mat-icon-button", "", 3, "title", "active", "click", 4, "ngFor", "ngForOf"], ["title", "Search", "mat-icon-button", "", 3, "click", "active"], ["mat-icon-button", "", 3, "click", "title"], ["class", "emoji-list", 4, "ngIf"]],
        template: function EmojiSelectorPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EmojiSelectorPanelComponent_div_0_Template, 8, 1, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, EmojiSelectorPanelComponent_ng_container_2_Template, 3, 1, "ng-container", 2)(3, EmojiSelectorPanelComponent_ng_container_3_Template, 4, 2, "ng-container", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.searchVisible);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.searchVisible);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.searchVisible);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgModel, i2$1.MatIcon, i6.MatIconAnchor, i6$1.MatFormField, i6$1.MatLabel, i7.MatInput],
        styles: ["[_nghost-%COMP%]{background:#111;color:#fff;border:1px solid #333;border-radius:5px;padding:.5em;width:calc(9*(32px + 1em));max-width:calc(100vw - 1.5em - 5px)}.selector[_ngcontent-%COMP%]{display:flex;flex-direction:column}.categories[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{opacity:.25;transition:.4s opacity ease-in-out}.categories[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{opacity:.5}.categories[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{opacity:1}.emoji-list[_ngcontent-%COMP%]{flex-grow:1;overflow-y:auto;height:20em}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;padding:2px;margin:4px;background-color:#111}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]     .emoji{width:32px;height:32px}.emoji-list[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{background-color:#333}.search-box[_ngcontent-%COMP%]{display:flex;align-items:baseline}.search-box[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{flex-grow:1}@media (max-width: 500px){.selector[_ngcontent-%COMP%]{flex-direction:row;height:27em}.emoji-list[_ngcontent-%COMP%]{height:auto}}.banta-mobile[_nghost-%COMP%]   .selector[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .selector[_ngcontent-%COMP%]{flex-direction:row;height:27em}.banta-mobile[_nghost-%COMP%]   .emoji-list[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .emoji-list[_ngcontent-%COMP%]{height:auto}"]
      });
    }
  }
  return EmojiSelectorPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmojiSelectorButtonComponent = /*#__PURE__*/(() => {
  class EmojiSelectorButtonComponent {
    constructor(elementRef, overlay) {
      this.elementRef = elementRef;
      this.overlay = overlay;
      this._selected = new Subject();
      this.showEmojiPanel = false;
      this.disabled = false;
      this.overlayX = 'end';
      this.overlayY = 'top';
      this.originX = 'end';
      this.originY = 'bottom';
    }
    get selected() {
      return this._selected;
    }
    get isOpen() {
      return this.overlayRef;
    }
    /**
     * Insert the given emoji.
     * @param str
     */
    insert(str) {
      this._selected.next(str);
      this.close();
    }
    close() {
      if (this.overlayRef) {
        this.overlayRef.dispose();
        this.overlayRef = null;
      }
    }
    show() {
      if (this.isOpen) {
        this.close();
      }
      this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay.position().flexibleConnectedTo(this.elementRef).withPositions([{
          originX: this.originX,
          originY: this.originY,
          overlayX: this.overlayX,
          overlayY: this.overlayY
        }]).withFlexibleDimensions(true),
        hasBackdrop: true,
        disposeOnNavigation: true,
        scrollStrategy: this.overlay.scrollStrategies.reposition({
          autoClose: true
        })
      });
      this.overlayRef.backdropClick().subscribe(() => {
        this.close();
      });
      this.overlayRef.keydownEvents().subscribe(event => {
        if (event.key === 'Escape') {
          this.close();
        }
      });
      this.overlayRef.attach(this.selectorPanelTemplate);
    }
    static {
      this.ɵfac = function EmojiSelectorButtonComponent_Factory(t) {
        return new (t || EmojiSelectorButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.Overlay));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EmojiSelectorButtonComponent,
        selectors: [["emoji-selector-button"]],
        viewQuery: function EmojiSelectorButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectorPanelTemplate = _t.first);
          }
        },
        inputs: {
          disabled: "disabled",
          overlayX: "overlayX",
          overlayY: "overlayY",
          originX: "originX",
          originY: "originY"
        },
        outputs: {
          selected: "selected"
        },
        decls: 6,
        vars: 1,
        consts: [["button", ""], ["selectorPanelTemplate", "cdkPortal"], ["panel", ""], ["type", "button", "mat-icon-button", "", 3, "click", "disabled"], ["cdkPortal", ""], [3, "selected"]],
        template: function EmojiSelectorButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 3, 0);
            i0.ɵɵlistener("click", function EmojiSelectorButtonComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.show());
            });
            i0.ɵɵelementStart(2, "mat-icon");
            i0.ɵɵtext(3, "emoji_emotions");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, EmojiSelectorButtonComponent_ng_template_4_Template, 2, 0, "ng-template", 4, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
          }
        },
        dependencies: [i2$1.MatIcon, i6.MatIconButton, i4.CdkPortal, EmojiSelectorPanelComponent],
        styles: ["[_nghost-%COMP%]{display:block;position:relative}button[_ngcontent-%COMP%]{color:#666}"]
      });
    }
  }
  return EmojiSelectorButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS$2 = [EmojiSelectorPanelComponent, EmojiSelectorButtonComponent];
let EmojiModule = /*#__PURE__*/(() => {
  class EmojiModule {
    static {
      this.ɵfac = function EmojiModule_Factory(t) {
        return new (t || EmojiModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EmojiModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, OverlayModule, PortalModule]
      });
    }
  }
  return EmojiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ChatBackendBase {
  constructor() {
    this._userChanged = new BehaviorSubject(null);
    this._attachmentScrapers = [];
    this._attachmentResolvers = [];
  }
  get userChanged() {
    return this._userChanged;
  }
  set user(user) {
    this._user = user;
    this._userChanged.next(user);
  }
  get user() {
    return this._user;
  }
  registerAttachmentScraper(scraper) {
    this._attachmentScrapers.push(scraper);
  }
  registerAttachmentResolver(resolver) {
    this._attachmentResolvers.push(resolver);
  }
  get attachmentScrapers() {
    return this._attachmentScrapers.slice();
  }
  get attachmentResolvers() {
    return this._attachmentResolvers.slice();
  }
}
let CommentComponent = /*#__PURE__*/(() => {
  class CommentComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
      //#endregion
      //#region Properties
      this.isLoaded = false;
      this.showReplyAction = true;
      this.maxLength = 1500;
      this.mine = false;
      this.editing = false;
      this.readonly = false;
      //#endregion
      //#region Outputs
      this._reported = new Subject();
      this._selected = new Subject();
      this._liked = new Subject();
      this._unliked = new Subject();
      this._shared = new Subject();
      this._userSelected = new Subject();
      this._avatarSelected = new Subject();
      this._usernameSelected = new Subject();
      this._editStarted = new Subject();
      this._deleted = new Subject();
      this._editEnded = new Subject();
      this._edited = new Subject();
      this._loaded = new Subject();
      this.liked = this._liked.asObservable();
      this.unliked = this._unliked.asObservable();
      this.selected = this._selected.asObservable();
      this.edited = this._edited.asObservable();
      this.deleted = this._deleted.asObservable();
      this.editStarted = this._editStarted.asObservable();
      this.editEnded = this._editEnded.asObservable();
      this.shared = this._shared.asObservable();
      this.userSelected = this._userSelected.asObservable();
      this.usernameSelected = this._usernameSelected.asObservable();
      this.avatarSelected = this._avatarSelected.asObservable();
      this.reported = this._reported.asObservable();
      this.loaded = this._loaded.asObservable();
      this.isNew = false;
      this.visible = false;
    }
    ngOnInit() {
      let maxTime = 100;
      let minTime = 0;
      let randomTime = minTime + Math.random() * (maxTime - minTime);
      setTimeout(() => {
        this.isNew = true;
        this.visible = true;
        setTimeout(() => this.isNew = false, 1000);
      }, randomTime);
    }
    //#region Message
    get message() {
      return this._message;
    }
    set message(value) {
      this.setMessage(value);
    }
    //#endregion
    //#region UI Bindings
    get commentId() {
      return this.message?.id;
    }
    get isHighlighted() {
      return this.message?.transientState?.highlighted ?? false;
    }
    get replyCount() {
      return this.message.submessages?.length || this.message.submessageCount || 0;
    }
    get element() {
      return this.elementRef.nativeElement;
    }
    avatarForUser(user) {
      return `url(${user?.avatarUrl ?? this.genericAvatarUrl})`;
    }
    //#endregion
    //#region Public Component API
    async waitForLoad() {
      (await this.isLoaded) ? Promise.resolve() : this.loaded.pipe(take(1)).toPromise();
    }
    //#endregion
    //#region Private API
    setMessage(value) {
      this._message = value;
      if (this._message.attachments?.length > 0) {
        this.isLoaded = false;
      } else {
        this.isLoaded = true;
        this._loaded.next();
      }
    }
    //#endregion
    //#region Actions
    markAttachmentsLoaded() {
      this.isLoaded = true;
      this._loaded.next();
    }
    saveEdit() {
      this._edited.next(this.editedMessage);
    }
    endEditing() {
      this._editEnded.next();
    }
    delete() {
      this._deleted.next();
    }
    report() {
      this._reported.next();
    }
    like() {
      this._liked.next();
    }
    unlike() {
      this._unliked.next();
    }
    share() {
      this._shared.next(this.message);
    }
    select() {
      this._selected.next();
    }
    selectUser() {
      this._userSelected.next();
    }
    startEdit() {
      this._editStarted.next();
      this.editedMessage = this.message.message;
    }
    selectUsername(user) {
      this._usernameSelected.next(user);
      this.selectUser();
    }
    selectAvatar(user) {
      this._avatarSelected.next(user);
      this.selectUser();
    }
    static {
      this.ɵfac = function CommentComponent_Factory(t) {
        return new (t || CommentComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CommentComponent,
        selectors: [["banta-comment"]],
        hostVars: 7,
        hostBindings: function CommentComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-comment-id", ctx.commentId);
            i0.ɵɵclassProp("new", ctx.isNew)("highlighted", ctx.isHighlighted)("visible", ctx.visible);
          }
        },
        inputs: {
          message: "message",
          customMenuItems: "customMenuItems",
          showReplyAction: "showReplyAction",
          maxLength: "maxLength",
          permissions: "permissions",
          mine: "mine",
          editing: "editing",
          genericAvatarUrl: "genericAvatarUrl",
          readonly: "readonly"
        },
        outputs: {
          liked: "liked",
          unliked: "unliked",
          selected: "selected",
          edited: "edited",
          deleted: "deleted",
          editStarted: "editStarted",
          editEnded: "editEnded",
          shared: "shared",
          userSelected: "userSelected",
          usernameSelected: "usernameSelected",
          avatarSelected: "avatarSelected",
          reported: "reported",
          loaded: "loaded"
        },
        decls: 34,
        vars: 18,
        consts: [["pointItemMenu", "matMenu"], ["mat-menu-item", "", 3, "click"], ["mat-menu-item", "", 3, "click", 4, "ngIf"], ["mat-menu-item", "", 3, "disabled", "click", 4, "ngIf"], ["mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], [1, "banta-message-content-container"], [1, "banta-user"], [1, "banta-user-1"], ["href", "javascript:;", 1, "banta-avatar", 3, "click"], [1, "banta-user-identity"], ["href", "javascript:;", 1, "banta-display-name", 3, "click"], ["href", "javascript:;", 1, "banta-username", 3, "click"], [1, "banta-user-2"], ["class", "banta-user-tag", 4, "ngIf"], [3, "value"], [1, "spacer"], ["class", "banta-content", 4, "ngIf"], ["class", "banta-content", "style", "padding-bottom: 2em;", 4, "ngIf"], [1, "banta-actions"], ["class", "banta-counted-action", 4, "ngIf"], [1, "banta-counted-action"], ["mat-icon-button", "", "matTooltipPosition", "below", 3, "disabled", "matTooltip", 4, "ngIf"], ["mat-button", "", "matTooltipPosition", "below", 3, "disabled", "matTooltip", "click", 4, "ngIf"], ["mat-icon-button", "", 3, "matMenuTriggerFor"], ["mat-menu-item", "", 3, "click", "disabled"], [1, "banta-user-tag"], [1, "banta-content"], [1, "banta-message-content", 3, "innerHTML"], [3, "loaded", "attachments"], [1, "message-facts"], [4, "ngIf"], [1, "banta-content", 2, "padding-bottom", "2em"], ["floatLabel", "always", "appearance", "outline", 2, "width", "100%"], ["matInput", "", 3, "ngModelChange", "ngModel", "maxlength"], ["mat-raised-button", "", 3, "click"], ["mat-button", "", 3, "click"], ["mat-button", "", "matTooltipPosition", "below", 3, "click", "matTooltip"], [1, "banta-count-indicator"], ["mat-icon-button", "", "matTooltipPosition", "below", 3, "disabled", "matTooltip"], [2, "margin-left", "1em", 3, "diameter"], ["mat-button", "", "matTooltipPosition", "below", 3, "click", "disabled", "matTooltip"], ["class", "banta-count-indicator", 4, "ngIf"]],
        template: function CommentComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-menu", null, 0)(2, "button", 1);
            i0.ɵɵlistener("click", function CommentComponent_Template_button_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.share());
            });
            i0.ɵɵelementStart(3, "mat-icon");
            i0.ɵɵtext(4, "share");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5, " Share ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, CommentComponent_button_6_Template, 4, 0, "button", 2)(7, CommentComponent_button_7_Template, 4, 1, "button", 3)(8, CommentComponent_button_8_Template, 4, 1, "button", 3)(9, CommentComponent_button_9_Template, 4, 2, "button", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 5)(11, "div", 6)(12, "div", 7)(13, "a", 8);
            i0.ɵɵlistener("click", function CommentComponent_Template_a_click_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectAvatar(ctx.message.user));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 9)(15, "a", 10);
            i0.ɵɵlistener("click", function CommentComponent_Template_a_click_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectUser());
            });
            i0.ɵɵtext(16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "a", 11);
            i0.ɵɵlistener("click", function CommentComponent_Template_a_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectUsername(ctx.message.user));
            });
            i0.ɵɵtext(18);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 12);
            i0.ɵɵtemplate(20, CommentComponent_span_20_Template, 2, 1, "span", 13);
            i0.ɵɵelement(21, "banta-timestamp", 14)(22, "span", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(23, CommentComponent_div_23_Template, 7, 8, "div", 16)(24, CommentComponent_div_24_Template, 11, 2, "div", 17);
            i0.ɵɵelementStart(25, "div", 18);
            i0.ɵɵelement(26, "div", 15);
            i0.ɵɵtemplate(27, CommentComponent_div_27_Template, 6, 3, "div", 19);
            i0.ɵɵelementStart(28, "div", 20);
            i0.ɵɵtemplate(29, CommentComponent_button_29_Template, 2, 3, "button", 21)(30, CommentComponent_button_30_Template, 4, 3, "button", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "button", 23)(32, "mat-icon");
            i0.ɵɵtext(33, "more_vert");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            const pointItemMenu_r12 = i0.ɵɵreference(1);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", !ctx.mine);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mine);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mine);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.customMenuItems);
            i0.ɵɵadvance(4);
            i0.ɵɵstyleProp("background-image", ctx.avatarForUser(ctx.message.user));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.message.user.displayName);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("@", ctx.message.user.username, "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.message.user.tag);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.message.sentAt);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.editing);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.editing);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showReplyAction);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("active", ctx.message.userState == null ? null : ctx.message.userState.liked);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.message.transientState == null ? null : ctx.message.transientState.liking);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !(ctx.message.transientState == null ? null : ctx.message.transientState.liking));
            i0.ɵɵadvance();
            i0.ɵɵproperty("matMenuTriggerFor", pointItemMenu_r12);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.MaxLengthValidator, i3$1.NgModel, i2$1.MatIcon, i6$1.MatFormField, i6$1.MatLabel, i7.MatInput, i6.MatButton, i6.MatIconButton, i7$1.MatMenu, i7$1.MatMenuItem, i7$1.MatMenuTrigger, i8.MatProgressSpinner, TimestampComponent, BantaAttachmentsComponent, i11.MatTooltip, BantaMarkdownToHtmlPipe, BantaMentionLinkerPipe],
        styles: ["@keyframes _ngcontent-%COMP%_comment-appear{0%{transform:translate(6em)}to{transform:translate(0)}}[_nghost-%COMP%]{display:flex;flex-direction:column;position:relative;padding:.5em;visibility:hidden}.new[_nghost-%COMP%]{visibility:visible;animation-name:_ngcontent-%COMP%_comment-appear;animation-duration:.25s;animation-fill-mode:both}.highlighted[_nghost-%COMP%]{background:#00223a;outline:2px solid #003277}.visible[_nghost-%COMP%]{visibility:visible}[_nghost-%COMP%]:hover{background:#eee}[_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .banta-content[_ngcontent-%COMP%]{margin-left:60px;margin-right:.5em}[_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .attachments-row[_ngcontent-%COMP%]{margin-top:15px;display:flex;gap:10px}[_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .attachments-row[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border-radius:10px;width:300px;max-width:100%;max-height:20em;object-fit:cover}.abbreviated[_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .banta-content[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow-y:hidden}[_nghost-%COMP%]   .banta-actions[_ngcontent-%COMP%]{display:flex;padding-right:10px;margin-left:60px;align-items:center}[_nghost-%COMP%]   .banta-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#666;flex-shrink:0}banta-timestamp[_ngcontent-%COMP%]{color:#666;font-size:10pt;flex-shrink:0;margin-left:1em;text-align:right}.banta-user[_ngcontent-%COMP%]{position:relative;margin:1em 0 0;display:flex;align-items:center;flex-wrap:wrap}.banta-user[_ngcontent-%COMP%]   .banta-user-1[_ngcontent-%COMP%], .banta-user[_ngcontent-%COMP%]   .banta-user-2[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;align-items:center;min-width:0}.banta-user[_ngcontent-%COMP%]   .banta-user-2[_ngcontent-%COMP%]{margin:1em 0}.banta-user[_ngcontent-%COMP%]   .banta-user-identity[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-width:0}.banta-user[_ngcontent-%COMP%]   .banta-display-name[_ngcontent-%COMP%], .banta-user[_ngcontent-%COMP%]   .banta-username[_ngcontent-%COMP%]{z-index:1;position:relative;padding:0 0 0 1em;font-size:10pt;color:#000;margin:0 auto 0 0;display:block;width:fit-content;max-width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;flex-shrink:1;flex-grow:0;min-width:0}.banta-user[_ngcontent-%COMP%]   .banta-display-name.banta-username.banta-username.banta-username[_ngcontent-%COMP%], .banta-user[_ngcontent-%COMP%]   .banta-username.banta-username.banta-username.banta-username[_ngcontent-%COMP%]{color:#666}.banta-avatar[_ngcontent-%COMP%]{height:48px;width:48px;background-position:center;background-size:cover;background-color:#333;border-radius:100%;flex-shrink:0;flex-grow:0}.banta-counted-action[_ngcontent-%COMP%]{display:flex;align-items:center}.banta-counted-action.active[_ngcontent-%COMP%]   button[_ngcontent-%COMP%], .banta-counted-action.active[_ngcontent-%COMP%]   .banta-count-indicator[_ngcontent-%COMP%]{color:#00a5ff}.banta-counted-action[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .banta-count-indicator[_ngcontent-%COMP%]{margin-left:.5em}.banta-count-indicator[_ngcontent-%COMP%]{font-size:9pt;padding:0 0 0 3px;color:#666}.mat-dark-theme[_nghost-%COMP%]   .banta-count-indicator[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .banta-count-indicator[_ngcontent-%COMP%]{border-color:#333}.mat-dark-theme[_nghost-%COMP%]:hover, .mat-dark-theme   [_nghost-%COMP%]:hover{background:#060606}.mat-dark-theme[_nghost-%COMP%]   .banta-user[_ngcontent-%COMP%]   .banta-display-name[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .banta-user[_ngcontent-%COMP%]   .banta-display-name[_ngcontent-%COMP%], .mat-dark-theme[_nghost-%COMP%]   .banta-user[_ngcontent-%COMP%]   .banta-username[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .banta-user[_ngcontent-%COMP%]   .banta-username[_ngcontent-%COMP%]{color:#fff}.banta-user-tag[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px;border:1px solid #b27373;background:#7a412b;color:#fff;padding:3px 5px;margin:0 .5em 0 1em;border-radius:3px}.spacer[_ngcontent-%COMP%]{flex-shrink:1;flex-grow:1}ul.message-facts[_ngcontent-%COMP%]{margin:0;padding:0;color:#666}ul.message-facts[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;border-left:1px solid #666;font-size:10pt;padding-left:.5em;margin-left:.5em}ul.message-facts[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-top:.5em}ul.message-facts[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{border-left:1px solid transparent;margin-left:0;padding-left:0}@media (max-width: 400px){.banta-avatar[_ngcontent-%COMP%]{height:32px;width:32px}[_nghost-%COMP%]   .banta-actions[_ngcontent-%COMP%]{margin-left:0;margin-top:.5em}[_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .banta-content[_ngcontent-%COMP%]{margin-left:44px;margin-right:.5em}}.banta-mobile[_nghost-%COMP%]   .banta-avatar[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .banta-avatar[_ngcontent-%COMP%]{height:32px;width:32px}.banta-mobile   [_nghost-%COMP%]   .banta-actions[_ngcontent-%COMP%]{margin-left:0;margin-top:.5em}.banta-mobile   [_nghost-%COMP%]   .banta-message-content-container[_ngcontent-%COMP%]   .banta-content[_ngcontent-%COMP%]{margin-left:44px;margin-right:.5em}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;align-items:flex-start;gap:1em;width:100%;border:1px solid #666;border-radius:4px;padding:1em;box-sizing:border-box;background-color:#191919}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px;aspect-ratio:16/9;object-fit:cover;border-radius:10px}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{margin:0;font-size:30px}  .banta-message-content img.emoji{height:1.5em;vertical-align:middle}"]
      });
    }
  }
  return CommentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommentViewComponent = /*#__PURE__*/(() => {
  class CommentViewComponent {
    constructor(backend, elementRef) {
      this.backend = backend;
      this.elementRef = elementRef;
      //#endregion
      //#region Fields
      this._sourceSubs = new Subscription();
      this.menuMessage = null;
      this.messages = [];
      this.customSortEnabled = false;
      this.sourceLoaded = new Promise(r => this.markSourceLoaded = r);
      this.isViewingMore = false;
      this.isLoadingMore = false;
      this.hasMore = false;
      this.newMessages = [];
      this.olderMessages = [];
      //#endregion
      //#region Inputs
      this.maxMessages = 2000;
      this.maxVisibleMessages = 200;
      this.newestLast = false;
      this.holdNewMessages = false;
      this.showEmptyState = true;
      this.allowReplies = true;
      this.enableHoldOnClick = false;
      this.enableHoldOnScroll = true;
      this.customMenuItems = [];
      //#endregion
      //#region Outputs
      this._selected = new Subject();
      this._liked = new Subject();
      this._unliked = new Subject();
      this._reported = new Subject();
      this._userSelected = new Subject();
      this._usernameSelected = new Subject();
      this._avatarSelected = new Subject();
      this._shared = new Subject();
      this._deleted = new Subject();
      this._messageEdited = new Subject();
      this._sortOrderChanged = new Subject();
      this._filterModeChanged = new Subject();
      this.userSelected = this._userSelected.asObservable();
      this.reported = this._reported.asObservable();
      this.liked = this._liked.asObservable();
      this.unliked = this._unliked.asObservable();
      this.usernameSelected = this._usernameSelected.asObservable();
      this.avatarSelected = this._avatarSelected.asObservable();
      this.shared = this._shared.asObservable();
      this.deleted = this._deleted.asObservable();
      this.selected = this._selected.asObservable();
      this.messageEdited = this._messageEdited.asObservable();
      this.sortOrderChanged = this._sortOrderChanged.asObservable();
      this.filterModeChanged = this._filterModeChanged.asObservable();
    }
    get source() {
      return this._source;
    }
    set source(value) {
      this.setSource(value);
    }
    get comments() {
      return Array.from(this.commentsQuery);
    }
    //#endregion
    /**
     * Returns true if this message can be found within one of the message buffers (older, current, newer)
     * @param message
     */
    isMessageLoadedInContext(message) {
      return this.olderMessages.find(x => x.id === message.id) || this.messages.find(x => x.id === message.id) || this.newMessages.find(x => x.id === message.id);
    }
    async loadMessageInContext(message) {
      await this.sourceLoaded;
      console.log(`Loading message ${message.id} in context...`);
      while (this.hasMore && !this.isMessageLoadedInContext(message)) {
        console.log(`...Need to load more comments to find ${message.id}`);
        await this.showMore();
      }
      if (!this.isMessageLoadedInContext(message)) {
        console.error(`Error while loading message in context: Failed to find message ${message.id}, maybe it was deleted!`);
        return false;
      }
      let pageSize = this.maxVisibleMessages;
      let items = [].concat(this.olderMessages, this.messages, this.newMessages);
      let index = items.findIndex(x => x.id === message.id);
      if (index < 0) {
        console.error(`Error while loading message in context: Message was not present in message list!`);
        return false;
      }
      let startIndex = Math.max(0, index - pageSize / 2);
      this.newMessages = items.splice(0, startIndex);
      this.messages = items.splice(0, pageSize);
      this.olderMessages = items;
      this.isViewingMore = true;
    }
    get shouldShowNewMessageIndicator() {
      return this.isViewingMore || this.customSortEnabled || this.source.filterMode !== FilterMode.ALL || this.newMessages.length > 0;
    }
    get shouldHoldNewMessages() {
      if (this.holdNewMessages || this.isViewingMore) {
        console.log(`holding due to settings`);
        return true;
      }
      if (this.enableHoldOnScroll) {
        let keyMessage;
        if (this.newestLast) keyMessage = this.messages[this.messages.length - 1];else keyMessage = this.messages[0];
        if (keyMessage) {
          const messageElement = this.getElementForComment(keyMessage.id);
          if (messageElement) {
            if (!this.isElementVisible(messageElement)) {
              console.log(`key element is not visible`);
              return true;
            } else {
              console.log(`key element is visible`);
            }
          } else {
            console.log(`could not find key element`);
          }
        } else {
          console.log(`could not find key message`);
        }
        return false;
      }
      return false;
    }
    isElementVisible(element) {
      const elementRect = element.getBoundingClientRect();
      return !!elementRect && elementRect.bottom >= 0 && elementRect.right >= 0 && elementRect.left <= document.documentElement.clientWidth && elementRect.top <= document.documentElement.clientHeight;
    }
    /**
     * Get the CommentComponent instantiated for the given ChatMessage,
     * if it exists in the current view. Note that messages which are not
     * currently shown to the user will not return a CommentComponent.
     * @param message
     * @returns
     */
    getCommentComponentForMessage(message) {
      if (!message) throw new Error(`You must pass a valid ChatMessage`);
      return this.comments.find(x => x.message?.id === message.id);
    }
    saveEdit(message, newMessage) {
      this._messageEdited.next({
        message,
        newMessage
      });
    }
    likeMessage(message) {
      this._liked.next(message);
    }
    unlikeMessage(message) {
      this._unliked.next(message);
    }
    reportMessage(message) {
      this._reported.next(message);
    }
    selectMessage(message) {
      this._selected.next(message);
    }
    selectMessageUser(message) {
      this._userSelected.next(message);
    }
    selectUsername(user) {
      this._usernameSelected.next(user);
    }
    selectAvatar(user) {
      this._avatarSelected.next(user);
    }
    sharedMessage(message) {
      this._shared.next(message);
    }
    startEditing(message) {
      this.messages.forEach(m => m.transientState.editing = false);
      message.transientState.editing = true;
    }
    deleteMessage(message) {
      this._deleted.next(message);
    }
    setSource(value) {
      this.customSortEnabled = value?.sortOrder !== CommentsOrder.NEWEST;
      this.newMessages = [];
      this.olderMessages = [];
      window.bantaSourceDebug = value;
      if (this._sourceSubs) {
        this._sourceSubs.unsubscribe();
        this._sourceSubs = null;
      }
      this._source = value;
      if (value) {
        const messages = (value.messages || []).slice();
        this.messages = messages;
        this.olderMessages = messages.splice(this.maxVisibleMessages, messages.length);
        this.hasMore = true; //this.olderMessages.length > 0;
        this._sourceSubs = new Subscription();
        this._sourceSubs.add(this._source.messageReceived.subscribe(msg => this.messageReceived(msg)));
        this._sourceSubs.add(this._source.messageSent.subscribe(msg => this.messageSent(msg)));
        this._sourceSubs.add(this.backend.userChanged.subscribe(user => this.currentUser = user));
        this.getInitialMessages();
      }
    }
    async getInitialMessages() {
      let messages = await this._source.getExistingMessages();
      messages.forEach(m => m.transientState ??= {});
      this.messages = this.newestLast ? messages.slice().reverse() : messages;
      this.sortMessages();
      if (this.markSourceLoaded) this.markSourceLoaded();
    }
    messageIdentity(index, chatMessage) {
      return chatMessage.id;
    }
    async showNew(event) {
      let naturalOrder = CommentsOrder.NEWEST;
      if (this.source && (this.source.sortOrder !== naturalOrder || this.source.filterMode !== FilterMode.ALL)) {
        if (this.source.sortOrder !== naturalOrder) this._sortOrderChanged.next(naturalOrder);
        if (this.source.filterMode !== FilterMode.ALL) this._filterModeChanged.next(FilterMode.ALL);
        return;
      }
      this.isViewingMore = false;
      if (this.newestLast) this.messages = this.messages.concat(this.newMessages.splice(0, this.newMessages.length));else this.messages = this.newMessages.splice(0, this.newMessages.length).concat(this.messages);
      let overflow = this.messages.splice(this.maxVisibleMessages, this.messages.length);
      this.olderMessages = overflow.concat(this.olderMessages);
      this.olderMessages.splice(this.maxMessages - this.maxVisibleMessages, this.olderMessages.length);
      this.hasMore = this.olderMessages.length > 0;
      if (this.messages.length > 0) {
        if (this.newestLast) {
          this.scrollToComment(this.messages[this.messages.length - 1].id);
        } else {
          this.scrollToComment(this.messages[0].id);
        }
      }
    }
    async showMore() {
      this.isViewingMore = true;
      if (this.olderMessages.length > 0) {
        this.isLoadingMore = false;
        this.messages = this.messages.concat(this.olderMessages.splice(0, 50));
      }
      this.isLoadingMore = true;
      let nextPageSize = 20;
      let lastMessage;
      if (this.newestLast) {
        lastMessage = this.olderMessages[0] ?? this.messages[0];
      } else {
        lastMessage = this.olderMessages[this.olderMessages.length - 1] ?? this.messages[this.messages.length - 1];
      }
      if (!lastMessage) {
        this.isLoadingMore = false;
        this.hasMore = false;
        return;
      }
      let messages = await this.source.loadAfter(lastMessage, nextPageSize);
      if (this.newestLast) messages = messages.slice().reverse();
      messages.forEach(m => m.transientState ??= {});
      if (this.newestLast) this.messages = messages.concat(this.messages);else this.messages = this.messages.concat(messages);
      this.isLoadingMore = false;
      if (messages.length === 0) {
        console.log(`Reached the end of the list.`);
        this.hasMore = false;
      }
    }
    addMessage(message) {
      if (!message.transientState) message.transientState ??= {};
      let destination = this.messages;
      let bucket = this.olderMessages;
      let newestLast = this.newestLast;
      if (this.shouldHoldNewMessages) {
        destination = this.newMessages;
        bucket = null;
      }
      if (newestLast) {
        destination.push(message);
        let overflow = destination.splice(this.maxVisibleMessages, destination.length);
        bucket?.push(...overflow);
      } else {
        destination.unshift(message);
        let overflow = destination.splice(this.maxVisibleMessages, destination.length);
        bucket?.unshift(...overflow);
      }
      if (bucket?.length > 0) this.hasMore = true;
      message.pagingCursor = String(this.incrementPagingCursors());
      this.sortMessages();
    }
    incrementPagingCursors() {
      if (this.source.sortOrder !== CommentsOrder.NEWEST) return;
      let maxPagingCursor = 0;
      for (let group of [this.messages, this.olderMessages, this.newMessages]) {
        for (let message of group) {
          if (message.pagingCursor) {
            let pagingCursor = Number(message.pagingCursor) + 1;
            if (pagingCursor > maxPagingCursor) maxPagingCursor = pagingCursor;
            message.pagingCursor = String(pagingCursor);
          }
        }
      }
      return maxPagingCursor;
    }
    /**
     * Wait for all currently visible comments to be fully loaded, including all attachments.
     * Doing this will prevent layout shift when scrolling to a specific comment.
     */
    async waitForAllCommentsToLoad() {
      await new Promise(r => setTimeout(r, 100));
      await this.sourceLoaded;
      await Promise.all(this.comments.map(x => x.waitForLoad()));
    }
    sortMessages() {
      if (!this.source) return;
      let sorter;
      if (this.source.sortOrder === CommentsOrder.LIKES) sorter = (a, b) => b.likes - a.likes;else if (this.source.sortOrder === CommentsOrder.NEWEST) sorter = (a, b) => (b.sentAt - a.sentAt) * (this.newestLast ? -1 : 1);else if (this.source.sortOrder === CommentsOrder.OLDEST) sorter = (a, b) => (a.sentAt - b.sentAt) * (this.newestLast ? -1 : 1);
      this.messages.sort(sorter);
      this.olderMessages.sort(sorter);
      this.newMessages.sort(sorter);
    }
    messageReceived(message) {
      this.addMessage(message);
    }
    isScrolledToLatest() {
      if (!this.messageContainer) return false;
      const el = this.messageContainer.nativeElement;
      const currentScroll = el.scrollTop;
      const currentTotal = el.scrollHeight - el.offsetHeight;
      return currentScroll > currentTotal - 10;
    }
    messageSent(message) {
      this.addMessage(message);
      if (!this.messageContainer) return;
      this.scrollToLatest();
    }
    scrollToLatest() {
      if (!this.messageContainer) {
        return;
      }
      const el = this.messageContainer.nativeElement;
      el.scrollIntoView({
        block: 'start'
      });
      //el.scrollTop = el.scrollHeight;
    }
    get element() {
      return this.elementRef.nativeElement;
    }
    async scrollToComment(commentId) {
      if (typeof window === 'undefined') return;
      await this.waitForAllCommentsToLoad();
      const comment = this.getElementForComment(commentId);
      if (comment) {
        comment.scrollIntoView({
          inline: 'center',
          block: 'center'
        });
      }
    }
    getElementForComment(commentId) {
      return this.element.querySelector(`[data-comment-id="${commentId}"]`);
    }
    mentionsMe(message) {
      if (!this.currentUser) return false;
      if (message.message.includes(`@${this.currentUser.username}`)) return true;
      return false;
    }
    static {
      this.ɵfac = function CommentViewComponent_Factory(t) {
        return new (t || CommentViewComponent)(i0.ɵɵdirectiveInject(ChatBackendBase), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CommentViewComponent,
        selectors: [["banta-comment-view"]],
        viewQuery: function CommentViewComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
            i0.ɵɵviewQuery(CommentComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commentsQuery = _t);
          }
        },
        hostVars: 2,
        hostBindings: function CommentViewComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("fixed-height", ctx.fixedHeight);
          }
        },
        inputs: {
          source: "source",
          maxMessages: "maxMessages",
          maxVisibleMessages: "maxVisibleMessages",
          newestLast: "newestLast",
          holdNewMessages: "holdNewMessages",
          showEmptyState: "showEmptyState",
          allowReplies: "allowReplies",
          enableHoldOnClick: "enableHoldOnClick",
          enableHoldOnScroll: "enableHoldOnScroll",
          customMenuItems: "customMenuItems",
          fixedHeight: "fixedHeight",
          selectedMessage: "selectedMessage",
          genericAvatarUrl: "genericAvatarUrl"
        },
        outputs: {
          userSelected: "userSelected",
          reported: "reported",
          liked: "liked",
          unliked: "unliked",
          usernameSelected: "usernameSelected",
          avatarSelected: "avatarSelected",
          shared: "shared",
          deleted: "deleted",
          selected: "selected",
          messageEdited: "messageEdited",
          sortOrderChanged: "sortOrderChanged",
          filterModeChanged: "filterModeChanged"
        },
        ngContentSelectors: _c5,
        decls: 15,
        vars: 10,
        consts: [["messageContainer", ""], [1, "banta-message-container"], [1, "banta-top-sticky"], ["mat-button", "", "class", "nav", "href", "javascript:;", 3, "visible", "click", 4, "ngIf"], ["mat-button", "", "href", "javascript:;", 1, "nav", 3, "click"], [4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "banta-nav-point", "banta-bottom-sticky"], ["mat-button", "", "href", "javascript:;", 1, "banta-nav", 3, "click"], ["class", "banta-loading-more", 4, "ngIf"], ["class", "banta-empty-state", 4, "ngIf"], [1, "banta-empty-state"], ["class", "abbreviated", 3, "customMenuItems", "message", "mine", "permissions", "showReplyAction", "editing", "genericAvatarUrl", "readonly", "click", "editStarted", "deleted", "editEnded", "edited", "userSelected", "avatarSelected", "usernameSelected", "liked", "unliked", "reported", "selected", "shared", 4, "ngIf"], ["class", "banta-inline-replies-container", 4, "ngIf"], [1, "abbreviated", 3, "click", "editStarted", "deleted", "editEnded", "edited", "userSelected", "avatarSelected", "usernameSelected", "liked", "unliked", "reported", "selected", "shared", "customMenuItems", "message", "mine", "permissions", "showReplyAction", "editing", "genericAvatarUrl", "readonly"], [1, "banta-inline-replies-container"], [1, "banta-loading-more"]],
        template: function CommentViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtemplate(4, CommentViewComponent_a_4_Template, 5, 4, "a", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "a", 4);
            i0.ɵɵlistener("click", function CommentViewComponent_Template_a_click_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showMore());
            });
            i0.ɵɵtext(6, "Show earlier");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, CommentViewComponent_ng_container_7_Template, 2, 1, "ng-container", 5)(8, CommentViewComponent_ng_container_8_Template, 3, 2, "ng-container", 6);
            i0.ɵɵelementStart(9, "div", 7);
            i0.ɵɵtemplate(10, CommentViewComponent_a_10_Template, 5, 4, "a", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "a", 8);
            i0.ɵɵlistener("click", function CommentViewComponent_Template_a_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showMore());
            });
            i0.ɵɵtext(12, "Show more");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, CommentViewComponent_div_13_Template, 2, 0, "div", 9);
            i0.ɵɵprojection(14, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.newestLast);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("visible", ctx.newestLast && ctx.hasMore && !ctx.isLoadingMore);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.messages.length === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.messages)("ngForTrackBy", ctx.messageIdentity);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.newestLast);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("visible", !ctx.newestLast && ctx.hasMore && !ctx.isLoadingMore);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isLoadingMore);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$1.MatIcon, i6.MatAnchor, i8.MatProgressSpinner, CommentComponent],
        styles: ["[_nghost-%COMP%]{flex-grow:1;display:flex;flex-direction:column;opacity:1;transition:.2s opacity ease-in}.banta-message-container[_ngcontent-%COMP%]{flex-grow:1;color:#111;background:#fff;padding:.5em 1em 3em .5em;opacity:1;transition:.5s opacity ease-in-out;position:relative}.banta-message-container.no-scroll[_ngcontent-%COMP%]{height:auto;overflow-y:visible}.banta-message-container.faded[_ngcontent-%COMP%]{opacity:.25}.banta-message-container[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:10}.fixed-height[_nghost-%COMP%]   .banta-message-container[_ngcontent-%COMP%]{overflow-y:auto}.mat-dark-theme[_nghost-%COMP%]   .banta-message-container[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .banta-message-container[_ngcontent-%COMP%]{color:#fff;background:#111}.banta-empty-state[_ngcontent-%COMP%]{text-align:center;margin:3em;color:#666}.mat-dark-theme[_nghost-%COMP%]   .empty-state[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .empty-state[_ngcontent-%COMP%]{color:#666}a.banta-nav[_ngcontent-%COMP%]{position:absolute;right:.5em;z-index:10;text-align:center;opacity:0;transition:.4s opacity ease-in-out;pointer-events:none;border-radius:2em;background:#222}a.banta-nav.visible[_ngcontent-%COMP%]{opacity:1;pointer-events:initial}.banta-top-sticky[_ngcontent-%COMP%]{position:sticky;top:.5em;z-index:10}.banta-bottom-sticky[_ngcontent-%COMP%]{position:sticky;bottom:3em;z-index:10}.banta-loading-more[_ngcontent-%COMP%]{padding:2em;text-align:center;margin:0 auto;width:fit-content}@media (max-width: 400px){.banta-message-container[_ngcontent-%COMP%]{padding:0 0 3em}}"]
      });
    }
  }
  return CommentViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BantaReplySendOptionsDirective = /*#__PURE__*/(() => {
  class BantaReplySendOptionsDirective {
    static {
      this.ɵfac = function BantaReplySendOptionsDirective_Factory(t) {
        return new (t || BantaReplySendOptionsDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BantaReplySendOptionsDirective,
        selectors: [["", "bantaReplySendOptions", ""]]
      });
    }
  }
  return BantaReplySendOptionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AttachmentButtonComponent = /*#__PURE__*/(() => {
  class AttachmentButtonComponent {
    constructor(cdnProvider) {
      this.cdnProvider = cdnProvider;
      //#region Properties
      this._addedAttachment = new Subject();
      this._attachmentError = new Subject();
      //#endregion
      //#region Inputs
      this.disabled = false;
    }
    //#endregion
    //#region Outputs
    get addedAttachment() {
      return this._addedAttachment.asObservable();
    }
    get attachmentError() {
      return this._attachmentError.asObservable();
    }
    //#endregion
    show() {
      this.fileInput.nativeElement.click();
    }
    async fileChange(event) {
      const element = event.currentTarget;
      if (element.files.length) {
        console.log('[Banta] File Added to comment');
        const file = element.files[0];
        let publicURL;
        let attachment = {
          type: file.type,
          url: undefined,
          transientState: {
            uploading: true,
            error: false,
            errorMessage: undefined
          }
        };
        this._addedAttachment.next(attachment);
        try {
          publicURL = await this.cdnProvider.uploadImage(file);
        } catch (e) {
          attachment.transientState.error = true;
          attachment.transientState.errorMessage = "Failed to upload";
          console.error(`[Banta] Caught an error while uploading image to CDN:`);
          console.error(e);
          alert(e.message);
          this._attachmentError.next(attachment);
          return;
        }
        // If no URL was returned, then an error must have occurred. Presumably the CDN
        // provider has conveyed an error to the user.
        if (!publicURL) return;
        attachment.url = publicURL;
        attachment.transientState = undefined;
      }
    }
    static {
      this.ɵfac = function AttachmentButtonComponent_Factory(t) {
        return new (t || AttachmentButtonComponent)(i0.ɵɵdirectiveInject(i1$2.CDNProvider));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AttachmentButtonComponent,
        selectors: [["banta-attachment-button"]],
        viewQuery: function AttachmentButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
          }
        },
        inputs: {
          disabled: "disabled"
        },
        outputs: {
          addedAttachment: "addedAttachment",
          attachmentError: "attachmentError"
        },
        decls: 6,
        vars: 2,
        consts: [["button", ""], ["fileUpload", ""], ["matTooltip", "Add an image or gif", "type", "button", "mat-icon-button", "", 3, "click", "disabled"], ["type", "file", 2, "display", "none", 3, "change", "multiple"]],
        template: function AttachmentButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 2, 0);
            i0.ɵɵlistener("click", function AttachmentButtonComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.show());
            });
            i0.ɵɵelementStart(2, "mat-icon");
            i0.ɵɵtext(3, "image");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "input", 3, 1);
            i0.ɵɵlistener("change", function AttachmentButtonComponent_Template_input_change_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.fileChange($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("multiple", false);
          }
        },
        dependencies: [i2$1.MatIcon, i6.MatIconButton, i11.MatTooltip],
        styles: ["button[_ngcontent-%COMP%]{color:#666}"]
      });
    }
  }
  return AttachmentButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AttachmentScraperDirective = /*#__PURE__*/(() => {
  class AttachmentScraperDirective {
    constructor(elementRef, chatBackend) {
      this.elementRef = elementRef;
      this.chatBackend = chatBackend;
      this.attachments = [];
      this.attachmentsChange = new Subject();
      this.scrapeDebounce = 1500;
      this.fragments = new Map();
    }
    ngOnInit() {
      if (typeof window === 'undefined') return;
      this.element.addEventListener('keydown', () => {
        clearTimeout(this.scrapeTimeout);
        this.scrapeTimeout = setTimeout(() => this.scrape(), this.scrapeDebounce);
      });
    }
    get element() {
      return this.elementRef?.nativeElement;
    }
    get text() {
      return this.element.value;
    }
    scrape() {
      let message = {
        likes: 0,
        message: this.text,
        sentAt: undefined,
        user: null,
        attachments: this.attachments
      };
      let foundFragments = [];
      for (let scraper of this.chatBackend.attachmentScrapers) {
        let fragments = scraper.findFragments(message);
        if (!fragments) {
          console.error(`Attachment fragment scraper ${scraper.constructor.name} is implemented incorrectly: Returned null instead of array`);
          continue;
        }
        for (let fragment of fragments) {
          foundFragments.push(fragment.text);
          if (!this.fragments.has(fragment.text)) {
            console.log(`Scraped new fragment:`);
            console.dir(fragment);
            this.fragments.set(fragment.text, {
              fragment,
              resolution: undefined
            });
          }
        }
      }
      // Remove fragments that are no longer in the message.
      let removedFragments = [];
      for (let [key] of this.fragments) {
        if (!foundFragments.includes(key)) removedFragments.push(key);
      }
      for (let removedFragment of removedFragments) {
        console.log(`Removed fragment: ${removedFragment}`);
        this.fragments.delete(removedFragment);
      }
      // Process any fragments that are not yet resolved (or being 
      // resolved)
      for (let [key, state] of this.fragments) {
        if (state.resolution) continue;
        state.resolution = new Promise(async (resolve, reject) => {
          console.log(`Resolving fragment ${key}`);
          for (let resolver of this.chatBackend.attachmentResolvers) {
            console.log(`- Trying resolver ${resolver.constructor.name}...`);
            try {
              let attachment = await resolver.resolveFragment(message, state.fragment);
              if (attachment) {
                console.log(`Resolved fragment ${key} into attachment:`);
                console.dir(attachment);
                this.attachments.push(attachment);
                this.attachmentsChange.next(this.attachments.slice());
                resolve(attachment);
                break;
              }
            } catch (e) {
              console.error(`Caught error during attachment resolver ${resolver.constructor.name}:`);
              console.error(e);
              continue;
            }
          }
        });
      }
    }
    static {
      this.ɵfac = function AttachmentScraperDirective_Factory(t) {
        return new (t || AttachmentScraperDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ChatBackendBase));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AttachmentScraperDirective,
        selectors: [["", "attachmentScraper", ""]],
        inputs: {
          attachments: "attachments"
        },
        outputs: {
          attachmentsChange: "attachmentsChange"
        }
      });
    }
  }
  return AttachmentScraperDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommentFieldComponent = /*#__PURE__*/(() => {
  class CommentFieldComponent {
    constructor() {
      //#endregion
      //#region Properties
      this._permissionDeniedError = new Subject();
      this._subs = new Subscription();
      this.sending = false;
      this.expandError = false;
      this.autocompleteVisible = false;
      this.autocompleteOptions = [];
      this.autoCompleteSelected = 0;
      this.text = '';
      this.chatMessageAttachments = [];
      this.canComment = true;
      this.allowAttachments = false;
      this.sendLabel = 'Send';
      this.signingInLabel = 'Signing in...';
      this.sendingLabel = 'Sending';
      this.label = 'Post a comment';
      this.permissionDeniedLabel = 'Unavailable';
      this.signInLabel = 'Sign In';
      this.maxLength = 1500;
      this.placeholder = '';
      this.participants = [];
      this.readonly = false;
      //#endregion
      //#region Outputs
      this.signInSelected = new Subject();
      this.editAvatarSelected = new Subject();
      this.focusChange = new Subject();
      this.textChanged = new Subject();
    }
    ngAfterViewInit() {
      if (typeof window !== 'undefined') {
        let root = document.body.querySelector('[ng-version]') || document.body;
        root.appendChild(this.autocompleteEl.nativeElement);
      }
    }
    get source() {
      return this._source;
    }
    set source(value) {
      this.setSource(value);
    }
    get permissionDeniedError() {
      return this._permissionDeniedError;
    }
    get indicatorState() {
      if (this.transientMessage) {
        return 'transient';
      } else if (this.sending) {
        return 'sending';
      } else if (this.sendError) {
        return 'error';
      } else {
        return 'none';
      }
    }
    get buttonState() {
      if (this.sending) return 'sending';else if (this.signInState === 'signing-in') return 'signing-in';else if (!this.canComment) return 'permission-denied';else return 'send';
    }
    get sendButtonEnabled() {
      if (this.readonly) return false;
      if (this.signInState === 'signing-in') return false;
      if (!['connected', 'restored'].includes(this.source.state)) return false;
      if (!this.canComment) {
        // In this case, we want to enable the button because we want to be able to 
        // send the permissionDenied message up to the host.
        return true;
      }
      return this.isValidMessage && !this.hasPendingAttachments && !this.sending;
    }
    get userAvatarUrl() {
      return this.user?.avatarUrl || this.genericAvatarUrl;
    }
    get isValidMessage() {
      return this.text || this.chatMessageAttachments.length > 0;
    }
    get hasPendingAttachments() {
      return this.chatMessageAttachments.some(x => x.transientState);
    }
    //#endregion
    //#region Private Component API
    setSource(value) {
      if (this._source) {
        this._subs?.unsubscribe();
        this._source = null;
      }
      this._source = value;
      this._subs = new Subscription();
      if (this._source) {
        setTimeout(() => {
          if (this._source.connectionStateChanged) {
            this._subs.add(this._source.connectionStateChanged.subscribe(state => {
              if (state === 'lost') {
                if (this._source.errorState === 'server-issue') this.transientMessage = `Reconnecting..`;else this.transientMessage = `Reconnecting...`;
              } else if (state === 'restored') {
                this.transientMessage = undefined;
              } else if (state === 'connecting') {
                this.transientMessage = `Connecting...`;
              }
            }));
          }
        });
      }
    }
    //#endregion
    //#region Actions
    sendPermissionDenied(message) {
      this._permissionDeniedError.next(message);
    }
    activateAutoComplete(option) {
      option.action();
      this.dismissAutoComplete();
    }
    onFocus() {
      this.focusChange.next(true);
    }
    onBlur() {
      this.focusChange.next(false);
      setTimeout(() => this.dismissAutoComplete(), 250);
    }
    showSignIn() {
      this.signInSelected.next();
    }
    showEditAvatar() {
      this.editAvatarSelected.next();
    }
    insertEmoji(text) {
      this.text += text;
    }
    showAutoComplete(options) {
      if (typeof window === 'undefined') return;
      this.autoCompleteSelected = 0;
      this.autocompleteOptions = options;
      let pos = this.autocompleteContainerEl.nativeElement.getBoundingClientRect();
      let size = this.autocompleteEl.nativeElement.getBoundingClientRect();
      this.autocompleteEl.nativeElement.style.left = `${window.scrollX + pos.left}px`;
      this.autocompleteEl.nativeElement.style.top = `${window.scrollY + pos.top}px`;
      this.autocompleteEl.nativeElement.style.width = `${pos.width}px`;
      this.autocompleteVisible = true;
    }
    dismissAutoComplete() {
      this.autocompleteVisible = false;
      this.completionFunc = null;
      this.completionPrefix = '';
    }
    indicateError(message) {
      this.sendError = new Error(message);
      this.expandError = false;
      clearTimeout(this.errorTimeout);
      this.errorTimeout = setTimeout(() => {
        this.expandError = true;
        this.errorTimeout = setTimeout(() => {
          this.expandError = false;
        }, 5 * 1000);
      }, 100);
      // On mobile, just show an alert dialog
      if (typeof window !== 'undefined' && window.innerWidth < 430) alert(message);
    }
    async autocomplete(replacement) {
      let el = this.textareaEl.nativeElement;
      this.text = this.text.slice(0, el.selectionStart - this.completionPrefix.length) + replacement + this.text.slice(el.selectionStart);
    }
    async insert(str) {
      let el = this.textareaEl.nativeElement;
      this.text = this.text.slice(0, el.selectionStart) + str + this.text.slice(el.selectionStart);
    }
    async onKeyDown(event) {
      if (this.autocompleteVisible) {
        if (event.key === 'Escape') {
          this.dismissAutoComplete();
          return;
        }
        if (event.key === 'Shift') {
          return;
        }
        if (event.key === 'Enter') {
          if (this.autocompleteOptions[this.autoCompleteSelected]) {
            this.activateAutoComplete(this.autocompleteOptions[this.autoCompleteSelected]);
            event.stopPropagation();
            event.preventDefault();
            return;
          }
        }
        if (event.key === 'ArrowUp') {
          if (this.autoCompleteSelected === 0) this.autoCompleteSelected = this.autocompleteOptions.length - 1;else this.autoCompleteSelected = this.autoCompleteSelected - 1;
          event.stopPropagation();
          event.preventDefault();
          return;
        } else if (event.key === 'ArrowDown') {
          this.autoCompleteSelected = (this.autoCompleteSelected + 1) % this.autocompleteOptions.length;
          event.stopPropagation();
          event.preventDefault();
          return;
        }
      }
      if (event.key === 'Enter' && event.ctrlKey) {
        await this.sendMessage();
        return;
      }
      if (this.completionFunc) {
        if (event.key === 'Backspace') {
          this.completionPrefix = this.completionPrefix.slice(0, this.completionPrefix.length - 1);
          if (this.completionPrefix === '') {
            this.dismissAutoComplete();
            return;
          }
        } else if (event.key === ' ' || event.key.length > 1) {
          this.dismissAutoComplete();
          return;
        } else {
          this.completionPrefix += event.key;
        }
        this.showAutoComplete(this.completionFunc(this.completionPrefix));
      } else {
        if (event.key === ':') {
          this.startAutoComplete(event, prefix => {
            prefix = prefix.slice(1);
            // makes :-), :-( etc work (as they are ":)" etc in the db)
            if (prefix.startsWith('-')) prefix = prefix.slice(1);
            return Object.keys(EMOJIS).filter(k => k.includes(prefix) || EMOJIS[k].keywords.some(kw => kw.includes(prefix))).map(k => ({
              label: `${EMOJIS[k].char} ${k}`,
              action: () => this.autocomplete(EMOJIS[k].char)
            })).slice(0, 5);
          });
        } else if (event.key === '@') {
          this.startAutoComplete(event, prefix => {
            prefix = prefix.slice(1);
            return this.participants.filter(x => x.username.includes(prefix)).map(p => ({
              label: `@${p.username} -- ${p.displayName}`,
              action: () => this.autocomplete(`@${p.username}`)
            }));
          });
        } else if (event.key === '#') {
          this.startAutoComplete(event, prefix => {
            prefix = prefix.slice(1);
            return this.hashtags.filter(ht => ht.hashtag.includes(prefix)).map(ht => ({
              label: `#${ht.hashtag}${ht.description ? ` -- ${ht.description}` : ``}`,
              action: () => this.autocomplete(`#${ht.hashtag}`)
            })).slice(0, 5);
          });
        }
      }
    }
    startAutoComplete(event, completionFunc) {
      this.completionPrefix = event.key;
      this.completionFunc = completionFunc;
      this.showAutoComplete(this.completionFunc(this.completionPrefix));
    }
    async sendMessage() {
      if (!this.source) return;
      this.sending = true;
      this.sendError = null;
      try {
        let text = (this.text || '').trim();
        if (this.canComment && !this.isValidMessage) return;
        let message = {
          user: this.user,
          sentAt: Date.now(),
          url: this.url ?? (typeof window !== 'undefined' ? location.href : undefined),
          likes: 0,
          message: text,
          attachments: this.chatMessageAttachments.filter(x => x.url)
        };
        try {
          await this.submit(message);
          this.text = '';
          this.chatMessageAttachments = [];
        } catch (e) {
          console.error(`[Banta/CommentField] sendMessage() failed: ${e.message}`);
          await new Promise(resolve => setTimeout(() => resolve(), 1000));
          this.indicateError(e.message);
        }
      } finally {
        this.sending = false;
        setTimeout(() => {
          this.textareaEl.nativeElement.focus();
        }, 100);
      }
    }
    addedAttachment(attachment) {
      this.chatMessageAttachments.push(attachment);
    }
    attachmentError(attachment) {
      setTimeout(() => {
        this.chatMessageAttachments = this.chatMessageAttachments.filter(x => x !== attachment);
      }, 3000);
    }
    removeAttachment(attachment) {
      let index = this.chatMessageAttachments.indexOf(attachment);
      if (index >= 0) this.chatMessageAttachments.splice(index, 1);
    }
    alertError() {
      if (!this.sendError) return;
      alert(this.sendError.message);
    }
    static {
      this.ɵfac = function CommentFieldComponent_Factory(t) {
        return new (t || CommentFieldComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CommentFieldComponent,
        selectors: [["banta-comment-field"]],
        viewQuery: function CommentFieldComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5);
            i0.ɵɵviewQuery(_c8, 5);
            i0.ɵɵviewQuery(_c9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteContainerEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textareaEl = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function CommentFieldComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("can-comment", ctx.canComment);
          }
        },
        inputs: {
          source: "source",
          user: "user",
          canComment: "canComment",
          signInState: "signInState",
          allowAttachments: "allowAttachments",
          transientMessage: "transientMessage",
          sendLabel: "sendLabel",
          signingInLabel: "signingInLabel",
          sendingLabel: "sendingLabel",
          label: "label",
          permissionDeniedLabel: "permissionDeniedLabel",
          signInLabel: "signInLabel",
          maxLength: "maxLength",
          placeholder: "placeholder",
          shouldInterceptMessageSend: "shouldInterceptMessageSend",
          hashtags: "hashtags",
          participants: "participants",
          genericAvatarUrl: "genericAvatarUrl",
          url: "url",
          submit: "submit",
          readonly: "readonly"
        },
        outputs: {
          signInSelected: "signInSelected",
          editAvatarSelected: "editAvatarSelected",
          focusChange: "focusChange",
          textChanged: "textChanged",
          permissionDeniedError: "permissionDeniedError"
        },
        ngContentSelectors: _c10,
        decls: 33,
        vars: 21,
        consts: [["textarea", ""], ["autocompleteContainer", ""], ["autocomplete", ""], [1, "new-message", 3, "submit"], [1, "banta-avatar-container"], ["href", "javascript:;", 1, "banta-avatar", 3, "click"], [1, "banta-text-container"], [1, "banta-field-container"], [1, "banta-field-row"], ["appearance", "outline", "floatLabel", "always", 1, "message-field"], ["name", "message", "attachmentScraper", "", "matInput", "", "cdkTextareaAutosize", "", "autocomplete", "off", 3, "attachmentsChange", "keydown", "focus", "blur", "ngModelChange", "attachments", "placeholder", "maxlength", "disabled", "ngModel"], [1, "banta-options-line"], [4, "ngIf"], [1, "spacer"], [1, "custom"], [3, "disabled", "addedAttachment", "attachmentError", 4, "ngIf"], [3, "selected", "disabled"], [1, "autocomplete-container"], [1, "autocomplete"], ["mat-button", "", 3, "active", "click", 4, "ngFor", "ngForOf"], [3, "remove", "attachments", "editing"], [1, "banta-actions"], [1, "transient-message", 3, "click", "matTooltip"], [3, "inline", "diameter"], [1, "banta-transient-message", 3, "click"], [1, "banta-error-message", 3, "click", "matTooltip"], [3, "addedAttachment", "attachmentError", "disabled"], ["mat-button", "", 3, "click"], ["mat-raised-button", "", "color", "primary", "type", "button", 3, "click"], ["mat-raised-button", "", "class", "send", "color", "primary", 3, "disabled", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", 1, "send", 3, "disabled"], [1, "label"], ["diameter", "18", "strokeWidth", "2", 1, "icon"]],
        template: function CommentFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "form", 3);
            i0.ɵɵlistener("submit", function CommentFieldComponent_Template_form_submit_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.sendMessage());
            });
            i0.ɵɵelementStart(1, "div", 4)(2, "a", 5);
            i0.ɵɵlistener("click", function CommentFieldComponent_Template_a_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showEditAvatar());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 6)(4, "div", 7)(5, "div", 8)(6, "mat-form-field", 9)(7, "mat-label");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "textarea", 10, 0);
            i0.ɵɵtwoWayListener("attachmentsChange", function CommentFieldComponent_Template_textarea_attachmentsChange_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.chatMessageAttachments, $event) || (ctx.chatMessageAttachments = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("keydown", function CommentFieldComponent_Template_textarea_keydown_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyDown($event));
            })("focus", function CommentFieldComponent_Template_textarea_focus_9_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus());
            })("blur", function CommentFieldComponent_Template_textarea_blur_9_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵtwoWayListener("ngModelChange", function CommentFieldComponent_Template_textarea_ngModelChange_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.text, $event) || (ctx.text = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div", 11);
            i0.ɵɵtemplate(12, CommentFieldComponent_ng_container_12_Template, 4, 6, "ng-container", 12)(13, CommentFieldComponent_ng_container_13_Template, 4, 5, "ng-container", 12)(14, CommentFieldComponent_ng_container_14_Template, 4, 5, "ng-container", 12);
            i0.ɵɵelement(15, "div", 13);
            i0.ɵɵelementStart(16, "div", 14);
            i0.ɵɵprojection(17);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(18, CommentFieldComponent_banta_attachment_button_18_Template, 1, 1, "banta-attachment-button", 15);
            i0.ɵɵelementStart(19, "emoji-selector-button", 16);
            i0.ɵɵlistener("selected", function CommentFieldComponent_Template_emoji_selector_button_selected_19_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.insertEmoji($event));
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 17, 1)(22, "div", 18, 2)(24, "div")(25, "strong");
            i0.ɵɵtext(26);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(27, "... ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(28, CommentFieldComponent_a_28_Template, 2, 3, "a", 19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(29, "banta-attachments", 20);
            i0.ɵɵlistener("remove", function CommentFieldComponent_Template_banta_attachments_remove_29_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.removeAttachment($event));
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(30, "div", 21);
            i0.ɵɵtemplate(31, CommentFieldComponent_ng_container_31_Template, 3, 1, "ng-container", 12)(32, CommentFieldComponent_ng_container_32_Template, 4, 3, "ng-container", 12);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("background-image", "url(" + ctx.userAvatarUrl + ")");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("attachments", ctx.chatMessageAttachments);
            i0.ɵɵproperty("placeholder", ctx.placeholder)("maxlength", ctx.maxLength)("disabled", ctx.sending || ctx.readonly);
            i0.ɵɵtwoWayProperty("ngModel", ctx.text);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.indicatorState === "transient");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.indicatorState === "sending");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.indicatorState === "error");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.allowAttachments);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.readonly);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("visible", ctx.autocompleteVisible);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.completionPrefix);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.autocompleteOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("attachments", ctx.chatMessageAttachments)("editing", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.user);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.user);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$2.CdkTextareaAutosize, i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.MaxLengthValidator, i3$1.NgModel, i3$1.NgForm, i2$1.MatIcon, i6$1.MatFormField, i6$1.MatLabel, i7.MatInput, i6.MatAnchor, i6.MatButton, i8.MatProgressSpinner, BantaAttachmentsComponent, EmojiSelectorButtonComponent, i11.MatTooltip, AttachmentButtonComponent, AttachmentScraperDirective],
        styles: ["@keyframes _ngcontent-%COMP%_comment-field-appear{0%{transform:translateY(128px);opacity:0}to{transform:translate(0);opacity:1}}[_nghost-%COMP%]{margin:0 2em 0 0;display:block;animation-name:_ngcontent-%COMP%_comment-field-appear;animation-duration:.8s;animation-delay:.4s;animation-fill-mode:both;position:relative;z-index:20}.banta-avatar-container[_ngcontent-%COMP%]{width:calc(48px + 1.75em);display:flex;justify-content:flex-end;flex-shrink:0}.banta-avatar-container[_ngcontent-%COMP%]   .banta-avatar[_ngcontent-%COMP%]{width:48px;height:48px;background:#000;border-radius:100%;background-size:cover;background-repeat:no-repeat;background-position:center;margin-top:.75em;margin-right:.75em}form[_ngcontent-%COMP%]{display:flex;padding:.5em;align-items:center}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]{position:relative;display:flex;flex-grow:1;min-width:0}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:14pt;width:100%}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   textarea[disabled][_ngcontent-%COMP%]{opacity:.5}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   mat-spinner.loading[_ngcontent-%COMP%]{position:absolute;left:.5em;bottom:.5em}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]{display:flex;align-items:center}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex-shrink:0}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]   .banta-transient-message[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;gap:.5em}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]   .banta-error-message[_ngcontent-%COMP%]{left:.5em;bottom:.5em;color:#683333;overflow-x:hidden;max-width:1.5em;white-space:nowrap;transition:2s max-width ease-in-out;text-overflow:ellipsis;overflow:hidden;flex-shrink:1}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]   .banta-error-message.expanded[_ngcontent-%COMP%], form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]   .banta-error-message[_ngcontent-%COMP%]:hover{max-width:100%}form[_ngcontent-%COMP%]   .banta-text-container[_ngcontent-%COMP%]   .banta-options-line[_ngcontent-%COMP%]   .banta-error-message[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{vertical-align:middle}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#000;color:#fff;border:1px solid #333;width:100%;height:1em}form[_ngcontent-%COMP%]   .banta-actions[_ngcontent-%COMP%]{margin-left:1em;flex-shrink:0}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}form.new-message[_ngcontent-%COMP%]{display:flex;align-items:flex-start;min-width:0}form.new-message[_ngcontent-%COMP%]   .banta-field-container[_ngcontent-%COMP%]{flex-grow:1;display:flex;flex-direction:column;min-width:0}form.new-message[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{width:100%}form.new-message[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]     .mat-form-field-wrapper{padding-bottom:0}form.new-message[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:1.25em 0 0}button.send[_ngcontent-%COMP%]{min-width:9em}textarea[_ngcontent-%COMP%]{max-height:7em}.autocomplete-container[_ngcontent-%COMP%]{width:calc(100% - 2em);position:relative;pointer-events:none;top:-2em}.autocomplete[_ngcontent-%COMP%]{visibility:hidden;pointer-events:none;position:absolute;background:#333;padding:.5em;display:flex;flex-direction:column;z-index:100}.autocomplete.visible[_ngcontent-%COMP%]{visibility:visible;pointer-events:initial}.autocomplete[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{width:100%;text-align:left}.autocomplete[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%]{background:#555}.image-attachments-container[_ngcontent-%COMP%]{display:flex;gap:20px}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]{width:300px;position:relative;text-align:center}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment.with-border[_ngcontent-%COMP%]{outline:1px solid #333;padding:1em 0}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{display:block;margin:0 auto .5em;width:fit-content}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]   mat-icon.error[_ngcontent-%COMP%]{display:block;font-size:48px;width:48px;height:48px;margin:0 auto .5em}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:#b76363}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px;border-radius:10px}.image-attachments-container[_ngcontent-%COMP%]   .image-attachment[_ngcontent-%COMP%]   .remove-img[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;margin:0}.banta-field-row[_ngcontent-%COMP%], .card-attachment[_ngcontent-%COMP%]{position:relative}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;align-items:flex-start;gap:1em;width:100%;border:1px solid #666;border-radius:4px;padding:2em;box-sizing:border-box;background-color:#191919}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:300px;aspect-ratio:16/9;object-fit:cover;border-radius:10px}.card-attachment[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{margin:0;font-size:30px}.card-attachment[_ngcontent-%COMP%]   .remove-img[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;margin:0}@media (max-width: 500px){[_nghost-%COMP%]{margin:0}.banta-avatar-container[_ngcontent-%COMP%]{display:none;width:auto;flex-shrink:0}.banta-avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{width:32px;height:32px;margin-top:1.5em}[_nghost-%COMP%]:not(.can-comment)   mat-form-field.message-field[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]:not(.can-comment)   .banta-text-container[_ngcontent-%COMP%]{display:none}.can-comment[_nghost-%COMP%]   button.send[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:none}button.send[_ngcontent-%COMP%]{min-width:auto;margin-top:1.5em}}.banta-mobile   [_nghost-%COMP%]{margin:0}.banta-mobile[_nghost-%COMP%]   .banta-avatar-container[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .banta-avatar-container[_ngcontent-%COMP%]{display:none;width:auto;flex-shrink:0}.banta-mobile[_nghost-%COMP%]   .banta-avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .banta-avatar-container[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{width:32px;height:32px;margin-top:1.5em}.banta-mobile   [_nghost-%COMP%]:not(.can-comment)   mat-form-field.message-field[_ngcontent-%COMP%]{display:none}.banta-mobile   [_nghost-%COMP%]:not(.can-comment)   .banta-text-container[_ngcontent-%COMP%]{display:none}.banta-mobile   .can-comment[_nghost-%COMP%]   button.send[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:none}.banta-mobile[_nghost-%COMP%]   button.send[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   button.send[_ngcontent-%COMP%]{min-width:auto;margin-top:1.5em}"]
      });
    }
  }
  return CommentFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/// <reference types="@types/resize-observer-browser" />
/**
 * Comments component
 */
let BantaCommentsComponent = /*#__PURE__*/(() => {
  class BantaCommentsComponent {
    constructor(backend, elementRef, activatedRoute, matSnackBar, ngZone) {
      this.backend = backend;
      this.elementRef = elementRef;
      this.activatedRoute = activatedRoute;
      this.matSnackBar = matSnackBar;
      this.ngZone = ngZone;
      this.isMobileSized = false;
      this.viewReady = new Promise(r => this.markViewReady = r);
      this.loadingTitle = 'Loading...';
      // Loading Screen
      this._loadingMessage = '';
      this.loadingMessageVisible = false;
      this.loading = true;
      this.showLoadingScreen = false;
      this.customMenuItems = [];
      this._loadingMessageIndex = 0;
      this.maxCommentLength = 1500;
      this.loadingMessages = [`Just a second...`, `It's definitely worth the wait!`, `This has never happened before.`, `We'll keep trying, but it's not looking great. 
            Commenting & chat services may be down or degraded. Try reloading the page.
            If you keep experiencing issues or reloading the page works for you, please let us know by contacting support.
        `];
      this.useInlineReplies = true;
      this.loaded = new Promise(r => this.markLoaded = r);
      // Properties
      this._signInSelected = new Subject();
      this._permissionDeniedError = new Subject();
      this._editAvatarSelected = new Subject();
      this._upvoted = new Subject();
      this._reported = new Subject();
      this._selected = new Subject();
      this._userSelected = new Subject();
      this._shared = new Subject();
      this._usernameSelected = new Subject();
      this._avatarSelected = new Subject();
      /**
       * Track whether we created this source. If we did not (ie it was passed in from the caller),
       * then we are not responsible for calling close(). If we do own it though, we will call close()
       * when we are done with it.
       */
      this._sourceIsOwned = false;
      this._subs = new Subscription();
      this.selectedMessageVisible = false;
      // Inputs
      this.signInLabel = 'Sign In';
      this.sendLabel = 'Send';
      this.signingInLabel = 'Signing in...';
      this.replyLabel = 'Reply';
      this.sendingLabel = 'Sending';
      this.permissionDeniedLabel = 'Send';
      this.postCommentLabel = 'Post a comment';
      this.postReplyLabel = 'Post a reply';
      this.allowAttachments = true;
      this.maxVisibleMessages = 20;
      this.genericAvatarUrl = `https://gravatar.com/avatar/${Date.now().toString(16)}?s=512&d=robohash`;
      this.participants = [];
      this.hashtags = [{
        hashtag: 'error',
        description: 'Cause an error'
      }, {
        hashtag: 'timeout',
        description: 'Cause a slow timeout error'
      }, {
        hashtag: 'slow',
        description: 'Be slow when this message is posted'
      }];
      this._sortOrder = 'newest';
      this._filterMode = FilterMode.ALL;
      this._metadata = {};
      this.loadingSharedComment = false;
      this.sharedCommentMissing = false;
      this.sendMessage = async message => {
        try {
          const intercept = await this.shouldInterceptMessageSend?.(message, this.source);
          if (!intercept) {
            await this.source.send(message);
          }
          if (this.source.sortOrder !== CommentsOrder.NEWEST) this.sortOrder = CommentsOrder.NEWEST;
          if (this.source.filterMode !== FilterMode.ALL) this.filterMode = FilterMode.ALL;
          return true;
        } catch (e) {
          this.handleBackendException(e, 'Could not send: ');
        }
      };
      this.sendReply = async message => {
        try {
          const intercept = await this.shouldInterceptMessageSend?.(message, this.selectedMessageThread);
          if (!intercept) {
            await this.selectedMessageThread.send(message);
          }
          return true;
        } catch (e) {
          this.handleBackendException(e, 'Could not send reply: ');
        }
      };
    }
    get element() {
      return this.elementRef.nativeElement;
    }
    handleBackendExceptionAsAlert(e, prefix = '') {
      try {
        this.handleBackendException(e, prefix);
      } catch (e) {
        console.log(`[Banta/Comments] Showed user error (via alert): '${e.message}'`);
        console.error(e);
        alert(e.message);
      }
    }
    handleBackendExceptionAsSnack(e, prefix = '') {
      try {
        this.handleBackendException(e, prefix);
      } catch (e) {
        console.log(`[Banta/Comments] Showed user error (via snack): '${e.message}'`);
        console.error(e);
        this.matSnackBar.open(e.message, undefined, {
          duration: 3000
        });
        //alert(e.message);
      }
    }
    handleBackendException(e, prefix = '') {
      let errorMessage = e.message;
      if (errorMessage.startsWith('permission-denied|')) {
        errorMessage = errorMessage.replace(/^permission-denied\|/, '');
        if (errorMessage.startsWith(`app-handle|`)) {
          // If this is an error during authorizeAction on the backend, pass control to the user-provided 
          // permission-denied handler.
          this.sendPermissionDenied(errorMessage.replace(/^app-handle\|/, ''));
          return;
        }
      }
      throw new Error(`${prefix}${errorMessage}`);
    }
    // Lifecycle Events / Initialization
    ngOnInit() {
      this._subs.add(this.backend.userChanged.subscribe(user => this.user = user));
      this.startLoading();
      if (typeof window !== 'undefined') {
        let queryString = window.location.search.substring(1);
        let query = queryString.split('&').map(s => s.split('=')).reduce((o, [k, v]) => (o[decodeURIComponent(k)] = decodeURIComponent(v), o), {});
        const commentID = query['comment'];
        if (commentID) {
          this.sharedCommentID = commentID;
        }
      }
    }
    ngAfterViewInit() {
      if (typeof window !== 'undefined') {
        let callback = () => {
          let size = this.elementRef.nativeElement.getBoundingClientRect();
          this.ngZone.run(() => {
            setTimeout(() => {
              this.width = size.width;
              this.height = size.height;
              this.isMobileSized = this.width < 500;
            });
          });
        };
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(callback);
          this.resizeObserver.observe(this.elementRef.nativeElement);
        } else {
          // One check is better than nothing!
          setTimeout(() => {
            this.width = this.elementRef.nativeElement.clientWidth;
            this.height = this.elementRef.nativeElement.clientHeight;
            this.isMobileSized = this.width < 500;
          }, 1000);
        }
        callback();
      }
      this.markViewReady();
    }
    ngOnDestroy() {
      this._subs.unsubscribe();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    async setSourceFromTopicID(topicID) {
      if (typeof window === 'undefined') return;
      setTimeout(async () => {
        console.log(`[Banta/Comments] Subscribing to topic source '${topicID}'`);
        this.source = await this.backend.getSourceForTopic(topicID, {
          sortOrder: this.sortOrder,
          filterMode: this.filterMode,
          metadata: this.metadata
        });
        this._sourceIsOwned = true;
      });
    }
    get loadingMessage() {
      return this._loadingMessage;
    }
    set loadingMessage(value) {
      this.loadingMessageVisible = false;
      setTimeout(() => {
        this._loadingMessage = value;
        this._loadingMessage = value;
        setTimeout(() => {
          this.loadingMessageVisible = true;
        });
      }, 500);
    }
    async startLoading() {
      this.loadingStartedAt = this.messageChangedAt = Date.now();
      if (this.updateLoading()) return;
      await new Promise(resolve => setTimeout(() => resolve(), 100));
      if (this.updateLoading()) return;
      await new Promise(resolve => setTimeout(() => resolve(), 250));
      if (this.updateLoading()) return;
      await new Promise(resolve => setTimeout(() => resolve(), 500));
      if (this.updateLoading()) return;
      console.log(`[Banta] Loading is taking a long time! Showing loading screen.`);
      this.showLoadingScreen = true;
      if (typeof window !== 'undefined') this._loadingTimer = setInterval(() => {
        this.updateLoading();
        this.loadingTitle = `Connecting to Live Comments service...`;
      }, 1000);
    }
    /**
     * Attempts to find the CommentComponent that corresponds to the given ChatMessage.
     * The ChatMessage could be a top-level message in this conversation, or a reply,
     * but note that a CommentComponent will only exist for a reply if the user has
     * the relevant reply thread open.
     * @param message The message to look for
     */
    getCommentComponentForMessage(message) {
      if (message.parentMessageId) return this.threadView?.getCommentComponentForMessage(message);else return this.commentView.getCommentComponentForMessage(message);
    }
    /**
     * Access the CommentViewComponent corresponding to the currently open reply thread.
     * This is not the top level comments, but instead the reply thread that the user has
     * opened (only one set of replies can be open at a time).
     *
     * For details about what CommentViewComponent affords you, see the commentView property.
     */
    get threadView() {
      return Array.from(this.threadViewQuery).filter(x => x !== this.commentView)[0];
    }
    async waitForThreadView() {
      if (this.threadView) return this.threadView;
      await this.threadViewQuery.changes.pipe(take(1)).toPromise();
      return this.threadView;
    }
    updateLoading() {
      if (this.source?.state && !['connecting', 'lost'].includes(this.source?.state)) {
        clearInterval(this._loadingTimer);
        this.loadingMessage = `Here we go!`;
        setTimeout(() => {
          this.loading = false;
          this.markLoaded();
        }, 750);
        return true;
      }
      console.log(`[Banta/Loader] State=${this.source ? this.source.state : 'no-source'}`);
      let messageSwitchTime = 5 * 1000;
      if (this.messageChangedAt + messageSwitchTime < Date.now()) {
        if (this.loadingMessages[this._loadingMessageIndex]) {
          this.loadingMessage = this.loadingMessages[this._loadingMessageIndex++];
          this.messageChangedAt = Date.now();
        }
      }
      return false;
    }
    get source() {
      return this._source;
    }
    set source(value) {
      if (this._source && this._sourceIsOwned) {
        this._source.close();
        this._sourceSubscription?.unsubscribe();
        this._source = null;
        this.participants = [];
      }
      this._source = value;
      this._sourceIsOwned = false; // Assume we don't own this source.
      this._sourceSubscription = new Subscription();
      if (value) {
        if (this.sharedCommentID) {
          this.navigateToSharedComment(this.sharedCommentID);
          this.lastSharedCommentID = this.sharedCommentID;
          this.sharedCommentID = null;
        }
        this._source.messages.forEach(m => this.addParticipant(m));
        this._sourceSubscription.add(this._source.connectionStateChanged.subscribe(state => this.connectionState = state));
        this._sourceSubscription.add(this._source.messageReceived.subscribe(m => this.addParticipant(m)));
        this._sourceSubscription.add(this._source.messageSent.subscribe(m => this.addParticipant(m)));
        this._sourceSubscription.add(this._source.messageObserved.subscribe(m => this.addParticipant(m)));
        this._sourceSubscription.add(this._source.messageUpdated.subscribe(msg => {
          console.log(`comments received message: `, msg);
          if (msg.id === this.selectedMessage?.id && msg.hidden) {
            this.unselectMessage();
            this.matSnackBar.open("The thread you were viewing was removed.", undefined, {
              duration: 2500
            });
          }
        }));
      }
    }
    get topicID() {
      return this._topicID;
    }
    set topicID(value) {
      if (this._topicID !== value) {
        this._topicID = value;
        setTimeout(() => this.setSourceFromTopicID(value));
      }
    }
    // Outputs
    get signInSelected() {
      return this._signInSelected;
    }
    get editAvatarSelected() {
      return this._editAvatarSelected;
    }
    get permissionDeniedError() {
      return this._permissionDeniedError;
    }
    get upvoted() {
      return this._upvoted.asObservable();
    }
    get reported() {
      return this._reported.asObservable();
    }
    get selected() {
      return this._selected.asObservable();
    }
    get userSelected() {
      return this._userSelected.asObservable();
    }
    get usernameSelected() {
      return this._usernameSelected.asObservable();
    }
    get avatarSelected() {
      return this._avatarSelected.asObservable();
    }
    get shared() {
      return this._shared.asObservable();
    }
    reloadSource() {
      clearTimeout(this._reloadSourceTimeout);
      this._reloadSourceTimeout = setTimeout(() => {
        this.setSourceFromTopicID(this.topicID);
      });
    }
    get sortOrder() {
      return this._sortOrder;
    }
    set sortOrder(value) {
      if (this._sortOrder !== value) {
        this._sortOrder = value;
        this.reloadSource();
      }
    }
    get filterMode() {
      return this._filterMode;
    }
    set filterMode(value) {
      if (this._filterMode !== value) {
        this._filterMode = value;
        this.reloadSource();
      }
    }
    /**
     * Arbitrary metadata to send to the chat server. This can be used to provide context about the client to the server
     * for things like validating authorization and other uses.
     */
    get metadata() {
      return this._metadata;
    }
    set metadata(value) {
      if (JSON.stringify(this._metadata) !== JSON.stringify(value)) {
        this._metadata = value;
        this.reloadSource();
      }
    }
    get filterModes() {
      return FilterMode.options;
    }
    get filterModeLabels() {
      return {
        [FilterMode.ALL]: 'All',
        [FilterMode.MINE]: 'Mine',
        [FilterMode.THREADS]: 'Involving Me',
        [FilterMode.MY_LIKES]: 'My Likes'
      };
    }
    get sortOrders() {
      return CommentsOrder.options;
    }
    get sortOrderLabels() {
      return {
        [CommentsOrder.NEWEST]: 'Newest',
        [CommentsOrder.OLDEST]: 'Oldest',
        [CommentsOrder.LIKES]: 'Likes'
      };
    }
    // UI Interactions
    async scrollToComment(commentId) {
      if (typeof window === 'undefined') return;
      await this.commentView.waitForAllCommentsToLoad();
      const comment = document.querySelector(`[data-comment-id="${commentId}"]`);
      if (comment) {
        comment.scrollIntoView({
          inline: 'center',
          block: 'center'
        });
      }
    }
    async navigateToSharedComment(id) {
      this.loadingSharedComment = true;
      await new Promise(r => setTimeout(r, 10));
      this.sharedCommentMissing = false;
      let source = this.source;
      await source.ready;
      await this.viewReady;
      await this.loaded;
      console.log(`Navigating to shared comment with ID '${id}'...`);
      let message;
      try {
        message = await this.source.get(id);
      } catch (e) {
        console.error(`Failed to find comment from URL: ${e.message}`);
        this.sharedCommentMissing = true;
        this.loadingSharedComment = false;
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            let notice = this.element.querySelector('.loading-comment');
            notice.scrollIntoView({
              block: 'center',
              inline: 'center'
            });
          }, 200);
        }
        return;
      }
      message.transientState ??= {};
      // If there is a parent message, we should instead focus that and let the 
      // scrollToComment and highlight do the work.
      if (message.parentMessageId) {
        let parentMessage = await this.source.get(message.parentMessageId);
        parentMessage.transientState ??= {};
        // Make sure that this message is loaded and visible to the user
        await this.commentView.loadMessageInContext(parentMessage);
        let thread = await this.selectMessage(parentMessage);
        // Need to re-retrieve the message within the new chat source to affect its
        // transient state.
        await thread.ready;
        // Make sure that this message is loaded and visible to the user
        await this.waitForThreadView();
        await this.threadView.loadMessageInContext(message);
        message = await thread.get(message.id);
        message.transientState ??= {};
        message.transientState.highlighted = true;
        console.dir(message);
        await new Promise(resolve => setTimeout(() => resolve(), 500));
      } else {
        // Make sure that this message is loaded and visible to the user
        await this.commentView.loadMessageInContext(message);
        message.transientState ??= {};
        message.transientState.highlighted = true;
      }
      this.loadingSharedComment = false;
      await this.scrollToComment(id);
    }
    handlePermissionDenied(errorMessage) {
      // This is what other components call when handling permission errors
      if (errorMessage.startsWith(`app-handle|`)) {
        // If this is an error during authorizeAction on the backend, pass control to the user-provided 
        // permission-denied handler.
        this.sendPermissionDenied(errorMessage.replace(/^app-handle\|/, ''));
        return;
      }
      alert(errorMessage);
    }
    sendPermissionDenied(message) {
      this._permissionDeniedError.next(message);
    }
    scrollToMessage(message) {
      let el = this.elementRef.nativeElement.querySelector(`[data-comment-id="${message.id}"]`);
      if (!el) return;
      el.scrollIntoView({
        block: 'center',
        inline: 'start'
      });
    }
    addParticipant(message) {
      if (!message || !message.user || !message.user.id) return;
      let existing = this.participants.find(x => x.id === message.user.id);
      if (existing) return;
      this.participants.push(message.user);
    }
    // Actions
    async likeMessage(source, message) {
      if (!this.user) {
        await this.showSignIn();
        return;
      }
      this._upvoted.next(message);
      message.transientState.liking = true;
      try {
        await source.likeMessage(message.id);
      } catch (e) {
        this.handleBackendExceptionAsSnack(e, 'Could not like this message: ');
      } finally {
        await new Promise(resolve => setTimeout(() => resolve(), 250));
        message.transientState.liking = false;
      }
    }
    async unlikeMessage(source, message) {
      if (!this.user) {
        await this.showSignIn();
        return;
      }
      this._upvoted.next(message);
      message.transientState.liking = true;
      if (message.userState?.liked) message.likes = (message.likes || 0) - 1;
      try {
        await source.unlikeMessage(message.id);
      } catch (e) {
        this.handleBackendExceptionAsAlert(e, 'Failed to unlike this message: ');
      }
      await new Promise(resolve => setTimeout(() => resolve(), 250));
      message.transientState.liking = false;
    }
    async reportMessage(message) {
      this._reported.next(message);
    }
    async unselectMessage() {
      let message = this.selectedMessage;
      this._selected.next(null);
      this.selectedMessage = null;
      if (this.selectedMessageThread) {
        if (this.selectedMessageThread.close) this.selectedMessageThread.close();
        this.selectedMessageThread = null;
      }
      if (message) setTimeout(() => this.scrollToMessage(message));
    }
    async toggleSelectedMessage(message) {
      if (this.selectedMessage === message) {
        await this.unselectMessage();
      } else {
        await this.selectMessage(message);
      }
    }
    async selectMessage(message) {
      if (this.selectedMessage === message) {
        console.log(`[Banta] Thread ${this.topicID}/${message.id} is already open.`);
        return this.selectedMessageThread;
      }
      if (this.selectedMessageThread) {
        if (this.selectedMessageThread.close) this.selectedMessageThread.close();
        this.selectedMessageThread = null;
      }
      this._selected.next(message);
      console.log(`[Banta] Opening thread for ${this.topicID}/${message.id}...`);
      let selectedMessageThread = await this.backend.getSourceForThread(this.topicID, message.id);
      if (!selectedMessageThread) {
        console.warn(`Failed to locate thread for message ${this.topicID}/${message.id}!`);
        return null;
      }
      console.log(`[Banta] Thread opened for ${this.topicID}/${message.id}.`);
      setTimeout(() => this.selectedMessageVisible = true);
      setTimeout(async () => {
        this.selectedMessage = message;
        this.selectedMessageThread = selectedMessageThread;
      }, 250);
      return selectedMessageThread;
    }
    async showSignIn() {
      this._signInSelected.next();
    }
    async showEditAvatar() {
      this._editAvatarSelected.next();
    }
    async selectMessageUser(message) {
      this._userSelected.next(message);
    }
    async selectUsername(user) {
      this._usernameSelected.next(user);
    }
    async selectAvatar(user) {
      this._avatarSelected.next(user);
    }
    async shareMessage(message) {
      this._shared.next(message);
    }
    async deleteMessage(message) {
      if (!this.user) {
        await this.showSignIn();
        return;
      }
      if (!confirm("Are you sure you want to delete this comment? You cannot undo this action.")) return;
      try {
        await this.source.deleteMessage(message.id);
        if (this.selectedMessage?.id === message.id) this.unselectMessage();
      } catch (e) {
        this.handleBackendExceptionAsAlert(e, `Could not delete message: `);
      }
    }
    async editMessage(source, message, newText) {
      if (!this.user) {
        await this.showSignIn();
        return;
      }
      try {
        await source.editMessage(message.id, newText);
      } catch (e) {
        this.handleBackendExceptionAsAlert(e, 'Could not edit this message: ');
        return;
      }
      message.message = newText;
      message.transientState.editing = false;
    }
    async startEditing(message) {
      this.selectedMessage.transientState.editing = false;
      message.transientState.editing = true;
    }
    async saveEdit(message, text) {
      if (!this.user) {
        await this.showSignIn();
        return;
      }
      try {
        await this.source.editMessage(message.id, text);
        message.transientState.editing = false;
      } catch (e) {
        this.handleBackendExceptionAsAlert(e, `Could not edit message: `);
      }
    }
    static {
      this.ɵfac = function BantaCommentsComponent_Factory(t) {
        return new (t || BantaCommentsComponent)(i0.ɵɵdirectiveInject(ChatBackendBase), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2$3.ActivatedRoute), i0.ɵɵdirectiveInject(i3$2.MatSnackBar), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaCommentsComponent,
        selectors: [["banta-comments"]],
        contentQueries: function BantaCommentsComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, BantaReplySendOptionsDirective, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sendReplyOptionsTemplate = _t.first);
          }
        },
        viewQuery: function BantaCommentsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
            i0.ɵɵviewQuery(CommentViewComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commentView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.threadViewQuery = _t);
          }
        },
        hostVars: 2,
        hostBindings: function BantaCommentsComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("banta-mobile", ctx.isMobileSized);
          }
        },
        inputs: {
          customMenuItems: "customMenuItems",
          url: "url",
          maxCommentLength: "maxCommentLength",
          loadingMessages: "loadingMessages",
          useInlineReplies: "useInlineReplies",
          signInLabel: "signInLabel",
          sendLabel: "sendLabel",
          signingInLabel: "signingInLabel",
          replyLabel: "replyLabel",
          sendingLabel: "sendingLabel",
          permissionDeniedLabel: "permissionDeniedLabel",
          postCommentLabel: "postCommentLabel",
          postReplyLabel: "postReplyLabel",
          allowAttachments: "allowAttachments",
          fixedHeight: "fixedHeight",
          maxMessages: "maxMessages",
          maxVisibleMessages: "maxVisibleMessages",
          genericAvatarUrl: "genericAvatarUrl",
          shouldInterceptMessageSend: "shouldInterceptMessageSend",
          participants: "participants",
          source: "source",
          hashtags: "hashtags",
          topicID: "topicID",
          sortOrder: "sortOrder",
          filterMode: "filterMode",
          metadata: "metadata"
        },
        outputs: {
          signInSelected: "signInSelected",
          editAvatarSelected: "editAvatarSelected",
          permissionDeniedError: "permissionDeniedError",
          upvoted: "upvoted",
          reported: "reported",
          selected: "selected",
          userSelected: "userSelected",
          usernameSelected: "usernameSelected",
          avatarSelected: "avatarSelected",
          shared: "shared"
        },
        decls: 2,
        vars: 2,
        consts: [["filterMenu", "matMenu"], ["sortMenu", "matMenu"], ["commentView", ""], ["threadView", ""], [4, "ngIf"], [1, "loading-screen"], [3, "diameter", "strokeWidth"], [1, "loading-message"], ["class", "focused", 3, "visible", 4, "ngIf"], [1, "main"], [3, "editAvatarSelected", "signInSelected", "permissionDeniedError", "url", "source", "user", "sendLabel", "sendingLabel", "signingInLabel", "signInLabel", "signInState", "canComment", "hashtags", "participants", "label", "maxLength", "permissionDeniedLabel", "shouldInterceptMessageSend", "submit", "allowAttachments", "genericAvatarUrl", "readonly"], ["mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], [1, "settings"], ["mat-button", "", 3, "matMenuTriggerFor"], ["class", "loading-comment", 4, "ngIf"], [3, "userSelected", "sortOrderChanged", "filterModeChanged", "selected", "liked", "unliked", "messageEdited", "reported", "usernameSelected", "avatarSelected", "shared", "deleted", "source", "fixedHeight", "maxMessages", "maxVisibleMessages", "genericAvatarUrl", "customMenuItems", "holdNewMessages", "selectedMessage"], [1, "inline-replies"], ["class", "reconnecting", 4, "ngIf"], [1, "focused"], ["mat-button", "", "href", "javascript:;", 3, "click"], [3, "editStarted", "editEnded", "edited", "userSelected", "avatarSelected", "usernameSelected", "liked", "unliked", "reported", "selected", "shared", "deleted", "message", "liking", "mine", "permissions", "showReplyAction", "editing", "maxLength", "genericAvatarUrl", "readonly"], [1, "replies"], [1, "loading"], [1, "replies", 3, "liked", "unliked", "messageEdited", "reported", "usernameSelected", "avatarSelected", "shared", "deleted", "source", "allowReplies", "fixedHeight", "showEmptyState", "newestLast", "genericAvatarUrl", "customMenuItems"], [3, "signInSelected", "editAvatarSelected", "permissionDeniedError", "url", "sendLabel", "sendingLabel", "signingInLabel", "hashtags", "participants", "readonly", "source", "maxLength", "canComment", "signInState", "signInLabel", "permissionDeniedLabel", "shouldInterceptMessageSend", "user", "label", "submit", "allowAttachments", "genericAvatarUrl"], [4, "ngTemplateOutlet"], ["mat-menu-item", "", 3, "click"], [1, "loading-comment"], ["mat-icon-button", "", "matTooltip", "Close this notice", "href", "javascript:;", 1, "close", 3, "click"], ["mat-button", "", 3, "click"], [3, "liked", "unliked", "messageEdited", "reported", "usernameSelected", "avatarSelected", "shared", "deleted", "source", "allowReplies", "fixedHeight", "showEmptyState", "newestLast", "enableHoldOnClick", "holdNewMessages", "genericAvatarUrl"], [3, "signInSelected", "permissionDeniedError", "editAvatarSelected", "focusChange", "url", "sendLabel", "sendingLabel", "signingInLabel", "hashtags", "participants", "maxLength", "source", "signInState", "canComment", "signInLabel", "permissionDeniedLabel", "readonly", "shouldInterceptMessageSend", "user", "label", "submit", "allowAttachments", "genericAvatarUrl"], [1, "reconnecting"]],
        template: function BantaCommentsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BantaCommentsComponent_ng_container_0_Template, 8, 8, "ng-container", 4)(1, BantaCommentsComponent_ng_container_1_Template, 26, 42, "ng-container", 4);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.loading);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2$1.MatIcon, i6.MatAnchor, i6.MatButton, i6.MatIconAnchor, i7$1.MatMenu, i7$1.MatMenuItem, i7$1.MatMenuTrigger, i8.MatProgressSpinner, i11.MatTooltip, CommentComponent, CommentViewComponent, CommentFieldComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column}@keyframes _ngcontent-%COMP%_select-comment{0%{transform:scale(1.15)}to{transform:scale(1)}}.focused[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_select-comment;animation-duration:.4s;animation-fill-mode:both}.focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{margin-top:1em;margin-left:2em;border-left:2px solid #333;padding-left:2em}banta-comment-view[_ngcontent-%COMP%]{opacity:1;transition:.4s opacity ease-in-out}banta-comment-view.faded[_ngcontent-%COMP%]{opacity:.25}.loading[_ngcontent-%COMP%]{display:block;width:fit-content;margin:0 auto;min-height:16em}.main.hidden[_ngcontent-%COMP%]{display:none}.loading-screen[_ngcontent-%COMP%]{text-align:center;opacity:0;transition:.25s ease-in-out opacity}.loading-screen.visible[_ngcontent-%COMP%]{opacity:1}.loading-screen[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:100}.loading-screen[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{margin:5em auto}.loading-screen[_ngcontent-%COMP%]   .loading-message[_ngcontent-%COMP%]{opacity:0;transition:.25s ease-in-out opacity;width:500px;max-width:100%;margin:0 auto}.loading-screen[_ngcontent-%COMP%]   .loading-message.visible[_ngcontent-%COMP%]{opacity:1}banta-comment-sort[_ngcontent-%COMP%]{margin:0 0 0 auto;width:fit-content;display:block}.inline-replies[_ngcontent-%COMP%]{margin-left:4em}@media (max-width: 500px){.focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{margin-left:0}.inline-replies[_ngcontent-%COMP%]{margin-left:1em}.focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{padding-left:.5em}banta-comment-sort[_ngcontent-%COMP%]{margin:0;width:100%}}.banta-mobile[_nghost-%COMP%]   .focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{margin-left:0}.banta-mobile[_nghost-%COMP%]   .inline-replies[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .inline-replies[_ngcontent-%COMP%]{margin-left:1em}.banta-mobile[_nghost-%COMP%]   .focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   .focused[_ngcontent-%COMP%]   .replies[_ngcontent-%COMP%]{padding-left:.5em}.banta-mobile[_nghost-%COMP%]   banta-comment-sort[_ngcontent-%COMP%], .banta-mobile   [_nghost-%COMP%]   banta-comment-sort[_ngcontent-%COMP%]{margin:0;width:100%}.loading-comment[_ngcontent-%COMP%]{z-index:100;border:1px solid #333;background:#000;color:#fff;padding:1em;border-radius:4px;text-align:center;position:relative}.loading-comment[_ngcontent-%COMP%]   a.close[_ngcontent-%COMP%]{position:absolute;top:1em;right:1em}.loading-comment[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:100;text-align:center}.loading-comment[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{margin:0 auto}.reconnecting[_ngcontent-%COMP%]{position:sticky;bottom:1em;background:#380a39;color:#926893;padding:1em;z-index:10;border-radius:4px;text-align:center}.settings[_ngcontent-%COMP%]{display:flex}"]
      });
    }
  }
  return BantaCommentsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChatMessageComponent = /*#__PURE__*/(() => {
  class ChatMessageComponent {
    constructor() {
      this._selected = new Subject();
      this._reported = new Subject();
      this._upvoted = new Subject();
      this._userSelected = new Subject();
    }
    get userSelected() {
      return this._userSelected;
    }
    get selected() {
      return this._selected;
    }
    get reported() {
      return this._reported;
    }
    get upvoted() {
      return this._upvoted;
    }
    avatarForUser(user) {
      if (user && user.avatarUrl) {
        let url = user.avatarUrl;
        return `url(${url})`;
      }
      return null;
    }
    upvote() {
      this._upvoted.next();
    }
    report() {
      this._reported.next();
    }
    select() {
      this._selected.next();
    }
    selectUser() {
      this._userSelected.next(this.message.user);
    }
    static {
      this.ɵfac = function ChatMessageComponent_Factory(t) {
        return new (t || ChatMessageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChatMessageComponent,
        selectors: [["banta-chat-message"]],
        inputs: {
          message: "message"
        },
        outputs: {
          userSelected: "userSelected",
          selected: "selected",
          reported: "reported",
          upvoted: "upvoted"
        },
        decls: 17,
        vars: 5,
        consts: [[1, "message-content"], [1, "user", 3, "click"], [1, "avatar"], [1, "content"], [3, "click"], [1, "status"], ["class", "count-indicator", 4, "ngIf"], [1, "actions"], ["mat-icon-button", "", "matTooltip", "Upvote", "matTooltipPosition", "below", 3, "click"], ["mat-icon-button", "", "matTooltip", "Report", "matTooltipPosition", "below", 3, "click"], [1, "count-indicator"]],
        template: function ChatMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function ChatMessageComponent_Template_div_click_1_listener() {
              return ctx.selectUser();
            });
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "label");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3)(6, "div", 4);
            i0.ɵɵlistener("click", function ChatMessageComponent_Template_div_click_6_listener() {
              return ctx.select();
            });
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 5);
            i0.ɵɵtemplate(9, ChatMessageComponent_div_9_Template, 4, 1, "div", 6);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 7)(11, "button", 8);
            i0.ɵɵlistener("click", function ChatMessageComponent_Template_button_click_11_listener() {
              return ctx.upvote();
            });
            i0.ɵɵelementStart(12, "mat-icon");
            i0.ɵɵtext(13, "thumb_up");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "button", 9);
            i0.ɵɵlistener("click", function ChatMessageComponent_Template_button_click_14_listener() {
              return ctx.report();
            });
            i0.ɵɵelementStart(15, "mat-icon");
            i0.ɵɵtext(16, "report");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("background-image", ctx.avatarForUser(ctx.message.user));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.message.user.username);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.message.message, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.message.likes > 0);
          }
        },
        dependencies: [i2.NgIf, i2$1.MatIcon, i6.MatIconButton],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;align-items:center;padding:0 1em;background-color:#fff;color:#000;transition:.4s background-color ease-out}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#111}[_nghost-%COMP%]:hover{background-color:#ddd}.highlight[_nghost-%COMP%]{background:#00121b}.highlight[_nghost-%COMP%]:hover{background:#01324d}[_nghost-%COMP%]:nth-child(2n){background-color:#eee}[_nghost-%COMP%]:nth-child(2n):hover{background:#ddd}[_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#222}[_nghost-%COMP%]:nth-child(2n).highlight{background:#001a2a}[_nghost-%COMP%]:nth-child(2n).highlight:hover{background:#002b44}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;align-items:center}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:5px 0}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .status[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;margin-left:1em}[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .status[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{margin-left:.5em}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]{color:#999;font-weight:400;text-align:right;margin-right:.25em;flex-shrink:0;display:flex;align-items:center}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{background-position:center;background-size:cover;background-color:#333;border-radius:100%;flex-shrink:0;flex-grow:0;margin-right:1em;width:2em;height:2em}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]:after{content:\":\";margin-right:1em}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{flex-grow:1}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]{flex-shrink:0;white-space:nowrap;opacity:0;transition:.4s opacity ease-out}[_nghost-%COMP%]:hover   .actions[_ngcontent-%COMP%]{opacity:1}.count-indicator[_ngcontent-%COMP%]{white-space:nowrap}.count-indicator[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{vertical-align:bottom}.mat-dark-theme[_nghost-%COMP%], .mat-dark-theme   [_nghost-%COMP%]{background-color:#000;color:#fff}.mat-dark-theme[_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#ddd}.mat-dark-theme[_nghost-%COMP%]:hover, .mat-dark-theme   [_nghost-%COMP%]:hover{background-color:#111}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n).highlight, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n).highlight{background:#001a2a}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n).highlight:hover, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n).highlight:hover{background:#002b44}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n):hover, .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n):hover{background-color:#111}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n), .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n){background-color:#080808}.mat-dark-theme[_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]:nth-child(2n)   .message-content[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{color:#eee}label[_ngcontent-%COMP%]{margin:0}"]
      });
    }
  }
  return ChatMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChatViewComponent = /*#__PURE__*/(() => {
  class ChatViewComponent {
    constructor(backend, elementRef) {
      this.backend = backend;
      this.elementRef = elementRef;
      this._sourceSubs = new Subscription();
      this._selected = new Subject();
      this._selected$ = this._selected.asObservable();
      this._reported = new Subject();
      this._reported$ = this._reported.asObservable();
      this._upvoted = new Subject();
      this._upvoted$ = this._upvoted.asObservable();
      this._userSelected = new Subject();
      this._userSelected$ = this._userSelected.asObservable();
      this._received = new Subject();
      this._received$ = this._received.asObservable();
      this.messages = [];
      this.maxMessages = 200;
      this.emptyLabel = 'Be the first to chat';
    }
    get source() {
      return this._source;
    }
    get selected() {
      return this._selected$;
    }
    get userSelected() {
      return this._userSelected$;
    }
    get reported() {
      return this._reported$;
    }
    get upvoted() {
      return this._upvoted$;
    }
    get received() {
      return this._received$;
    }
    set source(value) {
      if (this._sourceSubs) {
        this._sourceSubs.unsubscribe();
        this._sourceSubs = null;
      }
      this._source = value;
      this.messages = [];
      if (value) {
        this._sourceSubs = new Subscription();
        this.messages = value.messages.slice();
        console.log(`Source set:`);
        console.dir(value);
        console.log(`Messages loaded:`);
        console.dir(this.messages);
        this._sourceSubs.add(this._source.messageReceived.subscribe(msg => this.messageReceived(msg)));
        this._sourceSubs.add(this._source.messageSent.subscribe(msg => this.messageSent(msg)));
        this._sourceSubs.add(this.backend.userChanged.subscribe(user => this.currentUser = user));
        this.getInitialMessages();
      }
    }
    async getInitialMessages() {
      let messages = await this._source.getExistingMessages();
      messages.forEach(m => m.transientState ??= {});
      this.messages = messages.slice().reverse();
      this.sortMessages();
    }
    sortMessages() {
      if (!this.source) return;
      let sorter;
      sorter = (a, b) => a.sentAt - b.sentAt;
      this.messages.sort(sorter);
    }
    addMessage(message) {
      if (this.messages.length > this.maxMessages + 1) {
        while (this.messages.length > this.maxMessages) this.messages.shift();
      }
      this.messages.push(message);
      this.sortMessages();
    }
    messageReceived(message) {
      this.addMessage(message);
      this._received.next(message);
      if (this.isScrolledToLatest()) setTimeout(() => this.scrollToLatest());
    }
    isScrolledToLatest() {
      if (!this.messageContainer) return false;
      let el = this.messageContainer.nativeElement;
      let currentScroll = el.scrollTop;
      let currentTotal = el.scrollHeight - el.offsetHeight;
      return currentScroll > currentTotal - 10;
    }
    messageSent(message) {
      this.addMessage(message);
      if (!this.messageContainer) return;
      setTimeout(() => this.scrollToLatest());
    }
    scrollToLatest() {
      if (!this.messageContainer) return;
      let el = this.messageContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
    jumpTo(message) {
      let element = this.elementRef.nativeElement;
      let messageElement = element.querySelector(`banta-chat-message[data-id="${message.id}"]`);
      if (!messageElement) {
        alert(`could not find message ${message.id}`);
        return;
      }
      messageElement.scrollIntoView({
        behavior: 'smooth'
      });
      this.flashMessage(message);
    }
    flashMessage(message) {
      if (!message) return;
      this.flashedMessageId = message.id;
      //setTimeout(() => this.flashedMessageId = null, 250);
    }
    mentionsMe(message) {
      if (!this.currentUser) return false;
      if (message.message.includes(`@${this.currentUser.username}`)) return true;
      return false;
    }
    upvoteMessage(message) {
      this._upvoted.next(message);
    }
    reportMessage(message) {
      this._reported.next(message);
    }
    selectMessage(message) {
      this._selected.next(message);
    }
    selectMessageUser(message) {
      this._userSelected.next(message);
    }
    avatarForUser(user) {
      if (user && user.avatarUrl) {
        let url = user.avatarUrl;
        return `url(${url})`;
      }
      return null;
    }
    static {
      this.ɵfac = function ChatViewComponent_Factory(t) {
        return new (t || ChatViewComponent)(i0.ɵɵdirectiveInject(ChatBackendBase), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChatViewComponent,
        selectors: [["banta-chat-view"]],
        viewQuery: function ChatViewComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
          }
        },
        inputs: {
          source: "source",
          maxMessages: "maxMessages",
          emptyLabel: "emptyLabel"
        },
        outputs: {
          selected: "selected",
          userSelected: "userSelected",
          reported: "reported",
          upvoted: "upvoted",
          received: "received"
        },
        ngContentSelectors: _c13,
        decls: 6,
        vars: 2,
        consts: [["messageContainer", ""], [1, "message-container"], ["class", "empty", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "empty"], [3, "message", "highlight", "flash", "selected", "upvoted", "reported", "userSelected", 4, "ngIf"], [3, "selected", "upvoted", "reported", "userSelected", "message"]],
        template: function ChatViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c12);
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, ChatViewComponent_div_3_Template, 2, 1, "div", 2)(4, ChatViewComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
            i0.ɵɵprojection(5, 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.messages.length === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.messages);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, ChatMessageComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex-grow:1;min-height:1px}.message-container[_ngcontent-%COMP%]{flex-grow:1;overflow-y:auto;overflow-x:hidden;height:10em;color:#000;background:#fff;padding:.5em 1em .5em .5em}.message-container.no-scroll[_ngcontent-%COMP%]{height:auto;overflow-y:visible}.mat-dark-theme[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]{color:#fff;background:#000}banta-chat-message.flash[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_flash;animation-duration:2.5s;animation-iteration-count:1}@keyframes _ngcontent-%COMP%_flash{0%{transform:scale(1);background:#425700}25%{transform:scale(1.05)}50%{transform:scale(1)}75%{transform:scale(1.05)}to{transform:scale(1)}}.empty[_ngcontent-%COMP%]{text-align:center;margin:2em;color:#888;font-size:150%}"]
      });
    }
  }
  return ChatViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Chat component
 */
let BantaChatComponent = /*#__PURE__*/(() => {
  class BantaChatComponent {
    constructor(backend) {
      this.backend = backend;
      this._subs = new Subscription();
      this.user = null;
      this._metadata = {};
      this.signInLabel = 'Sign In';
      this.sendLabel = 'Send';
      this.permissionDeniedLabel = 'Send';
      this.messageFieldPlaceholder = 'Chat';
      this.emptyLabel = 'Be the first to chat';
      this._selected = new Subject();
      this._selected$ = this._selected.asObservable();
      this._reported = new Subject();
      this._reported$ = this._reported.asObservable();
      this._upvoted = new Subject();
      this._upvoted$ = this._upvoted.asObservable();
      this._userSelected = new Subject();
      this._userSelected$ = this._userSelected.asObservable();
      this._permissionDeniedError = new Subject();
      this._permissionDeniedError$ = this._permissionDeniedError.asObservable();
      this._signInSelected = new Subject();
      this._signInSelected$ = this._signInSelected.asObservable();
      this._received = new Subject();
      this._received$ = this._received.asObservable();
      this.showEmojiPanel = false;
      this.newMessage = {};
    }
    ngOnInit() {
      this._subs.add(this.backend.userChanged.subscribe(user => this.user = user));
    }
    ngOnDestroy() {
      this._subs.unsubscribe();
    }
    get source() {
      return this._source;
    }
    set source(value) {
      this._source = value;
    }
    get topicID() {
      return this._source.identifier;
    }
    set topicID(value) {
      this.setSourceFromTopicID(value);
    }
    /**
     * Arbitrary metadata to send to the chat server. This can be used to provide context about the client to the server
     * for things like validating authorization and other uses.
     */
    get metadata() {
      return this._metadata;
    }
    set metadata(value) {
      if (JSON.stringify(this._metadata) !== JSON.stringify(value)) {
        this._metadata = value;
        this.reloadSource();
      }
    }
    reloadSource() {
      clearTimeout(this._reloadSourceTimeout);
      this._reloadSourceTimeout = setTimeout(() => {
        this.setSourceFromTopicID(this.topicID);
      });
    }
    async setSourceFromTopicID(topicID) {
      if (this._source && this._source.close) this._source.close();
      this._source = null;
      this._source = await this.backend.getSourceForTopic(topicID, {
        metadata: this.metadata
      });
    }
    get selected() {
      return this._selected$;
    }
    get reported() {
      return this._reported$;
    }
    get upvoted() {
      return this._upvoted$;
    }
    get userSelected() {
      return this._userSelected$;
    }
    get permissionDeniedError() {
      return this._permissionDeniedError$;
    }
    get signInSelected() {
      return this._signInSelected$;
    }
    get received() {
      return this._received$;
    }
    onReceived(message) {
      this._received.next(message);
    }
    showSignIn() {
      this._signInSelected.next();
    }
    sendPermissionError(message) {
      this._permissionDeniedError.next(message);
    }
    insertEmoji(emoji) {
      let message = this.newMessage.message || '';
      this.newMessage.message = message + emoji;
    }
    onKeyDown(event) {
      // TODO
    }
    jumpToMessage(message) {
      if (this.chatView) this.chatView.jumpTo(message);
    }
    select(message) {
      this._selected.next(message);
    }
    selectUser(message) {
      this._userSelected.next(message);
    }
    report(message) {
      this._reported.next(message);
    }
    async upvote(message) {
      await this.source.likeMessage(message.id);
      this._upvoted.next(message);
    }
    get canChat() {
      if (!this.user) return false;
      // TODO
      // if (!this.user.permissions)
      //     return true;
      // if (!this.user.permissions.canChat)
      //     return true;
      // return this.user.permissions?.canChat(this.source);
      return true;
    }
    async sendMessage() {
      if (!this.source) return;
      let text = (this.newMessage.message || '').trim();
      this.newMessage.message = '';
      if (text === '') return;
      let message = {
        user: null,
        sentAt: Date.now(),
        likes: 0,
        url: this.url ?? (typeof window !== 'undefined' ? location.href : undefined),
        message: text
      };
      try {
        const intercept = await this.shouldInterceptMessageSend?.(message, this.source);
        if (!intercept) {
          await this.source.send(message);
        }
        this.chatView.scrollToLatest();
        this.inputElementRef.nativeElement.focus();
      } catch (e) {
        console.error(`Failed to send message: `, message);
        console.error(e);
      }
    }
    static {
      this.ɵfac = function BantaChatComponent_Factory(t) {
        return new (t || BantaChatComponent)(i0.ɵɵdirectiveInject(ChatBackendBase));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaChatComponent,
        selectors: [["banta-chat"]],
        viewQuery: function BantaChatComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5);
            i0.ɵɵviewQuery(_c15, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chatView = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElementRef = _t.first);
          }
        },
        inputs: {
          shouldInterceptMessageSend: "shouldInterceptMessageSend",
          url: "url",
          source: "source",
          topicID: "topicID",
          metadata: "metadata",
          signInLabel: "signInLabel",
          sendLabel: "sendLabel",
          permissionDeniedLabel: "permissionDeniedLabel",
          messageFieldPlaceholder: "messageFieldPlaceholder",
          emptyLabel: "emptyLabel"
        },
        outputs: {
          selected: "selected",
          reported: "reported",
          upvoted: "upvoted",
          userSelected: "userSelected",
          permissionDeniedError: "permissionDeniedError",
          signInSelected: "signInSelected",
          received: "received"
        },
        decls: 10,
        vars: 6,
        consts: [["chatView", ""], ["input", ""], [3, "upvoted", "reported", "selected", "received", "userSelected", "source", "emptyLabel"], [1, "new-message", 3, "submit"], [1, "entry-container"], ["type", "text", "name", "message", "autocomplete", "off", "enterkeyhint", "send", 3, "keydown", "ngModelChange", "placeholder", "ngModel"], ["overlayY", "bottom", "overlayX", "end", "originY", "top", 3, "selected"], [1, "actions"], [4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click"], ["mat-raised-button", "", "color", "primary", 3, "disabled", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", 3, "disabled"]],
        template: function BantaChatComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "banta-chat-view", 2, 0);
            i0.ɵɵlistener("upvoted", function BantaChatComponent_Template_banta_chat_view_upvoted_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.upvote($event));
            })("reported", function BantaChatComponent_Template_banta_chat_view_reported_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.report($event));
            })("selected", function BantaChatComponent_Template_banta_chat_view_selected_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.select($event));
            })("received", function BantaChatComponent_Template_banta_chat_view_received_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onReceived($event));
            })("userSelected", function BantaChatComponent_Template_banta_chat_view_userSelected_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectUser($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "form", 3);
            i0.ɵɵlistener("submit", function BantaChatComponent_Template_form_submit_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.sendMessage());
            });
            i0.ɵɵelementStart(3, "div", 4)(4, "input", 5, 1);
            i0.ɵɵlistener("keydown", function BantaChatComponent_Template_input_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyDown($event));
            });
            i0.ɵɵtwoWayListener("ngModelChange", function BantaChatComponent_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.newMessage.message, $event) || (ctx.newMessage.message = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "emoji-selector-button", 6);
            i0.ɵɵlistener("selected", function BantaChatComponent_Template_emoji_selector_button_selected_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.insertEmoji($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 7);
            i0.ɵɵtemplate(8, BantaChatComponent_ng_container_8_Template, 3, 1, "ng-container", 8)(9, BantaChatComponent_ng_container_9_Template, 3, 2, "ng-container", 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("source", ctx.source)("emptyLabel", ctx.emptyLabel);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", ctx.messageFieldPlaceholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.newMessage.message);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.user);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.user);
          }
        },
        dependencies: [i2.NgIf, i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.NgModel, i3$1.NgForm, i6.MatButton, EmojiSelectorButtonComponent, ChatViewComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;border-radius:5px;padding:10px;flex-grow:1;font-size:10pt;min-height:1px}.entry-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;position:relative}.entry-container[_ngcontent-%COMP%]   emoji-selector-button[_ngcontent-%COMP%]{position:absolute;right:0;top:.15em}.entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:2.6em;font-size:12pt;padding-left:1em}.entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill, .entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill:hover, .entry-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-webkit-autofill:focus{outline:1px solid #9da302;-webkit-text-fill-color:#9da302;-webkit-box-shadow:0 0 0px 1000px #211e07 inset;transition:background-color 5000s ease-in-out 0s;caret-color:#9da302}.entry-container[_ngcontent-%COMP%]   emoji-selector-panel[_ngcontent-%COMP%]{pointer-events:none;opacity:0;position:absolute;bottom:3.5em;right:0}.entry-container[_ngcontent-%COMP%]   emoji-selector-panel.visible[_ngcontent-%COMP%]{opacity:1;pointer-events:initial}form[_ngcontent-%COMP%]{display:flex;padding:.5em 0;align-items:center}form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:14pt;background:#000;color:#fff;border:1px solid #333;min-height:6em;width:100%}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#fff;color:#000;border:1px solid #ccc;width:100%;height:3.5em}form[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:1em}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}.mat-dark-theme[_nghost-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#000;color:#fff;border:1px solid #333}"]
      });
    }
  }
  return BantaChatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LiveCommentComponent = /*#__PURE__*/(() => {
  class LiveCommentComponent {
    constructor(backend) {
      this.backend = backend;
      this._upvoted = new Subject();
      this._reported = new Subject();
      this._selected = new Subject();
    }
    get upvoted() {
      return this._upvoted;
    }
    get reported() {
      return this._reported;
    }
    get selected() {
      return this._selected;
    }
    get message() {
      return this._message;
    }
    set message(value) {
      let originalId = null;
      if (this._message) originalId = this._message.id;
      this._message = value;
      if (value && originalId === value.id) {
        return;
      }
      if (this.unsubscribe) this.unsubscribe();
      if (value) {
        this.unsubscribe = this.backend.watchMessage(value, message => this.message = message);
      }
    }
    report() {
      this._reported.next();
    }
    upvote() {
      this._upvoted.next();
    }
    select() {
      this._selected.next();
    }
    static {
      this.ɵfac = function LiveCommentComponent_Factory(t) {
        return new (t || LiveCommentComponent)(i0.ɵɵdirectiveInject(ChatBackendBase));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LiveCommentComponent,
        selectors: [["banta-live-comment"]],
        inputs: {
          message: "message"
        },
        outputs: {
          upvoted: "upvoted",
          reported: "reported",
          selected: "selected"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "upvoted", "reported", "selected", "message"]],
        template: function LiveCommentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LiveCommentComponent_banta_comment_0_Template, 1, 1, "banta-comment", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.message);
          }
        },
        dependencies: [i2.NgIf, CommentComponent]
      });
    }
  }
  return LiveCommentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LiveChatMessageComponent = /*#__PURE__*/(() => {
  class LiveChatMessageComponent {
    constructor(backend) {
      this.backend = backend;
      this._upvoted = new Subject();
      this._reported = new Subject();
      this._selected = new Subject();
    }
    get upvoted() {
      return this._upvoted;
    }
    get reported() {
      return this._reported;
    }
    get selected() {
      return this._selected;
    }
    get message() {
      return this._message;
    }
    set message(value) {
      let originalId = null;
      if (this._message) originalId = this._message.id;
      this._message = value;
      if (value && originalId === value.id) {
        return;
      }
      if (this.unsubscribe) this.unsubscribe();
      if (value) {
        this.unsubscribe = this.backend.watchMessage(value, message => this.message = message);
      }
    }
    report() {
      this._reported.next();
    }
    upvote() {
      this._upvoted.next();
    }
    select() {
      this._selected.next();
    }
    static {
      this.ɵfac = function LiveChatMessageComponent_Factory(t) {
        return new (t || LiveChatMessageComponent)(i0.ɵɵdirectiveInject(ChatBackendBase));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LiveChatMessageComponent,
        selectors: [["banta-live-chat-message"]],
        inputs: {
          message: "message"
        },
        outputs: {
          upvoted: "upvoted",
          reported: "reported",
          selected: "selected"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "upvoted", "reported", "selected", "message"]],
        template: function LiveChatMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LiveChatMessageComponent_banta_chat_message_0_Template, 1, 1, "banta-chat-message", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.message);
          }
        },
        dependencies: [i2.NgIf, ChatMessageComponent]
      });
    }
  }
  return LiveChatMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LiveMessageComponent = /*#__PURE__*/(() => {
  class LiveMessageComponent {
    constructor() {
      this._upvoted = new Subject();
      this._reported = new Subject();
      this._selected = new Subject();
    }
    get upvoted() {
      return this._upvoted;
    }
    get reported() {
      return this._reported;
    }
    get selected() {
      return this._selected;
    }
    get message() {
      return this._message;
    }
    set message(value) {
      this._message = value;
      this.viewType = this.getViewType(value);
    }
    getViewType(message) {
      if (message.topicId.endsWith('_firehose')) return 'chat';else if (message.topicId.endsWith('_thepoint')) return 'comment';
      return 'comment';
    }
    upvote() {
      this._upvoted.next();
    }
    report() {
      this._reported.next();
    }
    select() {
      this._selected.next();
    }
    static {
      this.ɵfac = function LiveMessageComponent_Factory(t) {
        return new (t || LiveMessageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LiveMessageComponent,
        selectors: [["banta-live-message"]],
        inputs: {
          message: "message"
        },
        outputs: {
          upvoted: "upvoted",
          reported: "reported",
          selected: "selected"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [3, "message", "upvoted", "reported", "selected", 4, "ngIf"], [3, "upvoted", "reported", "selected", "message"]],
        template: function LiveMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LiveMessageComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.message);
          }
        },
        dependencies: [i2.NgIf, LiveCommentComponent, LiveChatMessageComponent]
      });
    }
  }
  return LiveMessageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Unified chat and comments component
 */
let BantaComponent = /*#__PURE__*/(() => {
  class BantaComponent {
    constructor(backend, matDialog) {
      this.backend = backend;
      this.matDialog = matDialog;
      this._subs = new Subscription();
      this.auxOpen = false;
      this.auxTitle = 'Notifications';
      this.auxMode = 'notifications';
      this.mobileFocus = null;
      this.newNotifications = false;
      this.chatLabel = 'Chat';
      this.commentsLabel = 'Comments';
      this._signInSelected = new Subject();
      this.pointOpen = null;
      this.pointSubChat = null;
      this.newPointSubMessage = {};
      this.genericAvatarUrl = 'https://gravatar.com/avatar/915c804e0be607a4ad766ddadea5c48a?s=512&d=https://codepen.io/assets/avatars/user-avatar-512x512-6e240cf350d2f1cc07c2bed234c3a3bb5f1b237023c204c782622e80d6b212ba.png';
    }
    ngOnInit() {
      this._subs.add(this.backend.userChanged.subscribe(user => this.currentUser = user));
      this._subs.add(this.backend.notificationsChanged.subscribe(notifs => this.notifications = notifs));
      this._subs.add(this.backend.newNotification.subscribe(notif => {
        this.newNotifications = true;
      }));
    }
    async sendPointSubMessage() {
      let text = (this.newPointSubMessage.message || '').trim();
      this.newPointSubMessage.message = '';
      if (text === '') return;
      let message = {
        user: null,
        sentAt: Date.now(),
        likes: 0,
        message: text
      };
      try {
        await this.pointSubChat.send(message);
      } catch (e) {
        console.error(`Failed to send point sub-message:`);
        console.error(e);
      }
    }
    async goToMessage(message) {
      let targetMessage = message;
      if (message.parentMessageId) {
        // jump to the parent message thread...
        let parentMessage;
        try {
          parentMessage = await this.backend.getMessage(message.topicId, message.parentMessageId);
        } catch (e) {
          console.error(`Received exception while fetching parent message:`);
          console.error(e);
        }
        if (!parentMessage) {
          console.error(`Failed to look up parent message ${message.topicId}/${message.parentMessageId}`);
          console.error(`Original message was:`);
          console.dir(targetMessage);
          return;
        }
        message = parentMessage;
      }
      let viewType = this.getViewType(message);
      if (viewType === 'comment') {
        if (this.pointSubChat) {
          if (this.pointSubChat.close) this.pointSubChat.close();
          this.pointSubChat = null;
        }
        this.mobileFocus = 'points';
        this.pointOpen = message;
        this.pointSubChat = await this.backend.getSourceForThread(message.topicId, message.id);
        this.pointOpen = await this.backend.refreshMessage(message);
        this.newPointSubMessage = {};
      } else if (viewType === 'chat') {
        this.mobileFocus = 'firehose';
        this.firehose.jumpToMessage(message);
      }
    }
    pointUnfocus() {
      this.pointOpen = null;
      if (this.pointSubChat) {
        if (this.pointSubChat.close) this.pointSubChat.close();
        this.pointSubChat = null;
      }
    }
    ngOnDestroy() {
      this._subs.unsubscribe();
    }
    showAux(title, mode) {
      this.auxOpen = true;
      this.auxTitle = title;
      this.auxMode = mode;
      this.mobileFocus = 'aux';
    }
    showNotifications() {
      this.showAux('Notifications', 'notifications');
    }
    get topicID() {
      return this._topicID;
    }
    set topicID(value) {
      this._topicID = value;
      this.close();
      this.connectToTopic(this._topicID);
    }
    async connectToTopic(id) {
      this.firehoseSource = await this.backend.getSourceForTopic(`${id}_firehose`);
      this.pointSource = await this.backend.getSourceForTopic(`${id}_thepoint`);
    }
    get signInSelected() {
      return this._signInSelected;
    }
    showSignIn() {
      this._signInSelected.next();
    }
    close() {
      if (this.firehoseSource) {
        if (this.firehoseSource.close) this.firehoseSource.close();
        this.firehoseSource = null;
      }
      if (this.pointSource) {
        if (this.pointSource.close) this.pointSource.close();
        this.pointSource = null;
      }
    }
    get hasPoint() {
      return this.pointOpen != null;
    }
    closeAux() {
      this.auxOpen = false;
      this.mobileFocus = 'firehose';
    }
    getViewType(message) {
      if (message.topicId.endsWith('_firehose')) return 'chat';else if (message.topicId.endsWith('_thepoint')) return 'comment';
      return 'comment';
    }
    async upvoteMessage(message) {
      // TODO
      //await this.backend.likeMessage(message.id);
    }
    showProfile(user) {
      this.profileUser = user;
      this.showAux(`@${user.username}'s Profile`, 'profile');
    }
    sendReport(message) {
      this.auxOpen = false;
      alert('would send report');
    }
    reportMessage(message) {
      this.reportedMessage = message;
      this.showAux(`Report message from @${message.user.username}`, 'report');
    }
    static {
      this.ɵfac = function BantaComponent_Factory(t) {
        return new (t || BantaComponent)(i0.ɵɵdirectiveInject(ChatBackendBase), i0.ɵɵdirectiveInject(i2$4.MatDialog));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaComponent,
        selectors: [["banta"]],
        viewQuery: function BantaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c16, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.firehose = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function BantaComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("point-focus", ctx.hasPoint);
          }
        },
        inputs: {
          topicID: "topicID",
          chatLabel: "chatLabel",
          commentsLabel: "commentsLabel"
        },
        outputs: {
          signInSelected: "signInSelected"
        },
        decls: 56,
        vars: 27,
        consts: [["userMenu", "matMenu"], ["firehose", ""], [4, "ngIf"], ["mat-menu-item", ""], [1, "tabs"], ["mat-button", "", 3, "click"], [1, "spacer"], ["mat-button", "", 3, "click", 4, "ngIf"], [1, "firehose"], [3, "click"], [3, "signInSelected", "upvoted", "userSelected", "reported", "source"], [1, "aux"], ["mat-icon-button", "", 3, "click"], [1, "aux-contents"], [1, "points"], [1, "point-focus"], [1, "actions"], ["class", "subcomments", 3, "newestLast", "allowReplies", "source", "upvoted", "reported", "userSelected", 4, "ngIf"], [1, "points-section"], [3, "signInSelected", "upvoted", "reported", "selected", "userSelected", "source"], ["mat-menu-item", "", 3, "disabled"], ["mat-menu-item", "", 3, "click"], ["mat-button", "", 3, "matMenuTriggerFor"], [2, "font-size", "125%"], [3, "message"], [2, "text-align", "center"], ["mat-raised-button", "", "color", "primary", 3, "click"], ["mat-raised-button", "", "color", "secondary", 3, "click"], [1, "notifications"], ["class", "notification", 4, "ngFor", "ngForOf"], [1, "notification"], [3, "value"], [3, "upvoted", "reported", "selected", "message"], ["mat-button", "", "target", "_blank", 3, "href"], [1, "counted-action"], [1, "count-indicator"], ["mat-icon-button", ""], [1, "subcomments", 3, "upvoted", "reported", "userSelected", "newestLast", "allowReplies", "source"], ["class", "focused-comment", "data-before", "", 3, "showReplyAction", "message", "readonly", "upvoted", "userSelected", "reported", 4, "ngIf"], [1, "message", "reply"], [1, "new-message", 3, "submit"], ["name", "message", 3, "keydown", "ngModelChange", "ngModel"], ["mat-raised-button", "", "color", "primary", 3, "disabled"], ["data-before", "", 1, "focused-comment", 3, "upvoted", "userSelected", "reported", "showReplyAction", "message", "readonly"]],
        template: function BantaComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-menu", null, 0);
            i0.ɵɵtemplate(2, BantaComponent_ng_container_2_Template, 5, 3, "ng-container", 2)(3, BantaComponent_ng_container_3_Template, 3, 0, "ng-container", 2);
            i0.ɵɵelementStart(4, "button", 3);
            i0.ɵɵtext(5, "Help");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 4)(7, "div")(8, "a", 5);
            i0.ɵɵlistener("click", function BantaComponent_Template_a_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mobileFocus = "chat");
            });
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "a", 5);
            i0.ɵɵlistener("click", function BantaComponent_Template_a_click_10_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mobileFocus = "comments");
            });
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(12, "div", 6);
            i0.ɵɵelementStart(13, "div");
            i0.ɵɵtemplate(14, BantaComponent_ng_container_14_Template, 6, 2, "ng-container", 2)(15, BantaComponent_button_15_Template, 2, 0, "button", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 8)(17, "header")(18, "div")(19, "label", 9);
            i0.ɵɵlistener("click", function BantaComponent_Template_label_click_19_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.mobileFocus = "chat");
            });
            i0.ɵɵtext(20);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(21, "div", 6);
            i0.ɵɵtemplate(22, BantaComponent_ng_container_22_Template, 6, 2, "ng-container", 2)(23, BantaComponent_button_23_Template, 2, 0, "button", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "banta-chat", 10, 1);
            i0.ɵɵlistener("signInSelected", function BantaComponent_Template_banta_chat_signInSelected_24_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showSignIn());
            })("upvoted", function BantaComponent_Template_banta_chat_upvoted_24_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.upvoteMessage($event));
            })("userSelected", function BantaComponent_Template_banta_chat_userSelected_24_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showProfile($event.user));
            })("reported", function BantaComponent_Template_banta_chat_reported_24_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.reportMessage($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(26, "div", 11)(27, "header")(28, "div")(29, "label");
            i0.ɵɵtext(30);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(31, "div", 6);
            i0.ɵɵelementStart(32, "button", 12);
            i0.ɵɵlistener("click", function BantaComponent_Template_button_click_32_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.auxOpen = false);
            });
            i0.ɵɵelementStart(33, "mat-icon");
            i0.ɵɵtext(34, "close");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(35, "div", 13);
            i0.ɵɵtemplate(36, BantaComponent_ng_container_36_Template, 2, 1, "ng-container", 2)(37, BantaComponent_ng_container_37_Template, 10, 1, "ng-container", 2)(38, BantaComponent_ng_container_38_Template, 4, 2, "ng-container", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(39, "div", 14)(40, "header")(41, "div")(42, "label");
            i0.ɵɵtext(43);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(44, "div", 15)(45, "div", 16)(46, "button", 5);
            i0.ɵɵlistener("click", function BantaComponent_Template_button_click_46_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.pointUnfocus());
            });
            i0.ɵɵelementStart(47, "mat-icon");
            i0.ɵɵtext(48, "arrow_back");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(49, " Back ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(50, "div", 6);
            i0.ɵɵtemplate(51, BantaComponent_ng_container_51_Template, 7, 1, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(52, BantaComponent_div_52_Template, 2, 0, "div", 2)(53, BantaComponent_banta_comment_view_53_Template, 9, 6, "banta-comment-view", 17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(54, "div", 18)(55, "banta-comments", 19);
            i0.ɵɵlistener("signInSelected", function BantaComponent_Template_banta_comments_signInSelected_55_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showSignIn());
            })("upvoted", function BantaComponent_Template_banta_comments_upvoted_55_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.upvoteMessage($event));
            })("reported", function BantaComponent_Template_banta_comments_reported_55_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.reportMessage($event));
            })("selected", function BantaComponent_Template_banta_comments_selected_55_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.goToMessage($event));
            })("userSelected", function BantaComponent_Template_banta_comments_userSelected_55_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showProfile($event.user));
            });
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.currentUser);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.currentUser);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.chatLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.commentsLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.currentUser);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.currentUser);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("focus", ctx.mobileFocus === "chat");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.chatLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.currentUser);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.currentUser);
            i0.ɵɵadvance();
            i0.ɵɵproperty("source", ctx.firehoseSource);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("focus", ctx.mobileFocus === "aux")("open", ctx.auxOpen);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.auxTitle);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.auxMode === "profile");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.auxMode === "report");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.auxMode === "notifications");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("focus", ctx.mobileFocus === "points");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.commentsLabel);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngIf", ctx.pointOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.pointSubChat);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pointSubChat);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("source", ctx.pointSource);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.NgModel, i3$1.NgForm, TimestampComponent, CommentComponent, CommentViewComponent, BantaCommentsComponent, BantaChatComponent, i2$1.MatIcon, i6.MatAnchor, i6.MatButton, i6.MatIconButton, i7$1.MatMenu, i7$1.MatMenuItem, i7$1.MatMenuTrigger, LiveMessageComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;padding:.5em;height:40em;position:relative}.counted-action[_ngcontent-%COMP%]{display:flex;align-items:center}.count-indicator[_ngcontent-%COMP%]{font-size:9pt;padding:0 3px;border-radius:3px;border:1px solid #333}header[_ngcontent-%COMP%]{position:relative;margin-bottom:1em}header[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:flex;align-items:center;height:30px}header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{color:#666}header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-transform:uppercase;z-index:1;font-size:12pt;letter-spacing:2px;font-weight:100;color:#333;margin:0 auto 0 0;display:block;width:fit-content;position:relative;white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis}header[_ngcontent-%COMP%]:after{content:\"\";border:1px solid;border-color:#ccc;height:0px;width:100%;display:block;position:relative;z-index:0}.points[_ngcontent-%COMP%]{width:33%;max-width:50em;display:flex;flex-direction:column}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]{width:66%;max-width:50em}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .points-section[_ngcontent-%COMP%]{opacity:0;pointer-events:none}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]{opacity:1;pointer-events:initial}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex}banta-comments[_ngcontent-%COMP%]{flex-grow:1}.points[_ngcontent-%COMP%]{width:33%;margin-left:.5em;font-size:12pt;flex-shrink:0;max-width:30em;transition:.2s width ease-in,.2s max-width ease-in;position:relative}.points[_ngcontent-%COMP%]   .points-section[_ngcontent-%COMP%]{flex-grow:1;display:flex;flex-direction:column;opacity:1;transition:.2s opacity ease-in;z-index:2}.points[_ngcontent-%COMP%]   .point-focus[_ngcontent-%COMP%]{position:absolute;width:100%;inset:1.75em 0 0;padding:.5em;opacity:0;transition:.2s opacity ease-in;flex-grow:1;display:flex;flex-direction:column}.firehose[_ngcontent-%COMP%]{flex-grow:1;font-size:10pt;display:flex;flex-direction:column}form[_ngcontent-%COMP%]{display:flex;padding:.5em 0;align-items:center}form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:14pt;background:#000;color:#fff;border:1px solid #333;min-height:6em;width:100%}form[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background:#000;color:#fff;border:1px solid #333;width:100%;height:1em}form[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{margin-left:1em}form[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:block;margin:0 0 0 auto}.subcomments[_ngcontent-%COMP%]     banta-comment{font-size:10pt}.subcomments[_ngcontent-%COMP%]     banta-comment.focused-comment{background:#001321;color:#fff;font-size:12pt}.aux[_ngcontent-%COMP%]{width:0px;min-width:0px;overflow-x:hidden;transition:.4s width ease-out,.4s min-width ease-out;display:flex;flex-direction:column}.aux.open[_ngcontent-%COMP%]{width:30em;min-width:18em}.aux[_ngcontent-%COMP%]   .aux-contents[_ngcontent-%COMP%]{width:30em;min-width:10em;max-width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;flex-grow:1}.notifications[_ngcontent-%COMP%]   .notification[_ngcontent-%COMP%]{border-bottom:1px solid #333;padding:1em}.notifications[_ngcontent-%COMP%]   .notification[_ngcontent-%COMP%]   banta-timestamp[_ngcontent-%COMP%]{display:block;text-align:right;font-size:9pt;color:#999}.message.reply[_ngcontent-%COMP%]{padding:1em}.tabs[_ngcontent-%COMP%]{display:none}@media (max-width: 1015px){[_nghost-%COMP%]{flex-direction:column}.tabs[_ngcontent-%COMP%]{display:flex;position:absolute;top:0;left:0;right:0;width:100%;z-index:10;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:#00000080}.points[_ngcontent-%COMP%]{width:100%;max-width:100%;margin-left:0}header[_ngcontent-%COMP%]{display:none}.point-focus[_nghost-%COMP%]   .points[_ngcontent-%COMP%]{width:100%;max-width:100%}.aux[_ngcontent-%COMP%]{width:100%;min-width:initial;max-width:100%}.points[_ngcontent-%COMP%], .firehose[_ngcontent-%COMP%], .aux[_ngcontent-%COMP%]{position:absolute;inset:2em 0 0;z-index:0;background:#000}.points.focus[_ngcontent-%COMP%], .firehose.focus[_ngcontent-%COMP%], .aux.focus[_ngcontent-%COMP%]{z-index:2}}.mat-dark-theme   [_nghost-%COMP%]{background:#090909;color:#fff}.mat-dark-theme[_nghost-%COMP%]   form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   form[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{background:#ccc;color:#333}.mat-dark-theme[_nghost-%COMP%]   header[_ngcontent-%COMP%]:after, .mat-dark-theme   [_nghost-%COMP%]   header[_ngcontent-%COMP%]:after{border-color:#222}.mat-dark-theme[_nghost-%COMP%]   header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .mat-dark-theme   [_nghost-%COMP%]   header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#aaa}"]
      });
    }
  }
  return BantaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BantaLogoComponent = /*#__PURE__*/(() => {
  class BantaLogoComponent {
    static {
      this.ɵfac = function BantaLogoComponent_Factory(t) {
        return new (t || BantaLogoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BantaLogoComponent,
        selectors: [["banta-logo"]],
        decls: 1,
        vars: 0,
        template: function BantaLogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0, "banta");
          }
        },
        styles: ["[_nghost-%COMP%]{font-family:Odibee Sans,sans-serif;font-size:40pt}.small[_nghost-%COMP%]{font-size:30pt}"]
      });
    }
  }
  return BantaLogoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS$1 = [ChatMessageComponent, LiveChatMessageComponent, ChatViewComponent, BantaChatComponent];
let ChatModule = /*#__PURE__*/(() => {
  class ChatModule {
    static {
      this.ɵfac = function ChatModule_Factory(t) {
        return new (t || ChatModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ChatModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, EmojiModule]
      });
    }
  }
  return ChatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommentSortComponent = /*#__PURE__*/(() => {
  class CommentSortComponent {
    constructor() {
      this.commentsOrder = CommentsOrder;
      this._sortChange = new Subject();
      this._sort = CommentsOrder.LIKES;
    }
    get sort() {
      return this._sort;
    }
    set sort(value) {
      if (this._sort !== value) {
        this._sort = value;
        setTimeout(() => this._sortChange.next(value));
      }
    }
    get sortChange() {
      return this._sortChange.asObservable();
    }
    static {
      this.ɵfac = function CommentSortComponent_Factory(t) {
        return new (t || CommentSortComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CommentSortComponent,
        selectors: [["banta-comment-sort"]],
        inputs: {
          sort: "sort"
        },
        outputs: {
          sortChange: "sortChange"
        },
        decls: 10,
        vars: 4,
        consts: [["appearance", "outline", "floatLabel", "always"], [3, "valueChange", "value"], [3, "value"]],
        template: function CommentSortComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0)(1, "mat-label");
            i0.ɵɵtext(2, "Sort");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-select", 1);
            i0.ɵɵtwoWayListener("valueChange", function CommentSortComponent_Template_mat_select_valueChange_3_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.sort, $event) || (ctx.sort = $event);
              return $event;
            });
            i0.ɵɵelementStart(4, "mat-option", 2);
            i0.ɵɵtext(5, "Newest");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-option", 2);
            i0.ɵɵtext(7, "Oldest");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-option", 2);
            i0.ɵɵtext(9, "Likes");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("value", ctx.sort);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.commentsOrder.NEWEST);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.commentsOrder.OLDEST);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.commentsOrder.LIKES);
          }
        },
        dependencies: [i6$1.MatFormField, i6$1.MatLabel, i2$5.MatSelect, i3$3.MatOption],
        styles: ["mat-form-field[_ngcontent-%COMP%]{width:100%}"]
      });
    }
  }
  return CommentSortComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS = [CommentComponent, CommentViewComponent, BantaCommentsComponent, LiveCommentComponent, CommentFieldComponent, CommentSortComponent, AttachmentButtonComponent, BantaReplySendOptionsDirective, AttachmentScraperDirective];
let CommentsModule = /*#__PURE__*/(() => {
  class CommentsModule {
    static {
      this.ɵfac = function CommentsModule_Factory(t) {
        return new (t || CommentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CommentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TextFieldModule, FormsModule, MatIconModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatMenuModule, MatProgressSpinnerModule, BantaCommonModule, EmojiModule, MatTooltipModule, MatSelectModule, OverlayModule, PortalModule]
      });
    }
  }
  return CommentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChatSource = /*#__PURE__*/(() => {
  class ChatSource extends SocketRPC {
    constructor(backend, identifier, parentIdentifier, options) {
      super();
      this.backend = backend;
      this.identifier = identifier;
      this.parentIdentifier = parentIdentifier;
      this.subscription = new Subscription();
      this.readonly = false;
      this.canLoadMore = true;
      this._state = 'connecting';
      this._connectionStateChanged = new Subject();
      this._connectionStateChanged$ = this._connectionStateChanged.asObservable();
      this.wasRestored = false;
      this.subscribeAttempt = 0;
      this._signInState = 'signed-out';
      this._signInStateChanged = new BehaviorSubject(this._signInState);
      this._signInStateChanged$ = this._signInStateChanged.asObservable();
      this.messageMap = new Map();
      this._messageReceived = new Subject();
      this._messageUpdated = new Subject();
      this._messageSent = new Subject();
      this._messageObserved = new Subject();
      this.messages = [];
      this.options = options ?? {};
      this.ready = new Promise(resolve => this.markReady = resolve);
    }
    get sortOrder() {
      return this.options?.sortOrder;
    }
    get filterMode() {
      return this.options?.filterMode;
    }
    get state() {
      return this._state;
    }
    set state(value) {
      this._state = value;
      setTimeout(() => this._connectionStateChanged.next(this._state));
    }
    get connectionStateChanged() {
      return this._connectionStateChanged$;
    }
    async bind(socket) {
      super.bind(socket);
      this.subscription.add(this.backend.userChanged.subscribe(() => this.authenticate()));
      socket.addEventListener('open', async () => {
        console.log(`[Banta/${this.identifier}] Socket is open`);
      });
      socket.addEventListener('error', async () => {
        console.log(`[Banta/${this.identifier}] Socket error`);
      });
      socket.addEventListener('lost', async () => {
        this.state = 'lost';
      });
      socket.addEventListener('restore', async () => {
        this.wasRestored = true;
        await this.authenticate();
        await this.subscribeToTopic();
      });
      try {
        await this.subscribeToTopic();
      } catch (e) {
        console.error(`[Banta/ChatSource] Error during initial subscribeToTopic: ${e.message}`);
      }
      return this;
    }
    mapOrUpdateMessages(messages) {
      return messages.map(message => this.mapOrUpdateMessage(message));
    }
    mapOrUpdateMessage(message) {
      let existingMessage = this.messageMap.get(message.id);
      if (existingMessage) {
        message = Object.assign(existingMessage, message);
      } else {
        this.messageMap.set(message.id, message);
        this._messageObserved.next(message);
      }
      return message;
    }
    async getExistingMessages() {
      try {
        let messages = await this.idempotentPeer.getExistingMessages(this.options.initialMessageCount ?? 20);
        messages = this.mapOrUpdateMessages(messages);
        return messages;
      } catch (e) {
        console.error(`[Banta/${this.identifier}] Error occurred while trying to get existing messages:`);
        console.error(e);
        return [];
      }
    }
    async ensureConnection(errorMessage) {
      // let reason = `Connection to chat services is not currently available.`;
      // if (this.state !== 'connected' && this.state !== 'restored') {
      //     if (errorMessage)
      //         throw new Error(`${errorMessage}: ${reason}`);
      //     else
      //         throw new Error(`${reason}`);
      // }
    }
    async editMessage(messageId, text) {
      await this.ensureConnection();
      await this.peer.editMessage(messageId, text);
    }
    get errorState() {
      return this._errorState;
    }
    async subscribeToTopic() {
      try {
        await this.immediatePeer.subscribe(this.identifier, this.parentIdentifier, this.options.sortOrder, this.options.filterMode, this.options.metadata ?? {});
        this.subscribeAttempt = 0;
        this._errorState = undefined;
        this.state = this.wasRestored ? 'restored' : 'connected';
        this.markReady();
      } catch (e) {
        console.error(`[Banta/${this.identifier}] Error while subscribing to topic`);
        console.error(e);
        this.state = 'lost';
        this._errorState = 'server-issue';
        this.subscribeAttempt += 1;
        let delay = Math.min(30 * 1000, 3 * 1000 * this.subscribeAttempt * (1 + Math.random()));
        console.error(`[Banta/${this.identifier}] Waiting ${delay}ms before attempting to reconnect...`);
        setTimeout(() => {
          if (this.state === 'lost') {
            console.info(`Attempting reconnection after error in subscribeToTopic...`);
            this.reconnect();
          }
        }, delay);
        throw e;
      }
    }
    get signInState() {
      return this._signInState;
    }
    get signInStateChanged() {
      return this._signInStateChanged$;
    }
    setSignInState(state) {
      this._signInState = state;
      this._signInStateChanged.next(state);
    }
    async authenticate() {
      this.setSignInState('signing-in');
      if (this.backend.user) {
        try {
          // console.log(`Artificial delay...`);
          // await new Promise(r => setTimeout(r, 30_000));
          // console.log(`Artificial delay complete...`);
          await this.immediatePeer.authenticate(this.backend.user?.token);
          this.setSignInState('signed-in');
        } catch (e) {
          console.error(`[Banta] Could not authenticate:`);
          console.error(e);
          this.setSignInState('signed-out');
        }
      }
    }
    close() {
      super.close();
      this.subscription.unsubscribe();
    }
    onPermissions(permissions) {
      window.bantaPermissionsDebug = permissions;
      this.permissions = permissions;
    }
    onChatMessage(message) {
      if (this.messageMap.has(message.id)) {
        return this.mapOrUpdateMessage(message);
      } else if (!message.hidden) {
        // Only process non-hidden messages through here. 
        // Hidden messages may be sent to us when they become hidden (ie moderation is occurring).
        // But if we never had the message to begin with, we should discard it.
        this.messageMap.set(message.id, message);
        this._messageReceived.next(message);
      }
    }
    get messageReceived() {
      return this._messageReceived.asObservable();
    }
    get messageUpdated() {
      return this._messageUpdated.asObservable();
    }
    get messageSent() {
      return this._messageSent.asObservable();
    }
    get messageObserved() {
      return this._messageObserved.asObservable();
    }
    async send(message) {
      await this.ensureConnection();
      message.id ??= v4();
      return await this.idempotentPeer.sendMessage(message);
    }
    async loadAfter(message, count) {
      if (!message) return;
      if (!message.pagingCursor) return [];
      return this.mapOrUpdateMessages(await this.idempotentPeer.loadAfter(Number(message.pagingCursor), count));
    }
    async get(id) {
      if (this.messageMap.has(id)) return this.messageMap.get(id);
      await this.ensureConnection(`Could not get message`);
      let message = await this.idempotentPeer.getMessage(id);
      if (this.messageMap.has(id)) {
        let existingMessage = this.messageMap.get(id);
        Object.assign(existingMessage, message);
        message = existingMessage;
      } else {
        this.messageMap.set(id, message);
      }
      return message;
    }
    async getCount() {
      return await this.idempotentPeer.getCount();
    }
    async likeMessage(messageId) {
      await this.ensureConnection();
      return await this.idempotentPeer.likeMessage(messageId);
    }
    async unlikeMessage(messageId) {
      await this.ensureConnection();
      return await this.idempotentPeer.unlikeMessage(messageId);
    }
    async deleteMessage(messageId) {
      await this.ensureConnection();
      return await this.idempotentPeer.deleteMessage(messageId);
    }
  }
  __decorate([RpcEvent()], ChatSource.prototype, "onPermissions", null);
  __decorate([RpcEvent()], ChatSource.prototype, "onChatMessage", null);

  /**
   * A special ChatSource which uses the REST API to load a limited number of chat messages, and does not support
   * sending/editing/deleting messages, liking/unliking, or loading more messages.
   *
   * This is used within Banta's SSR support.
   */
  return ChatSource;
})();
class StaticChatSource {
  constructor(backend, identifier, parentIdentifier, options) {
    this.backend = backend;
    this.identifier = identifier;
    this.parentIdentifier = parentIdentifier;
    this.ready = Promise.resolve(); // TODO: should we do more than this?
    this.readonly = true;
    this.canLoadMore = false;
    this.messageReceived = new Subject();
    this.messageObserved = new Subject();
    this.messageUpdated = new Subject();
    this.messageSent = new Subject();
    this.messages = [];
    this.connectionStateChanged = new Subject();
    this.state = 'connected';
    this.sortOrder = options?.sortOrder ?? CommentsOrder.NEWEST;
    this.filterMode = options?.filterMode ?? FilterMode.ALL;
    this.initialMessageCount = options?.initialMessageCount ?? 100;
  }
  async send(message) {
    throw new Error(`Cannot send a message in this state.`);
  }
  close() {
    // no op
  }
  async getCount() {
    if (this.parentIdentifier) {
      // TODO: We need a getReplyCount or something
      return 0;
    }
    this.backend.getSourceCountForTopic(this.identifier);
  }
  async getExistingMessages() {
    if (this.parentIdentifier) {
      return await this.backend.getReplies(this.parentIdentifier, this.sortOrder, this.filterMode, 0, this.initialMessageCount);
    } else {
      return await this.backend.getMessages(this.identifier, this.sortOrder, this.filterMode, 0, this.initialMessageCount);
    }
  }
  async loadAfter(message, count) {
    return []; // no op
  }
  async get(id) {
    return await this.backend.getMessage(this.identifier, id);
  }
  async likeMessage(messageId) {
    throw new Error(`Cannot perform this action in this state.`);
  }
  async unlikeMessage(messageId) {
    throw new Error(`Cannot perform this action in this state.`);
  }
  async editMessage(messageId, text) {
    throw new Error(`Cannot perform this action in this state.`);
  }
  async deleteMessage(messageId) {
    throw new Error(`Cannot perform this action in this state.`);
  }
  get errorState() {
    return undefined;
  }
}
let ChatBackend = /*#__PURE__*/(() => {
  class ChatBackend extends ChatBackendBase {
    constructor(options, platformId) {
      super();
      this.options = options;
      this.platformId = platformId;
    }
    get serviceUrl() {
      return `${this.options?.serviceUrl ?? 'http://localhost:3422'}`;
    }
    async connectToService() {
      let socket = new DurableSocket(`${this.serviceUrl.replace(/^http/, 'ws')}/socket`);
      await new Promise((resolve, reject) => {
        socket.onopen = () => {
          resolve();
        };
        socket.onclose = e => {
          if (e.code === 503) {
            console.error(`Failed to connect to chat service!`);
            reject(e);
          }
        };
      });
      socket.onerror = undefined;
      return socket;
    }
    isServer() {
      if (typeof localStorage !== 'undefined' && localStorage['banta:debug:useStaticSource'] === '1') return true;
      return isPlatformServer(this.platformId);
    }
    /**
     * Check if we are currently running inside a Googlebot user agent or via the Google inspection tool in Search Console.
     * We'll use this to avoid WebSockets so that comments can be indexable.
     * @returns
     */
    isGooglebot() {
      return typeof navigator !== 'undefined' && (navigator.userAgent.includes('Googlebot') || navigator.userAgent.includes('Google-InspectionTool'));
    }
    async getSourceForTopic(topicId, options) {
      // In some cases we need to do a single REST request to fetch the messages 
      // and not use Banta's socket RPC since the open ended lifetime of a WebSocket connection 
      // does not match the use case.
      // - When running in SSR
      // - When running in Googlebot (Googlebot also doesn't support WebSockets anyway)
      if (this.isServer() || this.isGooglebot()) {
        return new StaticChatSource(this, topicId, undefined, options);
      } else {
        return await new ChatSource(this, topicId, undefined, {
          sortOrder: CommentsOrder.NEWEST,
          filterMode: FilterMode.ALL,
          ...options
        }).bind(await this.connectToService());
      }
    }
    async getSourceForThread(topicId, messageId, options) {
      // When running on the server platform, we're just going to do a single REST request to fetch the messages 
      // and not use Banta's socket RPC.
      if (this.isServer()) {
        return new StaticChatSource(this, topicId, messageId, options);
      } else {
        return await new ChatSource(this, topicId, messageId, {
          sortOrder: CommentsOrder.NEWEST,
          filterMode: FilterMode.ALL,
          ...options
        }).bind(await this.connectToService());
      }
    }
    /**
     * Get the count of the given topic
     * @param topicId
     * @returns
     */
    async getSourceCountForTopic(topicId) {
      try {
        let topic = await this.getTopic(topicId);
        return topic?.messageCount ?? 0;
      } catch (e) {
        console.error(`[Banta/${topicId}] Failed to get message count for topic:`);
        console.error(e);
        return undefined;
      }
    }
    /**
     * Get the count of the given topics.
     * @param topicId Topics to count messages on. Maximum of 1000.
     * @returns
     */
    async getSourceCountForTopics(topicIds) {
      try {
        let topics = await this.getTopicsById(topicIds);
        return Object.fromEntries(topics.map(topic => [topic.id, topic.messageCount ?? 0]));
      } catch (e) {
        console.error(`[Banta/Topics] Failed to get message count for topics '${topicIds.join(',')}]':`);
        console.error(e);
        return undefined;
      }
    }
    /**
     * Get information about the given topic.
     * @param topicId
     * @returns The topic object, or undefined if no such topic was found.
     */
    async getTopic(topicId) {
      let response = await fetch(`${this.serviceUrl}/topics/${topicId}`);
      if (response.status === 404) return undefined;
      if (response.status >= 400) throw new Error(`Failed to fetch topic: ${response.status}`);
      return await response.json();
    }
    /**
     * Get information about the given topics
     * @param topicIds The topic IDs to look up. Maximum of 1000.
     * @returns An array of matching topic objects.
     */
    async getTopicsById(topicIds) {
      if (topicIds.length > 1000) throw new Error(`Cannot look up more than 1000 topics at a time.`);
      let response = await fetch(`${this.serviceUrl}/topics?ids=${encodeURIComponent(topicIds.join(','))}`);
      if (response.status >= 400) throw new Error(`Failed to fetch topic: ${response.status}`);
      return await response.json();
    }
    /**
     * Get a set of messages from the given topic.
     * @param topicId
     * @returns
     */
    async getMessages(topicId, sort, filter, offset, limit) {
      let response = await fetch(`${this.serviceUrl}/topics/${topicId}/messages?${buildQuery({
        sort,
        filter,
        offset,
        limit
      })}`);
      if (response.status >= 400) throw new Error(`Failed to fetch messages for topic: ${response.status}`);
      return await response.json();
    }
    /**
     * Get a set of messages from the given topic.
     * @param topicId
     * @returns
     */
    async getReplies(parentMessageId, sort, filter, offset, limit) {
      let response = await fetch(`${this.serviceUrl}/messages/${parentMessageId}/replies?${buildQuery({
        sort,
        filter,
        offset,
        limit
      })}`);
      if (response.status >= 400) throw new Error(`Failed to fetch replies: ${response.status}`);
      return await response.json();
    }
    refreshMessage(message) {
      throw new Error("Method not implemented.");
    }
    getMessage(topicId, messageId) {
      throw new Error("Method not implemented.");
    }
    getSubMessage(topicId, parentMessageId, messageId) {
      throw new Error("Method not implemented.");
    }
    watchMessage(message, handler) {
      throw new Error("Method not implemented.");
    }
    async getCardForUrl(url) {
      let response = await fetch(`${this.serviceUrl}/urls`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url
        })
      });
      if (response.status == 404) return null;
      if (response.status >= 400) throw new Error(`Failed to retrieve URL card: ${response.status}. Body: '${await response.text()}'`);
      return await response.json();
    }
    static {
      this.ɵfac = function ChatBackend_Factory(t) {
        return new (t || ChatBackend)(i0.ɵɵinject(BANTA_SDK_OPTIONS), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ChatBackend,
        factory: ChatBackend.ɵfac
      });
    }
  }
  return ChatBackend;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const URL_REGEX = new RegExp('(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?', 'ig');
class UrlAttachmentScraper {
  findFragments(message) {
    // If a message already has a URL attachment, don't add another one.
    if (message.attachments && message.attachments.filter(x => x.type === 'url').length > 0) return null;
    return Array.from(message.message.match(URL_REGEX) ?? []).reduce((a, item) => (a.includes(item) ? undefined : a.push(item), a), []).map(url => ({
      text: url,
      offset: message.message.indexOf(url),
      type: 'url'
    }));
  }
}
let UrlAttachmentResolver = /*#__PURE__*/(() => {
  class UrlAttachmentResolver {
    constructor(backend) {
      this.backend = backend;
    }
    async resolveFragment(message, fragment) {
      if (fragment.type !== 'url') return null;
      let urlCard = await this.backend.getCardForUrl(fragment.text);
      if (urlCard) {
        return {
          type: 'card',
          url: fragment.text,
          card: urlCard,
          style: 'block'
        };
      }
    }
    static {
      this.ɵfac = function UrlAttachmentResolver_Factory(t) {
        return new (t || UrlAttachmentResolver)(i0.ɵɵinject(ChatBackendBase));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UrlAttachmentResolver,
        factory: UrlAttachmentResolver.ɵfac
      });
    }
  }
  return UrlAttachmentResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class YouTubeAttachmentResolver {
  async resolveFragment(message, fragment) {
    if (fragment.type !== 'url') return null;
    let videoId;
    // https://youtu.be/jXzJ7FlqX6M
    if (fragment.text.match(/^https:\/\/youtu\.be\//)) {
      let match = /^https:\/\/youtu\.be\/([^\/]+)/.exec(fragment.text);
      if (match) {
        videoId = match[1];
      }
    }
    if (!videoId && fragment.text.match(/^https?:\/\/(www\.|m\.)?youtube.com\/watch\?v=/)) {
      let match = /watch\?v=([^&]+)/.exec(fragment.text);
      if (match) {
        videoId = match[1];
      }
    }
    if (videoId) {
      return {
        type: 'iframe',
        url: `https://www.youtube.com/embed/${videoId}`,
        style: 'block'
      };
    }
    return null;
  }
}
class GiphyAttachmentResolver {
  async resolveFragment(message, fragment) {
    if (fragment.type === 'url' && fragment.text.startsWith('https://giphy.com/gifs')) {
      let gifId = /[^-\/]+$/.exec(fragment.text)?.toString();
      if (!gifId) return null;
      return {
        type: 'iframe',
        url: `https://giphy.com/embed/${gifId}`,
        style: 'inline'
      };
    }
    return null;
  }
}
class TweetAttachmentResolver {
  async resolveFragment(message, fragment) {
    if (fragment.type === 'url' && (fragment.text.startsWith('https://twitter.com/') || fragment.text.startsWith('https://x.com/'))) {
      return {
        type: 'tweet',
        url: fragment.text,
        style: 'block'
      };
    }
    return null;
  }
}
let BantaSdkModule = /*#__PURE__*/(() => {
  class BantaSdkModule {
    constructor(chatBackend) {
      chatBackend.registerAttachmentScraper(new UrlAttachmentScraper());
      chatBackend.registerAttachmentResolver(new GiphyAttachmentResolver());
      chatBackend.registerAttachmentResolver(new YouTubeAttachmentResolver());
      chatBackend.registerAttachmentResolver(new TweetAttachmentResolver());
      chatBackend.registerAttachmentResolver(new UrlAttachmentResolver(chatBackend));
    }
    static configure(options) {
      return {
        ngModule: BantaSdkModule,
        providers: [{
          provide: BANTA_SDK_OPTIONS,
          useValue: options || {}
        }, {
          provide: ChatBackendBase,
          useClass: ChatBackend
        }]
      };
    }
    static {
      this.ɵfac = function BantaSdkModule_Factory(t) {
        return new (t || BantaSdkModule)(i0.ɵɵinject(ChatBackendBase));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BantaSdkModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, BantaCommonModule.forRoot(), CommentsModule, ChatModule, EmojiModule, MatIconModule, MatButtonModule, MatTooltipModule, MatMenuModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatSnackBarModule, OverlayModule, PortalModule, BantaCommonModule, ChatModule, CommentsModule, EmojiModule]
      });
    }
  }
  return BantaSdkModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AttachmentButtonComponent, AttachmentScraperDirective, BANTA_SDK_OPTIONS, BantaAttachmentComponent, BantaAttachmentsComponent, BantaChatComponent, BantaCommentsComponent, BantaCommonModule, BantaComponent, BantaLogoComponent, BantaMarkdownToHtmlPipe, BantaMentionLinkerPipe, BantaReplySendOptionsDirective, BantaSdkModule, BantaTrustResourceUrlPipe, ChatBackend, ChatBackendBase, ChatMessageComponent, ChatModule, ChatSource, ChatViewComponent, CommentComponent, CommentFieldComponent, CommentSortComponent, CommentViewComponent, CommentsModule, EMOJIS, EmojiModule, EmojiSelectorButtonComponent, EmojiSelectorPanelComponent, GiphyAttachmentResolver, LightboxComponent, LiveChatMessageComponent, LiveCommentComponent, LiveMessageComponent, TimerPool, TimestampComponent, TweetAttachmentResolver, UrlAttachmentResolver, UrlAttachmentScraper, YouTubeAttachmentResolver, lazyConnection };
